import gql from '~logic/graphQL/gqlTag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '~logic/graphQL/hooks';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: ID; output: ID; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: Date; output: Date; }
  DateTime: { input: Date; output: Date; }
  InputFile: { input: any; output: any; }
  Json: { input: JsonString; output: JsonString; }
  Time: { input: TimeString; output: TimeString; }
};

/**
 * Address schema of User, Company or Company Branch. Holds information about location and contact possibilities.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, editor_address, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, editor_address, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, customer, editor_address, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, customer, editor_address, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * DESTROY: [admin, customer, editor_address, super_admin]
 *
 */
export type TAddress = {
  readonly __typename?: 'Address';
  readonly addressType: TAddressType;
  readonly country: Maybe<TCountry>;
  readonly driverNote: Maybe<Scalars['String']['output']>;
  /** possible e-mail contacts */
  readonly emails: ReadonlyArray<TEmail>;
  readonly gps: Maybe<TGeoPoint>;
  readonly id: Scalars['ID']['output'];
  /** description of location */
  readonly location: Maybe<TJsonAddress>;
  /** possible phone contacts */
  readonly phones: ReadonlyArray<TPhone>;
  readonly title: Maybe<Scalars['String']['output']>;
};

export type TAddressResolvedLocation = {
  readonly __typename?: 'AddressResolvedLocation';
  readonly companyBranch: Maybe<TCompanyBranch>;
  readonly finalAddress: Maybe<TJsonAddress>;
  readonly finalAddressFormatted: Maybe<Scalars['String']['output']>;
  readonly gpsCoordinates: Maybe<TGeoPoint>;
  readonly inDeliveryLocation: Scalars['Boolean']['output'];
  readonly isResolved: Scalars['Boolean']['output'];
  readonly isValidAddress: Scalars['Boolean']['output'];
  readonly zone: Maybe<TZone>;
};

/**
 * Possible AddressType types
 *
 *
 * INDEX: [admin, operator, super_admin, support, user]
 *
 * READ: [admin, operator, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TAddressType = {
  readonly __typename?: 'AddressType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TAddressTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** mark if this address type is public and should be used in registration */
  readonly internal: Scalars['Boolean']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** AddressType enum */
export type TAddressTypeEnum =
  | 'BUSINESS'
  | 'HOME'
  | 'MAIN_ADDRESS'
  | 'OTHER'
  | 'PREMISES'
  | 'WORK';

/**
 * Allergen type schema
 *
 *
 * INDEX: [admin, editor_menu, editor_orders, guest, super_admin, support, user]
 *
 * READ: [admin, editor_menu, editor_orders, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TAllergen = {
  readonly __typename?: 'Allergen';
  /** category of allergen */
  readonly category: Scalars['Int']['output'];
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TAllergenEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** Allergen enum */
export type TAllergenEnum =
  | 'CELERY'
  | 'CEREALS_WITH_GLUTTEN'
  | 'EGG'
  | 'FISH'
  | 'LUPIN'
  | 'MILK'
  | 'MOLLUSCS'
  | 'MUSTARD'
  | 'NUT'
  | 'PEANUT'
  | 'SESAME'
  | 'SHELLFISH'
  | 'SOYBEANS'
  | 'SULFUROUS';

/** Information about available analytics codes */
export type TAnalyticsCode = {
  readonly __typename?: 'AnalyticsCode';
  readonly analyticsCodeType: TAnalyticsCodeType;
  readonly code: Maybe<Scalars['String']['output']>;
};

/**
 * Possible AnalyticsCodeType types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TAnalyticsCodeType = {
  readonly __typename?: 'AnalyticsCodeType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TAnalyticsCodeTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** AnalyticsCodeType enum */
export type TAnalyticsCodeTypeEnum =
  | 'FACEBOOK_PIXEL'
  | 'GOOGLE_ANALYTICS'
  | 'SKLIK_CONVERSION';

/** Setting attributes for brand or branch */
export type TApplicationSettings = TApplicationSettingsInterface & {
  readonly __typename?: 'ApplicationSettings';
  readonly headerText: Maybe<Scalars['String']['output']>;
  readonly homepageUrl: Maybe<Scalars['String']['output']>;
  /** enabling promo header setting */
  readonly promoHeaderEnabled: Maybe<Scalars['Boolean']['output']>;
  /** inherited promo header text */
  readonly promoHeaderText: Maybe<Scalars['String']['output']>;
  /** promo header text from setting without inheritance */
  readonly promoHeaderTranslations: Maybe<ReadonlyArray<TPromoHeaderTranslation>>;
  /** graphic styles */
  readonly styles: TGraphicStyle;
  readonly userAccountsEnabledForCustomer: Scalars['Boolean']['output'];
  readonly wifiAppInstructions: ReadonlyArray<TWiFiAppInstruction>;
};


/** Setting attributes for brand or branch */
export type TApplicationSettingsStylesArgs = {
  originCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};

export type TApplicationSettingsInterface = {
  readonly headerText: Maybe<Scalars['String']['output']>;
  readonly homepageUrl: Maybe<Scalars['String']['output']>;
  /** enabling promo header setting */
  readonly promoHeaderEnabled: Maybe<Scalars['Boolean']['output']>;
  /** inherited promo header text */
  readonly promoHeaderText: Maybe<Scalars['String']['output']>;
  /** promo header text from setting without inheritance */
  readonly promoHeaderTranslations: Maybe<ReadonlyArray<TPromoHeaderTranslation>>;
  /** graphic styles */
  readonly styles: TGraphicStyle;
  readonly userAccountsEnabledForCustomer: Scalars['Boolean']['output'];
  readonly wifiAppInstructions: ReadonlyArray<TWiFiAppInstruction>;
};


export type TApplicationSettingsInterfaceStylesArgs = {
  originCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};

/**
 * Holds information about usability - what times can be Ware, etc. used
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, cashier_menu, editor_availability, editor_menu, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, cashier_menu, editor_availability, editor_menu, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_availability, editor_menu, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_availability, editor_menu, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_availability, editor_menu, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TAvailability = {
  readonly __typename?: 'Availability';
  readonly availabilityType: TAvailabilityType;
  readonly available: Scalars['Boolean']['output'];
  readonly dateFrom: Maybe<Scalars['Date']['output']>;
  readonly dateTo: Maybe<Scalars['Date']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly orderOriginCategories: ReadonlyArray<TOrderOriginCategoryEnum>;
  readonly periodic: Scalars['Boolean']['output'];
  readonly timeFrom: Maybe<Scalars['Time']['output']>;
  readonly timeTo: Maybe<Scalars['Time']['output']>;
  readonly weekDay: Maybe<TWeekDay>;
};

export type TAvailabilityInterface = {
  /** when record is available */
  readonly availabilities: ReadonlyArray<TAvailability>;
  /** is available at specific time? */
  readonly isAvailable: Scalars['Boolean']['output'];
};


export type TAvailabilityInterfaceIsAvailableArgs = {
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};

/**
 * Possible AvailabilityType types
 *
 *
 * INDEX: [admin, editor_menu, super_admin, support, user]
 *
 * READ: [admin, editor_menu, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TAvailabilityType = {
  readonly __typename?: 'AvailabilityType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TAvailabilityTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** AvailabilityType enum */
export type TAvailabilityTypeEnum =
  | 'MAIN'
  | 'SPECIFIC';

/**
 * Board
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
 *
 */
export type TBoard = {
  readonly __typename?: 'Board';
  /** Converts ActiveStorage attachment to URL */
  readonly backgroundImage: Maybe<Scalars['String']['output']>;
  /** Converts ActiveStorage attachment to URL */
  readonly backgroundVideo: Maybe<Scalars['String']['output']>;
  /** Board screens ordered through sorting */
  readonly boardScreens: ReadonlyArray<TBoardScreen>;
  readonly boardTemplate: TBoardTemplate;
  /** Custom color set */
  readonly colors: ReadonlyArray<Scalars['String']['output']>;
  readonly companyBranch: TCompanyBranch;
  readonly features: TBoardFeatures;
  readonly id: Scalars['ID']['output'];
  /** Converts ActiveStorage attachment to URL */
  readonly logo: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
};


/**
 * Board
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
 *
 */
export type TBoardBackgroundImageArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Board
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
 *
 */
export type TBoardBackgroundVideoArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Board
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
 *
 */
export type TBoardLogoArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Board features */
export type TBoardFeatures = {
  readonly __typename?: 'BoardFeatures';
  readonly allergensEnabled: Scalars['Boolean']['output'];
  readonly infoMessageEnabled: Scalars['Boolean']['output'];
  readonly infoMessagePrimary: Maybe<Scalars['String']['output']>;
  readonly infoMessageSecondary: Maybe<Scalars['String']['output']>;
  readonly logoEnabled: Scalars['Boolean']['output'];
  readonly promoCategory: Maybe<TWareCategory>;
  readonly promoEnabled: Scalars['Boolean']['output'];
  readonly titleEnabled: Scalars['Boolean']['output'];
  readonly titleText: Maybe<Scalars['String']['output']>;
  readonly titleUrl: Maybe<Scalars['String']['output']>;
};

/**
 * Board screen
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
 *
 */
export type TBoardScreen = {
  readonly __typename?: 'BoardScreen';
  /** Converts ActiveStorage attachment to URL */
  readonly backgroundImage: Maybe<Scalars['String']['output']>;
  /** Converts ActiveStorage attachment to URL */
  readonly backgroundVideo: Maybe<Scalars['String']['output']>;
  readonly board: TBoard;
  readonly id: Scalars['ID']['output'];
  /** Board screen name */
  readonly name: Scalars['String']['output'];
  readonly wareCategories: ReadonlyArray<TWareCategory>;
};


/**
 * Board screen
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
 *
 */
export type TBoardScreenBackgroundImageArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Board screen
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
 *
 */
export type TBoardScreenBackgroundVideoArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Board template
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TBoardTemplate = {
  readonly __typename?: 'BoardTemplate';
  readonly features: TBoardTemplateFeatures;
  readonly id: Scalars['ID']['output'];
  /** Template name */
  readonly name: Scalars['String']['output'];
  /** Converts ActiveStorage attachment to URL */
  readonly preview: Scalars['String']['output'];
  /** Converts ActiveStorage attachment to URL */
  readonly styles: Scalars['String']['output'];
};


/**
 * Board template
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TBoardTemplatePreviewArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Board template
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TBoardTemplateStylesArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Board template features */
export type TBoardTemplateFeatures = {
  readonly __typename?: 'BoardTemplateFeatures';
  readonly allergens: Scalars['Boolean']['output'];
  readonly availableColors: Scalars['Int']['output'];
  readonly infoMessage: Scalars['Boolean']['output'];
  readonly logo: Scalars['Boolean']['output'];
  readonly promo: Scalars['Boolean']['output'];
  readonly screenTitle: Scalars['Boolean']['output'];
};

/**
 * Schema of opening hours of Company Branch
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TBusinessHour = {
  readonly __typename?: 'BusinessHour';
  readonly closeAt: Scalars['Time']['output'];
  readonly closed: Scalars['Boolean']['output'];
  /** reason of closing */
  readonly closedNote: Maybe<Scalars['String']['output']>;
  readonly companyBranch: TCompanyBranch;
  readonly id: Scalars['ID']['output'];
  readonly openAt: Scalars['Time']['output'];
  readonly smsLabel: Maybe<Scalars['String']['output']>;
  /** special day */
  readonly specificDate: Maybe<Scalars['Date']['output']>;
  /** localized special day */
  readonly specificDateLocalized: Maybe<Scalars['String']['output']>;
  /** can hours work together with regular ones */
  readonly type: TBusinessHoursTypeEnum;
  readonly webLabel: Maybe<Scalars['String']['output']>;
  /** which day of week It is used to */
  readonly weekDay: Maybe<TWeekDay>;
};

/** Grouped business hours of company branch */
export type TBusinessHourInterval = {
  readonly __typename?: 'BusinessHourInterval';
  readonly closeAt: Scalars['DateTime']['output'];
  readonly closed: Scalars['Boolean']['output'];
  /** reason of closing */
  readonly closedNote: Maybe<Scalars['String']['output']>;
  readonly openAt: Scalars['DateTime']['output'];
  readonly relevantDay: Scalars['Date']['output'];
};

export type TBusinessHoursInterface = {
  readonly businessHours: ReadonlyArray<TBusinessHour>;
  readonly businessHoursIntervals: ReadonlyArray<TBusinessHourInterval>;
  readonly currentInterval: Maybe<TBusinessHourInterval>;
  readonly delayedDeliveryIntervals: ReadonlyArray<TBusinessHourInterval>;
  readonly isOpen: Scalars['Boolean']['output'];
  readonly willCloseAt: Maybe<Scalars['DateTime']['output']>;
  readonly willOpenAt: Maybe<Scalars['DateTime']['output']>;
};


export type TBusinessHoursInterfaceBusinessHoursArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  wholeWeek?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TBusinessHoursInterfaceBusinessHoursIntervalsArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  ignoreFastClose?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type TBusinessHoursInterfaceIsOpenArgs = {
  atDateTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** BusinessHoursType enum */
export type TBusinessHoursTypeEnum =
  | 'FAST_CLOSE'
  | 'PLANNED_CHANGE'
  | 'REGULAR';

/**
 * Schema of cash boxes of Company Branch
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_cash_box, super_admin]
 *
 */
export type TCashBox = TInvoiceSequenceInterface & {
  readonly __typename?: 'CashBox';
  readonly automaticOrderFinish: Scalars['Boolean']['output'];
  readonly companyBranch: TCompanyBranch;
  readonly configuration: Maybe<Scalars['Json']['output']>;
  readonly eetId: Scalars['String']['output'];
  readonly enabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly kiosk: Scalars['Boolean']['output'];
  readonly lastInvoiceSequence: Scalars['Int']['output'];
  readonly lastResettableInvoiceSequence: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly resettableInvoicePrefix: Maybe<Scalars['Int']['output']>;
  readonly user: Maybe<TUser>;
  readonly uuid: Scalars['String']['output'];
  readonly virtual: Scalars['Boolean']['output'];
};

export type TColorInterface = {
  readonly code: Scalars['String']['output'];
  readonly color: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
};

/**
 * Company type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company, super_admin]
 *
 */
export type TCompany = TApplicationSettingsInterface & TLanguageInterface & {
  readonly __typename?: 'Company';
  /** Company account number */
  readonly account: Scalars['String']['output'];
  /** Main address of company */
  readonly address: Maybe<TAddress>;
  /** Company branches accessible by user */
  readonly companyBranches: ReadonlyArray<TCompanyBranch>;
  readonly companyConsents: ReadonlyArray<TConsentCompany>;
  readonly companyType: TCompanyType;
  readonly defaultLanguage: TLanguageEnum;
  /** possibility of delivering order at least by one brand branch */
  readonly deliveryEnabled: Maybe<Scalars['Boolean']['output']>;
  readonly hasCreditsGroups: Scalars['Boolean']['output'];
  readonly headerText: Maybe<Scalars['String']['output']>;
  readonly homepageUrl: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly internalNumber: Maybe<Scalars['String']['output']>;
  readonly mobileApplicationSetting: Maybe<TMobileApplicationSetting>;
  readonly name: Scalars['String']['output'];
  readonly number: Scalars['String']['output'];
  /** possibility of personal order pickup at least by one brand branch */
  readonly pickupEnabled: Maybe<Scalars['Boolean']['output']>;
  /** enabling promo header setting */
  readonly promoHeaderEnabled: Maybe<Scalars['Boolean']['output']>;
  /** inherited promo header text */
  readonly promoHeaderText: Maybe<Scalars['String']['output']>;
  /** promo header text from setting without inheritance */
  readonly promoHeaderTranslations: Maybe<ReadonlyArray<TPromoHeaderTranslation>>;
  readonly settings: TSettingCompany;
  /** graphic styles */
  readonly styles: TGraphicStyle;
  readonly subdomain: Scalars['String']['output'];
  readonly supportedLanguages: ReadonlyArray<TLanguageEnum>;
  readonly url: Scalars['String']['output'];
  readonly userAccountsEnabledForCustomer: Scalars['Boolean']['output'];
  readonly vatIdent: Maybe<Scalars['String']['output']>;
  /** Indicates if Company is payer of VAT. Only for company client type. */
  readonly vatPayer: Scalars['Boolean']['output'];
  readonly wac: Scalars['String']['output'];
  readonly wareCategorySharingAllowed: Scalars['Boolean']['output'];
  readonly wifiAppInstructions: ReadonlyArray<TWiFiAppInstruction>;
};


/**
 * Company type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company, super_admin]
 *
 */
export type TCompanyMobileApplicationSettingArgs = {
  platform: TMobilePlatformEnum;
};


/**
 * Company type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company, super_admin]
 *
 */
export type TCompanyStylesArgs = {
  originCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};


/**
 * Company type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company, super_admin]
 *
 */
export type TCompanySupportedLanguagesArgs = {
  userSpecific?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Company type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
 *
 * CREATE: [admin, editor_company, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company, super_admin]
 *
 */
export type TCompanyUrlArgs = {
  origin?: InputMaybe<TOrderOriginEnum>;
};

/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranch = TApplicationSettingsInterface & TBusinessHoursInterface & TCompanyBranchSettingInterface & TInvoiceSequenceInterface & TLanguageInterface & TProcessTimeInterface & TStockInterface & {
  readonly __typename?: 'CompanyBranch';
  readonly accountNumber: Scalars['String']['output'];
  /** Main address of company branch */
  readonly address: TAddress;
  /** definition of allowed order state categories */
  readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>;
  readonly brand: TCompany;
  readonly businessHours: ReadonlyArray<TBusinessHour>;
  readonly businessHoursIntervals: ReadonlyArray<TBusinessHourInterval>;
  readonly businessHoursMidnight: Scalars['Time']['output'];
  /** order payment method can be updated to these values */
  readonly canBeUpdatedToPaymentMethods: ReadonlyArray<TPaymentMethod>;
  readonly company: TCompany;
  /** all possible covers of company branch */
  readonly covers: ReadonlyArray<TRecipe>;
  readonly creditsGroupMembership: Maybe<TCreditsGroupMembership>;
  /** currencies used by company branch */
  readonly currencies: ReadonlyArray<TCurrency>;
  readonly currentDeliveryTime: Scalars['Int']['output'];
  readonly currentInterval: Maybe<TBusinessHourInterval>;
  readonly currentPickupTime: Scalars['Int']['output'];
  readonly defaultCurrency: TCurrency;
  /** time in minutes that is required to deliver order */
  readonly defaultDeliveryTime: Scalars['Int']['output'];
  readonly defaultDeliveryTimeEnabled: Scalars['Boolean']['output'];
  readonly defaultLanguage: TLanguageEnum;
  /** time in minutes that is required to pickup order */
  readonly defaultPickupTime: Scalars['Int']['output'];
  readonly defaultPickupTimeEnabled: Scalars['Boolean']['output'];
  /** default vat of company branch for defined price type */
  readonly defaultVats: ReadonlyArray<TVatPriceType>;
  readonly delayedDeliveryEnabled: Scalars['Boolean']['output'];
  readonly delayedDeliveryIntervals: ReadonlyArray<TBusinessHourInterval>;
  readonly delayedDeliveryLimit: Scalars['Int']['output'];
  readonly deliveryAsapEnabled: Maybe<Scalars['Boolean']['output']>;
  /** possibility of delivering order */
  readonly deliveryEnabled: Scalars['Boolean']['output'];
  readonly driverOrderAssignments: ReadonlyArray<TUserDeliveringOrdersAssignmentType>;
  readonly driverSmsText: Maybe<Scalars['String']['output']>;
  /** Mark if branch allowing assign driver before order is ready to deliver */
  readonly earlyDriverAssignment: Scalars['Boolean']['output'];
  readonly eetCertificate: Maybe<TEetCertificate>;
  readonly employers: ReadonlyArray<TUser>;
  /** is company branch working? */
  readonly enabled: Scalars['Boolean']['output'];
  readonly foodMenuUrl: Maybe<Scalars['String']['output']>;
  readonly gpTomIntegrationAllowed: Scalars['Boolean']['output'];
  /** GPS coordinates of company branch */
  readonly gps: TGeoPoint;
  readonly headerText: Maybe<Scalars['String']['output']>;
  readonly homepageUrl: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  /** stock items that are incoming to branch */
  readonly incomingStockTransfer: ReadonlyArray<TStockTransfer>;
  readonly internalNumber: Maybe<Scalars['String']['output']>;
  readonly isOpen: Scalars['Boolean']['output'];
  readonly kitchenModuleEnabled: Scalars['Boolean']['output'];
  readonly lastInvoiceSequence: Scalars['Int']['output'];
  readonly lastResettableInvoiceSequence: Scalars['Int']['output'];
  /** maximal size of cart */
  readonly maxCartSize: Scalars['Int']['output'];
  readonly mobileApplicationSetting: Maybe<TMobileApplicationSetting>;
  readonly name: Scalars['String']['output'];
  readonly occasions: ReadonlyArray<TOccasion>;
  /** how many hours it takes for order to be marked as old */
  readonly oldOrderThreshold: Scalars['Int']['output'];
  /** stock items that are leaving branch */
  readonly outcomingStockTransfer: ReadonlyArray<TStockTransfer>;
  readonly overriddenDeliveryTime: Maybe<TOrderProcessTime>;
  readonly overriddenPickupTime: Maybe<TOrderProcessTime>;
  /** payment method used by company branch */
  readonly paymentMethods: ReadonlyArray<TPaymentMethodBranch>;
  readonly phone: Scalars['String']['output'];
  readonly pickupAsapEnabled: Maybe<Scalars['Boolean']['output']>;
  /** possibility of personal order pickup */
  readonly pickupEnabled: Scalars['Boolean']['output'];
  readonly popUpMessage: Maybe<Scalars['String']['output']>;
  readonly popUpMessageFromBranch: Maybe<Scalars['Boolean']['output']>;
  readonly promoCodeLimit: Scalars['Int']['output'];
  /** enabling promo header setting */
  readonly promoHeaderEnabled: Maybe<Scalars['Boolean']['output']>;
  /** inherited promo header text */
  readonly promoHeaderText: Maybe<Scalars['String']['output']>;
  /** promo header text from setting without inheritance */
  readonly promoHeaderTranslations: Maybe<ReadonlyArray<TPromoHeaderTranslation>>;
  readonly settings: TSettingCompanyBranch;
  readonly shifts: ReadonlyArray<TShift>;
  readonly stockItemsCanBeNegative: Scalars['Boolean']['output'];
  /** graphic styles */
  readonly styles: TGraphicStyle;
  readonly supportedLanguages: ReadonlyArray<TLanguageEnum>;
  readonly url: Scalars['String']['output'];
  readonly urlPath: Scalars['String']['output'];
  readonly userAccountsEnabledForCustomer: Scalars['Boolean']['output'];
  readonly wac: Scalars['String']['output'];
  readonly wareCategories: ReadonlyArray<TWareCategory>;
  readonly wifiAppInstructions: ReadonlyArray<TWiFiAppInstruction>;
  readonly willCloseAt: Maybe<Scalars['DateTime']['output']>;
  readonly willOpenAt: Maybe<Scalars['DateTime']['output']>;
  readonly zones: ReadonlyArray<TZone>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchAllowedCategoriesArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchBusinessHoursArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  wholeWeek?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchBusinessHoursIntervalsArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  ignoreFastClose?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchCanBeUpdatedToPaymentMethodsArgs = {
  country?: InputMaybe<TCountryEnum>;
  deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  orderOrigin?: InputMaybe<TOrderOriginEnum>;
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchIsOpenArgs = {
  atDateTime?: InputMaybe<Scalars['DateTime']['input']>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchMobileApplicationSettingArgs = {
  platform: TMobilePlatformEnum;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchPaymentMethodsArgs = {
  country?: InputMaybe<TCountryEnum>;
  deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  orderOrigin: TOrderOriginEnum;
  warePriceType: TWarePriceTypeEnum;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchPopUpMessageArgs = {
  orderOrigin: TOrderOriginEnum;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchPopUpMessageFromBranchArgs = {
  orderOrigin: TOrderOriginEnum;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchStylesArgs = {
  originCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchSupportedLanguagesArgs = {
  userSpecific?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Company Branch type
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
 *
 * CREATE: [admin, editor_company_branch, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_company_branch, super_admin]
 *
 */
export type TCompanyBranchWareCategoriesArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Company branch printer
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, cashier, super_admin, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
 *
 */
export type TCompanyBranchPrinter = {
  readonly __typename?: 'CompanyBranchPrinter';
  /** Company branch */
  readonly companyBranch: TCompanyBranch;
  readonly id: Scalars['ID']['output'];
  /** printer */
  readonly printer: TPrinter;
};

export type TCompanyBranchSettingInterface = {
  /** definition of allowed order state categories */
  readonly allowedCategories: ReadonlyArray<TOrderStateCategoryEnum>;
  readonly businessHoursMidnight: Scalars['Time']['output'];
  readonly deliveryAsapEnabled: Maybe<Scalars['Boolean']['output']>;
  /** possibility of delivering order */
  readonly deliveryEnabled: Scalars['Boolean']['output'];
  readonly driverOrderAssignments: ReadonlyArray<TUserDeliveringOrdersAssignmentType>;
  readonly driverSmsText: Maybe<Scalars['String']['output']>;
  /** Mark if branch allowing assign driver before order is ready to deliver */
  readonly earlyDriverAssignment: Scalars['Boolean']['output'];
  readonly foodMenuUrl: Maybe<Scalars['String']['output']>;
  readonly gpTomIntegrationAllowed: Scalars['Boolean']['output'];
  readonly kitchenModuleEnabled: Scalars['Boolean']['output'];
  /** maximal size of cart */
  readonly maxCartSize: Scalars['Int']['output'];
  readonly mobileApplicationSetting: Maybe<TMobileApplicationSetting>;
  /** how many hours it takes for order to be marked as old */
  readonly oldOrderThreshold: Scalars['Int']['output'];
  readonly pickupAsapEnabled: Maybe<Scalars['Boolean']['output']>;
  /** possibility of personal order pickup */
  readonly pickupEnabled: Scalars['Boolean']['output'];
  readonly promoCodeLimit: Scalars['Int']['output'];
  readonly settings: TSettingCompanyBranch;
  readonly urlPath: Scalars['String']['output'];
};


export type TCompanyBranchSettingInterfaceAllowedCategoriesArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


export type TCompanyBranchSettingInterfaceMobileApplicationSettingArgs = {
  platform: TMobilePlatformEnum;
};

/**
 * Company branch trigger
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
 *
 */
export type TCompanyBranchTrigger = {
  readonly __typename?: 'CompanyBranchTrigger';
  readonly assignable: TCompanyBranchTriggerAssignable;
  /**
   * Company branch
   * @deprecated Use assignable polymorphic association instead
   */
  readonly companyBranch: TCompanyBranch;
  /** Company branch trigger printers */
  readonly companyBranchTriggerPrinters: ReadonlyArray<TCompanyBranchTriggerPrinter>;
  readonly id: Scalars['ID']['output'];
  /**
   * Print configuration
   * @deprecated Use triggerConfiguration field instead
   */
  readonly printConfiguration: TPrintConfiguration;
  /**
   * Template
   * @deprecated Use templatable polymorphic association instead
   */
  readonly printTemplate: TPrintTemplate;
  readonly templatable: TCompanyBranchTriggerTemplatable;
  /** Trigger configuration */
  readonly triggerConfiguration: TTriggerConfiguration;
  /**
   * Trigger type
   * @deprecated Determine the trigger type according to the trigger configuration.
   */
  readonly triggerType: TTriggerType;
};

/** Object in which it may belong a CompanyBranchTrigger */
export type TCompanyBranchTriggerAssignable = TCompany | TCompanyBranch;

/**
 * Company branch trigger to printer
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
 *
 */
export type TCompanyBranchTriggerPrinter = {
  readonly __typename?: 'CompanyBranchTriggerPrinter';
  /** printer */
  readonly companyBranchPrinter: TCompanyBranchPrinter;
  /** triggers */
  readonly companyBranchTrigger: TCompanyBranchTrigger;
  readonly id: Scalars['ID']['output'];
  readonly targetMac: Scalars['String']['output'];
};

/** Object which can be triggered by a CompanyBranchTrigger */
export type TCompanyBranchTriggerTemplatable = TPrintTemplate | TSmsTemplate;

/**
 * Link between Company Branch and User
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor]
 *
 */
export type TCompanyBranchUser = {
  readonly __typename?: 'CompanyBranchUser';
  readonly companyBranch: TCompanyBranch;
  /** user is no longer employed by company branch */
  readonly deleted: Scalars['Boolean']['output'];
  readonly driverOrderAssignments: ReadonlyArray<TUserDeliveringOrdersAssignmentType>;
  readonly driverSmsText: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly user: TUser;
};


/**
 * Link between Company Branch and User
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor]
 *
 */
export type TCompanyBranchUserDriverOrderAssignmentsArgs = {
  enableFallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TCompanyBranchesLookUp = {
  readonly __typename?: 'CompanyBranchesLookUp';
  readonly finalAddress: Maybe<TJsonAddress>;
  readonly finalAddressFormatted: Maybe<Scalars['String']['output']>;
  readonly gpsCoordinates: Maybe<TGeoPoint>;
  readonly isResolved: Scalars['Boolean']['output'];
  readonly isValidAddress: Scalars['Boolean']['output'];
  readonly resolvedBranches: ReadonlyArray<TResolvedCompanyBranch>;
};

export type TCompanyBrandLookUp = {
  readonly __typename?: 'CompanyBrandLookUp';
  readonly analyticsCodes: ReadonlyArray<TAnalyticsCode>;
  readonly brand: Maybe<TCompany>;
  readonly companyBranch: Maybe<TCompanyBranch>;
  readonly companyBranches: ReadonlyArray<TCompanyBranch>;
  /** @deprecated Use analyticsCodes instead. */
  readonly googleAnalyticsCode: Maybe<Scalars['String']['output']>;
  readonly isBrandUrl: Scalars['Boolean']['output'];
  /** @deprecated Use isBrandUrl instead. */
  readonly isBrandWac: Scalars['Boolean']['output'];
  readonly isMobileApp: Scalars['Boolean']['output'];
  readonly knownBasePath: Scalars['String']['output'];
  readonly orderOrigin: TOrderOriginEnum;
  readonly redirectUrl: Maybe<Scalars['String']['output']>;
  readonly sector: Maybe<TSector>;
  readonly userDefaultLanguage: TLanguageEnum;
};

/**
 * Possible CompanyType types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TCompanyType = {
  readonly __typename?: 'CompanyType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TCompanyTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** CompanyType enum */
export type TCompanyTypeEnum =
  | 'AFFILIATE'
  | 'BRAND'
  | 'CLIENT';

/** Allows to select a only records with a specified confirmation status. */
export type TConfirmationStatusSelectorEnum =
  | 'CONFIRMED'
  | 'PENDING';

/**
 * Details about consent.
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TConsent = {
  readonly __typename?: 'Consent';
  /** Description of consent translated into request language. */
  readonly description: Scalars['String']['output'];
  /** Value in seconds. Meaning: How long is consent active from users confirmation. */
  readonly expiration: Scalars['Int']['output'];
  /** Consent ID */
  readonly id: Scalars['ID']['output'];
  /** Name of consent translated into request language. */
  readonly name: Scalars['String']['output'];
  /** Indicates if consent is active just for order processing. */
  readonly oneTime: Scalars['Boolean']['output'];
  readonly parent: Maybe<TConsent>;
  /** Type of consent */
  readonly type: TConsentsType;
};

export type TConsentCompany = {
  readonly __typename?: 'ConsentCompany';
  readonly company: TCompany;
  readonly consent: TConsent;
  readonly id: Scalars['ID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
};

/** Information about customer consent association. */
export type TConsentCustomer = {
  readonly __typename?: 'ConsentCustomer';
  readonly consent: TConsent;
  readonly customer: TCustomer;
  readonly history: ReadonlyArray<TConsentCustomerHistory>;
  readonly isActive: Scalars['Boolean']['output'];
};

/** Historical activity of customers consent association. */
export type TConsentCustomerHistory = {
  readonly __typename?: 'ConsentCustomerHistory';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly revokeType: Maybe<TConsentsRevokeType>;
  readonly revokedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Information about active consent assigned with order record. */
export type TConsentOrder = {
  readonly __typename?: 'ConsentOrder';
  readonly consent: TConsent;
  readonly id: Scalars['ID']['output'];
  readonly order: TOrder;
};

/** Possible ConsentsRevokeType types */
export type TConsentsRevokeType = {
  readonly __typename?: 'ConsentsRevokeType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TConsentsRevokeTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** ConsentsRevokeType enum */
export type TConsentsRevokeTypeEnum =
  | 'COMPANY_REVOKE'
  | 'CUSTOMER_REVOKE'
  | 'EXPIRATION'
  | 'MASS_REVOKE'
  | 'ONE_TIME'
  | 'TRANSFER_REVOKE';

/** Possible ConsentsType types */
export type TConsentsType = {
  readonly __typename?: 'ConsentsType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TConsentsTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** ConsentsType enum */
export type TConsentsTypeEnum =
  | 'ANALYTICS'
  | 'MARKETING'
  | 'TERMS_AND_CONDITIONS';

/**
 * Holds information about a Country
 *
 *
 * INDEX: [admin, editor_country, editor_menu, guest, operator, super_admin, support, user]
 *
 * READ: [admin, editor_country, editor_menu, guest, operator, super_admin, support, user]
 *
 * CREATE: [admin, editor_country, super_admin, support]
 *
 * UPDATE: [admin, editor_country, super_admin, support]
 *
 * DESTROY: [admin, editor_country, super_admin]
 *
 */
export type TCountry = {
  readonly __typename?: 'Country';
  readonly cashPaymentDecimals: Scalars['Int']['output'];
  readonly cashPaymentUnit: Scalars['Float']['output'];
  readonly code: Scalars['String']['output'];
  readonly countryVats: ReadonlyArray<TVat>;
  /** default currency for country */
  readonly currency: TCurrency;
  /** enum string used to identify object */
  readonly enum: TCountryEnum;
  readonly id: Scalars['ID']['output'];
  readonly phonePrefix: Scalars['String']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** Country enum */
export type TCountryEnum =
  | 'CZ'
  | 'PL'
  | 'RSA'
  | 'SK';

/** Response for created order by external service */
export type TCreatedExternalOrderType = {
  readonly __typename?: 'CreatedExternalOrderType';
  readonly missingStockItems: ReadonlyArray<TStockItem>;
  readonly order: Maybe<TOrder>;
  readonly userErrors: ReadonlyArray<Scalars['String']['output']>;
};

export type TCreditsCurrencyInterface = {
  /** Alias of `self.group.country.cashPaymentDecimals`. */
  readonly cashPaymentDecimals: Scalars['Int']['output'];
  /** Alias of `self.group.country.cashPaymentUnit`. */
  readonly cashPaymentUnit: Scalars['Float']['output'];
  readonly currency: TCurrency;
  readonly group: TCreditsGroup;
};

export type TCreditsGroup = {
  readonly __typename?: 'CreditsGroup';
  readonly closedAt: Maybe<Scalars['DateTime']['output']>;
  readonly country: TCountry;
  readonly id: Scalars['ID']['output'];
  readonly isClosed: Scalars['Boolean']['output'];
  readonly memberships: TCreditsGroupMembership;
};

export type TCreditsGroupMembership = {
  readonly __typename?: 'CreditsGroupMembership';
  readonly canCollect: Scalars['Boolean']['output'];
  readonly canSpend: Scalars['Boolean']['output'];
  readonly closedAt: Maybe<Scalars['DateTime']['output']>;
  readonly group: TCreditsGroup;
  readonly id: Scalars['ID']['output'];
  readonly isClosed: Scalars['Boolean']['output'];
};

export type TCreditsOverviewInterface = {
  readonly creditsExpiringSoon: Maybe<TCreditsWalletActivityConnection>;
  readonly creditsPendingRewards: TCreditsRewardConnection;
  readonly creditsRewards: TCreditsRewardConnection;
  readonly creditsWalletActivities: TCreditsWalletActivityConnection;
};


export type TCreditsOverviewInterfaceCreditsExpiringSoonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TCreditsOverviewInterfaceCreditsPendingRewardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TCreditsOverviewInterfaceCreditsRewardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<ReadonlyArray<TCreditsRewardStateEnum>>;
};


export type TCreditsOverviewInterfaceCreditsWalletActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TCreditsPaymentAdd = {
  readonly __typename?: 'CreditsPaymentAdd';
  readonly order: TOrder;
  readonly wallet: TCreditsWallet;
};

/** Pending wallet credit payments */
export type TCreditsPendingWalletPayment = {
  readonly __typename?: 'CreditsPendingWalletPayment';
  readonly amount: TPriceConverted;
  readonly resolvedAt: Scalars['DateTime']['output'];
  readonly unpaid: TPriceConverted;
};

/** Credits price converted to format of the current locale */
export type TCreditsPriceConverted = {
  readonly __typename?: 'CreditsPriceConverted';
  readonly formattedValue: Scalars['String']['output'];
  readonly value: Scalars['Float']['output'];
};

export type TCreditsReward = TCreditsCurrencyInterface & {
  readonly __typename?: 'CreditsReward';
  readonly amount: TCreditsPriceConverted;
  /** Alias of `self.group.country.cashPaymentDecimals`. */
  readonly cashPaymentDecimals: Scalars['Int']['output'];
  /** Alias of `self.group.country.cashPaymentUnit`. */
  readonly cashPaymentUnit: Scalars['Float']['output'];
  readonly createdAt: Maybe<Scalars['DateTime']['output']>;
  readonly currency: TCurrency;
  readonly group: TCreditsGroup;
  readonly id: Maybe<Scalars['ID']['output']>;
  readonly order: TOrder;
  readonly state: TCreditsRewardState;
};

/** The connection type for CreditsReward. */
export type TCreditsRewardConnection = {
  readonly __typename?: 'CreditsRewardConnection';
  /** A list of edges. */
  readonly edges: Maybe<ReadonlyArray<Maybe<TCreditsRewardEdge>>>;
  /** A list of nodes. */
  readonly nodes: Maybe<ReadonlyArray<Maybe<TCreditsReward>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: TPageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TCreditsRewardEdge = {
  readonly __typename?: 'CreditsRewardEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: Maybe<TCreditsReward>;
};

/** Possible CreditsRewardState types */
export type TCreditsRewardState = {
  readonly __typename?: 'CreditsRewardState';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TCreditsRewardStateEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** CreditsRewardState enum */
export type TCreditsRewardStateEnum =
  | 'CANCELED'
  | 'COLLECTED'
  | 'PENDING'
  | 'PENDING_COLLECTION'
  | 'PENDING_ORDER_FINISH'
  | 'POTENTIAL';

export type TCreditsWallet = TCreditsCurrencyInterface & TCreditsOverviewInterface & {
  readonly __typename?: 'CreditsWallet';
  readonly balance: TCreditsPriceConverted;
  /** Alias of `self.group.country.cashPaymentDecimals`. */
  readonly cashPaymentDecimals: Scalars['Int']['output'];
  /** Alias of `self.group.country.cashPaymentUnit`. */
  readonly cashPaymentUnit: Scalars['Float']['output'];
  readonly closedAt: Maybe<Scalars['DateTime']['output']>;
  readonly companyBranches: ReadonlyArray<TCompanyBranch>;
  readonly creditsExpiringSoon: Maybe<TCreditsWalletActivityConnection>;
  readonly creditsPendingRewards: TCreditsRewardConnection;
  readonly creditsRewards: TCreditsRewardConnection;
  readonly creditsWalletActivities: TCreditsWalletActivityConnection;
  readonly currency: TCurrency;
  readonly group: TCreditsGroup;
  readonly id: Scalars['ID']['output'];
  readonly isClosed: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};


export type TCreditsWalletCreditsExpiringSoonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TCreditsWalletCreditsPendingRewardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TCreditsWalletCreditsRewardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<ReadonlyArray<TCreditsRewardStateEnum>>;
};


export type TCreditsWalletCreditsWalletActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TCreditsWalletActivity = TCreditsCurrencyInterface & {
  readonly __typename?: 'CreditsWalletActivity';
  readonly activityType: TCreditsWalletActivityType;
  readonly amount: TCreditsPriceConverted;
  /** Alias of `self.group.country.cashPaymentDecimals`. */
  readonly cashPaymentDecimals: Scalars['Int']['output'];
  /** Alias of `self.group.country.cashPaymentUnit`. */
  readonly cashPaymentUnit: Scalars['Float']['output'];
  readonly companyBranch: TCompanyBranch;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly currency: TCurrency;
  readonly expiresAt: Maybe<Scalars['DateTime']['output']>;
  readonly group: TCreditsGroup;
  readonly id: Scalars['ID']['output'];
  readonly isExpired: Scalars['Boolean']['output'];
  readonly isExpiringSoon: Scalars['Boolean']['output'];
  readonly order: Maybe<TOrder>;
  readonly remainingAmount: TCreditsPriceConverted;
  readonly wallet: TCreditsWallet;
};

/** The connection type for CreditsWalletActivity. */
export type TCreditsWalletActivityConnection = {
  readonly __typename?: 'CreditsWalletActivityConnection';
  /** A list of edges. */
  readonly edges: Maybe<ReadonlyArray<Maybe<TCreditsWalletActivityEdge>>>;
  /** A list of nodes. */
  readonly nodes: Maybe<ReadonlyArray<Maybe<TCreditsWalletActivity>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: TPageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TCreditsWalletActivityEdge = {
  readonly __typename?: 'CreditsWalletActivityEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: Maybe<TCreditsWalletActivity>;
};

/** Possible CreditsWalletActivityType types */
export type TCreditsWalletActivityType = {
  readonly __typename?: 'CreditsWalletActivityType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TCreditsWalletActivityTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** CreditsWalletActivityType enum */
export type TCreditsWalletActivityTypeEnum =
  | 'GIFT'
  | 'MANUAL_DECREASE'
  | 'ORDER_PAYMENT'
  | 'ORDER_PAYMENT_CANCELED'
  | 'ORDER_REWARD';

/**
 * Currency type schema
 *
 *
 * INDEX: [admin, editor_currency, guest, super_admin, support, user]
 *
 * READ: [admin, editor_currency, guest, super_admin, support, user]
 *
 * CREATE: [admin, editor_currency, super_admin, support]
 *
 * UPDATE: [admin, editor_currency, super_admin, support]
 *
 * DESTROY: [admin, editor_currency, super_admin]
 *
 */
export type TCurrency = {
  readonly __typename?: 'Currency';
  readonly code: Scalars['String']['output'];
  /** number of digits */
  readonly decimalRound: Scalars['Int']['output'];
  /** enum string used to identify object */
  readonly enum: TCurrencyEnum;
  /** rate is used for money exchanging */
  readonly exchangeRate: Scalars['Float']['output'];
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** Currency enum */
export type TCurrencyEnum =
  | 'CZK'
  | 'EUR'
  | 'HOP'
  | 'PLN'
  | 'USD'
  | 'ZAR';

/** Hold registration token for phone number of the current user */
export type TCurrentUserValidation = {
  readonly __typename?: 'CurrentUserValidation';
  readonly token: Scalars['String']['output'];
};

/** Holds information about Customer */
export type TCustomer = TOrdersInterface & {
  readonly __typename?: 'Customer';
  readonly company: TCompany;
  readonly customerConsents: ReadonlyArray<TConsentCustomer>;
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly orders: ReadonlyArray<TOrder>;
  readonly phone: Scalars['String']['output'];
};


/** Holds information about Customer */
export type TCustomerOrdersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  orderOrigins?: InputMaybe<ReadonlyArray<TOrderOriginEnum>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Holds information about Customer */
export type TCustomerPhoneArgs = {
  part?: InputMaybe<TPhonePartSelectorEnum>;
};

/** CustomerExport */
export type TCustomerExport = {
  readonly __typename?: 'CustomerExport';
  readonly maskedEmail: Maybe<Scalars['String']['output']>;
  /** status of customer export */
  readonly success: Scalars['Boolean']['output'];
};

/** Possible information for customer */
export type TCustomerInformation = {
  readonly __typename?: 'CustomerInformation';
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly isFound: Scalars['Boolean']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly lastOrder: Maybe<TOrder>;
  readonly locations: ReadonlyArray<TJsonAddress>;
  readonly phone: Scalars['String']['output'];
};


/** Possible information for customer */
export type TCustomerInformationLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Wrapper for DateTime scalar type. Used in union types. */
export type TDateTimeWrapped = {
  readonly __typename?: 'DateTimeWrapped';
  readonly value: Scalars['DateTime']['output'];
};

/**
 * Schema of a DeliverySlot
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TDeliverySlot = {
  readonly __typename?: 'DeliverySlot';
  readonly capacity: Scalars['Int']['output'];
  readonly capacityTaken: Scalars['Int']['output'];
  readonly companyBranch: TCompanyBranch;
  readonly deliveryType: TDeliveryType;
  readonly endAt: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isFull: Scalars['Boolean']['output'];
  readonly startAt: Scalars['DateTime']['output'];
  readonly userEdited: Scalars['Boolean']['output'];
};

/**
 * Schema of a DeliverySlotElement
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TDeliverySlotElement = {
  readonly __typename?: 'DeliverySlotElement';
  readonly capacityTaken: Scalars['Int']['output'];
  readonly companyBranch: TCompanyBranch;
  readonly deliverySlot: Maybe<TDeliverySlot>;
  readonly deliveryType: TDeliveryType;
  readonly id: Scalars['ID']['output'];
  readonly startAt: Scalars['DateTime']['output'];
};

/** DeliveryState enum */
export type TDeliveryStateEnum =
  | 'ACCEPTED'
  | 'CANCELED'
  | 'DELIVERED'
  | 'DRIVER_CHANGED'
  | 'DRIVER_REJECTED'
  | 'FRESH'
  | 'LAST_MILE_DELIVERY'
  | 'LATE_DELIVERY'
  | 'NOT_FOUND'
  | 'ON_WAY'
  | 'RECLAMATION';

/** History of delivery state assignments taken from events. */
export type TDeliveryStateHistorical = {
  readonly __typename?: 'DeliveryStateHistorical';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly deliveryState: TDeliveryStateEnum;
  readonly user: TUser;
};

/**
 * Possible DeliveryType types
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TDeliveryType = {
  readonly __typename?: 'DeliveryType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TDeliveryTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** DeliveryType enum */
export type TDeliveryTypeEnum =
  | 'DRON'
  | 'MAIL'
  | 'MESSENGER'
  | 'PICKUP';

/**
 * Possible DeviceState types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TDeviceState = {
  readonly __typename?: 'DeviceState';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TDeviceStateEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** DeviceState enum */
export type TDeviceStateEnum =
  | 'BROKEN'
  | 'BUSY'
  | 'FREE'
  | 'WORKING';

/**
 * Possible DeviceType types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TDeviceType = {
  readonly __typename?: 'DeviceType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TDeviceTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** DeviceType enum */
export type TDeviceTypeEnum =
  | 'CAR'
  | 'DRON'
  | 'PLANE';

/** Setting attributes for Dotykacka */
export type TDotykackaSetting = {
  readonly __typename?: 'DotykackaSetting';
  readonly branchId: Maybe<Scalars['String']['output']>;
  readonly cloudId: Maybe<Scalars['String']['output']>;
  readonly enabled: Scalars['Boolean']['output'];
  readonly refreshToken: Maybe<Scalars['String']['output']>;
  readonly webhookUrl: Maybe<Scalars['String']['output']>;
};

export type TDriverInterface = {
  readonly countUndeliveredOrders: Scalars['Int']['output'];
  readonly transportationDeviceUsers: ReadonlyArray<TTransportationDeviceUser>;
  readonly usedTransportationDevice: Maybe<TTransportationDeviceUser>;
  readonly userDeliveringOrders: ReadonlyArray<TUserDeliveringOrder>;
};


export type TDriverInterfaceUserDeliveringOrdersArgs = {
  onlyUndelivered?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * EET certificate informations
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TEetCertificate = {
  readonly __typename?: 'EETCertificate';
  readonly mode: Scalars['String']['output'];
  readonly passphrase: Scalars['String']['output'];
  readonly placeId: Scalars['Int']['output'];
  readonly privateKey: Scalars['String']['output'];
  readonly rootCertificate: Scalars['String']['output'];
};

/**
 * EET receipt
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TEetType = {
  readonly __typename?: 'EETType';
  readonly bkp: Scalars['String']['output'];
  readonly fik: Maybe<Scalars['String']['output']>;
  readonly mode: Scalars['String']['output'];
  readonly pkp: Scalars['String']['output'];
  readonly placeId: Scalars['String']['output'];
  readonly receiptId: Scalars['String']['output'];
  readonly warnings: ReadonlyArray<Scalars['String']['output']>;
};

/** Holds information about email and its description */
export type TEmail = {
  readonly __typename?: 'Email';
  /** is contact method default one */
  readonly default: Scalars['Boolean']['output'];
  readonly description: Maybe<Scalars['String']['output']>;
  readonly email: Scalars['String']['output'];
};

/**
 * Status of external delivery request
 *
 *
 * INDEX: [admin, request_external_driver, super_admin, support]
 *
 * READ: [admin, request_external_driver, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TExternalDelivery = {
  readonly __typename?: 'ExternalDelivery';
  readonly errorMessage: Maybe<Scalars['String']['output']>;
  readonly externalDeliveryProvider: TExternalDeliveryProvider;
  readonly externalDeliveryState: TExternalDeliveryState;
  readonly externalIdentifier: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly order: TOrder;
  readonly orderNumber: Maybe<Scalars['String']['output']>;
  readonly seen: Scalars['Boolean']['output'];
};

/** Estimated pickup, delivery times and estimated delivery fee */
export type TExternalDeliveryEstimate = {
  readonly __typename?: 'ExternalDeliveryEstimate';
  readonly courierEtaDelivery: Maybe<Scalars['DateTime']['output']>;
  readonly courierEtaPickup: Maybe<Scalars['DateTime']['output']>;
  readonly errorMessage: Maybe<Scalars['String']['output']>;
  readonly estimatedDeliveryFee: Maybe<TPriceConverted>;
  readonly rawErrorMessage: Maybe<Scalars['String']['output']>;
};

/**
 * Possible ExternalDeliveryProvider types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TExternalDeliveryProvider = {
  readonly __typename?: 'ExternalDeliveryProvider';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TExternalDeliveryProviderEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** ExternalDeliveryProvider enum */
export type TExternalDeliveryProviderEnum =
  | 'FOODORA_GO'
  | 'WOLT';

/**
 * Possible ExternalDeliveryState types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TExternalDeliveryState = {
  readonly __typename?: 'ExternalDeliveryState';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TExternalDeliveryStateEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** ExternalDeliveryState enum */
export type TExternalDeliveryStateEnum =
  | 'ACCEPTED'
  | 'CANCELED'
  | 'FINISHED'
  | 'REJECTED'
  | 'REQUESTED';

/** Subscription of external deliveries statuses */
export type TExternalDeliveryUpdateSubscription = {
  readonly __typename?: 'ExternalDeliveryUpdateSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly externalDelivery: Maybe<TExternalDelivery>;
  readonly id: Scalars['ID']['output'];
};

/** ExtraFee graphql model */
export type TExtraFee = {
  readonly __typename?: 'ExtraFee';
  readonly code: TExtraFeeType;
  readonly name: Scalars['String']['output'];
  readonly price: TPriceConverted;
};

/** Possible extra fees */
export type TExtraFeeType =
  | 'DAME_JIDLO_FEE';

/**
 * Possible FieldState types
 *
 *
 * INDEX: [admin, editor, super_admin, support, user]
 *
 * READ: [admin, editor, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TFieldState = {
  readonly __typename?: 'FieldState';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TFieldStateEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** FieldState enum */
export type TFieldStateEnum =
  | 'DEFAULT'
  | 'DISABLED'
  | 'ENABLED';

/** Possible file formats for export */
export type TFileReportFormat =
  | 'CSV'
  | 'XLS';

/**
 * Possible FileReportType types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TFileReportType = {
  readonly __typename?: 'FileReportType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TFileReportTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** FileReportType enum */
export type TFileReportTypeEnum =
  | 'CSV_DAILY_VAT'
  | 'CSV_EXTERNAL_DELIVERIES_FOODORA_GO'
  | 'CSV_EXTERNAL_DELIVERIES_WOLT_DRIVE'
  | 'CSV_INCOMING_CALL'
  | 'CSV_ORDERS_DETAILS'
  | 'CSV_SALES'
  | 'CSV_STOCK_MANIPULATIONS'
  | 'XLS_DAILY_VAT'
  | 'XLS_EXTERNAL_DELIVERIES_FOODORA_GO'
  | 'XLS_EXTERNAL_DELIVERIES_WOLT_DRIVE'
  | 'XLS_INCOMING_CALL'
  | 'XLS_ORDERS_DETAILS'
  | 'XLS_SALES'
  | 'XLS_STOCK_MANIPULATIONS';

/**
 * Schema of financial report of associated objects
 *
 *
 * INDEX: [accountant, admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [accountant, admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_financial_report, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_financial_report, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TFinancialReport = {
  readonly __typename?: 'FinancialReport';
  readonly categoryData: ReadonlyArray<TStatisticsCategory>;
  readonly data: ReadonlyArray<TStatisticsDelivery>;
  readonly deliveryZoneData: ReadonlyArray<TStatisticsDeliveryZone>;
  readonly discountData: ReadonlyArray<TStatisticsDiscount>;
  readonly id: Scalars['ID']['output'];
  readonly plainData: Scalars['String']['output'];
  readonly reportDatetime: Scalars['DateTime']['output'];
  readonly reportSequence: Scalars['Int']['output'];
  readonly sectorRecipesData: TStatisticsSectorRecipe;
};

export type TFinishedOrder = TOnlinePaymentGatesInterface & {
  readonly __typename?: 'FinishedOrder';
  readonly csobUrl: Maybe<Scalars['String']['output']>;
  readonly gopayUrl: Maybe<Scalars['String']['output']>;
  readonly gpWebpayUrl: Maybe<Scalars['String']['output']>;
  readonly order: TOrder;
  readonly payFastUrl: Maybe<Scalars['String']['output']>;
  readonly payuUrl: Maybe<Scalars['String']['output']>;
  /** errors which we should display to user */
  readonly userErrors: ReadonlyArray<Scalars['String']['output']>;
};

export type TFlagAttributesInterface = {
  /** was it non registered user who made order */
  readonly isAnonymous: Scalars['Boolean']['output'];
  /** can user cancel current order */
  readonly isCancelable: Scalars['Boolean']['output'];
  /** is current order finalized */
  readonly isFinalized: Scalars['Boolean']['output'];
  /** is current order partially finalized */
  readonly isPartiallyFinalized: Scalars['Boolean']['output'];
  /** is current order marked as high priority */
  readonly isPriority: Scalars['Boolean']['output'];
};

/** Geographic coordinates */
export type TGeoPoint = {
  readonly __typename?: 'GeoPoint';
  readonly latitude: Scalars['Float']['output'];
  readonly longitude: Scalars['Float']['output'];
};

/** Gps position with timestamp */
export type TGeoPositionWithTimestamp = {
  readonly __typename?: 'GeoPositionWithTimestamp';
  readonly geoPosition: TGeoPoint;
  readonly timestamp: Scalars['DateTime']['output'];
};

export type TGraphicStyle = {
  readonly __typename?: 'GraphicStyle';
  readonly active: Scalars['String']['output'];
  readonly applicationStyles: Scalars['String']['output'];
  readonly backgroundCart: Scalars['String']['output'];
  readonly headerImage: Scalars['String']['output'];
  readonly main: Scalars['String']['output'];
  readonly mainSecondary: Scalars['String']['output'];
  readonly owner: Scalars['Boolean']['output'];
  readonly storeLogo: Scalars['String']['output'];
  readonly storeLogoMobile: Scalars['String']['output'];
};


export type TGraphicStyleBackgroundCartArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type TGraphicStyleHeaderImageArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type TGraphicStyleStoreLogoArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type TGraphicStyleStoreLogoMobileArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Group (workplace) for recipes
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TGroup = {
  readonly __typename?: 'Group';
  readonly code: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly label: Scalars['String']['output'];
};

/** Brief information about imported order */
export type TImportedOrder = {
  readonly __typename?: 'ImportedOrder';
  /** errors of import */
  readonly error: Maybe<Scalars['String']['output']>;
  readonly id: Maybe<Scalars['ID']['output']>;
  /** invoice sequence of cash_box */
  readonly invoiceSequenceCashBox: Scalars['Int']['output'];
  /** status of order import */
  readonly success: Scalars['Boolean']['output'];
};

/** InAppNotification */
export type TInAppNotification = {
  readonly __typename?: 'InAppNotification';
  readonly content: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isRead: Scalars['Boolean']['output'];
  readonly readAt: Maybe<Scalars['DateTime']['output']>;
  readonly title: Scalars['String']['output'];
  readonly url: Maybe<Scalars['String']['output']>;
};

/** The connection type for InAppNotification. */
export type TInAppNotificationConnection = {
  readonly __typename?: 'InAppNotificationConnection';
  /** A list of edges. */
  readonly edges: Maybe<ReadonlyArray<Maybe<TInAppNotificationEdge>>>;
  /** A list of nodes. */
  readonly nodes: Maybe<ReadonlyArray<Maybe<TInAppNotification>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: TPageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TInAppNotificationEdge = {
  readonly __typename?: 'InAppNotificationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: Maybe<TInAppNotification>;
};

/**
 * Holds information about recipe/ware ingredients
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, editor_ingredient, editor_menu, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, editor_ingredient, editor_menu, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_ingredient, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_ingredient, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_ingredient, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TIngredient = {
  readonly __typename?: 'Ingredient';
  readonly id: Scalars['ID']['output'];
  readonly quantity: Scalars['Float']['output'];
  readonly recipe: TRecipe;
  readonly stockItem: TStockItem;
};

export type TInputAddressCreate = {
  readonly addressType: TAddressTypeEnum;
  readonly driverNote?: InputMaybe<Scalars['String']['input']>;
  readonly gps: TInputGeoPointCreate;
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputAddressUpdate = {
  readonly addressType?: InputMaybe<TAddressTypeEnum>;
  readonly driverNote?: InputMaybe<Scalars['String']['input']>;
  readonly gps?: InputMaybe<TInputGeoPointCreate>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

export type TInputAvailabilityCreate = {
  readonly availabilityType?: InputMaybe<TAvailabilityTypeEnum>;
  readonly available?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dateFrom?: InputMaybe<Scalars['Date']['input']>;
  readonly dateTo?: InputMaybe<Scalars['Date']['input']>;
  readonly orderOriginCategories?: InputMaybe<ReadonlyArray<TOrderOriginCategoryEnum>>;
  readonly periodic?: InputMaybe<Scalars['Boolean']['input']>;
  readonly timeFrom?: InputMaybe<Scalars['Time']['input']>;
  readonly timeTo?: InputMaybe<Scalars['Time']['input']>;
  readonly weekDay?: InputMaybe<TWeekDayEnum>;
};

export type TInputAvailabilityUpdate = {
  readonly availabilityType?: InputMaybe<TAvailabilityTypeEnum>;
  readonly available?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dateFrom?: InputMaybe<Scalars['Date']['input']>;
  readonly dateTo?: InputMaybe<Scalars['Date']['input']>;
  readonly orderOriginCategories?: InputMaybe<ReadonlyArray<TOrderOriginCategoryEnum>>;
  readonly periodic?: InputMaybe<Scalars['Boolean']['input']>;
  readonly timeFrom?: InputMaybe<Scalars['Time']['input']>;
  readonly timeTo?: InputMaybe<Scalars['Time']['input']>;
  readonly weekDay?: InputMaybe<TWeekDayEnum>;
};

export type TInputBoardFeaturesCreate = {
  readonly allergensEnabled: Scalars['Boolean']['input'];
  readonly infoMessageEnabled: Scalars['Boolean']['input'];
  readonly infoMessagePrimary?: InputMaybe<Scalars['String']['input']>;
  readonly infoMessageSecondary?: InputMaybe<Scalars['String']['input']>;
  readonly logoEnabled: Scalars['Boolean']['input'];
  readonly promoCategory?: InputMaybe<Scalars['ID']['input']>;
  readonly promoEnabled: Scalars['Boolean']['input'];
  readonly titleEnabled: Scalars['Boolean']['input'];
  readonly titleText?: InputMaybe<Scalars['String']['input']>;
  readonly titleUrl?: InputMaybe<Scalars['String']['input']>;
};

export type TInputBoardFeaturesUpdate = {
  readonly allergensEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly infoMessageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly logoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly promoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly titleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TInputBoardTemplateFeaturesIndex = {
  readonly allergens?: InputMaybe<Scalars['Boolean']['input']>;
  readonly availableColors?: InputMaybe<Scalars['Int']['input']>;
  readonly infoMessage?: InputMaybe<Scalars['Boolean']['input']>;
  readonly logo?: InputMaybe<Scalars['Boolean']['input']>;
  readonly promo?: InputMaybe<Scalars['Boolean']['input']>;
  readonly screenTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TInputBusinessHourCreate = {
  readonly closeAt: Scalars['Time']['input'];
  readonly openAt: Scalars['Time']['input'];
  readonly smsLabel?: InputMaybe<TInputLabelCreate>;
  readonly webLabel?: InputMaybe<TInputLabelCreate>;
  readonly weekDay: TWeekDayEnum;
};

export type TInputBusinessHourSpecificCloseCreate = {
  readonly closedNote?: InputMaybe<Scalars['String']['input']>;
  /** close for defined interval in minutes */
  readonly closingInterval: Scalars['Int']['input'];
  readonly companyBranchId: Scalars['ID']['input'];
};

export type TInputBusinessHourSpecificDateCreate = {
  readonly closeAt?: InputMaybe<Scalars['Time']['input']>;
  readonly closed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly closedNote?: InputMaybe<Scalars['String']['input']>;
  readonly companyBranch: Scalars['ID']['input'];
  readonly openAt?: InputMaybe<Scalars['Time']['input']>;
  readonly smsLabel?: InputMaybe<TInputLabelCreate>;
  readonly specificDate: Scalars['Date']['input'];
  readonly type?: InputMaybe<TBusinessHoursTypeEnum>;
  readonly webLabel?: InputMaybe<TInputLabelCreate>;
};

export type TInputCashBoxLogTerminalEvent = {
  readonly message: Scalars['String']['input'];
  readonly terminalUuid: Scalars['String']['input'];
  readonly timestamp: Scalars['DateTime']['input'];
};

export type TInputCompanyBranchCreate = {
  readonly brand: Scalars['ID']['input'];
  readonly currencies?: InputMaybe<ReadonlyArray<TCurrencyEnum>>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly internalNumber: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
};

export type TInputCompanyBranchRecipeUpdate = {
  readonly bistroId?: InputMaybe<Scalars['ID']['input']>;
  readonly dotykackaId?: InputMaybe<Scalars['ID']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly soldOut?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TInputCompanyBranchUserDriverSetting = {
  readonly driverSmsText?: InputMaybe<Scalars['String']['input']>;
  readonly orderAssignmentTypes?: InputMaybe<ReadonlyArray<TUserDeliveringOrdersAssignmentTypeEnum>>;
};

export type TInputCompanyBranchUserUpdate = {
  readonly deleted?: InputMaybe<Scalars['Boolean']['input']>;
  readonly driverSetting?: InputMaybe<TInputCompanyBranchUserDriverSetting>;
};

export type TInputCompanyBranchWareCategoryUpdate = {
  readonly dotykackaId?: InputMaybe<Scalars['ID']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id: Scalars['ID']['input'];
};

export type TInputCompanyCreate = {
  readonly account: Scalars['String']['input'];
  readonly companyType: TCompanyTypeEnum;
  readonly internalNumber?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly number: Scalars['String']['input'];
  readonly vatIdent: Scalars['String']['input'];
};

export type TInputConsentOrderCreate = {
  readonly consent: Scalars['ID']['input'];
  readonly order: Scalars['ID']['input'];
};

export type TInputCurrencyCreate = {
  readonly currency?: InputMaybe<TCurrencyEnum>;
  readonly value: Scalars['Float']['input'];
};

export type TInputCustomerCreate = {
  readonly emails?: InputMaybe<ReadonlyArray<TInputEmailCreate>>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly phones?: InputMaybe<ReadonlyArray<TInputPhoneCreate>>;
};

export type TInputEmailCreate = {
  readonly default?: InputMaybe<Scalars['Boolean']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
};

export type TInputExternalOrderCreate = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly cancelUnpaid?: InputMaybe<Scalars['Boolean']['input']>;
  readonly companyBranch: Scalars['ID']['input'];
  readonly customer?: InputMaybe<TInputCustomerCreate>;
  readonly deliverAt: Scalars['DateTime']['input'];
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  readonly gps?: InputMaybe<TInputGeoPointCreate>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly orderOrigin: TOrderOriginEnum;
  readonly orderRecipes?: InputMaybe<ReadonlyArray<TInputOrderRecipeCreates>>;
  readonly warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};

export type TInputFeeStatistics = {
  readonly branches: ReadonlyArray<Scalars['ID']['input']>;
  readonly country?: InputMaybe<TCountryEnum>;
  readonly months: ReadonlyArray<TMonthAndYear>;
  readonly operatingCostTypes?: InputMaybe<ReadonlyArray<TOperatingCostTypeEnum>>;
  readonly orderOrigins?: InputMaybe<ReadonlyArray<TOrderOriginEnum>>;
};

export type TInputFileUpdate = {
  readonly delete?: InputMaybe<Scalars['Boolean']['input']>;
  readonly file?: InputMaybe<Scalars['InputFile']['input']>;
};

export type TInputGeoPointCreate = {
  readonly latitude: Scalars['Float']['input'];
  readonly longitude: Scalars['Float']['input'];
};

export type TInputIngredientCreate = {
  readonly quantity: Scalars['Float']['input'];
  readonly recipe: Scalars['ID']['input'];
  readonly stockItem: Scalars['ID']['input'];
};

export type TInputKioskEventLog = {
  readonly message: Scalars['String']['input'];
  readonly terminalUuid: Scalars['String']['input'];
  readonly timestamp: Scalars['DateTime']['input'];
};

export type TInputLabelCreate = {
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly translations: ReadonlyArray<TInputLabelTranslation>;
};

export type TInputLabelTranslation = {
  readonly content: Scalars['String']['input'];
  readonly language: TLanguageEnum;
};

export type TInputLabelUpdate = {
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly translations?: InputMaybe<ReadonlyArray<TInputLabelTranslation>>;
};

export type TInputLocationCreate = {
  readonly tableNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputLocationIndex = {
  readonly tableNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputNotificationCreate = {
  readonly chrome?: InputMaybe<Scalars['Json']['input']>;
  readonly firebase?: InputMaybe<Scalars['Json']['input']>;
  readonly sms?: InputMaybe<Scalars['String']['input']>;
};

export type TInputOccasionCreate = {
  readonly companyBranch: Scalars['ID']['input'];
  /** Date when occasion begins */
  readonly dateFrom: Scalars['DateTime']['input'];
  /** Date when occasions ends */
  readonly dateTo: Scalars['DateTime']['input'];
  readonly image?: InputMaybe<Scalars['InputFile']['input']>;
  /** Beginning of preorder */
  readonly preorderFrom: Scalars['DateTime']['input'];
  /** End of preorder */
  readonly preorderTo: Scalars['DateTime']['input'];
  readonly title: Scalars['String']['input'];
  /** Short title for mobile view */
  readonly titleShort: Scalars['String']['input'];
};

export type TInputOccasionUpdate = {
  /** Date when occasion begins */
  readonly dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date when occasions ends */
  readonly dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  readonly image?: InputMaybe<TInputRecipeImage>;
  /** Beginning of preorder */
  readonly preorderFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** End of preorder */
  readonly preorderTo?: InputMaybe<Scalars['DateTime']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** Short title for mobile view */
  readonly titleShort?: InputMaybe<Scalars['String']['input']>;
};

export type TInputOrderCreate = {
  /** Argument is not required for STAFF orders. Also we try to reverse geocode GPS to address, thus argument may be blank. */
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly callEventId?: InputMaybe<Scalars['ID']['input']>;
  readonly cashBox?: InputMaybe<Scalars['ID']['input']>;
  readonly companyBranch: Scalars['ID']['input'];
  readonly customer: TInputCustomerCreate;
  readonly deliverAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly deliverySlot?: InputMaybe<Scalars['ID']['input']>;
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  /** Optional for INHOUSE-PICKUP order and for MESSENGER delivering orders associated with Sector, which has defines its GPS. */
  readonly gps?: InputMaybe<TInputGeoPointCreate>;
  readonly language?: InputMaybe<TLanguageEnum>;
  readonly location?: InputMaybe<TInputLocationCreate>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly notification?: InputMaybe<TInputNotificationCreate>;
  readonly occasion?: InputMaybe<Scalars['ID']['input']>;
  readonly orderOrigin: TOrderOriginEnum;
  readonly resolvedAddress?: InputMaybe<TInputOrderResolvedAddressType>;
  readonly sector?: InputMaybe<Scalars['ID']['input']>;
  readonly warePriceType: TWarePriceTypeEnum;
};

export type TInputOrderDeliveryCreate = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly brand?: InputMaybe<Scalars['ID']['input']>;
  readonly companyBranch?: InputMaybe<Scalars['ID']['input']>;
  readonly deliverySlot?: InputMaybe<Scalars['ID']['input']>;
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  readonly gps: TInputGeoPointCreate;
  readonly orderOrigin: TOrderOriginEnum;
};

export type TInputOrderFinish = {
  readonly cancelUrl?: InputMaybe<Scalars['String']['input']>;
  readonly confirmedAgreements?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly customer?: InputMaybe<TInputCustomerCreate>;
  /** Preferred time of order delivery. In case that argument is null, deliver_at value is computed based on branch opening hours and default delivery times */
  readonly deliverAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly deliverySlot?: InputMaybe<Scalars['ID']['input']>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  /** payment gate used to finalize order */
  readonly paymentGate?: InputMaybe<TPaymentGateEnum>;
  /** payment type used to finalize order */
  readonly paymentMethod?: InputMaybe<TPaymentTypeEnum>;
  /** id of payment method  used to finalize order */
  readonly paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  readonly returnUrl?: InputMaybe<Scalars['String']['input']>;
  /** percentage value of tips */
  readonly tips?: InputMaybe<Scalars['Float']['input']>;
};

export type TInputOrderGroupCreate = {
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly orderGroupColor?: InputMaybe<Scalars['ID']['input']>;
  readonly orders: ReadonlyArray<Scalars['ID']['input']>;
};

export type TInputOrderGroupUpdate = {
  readonly addedOrders?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly id: Scalars['ID']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly orderGroupColor?: InputMaybe<Scalars['ID']['input']>;
  readonly removedOrders?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly updatedOrders?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type TInputOrderIndex = {
  readonly companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly currency?: InputMaybe<TCurrencyEnum>;
  readonly groups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly includeOldFinished?: InputMaybe<Scalars['Boolean']['input']>;
  readonly location?: InputMaybe<TInputLocationIndex>;
  readonly occasions?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly orderStateCategoriesOR?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  readonly orderStateCategoryTarget?: InputMaybe<TOrderStateCategoryTargetEnum>;
  readonly orderStatesAND?: InputMaybe<ReadonlyArray<TOrderStateEnum>>;
  readonly orderStatesOR?: InputMaybe<ReadonlyArray<TOrderStateEnum>>;
  readonly sectors?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sectorsWithChildren?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return only records changed after argument value. */
  readonly stateChangeSince?: InputMaybe<Scalars['DateTime']['input']>;
  readonly user?: InputMaybe<Scalars['ID']['input']>;
};

export type TInputOrderPaymentMethodCreate = {
  readonly order: Scalars['ID']['input'];
  readonly paymentMethod: Scalars['ID']['input'];
  readonly price: TInputCurrencyCreate;
};

export type TInputOrderPaymentMethodUpdate = {
  readonly paymentMethodId: Scalars['ID']['input'];
  readonly price: TInputCurrencyCreate;
};

export type TInputOrderPaymentMethodsCreate = {
  readonly paymentGate: TPaymentGateEnum;
  readonly paymentType: TPaymentTypeEnum;
  readonly price: TInputCurrencyCreate;
};

export type TInputOrderPickupCreate = {
  readonly companyBranch: Scalars['ID']['input'];
  readonly deliverySlot?: InputMaybe<Scalars['ID']['input']>;
  readonly orderOrigin: TOrderOriginEnum;
};

export type TInputOrderRatingCreate = {
  readonly orderRatingType: TOrderRatingTypeEnum;
  readonly text?: InputMaybe<Scalars['String']['input']>;
  readonly value?: InputMaybe<Scalars['Int']['input']>;
};

export type TInputOrderRecipeCreate = {
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  readonly associatedRecipes?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly order: Scalars['ID']['input'];
  readonly orderRecipeState?: InputMaybe<TOrderRecipeStateEnum>;
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  readonly promoTag?: InputMaybe<TPromoTagEnum>;
  readonly recipe: Scalars['ID']['input'];
  readonly sideDishRecipes?: InputMaybe<ReadonlyArray<TInputOrderRecipeSideDishCreate>>;
  readonly sideDishes?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly wareCategory?: InputMaybe<Scalars['ID']['input']>;
};

export type TInputOrderRecipeCreates = {
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  readonly associatedRecipes?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly recipe: Scalars['ID']['input'];
  readonly sideDishRecipes?: InputMaybe<ReadonlyArray<TInputOrderRecipeSideDishCreate>>;
  readonly sideDishes?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type TInputOrderRecipeSideDishCreate = {
  readonly categoryId: Scalars['ID']['input'];
  readonly recipeId: Scalars['ID']['input'];
};

export type TInputOrderRecipeSideDishUpdate = {
  readonly categoryId: Scalars['ID']['input'];
  readonly recipeId: Scalars['ID']['input'];
};

export type TInputOrderRecipeUpdate = {
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly order?: InputMaybe<Scalars['ID']['input']>;
  readonly orderRecipeState?: InputMaybe<TOrderRecipeStateEnum>;
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  readonly recipe?: InputMaybe<Scalars['ID']['input']>;
  readonly sideDishRecipes?: InputMaybe<ReadonlyArray<TInputOrderRecipeSideDishUpdate>>;
  readonly sideDishes?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type TInputOrderResolvedAddressType = {
  readonly city?: InputMaybe<Scalars['String']['input']>;
  readonly country?: InputMaybe<Scalars['String']['input']>;
  readonly houseNumber?: InputMaybe<Scalars['String']['input']>;
  readonly postCode?: InputMaybe<Scalars['String']['input']>;
  readonly state?: InputMaybe<Scalars['String']['input']>;
  readonly street?: InputMaybe<Scalars['String']['input']>;
  readonly venue?: InputMaybe<Scalars['String']['input']>;
};

export type TInputOrderStaffImport = {
  readonly acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly acceptedAtRaw?: InputMaybe<Scalars['String']['input']>;
  readonly canceled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly companyBranch: Scalars['ID']['input'];
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  readonly fik?: InputMaybe<Scalars['String']['input']>;
  readonly forceFinish?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly invoice: Scalars['String']['input'];
  readonly invoiceNumber: Scalars['Int']['input'];
  readonly orderRecipes: ReadonlyArray<TInputOrderRecipeCreates>;
  readonly paymentMethods: ReadonlyArray<TInputOrderPaymentMethodsCreate>;
  readonly recipePrices?: InputMaybe<ReadonlyArray<TInputRecipePriceCashBox>>;
  readonly sector?: InputMaybe<Scalars['ID']['input']>;
  readonly totalDiscount?: InputMaybe<TInputCurrencyCreate>;
  readonly warePriceType: TWarePriceTypeEnum;
};

export type TInputOrderStaffPosCreate = {
  /** Argument is not reguired for STAFF orders. Also we try to reverse geocode GPS to address, thus argument may be blank. */
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly callEventId?: InputMaybe<Scalars['ID']['input']>;
  readonly companyBranch: Scalars['ID']['input'];
  readonly customer: TInputCustomerCreate;
  readonly deliverAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly deliverySlot?: InputMaybe<Scalars['ID']['input']>;
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  /** Optional for INHOUSE-PICKUP order and for MESSENGER delivering orders associateg with Sector, which has defines its GPS. */
  readonly gps?: InputMaybe<TInputGeoPointCreate>;
  readonly language?: InputMaybe<TLanguageEnum>;
  readonly location?: InputMaybe<TInputLocationCreate>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly notification?: InputMaybe<TInputNotificationCreate>;
  readonly occasion?: InputMaybe<Scalars['ID']['input']>;
  readonly sector?: InputMaybe<Scalars['ID']['input']>;
  readonly warePriceType: TWarePriceTypeEnum;
};

export type TInputOrderUpdate = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly companyBranch?: InputMaybe<Scalars['ID']['input']>;
  readonly customer?: InputMaybe<TInputCustomerCreate>;
  readonly deliverAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly deliverySlot?: InputMaybe<Scalars['ID']['input']>;
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  readonly gps?: InputMaybe<TInputGeoPointCreate>;
  readonly language?: InputMaybe<TLanguageEnum>;
  readonly location?: InputMaybe<TInputLocationCreate>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly notification?: InputMaybe<TInputNotificationCreate>;
  readonly orderGroup?: InputMaybe<Scalars['ID']['input']>;
  readonly resolvedAddress?: InputMaybe<TInputOrderResolvedAddressType>;
  /** percentage value of tips */
  readonly tips?: InputMaybe<Scalars['Float']['input']>;
  readonly warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};

export type TInputOrderWifiCreate = {
  readonly companyBranch: Scalars['ID']['input'];
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  readonly occasion?: InputMaybe<Scalars['ID']['input']>;
  readonly orderOrigin: TOrderOriginEnum;
  readonly sector?: InputMaybe<Scalars['ID']['input']>;
  readonly warePriceType: TWarePriceTypeEnum;
};

export type TInputPaginationParams = {
  readonly fromIndex: Scalars['Int']['input'];
  readonly toIndex: Scalars['Int']['input'];
};

export type TInputPaymentMethodIndex = {
  readonly companyBranch: Scalars['ID']['input'];
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly orderOrigin: TOrderOriginEnum;
  readonly paymentGate: TPaymentGateEnum;
  readonly paymentType: TPaymentTypeEnum;
  readonly warePriceType: TWarePriceTypeEnum;
};

export type TInputPhoneCreate = {
  readonly default?: InputMaybe<Scalars['Boolean']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly phone: Scalars['String']['input'];
};

export type TInputPromoCodeIndex = {
  readonly brand?: InputMaybe<Scalars['ID']['input']>;
  readonly companyBranch?: InputMaybe<Scalars['ID']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TInputRecipeCreate = {
  readonly ageControl?: InputMaybe<Scalars['Boolean']['input']>;
  readonly associatedRecipes?: InputMaybe<ReadonlyArray<TInputRecipeRelationCreate>>;
  readonly availabilities?: InputMaybe<ReadonlyArray<TInputAvailabilityCreate>>;
  readonly bistroId?: InputMaybe<Scalars['ID']['input']>;
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly companyBranch: Scalars['ID']['input'];
  readonly descriptionLabel?: InputMaybe<Scalars['String']['input']>;
  readonly dotykackaId?: InputMaybe<Scalars['ID']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly groups: ReadonlyArray<Scalars['ID']['input']>;
  readonly image?: InputMaybe<Scalars['InputFile']['input']>;
  readonly ingredients?: InputMaybe<ReadonlyArray<TInputRecipeIngredient>>;
  readonly internalNote?: InputMaybe<Scalars['String']['input']>;
  readonly isCombinationMeal?: InputMaybe<Scalars['Boolean']['input']>;
  readonly nameLabel?: InputMaybe<Scalars['String']['input']>;
  readonly pictogram?: InputMaybe<Scalars['String']['input']>;
  readonly prices: ReadonlyArray<TInputRecipePriceCreate>;
  readonly primaryWareCategory?: InputMaybe<Scalars['ID']['input']>;
  readonly recipeColor?: InputMaybe<Scalars['ID']['input']>;
  readonly recipeTags?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sideDishCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly soldOut?: InputMaybe<Scalars['Boolean']['input']>;
  readonly translations?: InputMaybe<ReadonlyArray<TInputRecipeTranslation>>;
  readonly video?: InputMaybe<Scalars['String']['input']>;
  readonly ware?: InputMaybe<Scalars['ID']['input']>;
  readonly wareCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly wareCategoryType: TWareCategoryTypeEnum;
};

export type TInputRecipeImage = {
  readonly delete: Scalars['Boolean']['input'];
  readonly file?: InputMaybe<Scalars['InputFile']['input']>;
};

export type TInputRecipeIngredient = {
  readonly quantity: Scalars['Float']['input'];
  readonly stockItem: Scalars['ID']['input'];
};

export type TInputRecipePriceCashBox = {
  readonly price: TInputCurrencyCreate;
  readonly recipe: Scalars['ID']['input'];
};

export type TInputRecipePriceCreate = {
  readonly price: TInputCurrencyCreate;
  readonly vat: Scalars['ID']['input'];
  readonly warePriceType: TWarePriceTypeEnum;
};

export type TInputRecipeRelationCreate = {
  readonly associatedRecipe: Scalars['ID']['input'];
  readonly warePriceType: TWarePriceTypeEnum;
};

export type TInputRecipeTagCreate = {
  readonly color?: InputMaybe<Scalars['String']['input']>;
  readonly company: Scalars['ID']['input'];
  readonly image?: InputMaybe<Scalars['InputFile']['input']>;
  readonly pictogram?: InputMaybe<Scalars['String']['input']>;
  readonly systemRecipeTag: Scalars['ID']['input'];
  readonly translations?: InputMaybe<ReadonlyArray<TInputRecipeTagTranslation>>;
};

export type TInputRecipeTagImage = {
  readonly delete?: InputMaybe<Scalars['Boolean']['input']>;
  readonly file?: InputMaybe<Scalars['InputFile']['input']>;
};

export type TInputRecipeTagTranslation = {
  readonly label?: InputMaybe<Scalars['String']['input']>;
  readonly language: TLanguageEnum;
};

export type TInputRecipeTagUpdate = {
  readonly color?: InputMaybe<Scalars['String']['input']>;
  readonly company?: InputMaybe<Scalars['ID']['input']>;
  readonly deleteLabel?: InputMaybe<Scalars['Boolean']['input']>;
  readonly image?: InputMaybe<TInputRecipeTagImage>;
  readonly pictogram?: InputMaybe<Scalars['String']['input']>;
  readonly systemRecipeTag?: InputMaybe<Scalars['ID']['input']>;
  readonly translations?: InputMaybe<ReadonlyArray<TInputRecipeTagTranslation>>;
};

export type TInputRecipeTranslation = {
  readonly descriptionLabel?: InputMaybe<Scalars['String']['input']>;
  readonly language: TLanguageEnum;
  readonly nameLabel?: InputMaybe<Scalars['String']['input']>;
};

export type TInputRecipeUpdate = {
  readonly ageControl?: InputMaybe<Scalars['Boolean']['input']>;
  readonly associatedRecipes?: InputMaybe<ReadonlyArray<TInputRecipeRelationCreate>>;
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly descriptionLabel?: InputMaybe<Scalars['String']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly groups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly image?: InputMaybe<TInputRecipeImage>;
  readonly ingredients?: InputMaybe<ReadonlyArray<TInputRecipeIngredient>>;
  readonly internalNote?: InputMaybe<Scalars['String']['input']>;
  readonly isCombinationMeal?: InputMaybe<Scalars['Boolean']['input']>;
  readonly nameLabel?: InputMaybe<Scalars['String']['input']>;
  readonly pictogram?: InputMaybe<Scalars['String']['input']>;
  readonly prices?: InputMaybe<ReadonlyArray<TInputRecipePriceCreate>>;
  readonly primaryWareCategory?: InputMaybe<Scalars['ID']['input']>;
  readonly recipeColor?: InputMaybe<Scalars['ID']['input']>;
  readonly recipeTags?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sideDishCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly soldOut?: InputMaybe<Scalars['Boolean']['input']>;
  readonly translations?: InputMaybe<ReadonlyArray<TInputRecipeTranslation>>;
  readonly video?: InputMaybe<Scalars['String']['input']>;
  readonly ware?: InputMaybe<Scalars['ID']['input']>;
  readonly wareCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type TInputSectorCreate = {
  readonly availabilities?: InputMaybe<ReadonlyArray<TInputAvailabilityCreate>>;
  readonly code: Scalars['String']['input'];
  readonly companyBranch: Scalars['ID']['input'];
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  readonly disabledWareCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly eetEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enabledWareCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly gps?: InputMaybe<TInputGeoPointCreate>;
  readonly nameLabel: Scalars['String']['input'];
  readonly orderDelaySeconds?: InputMaybe<Scalars['Int']['input']>;
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  readonly sectorType: TSectorTypeEnum;
  readonly warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};

export type TInputSectorRecipeCreate = {
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  readonly associatedRecipes?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  readonly recipe: Scalars['ID']['input'];
  readonly sector: Scalars['ID']['input'];
  readonly sideDishes?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};

export type TInputSectorTranslation = {
  readonly language: TLanguageEnum;
  readonly nameLabel?: InputMaybe<Scalars['String']['input']>;
};

export type TInputSectorUpdate = {
  readonly availabilities?: InputMaybe<ReadonlyArray<TInputAvailabilityCreate>>;
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly companyBranch?: InputMaybe<Scalars['ID']['input']>;
  readonly deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  readonly disabledWareCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly eetEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enabledWareCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly gps?: InputMaybe<TInputGeoPointCreate>;
  readonly id: Scalars['ID']['input'];
  readonly orderDelaySeconds?: InputMaybe<Scalars['Int']['input']>;
  readonly parent?: InputMaybe<Scalars['ID']['input']>;
  readonly sectorType?: InputMaybe<TSectorTypeEnum>;
  readonly translations?: InputMaybe<ReadonlyArray<TInputSectorTranslation>>;
  readonly warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};

export type TInputShiftCreate = {
  readonly beginAt: Scalars['DateTime']['input'];
  readonly capacity?: InputMaybe<Scalars['Int']['input']>;
  readonly companyBranch: Scalars['ID']['input'];
  readonly endAt: Scalars['DateTime']['input'];
  readonly placeCode: Scalars['String']['input'];
};

export type TInputStatisticCreate = {
  readonly branches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly cashBoxes?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly cashiers?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly country?: InputMaybe<TCountryEnum>;
  readonly customerPhone?: InputMaybe<Scalars['String']['input']>;
  readonly dateFrom?: InputMaybe<Scalars['Date']['input']>;
  readonly dateTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  readonly dateTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  readonly dateTo?: InputMaybe<Scalars['Date']['input']>;
  readonly drivers?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly hasRating?: InputMaybe<Scalars['Boolean']['input']>;
  readonly occasions?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly orderOrigins?: InputMaybe<ReadonlyArray<TOrderOriginEnum>>;
  readonly paymentGates?: InputMaybe<ReadonlyArray<TPaymentGateEnum>>;
  readonly sectors?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sectorsWithChildren?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TInputStockInventoryItemUpdate = {
  readonly finalQuantity: Scalars['Float']['input'];
  readonly stockInventoryItemChangeType?: InputMaybe<TStockInventoryItemChangeTypeEnum>;
  readonly stockItemChangeType?: InputMaybe<TStockInventoryItemChangeTypeEnum>;
};

export type TInputStockItemCreate = {
  readonly allergens?: InputMaybe<ReadonlyArray<TAllergenEnum>>;
  readonly allowNegative: TFieldStateEnum;
  readonly code: Scalars['String']['input'];
  readonly companyBranch: Scalars['ID']['input'];
  readonly label: Scalars['String']['input'];
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly plu?: InputMaybe<Scalars['String']['input']>;
  readonly price?: InputMaybe<Scalars['Float']['input']>;
  readonly quantity?: InputMaybe<Scalars['Float']['input']>;
  readonly wareUnit: TWareUnitEnum;
};

export type TInputStockItemUpdate = {
  readonly allergens?: InputMaybe<ReadonlyArray<TAllergenEnum>>;
  readonly allowNegative?: InputMaybe<TFieldStateEnum>;
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly label?: InputMaybe<Scalars['String']['input']>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly plu?: InputMaybe<Scalars['String']['input']>;
  readonly price?: InputMaybe<Scalars['Float']['input']>;
  readonly quantity?: InputMaybe<Scalars['Float']['input']>;
  readonly wareUnit?: InputMaybe<TWareUnitEnum>;
};

export type TInputStockTransferCreate = {
  readonly quantity: Scalars['Float']['input'];
  readonly stockItemId: Scalars['ID']['input'];
};

export type TInputTransportationDeviceCreate = {
  readonly companyBranch: Scalars['ID']['input'];
  readonly deviceState: Scalars['ID']['input'];
  readonly deviceType: Scalars['ID']['input'];
  readonly idNumber: Scalars['String']['input'];
};

export type TInputUserCreate = {
  readonly companyBranches: ReadonlyArray<Scalars['ID']['input']>;
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly language: TLanguageEnum;
  readonly lastName: Scalars['String']['input'];
  readonly login: Scalars['String']['input'];
  readonly phone: Scalars['String']['input'];
  readonly roles: ReadonlyArray<TRoleEnum>;
};

export type TInputUserRegisteredCreate = {
  readonly email: Scalars['String']['input'];
  readonly language: TLanguageEnum;
  readonly password: Scalars['String']['input'];
  /** The absolute URL that the User will visit to confirm the provided email or a relative URL that will be appended to an absolute URL taken from the HTTP referer. */
  readonly returnUrl: Scalars['String']['input'];
  readonly token: Scalars['String']['input'];
};

export type TInputUserUpdate = {
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly language?: InputMaybe<TLanguageEnum>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  readonly roles?: InputMaybe<ReadonlyArray<TRoleEnum>>;
};

export type TInputVamStatus = {
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstname?: InputMaybe<Scalars['String']['input']>;
  readonly lastname?: InputMaybe<Scalars['String']['input']>;
  readonly orderId: Scalars['ID']['input'];
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  readonly user?: InputMaybe<Scalars['ID']['input']>;
};

export type TInputWareCategoryCreate = {
  readonly automaticFinish?: InputMaybe<Scalars['Boolean']['input']>;
  readonly availabilities?: InputMaybe<ReadonlyArray<TInputAvailabilityCreate>>;
  readonly companyBranch: Scalars['ID']['input'];
  readonly descriptionLabel?: InputMaybe<Scalars['String']['input']>;
  readonly dotykackaId?: InputMaybe<Scalars['ID']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly image?: InputMaybe<Scalars['InputFile']['input']>;
  readonly internalNoteLabel?: InputMaybe<Scalars['String']['input']>;
  readonly maxCount?: InputMaybe<Scalars['Int']['input']>;
  readonly maxRecipesCount?: InputMaybe<Scalars['Int']['input']>;
  readonly minCount?: InputMaybe<Scalars['Int']['input']>;
  readonly nameLabel?: InputMaybe<Scalars['String']['input']>;
  readonly orderOriginCategories?: InputMaybe<ReadonlyArray<TOrderOriginCategoryEnum>>;
  readonly pictogram?: InputMaybe<Scalars['String']['input']>;
  readonly promoTags?: InputMaybe<ReadonlyArray<TPromoTagEnum>>;
  readonly public?: InputMaybe<Scalars['Boolean']['input']>;
  readonly recipeTags?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly recipes?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sharedCompanyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly translations?: InputMaybe<ReadonlyArray<TInputWareCategoryTranslation>>;
  readonly wareCategoryColor?: InputMaybe<Scalars['ID']['input']>;
  readonly wareCategoryType: TWareCategoryTypeEnum;
};

export type TInputWareCategoryImage = {
  readonly delete: Scalars['Boolean']['input'];
  readonly file?: InputMaybe<Scalars['InputFile']['input']>;
};

export type TInputWareCategoryTranslation = {
  readonly descriptionLabel?: InputMaybe<Scalars['String']['input']>;
  readonly internalNoteLabel?: InputMaybe<Scalars['String']['input']>;
  readonly language: TLanguageEnum;
  readonly nameLabel?: InputMaybe<Scalars['String']['input']>;
};

export type TInputWareCategoryUpdate = {
  readonly automaticFinish?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly image?: InputMaybe<TInputWareCategoryImage>;
  readonly internalNoteLabel?: InputMaybe<Scalars['String']['input']>;
  readonly maxCount?: InputMaybe<Scalars['Int']['input']>;
  readonly maxRecipesCount?: InputMaybe<Scalars['Int']['input']>;
  readonly minCount?: InputMaybe<Scalars['Int']['input']>;
  readonly nameLabel?: InputMaybe<Scalars['String']['input']>;
  readonly orderOriginCategories?: InputMaybe<ReadonlyArray<TOrderOriginCategoryEnum>>;
  readonly pictogram?: InputMaybe<Scalars['String']['input']>;
  readonly promoTags?: InputMaybe<ReadonlyArray<TPromoTagEnum>>;
  readonly public?: InputMaybe<Scalars['Boolean']['input']>;
  readonly recipeTags?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly recipes?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sharedCompanyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly translations?: InputMaybe<ReadonlyArray<TInputWareCategoryTranslation>>;
  readonly wareCategoryColor?: InputMaybe<Scalars['ID']['input']>;
  readonly wareCategoryType?: InputMaybe<TWareCategoryTypeEnum>;
  readonly wareRequirement?: InputMaybe<TWareRequirementEnum>;
};

export type TInputWareCreate = {
  readonly availabilities?: InputMaybe<ReadonlyArray<TInputAvailabilityCreate>>;
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly companyBranch: Scalars['ID']['input'];
  readonly descriptionLabel: TInputLabelCreate;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly internalCode?: InputMaybe<Scalars['String']['input']>;
  readonly nameLabel: TInputLabelCreate;
};

export type TInputWareUpdate = {
  readonly code?: InputMaybe<Scalars['String']['input']>;
  readonly companyBranch?: InputMaybe<Scalars['ID']['input']>;
  readonly descriptionLabel?: InputMaybe<TInputLabelUpdate>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly internalCode?: InputMaybe<Scalars['String']['input']>;
  readonly nameLabel?: InputMaybe<TInputLabelUpdate>;
};

export type TInputZoneCreate = {
  readonly availabilities?: InputMaybe<ReadonlyArray<TInputAvailabilityCreate>>;
  readonly companyBranch: Scalars['ID']['input'];
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly geoPolygon?: InputMaybe<ReadonlyArray<TInputGeoPointCreate>>;
  readonly minimalOrderPrice?: InputMaybe<TInputCurrencyCreate>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly priceRangeRules?: InputMaybe<ReadonlyArray<TPriceRangeRuleCreate>>;
  readonly zoneColor?: InputMaybe<Scalars['ID']['input']>;
  readonly zoneType?: InputMaybe<TZoneTypeEnum>;
};

export type TInputZoneUpdate = {
  readonly availabilities?: InputMaybe<ReadonlyArray<TInputAvailabilityUpdate>>;
  readonly companyBranch?: InputMaybe<Scalars['ID']['input']>;
  readonly deliveryTimeDeviation?: InputMaybe<Scalars['Int']['input']>;
  readonly enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly geoPolygon?: InputMaybe<ReadonlyArray<TInputGeoPointCreate>>;
  readonly minimalOrderPrice?: InputMaybe<TInputCurrencyCreate>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly priceRangeRules?: InputMaybe<ReadonlyArray<TPriceRangeRuleCreate>>;
  readonly zoneColor?: InputMaybe<Scalars['ID']['input']>;
};

export type TInvoiceSequenceInterface = {
  readonly lastInvoiceSequence: Scalars['Int']['output'];
  readonly lastResettableInvoiceSequence: Scalars['Int']['output'];
};

export type TInvoiceSequencesInterface = {
  /** invoice sequence of company branch */
  readonly invoiceSequence: Maybe<Scalars['String']['output']>;
  /** invoice sequence of cash_box */
  readonly invoiceSequenceCashBox: Maybe<Scalars['Int']['output']>;
  /** resettable invoice sequence of company branch, e.g. queue number */
  readonly invoiceSequenceResettable: Maybe<Scalars['Int']['output']>;
};

/** Address data such as city, street, etc. Often obtained automatically with inconsistent information. */
export type TJsonAddress = {
  readonly __typename?: 'JsonAddress';
  readonly city: Maybe<Scalars['String']['output']>;
  readonly country: Maybe<Scalars['String']['output']>;
  readonly gps: Maybe<TGeoPoint>;
  readonly houseNumber: Maybe<Scalars['String']['output']>;
  readonly original: Maybe<Scalars['String']['output']>;
  readonly postCode: Maybe<Scalars['String']['output']>;
  readonly state: Maybe<Scalars['String']['output']>;
  readonly street: Maybe<Scalars['String']['output']>;
  readonly venue: Maybe<Scalars['String']['output']>;
};

/** Possible information for anonymous user that made order */
export type TJsonCustomer = {
  readonly __typename?: 'JsonCustomer';
  readonly defaultEmail: Maybe<TEmail>;
  readonly defaultPhone: Maybe<TPhone>;
  /** possible emails contacts */
  readonly emails: ReadonlyArray<TEmail>;
  readonly firstName: Maybe<Scalars['String']['output']>;
  readonly lastName: Maybe<Scalars['String']['output']>;
  /** possible phone contacts */
  readonly phones: ReadonlyArray<TPhone>;
  readonly vamAgreements: ReadonlyArray<TVamAgreement>;
};

/** Location of order, for example number of table. */
export type TJsonLocation = {
  readonly __typename?: 'JsonLocation';
  readonly tableNumber: Maybe<Scalars['Int']['output']>;
};

/** Kiosk carousel image */
export type TKioskCarouselImage = {
  readonly __typename?: 'KioskCarouselImage';
  readonly duration: Scalars['Int']['output'];
  readonly imageUrl: Scalars['String']['output'];
};

/** Setting attributes for kiosk styles */
export type TKioskStylesSetting = {
  readonly __typename?: 'KioskStylesSetting';
  readonly carouselImages: ReadonlyArray<TKioskCarouselImage>;
  readonly mainIntroImage: Maybe<Scalars['String']['output']>;
};


/** Setting attributes for kiosk styles */
export type TKioskStylesSettingMainIntroImageArgs = {
  language?: InputMaybe<TLanguageEnum>;
};

/**
 * String description of some attribute - can be localized name, etc.
 *
 *
 * INDEX: [admin, editor_business_hours, editor_label, editor_menu, guest, merchant, super_admin, support, user]
 *
 * READ: [admin, editor_business_hours, editor_label, editor_menu, guest, merchant, super_admin, support, user]
 *
 * CREATE: [admin, editor_label, super_admin, support]
 *
 * UPDATE: [admin, editor_label, editor_menu, super_admin, support]
 *
 * DESTROY: [admin, editor_label, super_admin]
 *
 */
export type TLabel = {
  readonly __typename?: 'Label';
  readonly content: Maybe<Scalars['String']['output']>;
  readonly enabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
};

/**
 * Possible Language types
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TLanguage = {
  readonly __typename?: 'Language';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TLanguageEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** Language enum */
export type TLanguageEnum =
  | 'AF'
  | 'CS'
  | 'DE'
  | 'EN'
  | 'ES'
  | 'FR'
  | 'IT'
  | 'NL'
  | 'PL'
  | 'PT'
  | 'RU'
  | 'SK'
  | 'UK'
  | 'ZU';

export type TLanguageInterface = {
  readonly defaultLanguage: TLanguageEnum;
  readonly supportedLanguages: ReadonlyArray<TLanguageEnum>;
};


export type TLanguageInterfaceSupportedLanguagesArgs = {
  userSpecific?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Setting attributes for company branches mobile application */
export type TMobileApplicationSetting = {
  readonly __typename?: 'MobileApplicationSetting';
  readonly icon: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
};


/** Setting attributes for company branches mobile application */
export type TMobileApplicationSettingIconArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Possible mobile platforms */
export type TMobilePlatformEnum =
  | 'ANDROID'
  | 'IOS'
  | 'PWA';

/** Representation of month in the year */
export type TMonthAndYear = {
  readonly month?: InputMaybe<Scalars['Int']['input']>;
  readonly year?: InputMaybe<Scalars['Int']['input']>;
};

/** The mutation root of this schema */
export type TMutation = {
  readonly __typename?: 'Mutation';
  /**
   * Acknowledge that user seen rejected status of external delivery and unassign driver
   *
   * ALLOWED ROLES: [admin, editor_order, operator, request_external_driver, super_admin]
   *
   */
  readonly acknowledgeExternalDelivery: Maybe<TExternalDelivery>;
  /**
   * Add new allergen to recipe
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_item_allergen, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly addAllergenStockItem: TStockItem;
  /**
   * Add pending wallet credit payment
   *
   * ALLOWED ROLES: [admin, customer, super_admin]
   *
   */
  readonly addCreditsPayment: TCreditsPaymentAdd;
  /**
   * Create order group record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly addItemToOrderGroup: TOrderGroup;
  /**
   * Assign promo code to order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly addOrderPromoCode: TOrderWithErrors;
  /**
   * Add new order state to order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_cancel, customer, driver, editor_order_state_relation, guest, operator, owner_cancel, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly addOrderState: TOrder;
  /**
   * Create business hour record for specific date
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly addSpecialBusinessHour: TBusinessHour;
  /**
   * Close company branch for specific amount of time
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly addSpecialClosingBusinessHours: TCompanyBranch;
  /**
   * Update InAppNotification records
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly bulkUpdateInAppNotifications: ReadonlyArray<TInAppNotification>;
  /**
   * Cancel multiple orders in one request
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_cancel, customer, driver, editor_order_state_relation, guest, operator, owner_cancel, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly cancelOrders: TOrdersBulkCanceledResult;
  /**
   * Login user to appropriate cash box
   *
   * ALLOWED ROLES: [admin, cashier_kiosk, cashier_pos, editor_cash_box, super_admin]
   *
   */
  readonly cashBoxLogTerminalEvent: Scalars['Boolean']['output'];
  /**
   * Login user to appropriate cash box
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly cashBoxLogin: TCashBox;
  /**
   * Logout user from appropriate cash box
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly cashBoxLogout: TCashBox;
  /**
   * Change amount of stock item by defined offset (add or remove)
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly changeAmountStockItem: TStockItem;
  /**
   * Confirm stock item transfer
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly confirmStockItemTransfer: TStockTransfer;
  /**
   * Request a login link to the consents manager app
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, guest, super_admin, supervisor, user]
   *
   */
  readonly consentsAppLink: Scalars['String']['output'];
  /**
   * Create address record for current user
   *
   * ALLOWED ROLES: [admin, customer, editor_address, super_admin, support]
   *
   */
  readonly createAddress: TAddress;
  /**
   * Board create
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createBoard: TBoard;
  /**
   * Board screen create
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createBoardScreen: TBoardScreen;
  /**
   * Create business hour records
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createBusinessHours: ReadonlyArray<TBusinessHour>;
  /**
   * Create company record
   *
   * ALLOWED ROLES: [admin, editor_company, super_admin, support]
   *
   */
  readonly createCompany: TCompany;
  /**
   * Create company branch record
   *
   * ALLOWED ROLES: [admin, editor_company_branch, super_admin, support]
   *
   */
  readonly createCompanyBranch: TCompanyBranch;
  /**
   * Create new popup message for company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createCompanyBranchPopup: ReadonlyArray<TPopup>;
  /**
   * Create binding printer to company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createCompanyBranchPrinter: TCompanyBranchPrinter;
  /**
   * Create printer trigger for company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createCompanyBranchTrigger: TCompanyBranchTrigger;
  /**
   * Create printer to trigger association for company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createCompanyBranchTriggerPrinter: TCompanyBranchTriggerPrinter;
  /**
   * Create connection between user and specific company branch or enable existing connection
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createCompanyBranchUser: TUser;
  /**
   * Create new popup message for brand
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createCompanyPopup: ReadonlyArray<TPopup>;
  /**
   * Create consent assigned to order
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support]
   *
   */
  readonly createConsentOrder: TOrder;
  /**
   * Create currency record
   *
   * ALLOWED ROLES: [admin, editor_currency, super_admin, support]
   *
   */
  readonly createCurrency: TCurrency;
  /**
   * Create delivery order record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly createDeliveryOrder: TOrder;
  /**
   * Create external delivery request for order
   *
   * ALLOWED ROLES: [admin, editor_order, operator, request_external_driver, super_admin]
   *
   */
  readonly createExternalDelivery: Maybe<Scalars['String']['output']>;
  /**
   * Create order record for external service
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly createExternalOrder: TCreatedExternalOrderType;
  /**
   * Create financial report for specified object.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createFinancialReport: TFinancialReport;
  /**
   * Create ingredient record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_ingredient, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createIngredient: TIngredient;
  /**
   * Create order record for kiosk
   *
   * ALLOWED ROLES: [admin, cashier, cashier_kiosk, editor_order, operator, super_admin]
   *
   */
  readonly createKioskOrder: TOrder;
  /**
   * Create Label with defined translations
   *
   * ALLOWED ROLES: [admin, editor_label, super_admin, support]
   *
   */
  readonly createLabel: TLabel;
  /**
   * Create occasion
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createOccasion: TOccasion;
  /**
   * Create order record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly createOrder: TOrder;
  /**
   * Create order group record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createOrderGroup: TOrderGroup;
  /**
   * Create payment record for order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createOrderPaymentMethod: TOrder;
  /**
   * Update default delivery or pickup time of company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, super_admin, supervisor, support]
   *
   */
  readonly createOrderProcessTime: TCompanyBranch;
  /**
   * Create rating for order
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin]
   *
   */
  readonly createOrderRating: TOrder;
  /**
   * Create order recipe record (new item of order)
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin, support]
   *
   */
  readonly createOrderRecipe: TOrder;
  /**
   * Create pickup order record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly createPickupOrder: TOrder;
  /**
   * Reprint
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createPrintQueue: Maybe<TPrintQueue>;
  /**
   * Printer create
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createPrinter: TPrinter;
  /**
   * Create recipe record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createRecipe: TRecipe;
  /**
   * Create recipe price record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createRecipePrice: TRecipe;
  /**
   * Create recipe relation record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_recipe_relation, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createRecipeRelation: TRecipeRelation;
  /**
   * Create a RecipeTag record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
   *
   */
  readonly createRecipeTag: TRecipeTag;
  /**
   * Create new registered user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, guest, super_admin, supervisor]
   *
   */
  readonly createRegisteredUser: Scalars['ID']['output'];
  /**
   * Print the financial report from the kiosk
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createReportPrintQueue: Maybe<TPrintQueue>;
  /**
   * Create sector record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createSector: TSector;
  /**
   * Create sector recipe
   *
   * ALLOWED ROLES: [admin, cashier, super_admin, support]
   *
   */
  readonly createSectorRecipe: ReadonlyArray<TSectorRecipe>;
  /**
   * Create sector recipes in batch.
   *
   * ALLOWED ROLES: [admin, cashier, super_admin, support]
   *
   */
  readonly createSectorRecipes: ReadonlyArray<TSectorRecipe>;
  /**
   * Create shift record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_shift, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createShift: TShift;
  /**
   * Create user shift record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createShiftUser: TShift;
  /**
   * Create staff order record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly createStaffOrder: TOrder;
  /**
   * Create stock inventory
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createStockInventory: TStockInventory;
  /**
   * Create stock item
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createStockItem: TStockItem;
  /**
   * Create stock item transfer
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createStockItemTransfer: TStockTransfer;
  /**
   * Create batch of stock item transfers that are immediately confirmed
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createStockItemTransfers: ReadonlyArray<TStockItem>;
  /**
   * Create transportation device record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createTransportationDevice: TTransportationDevice;
  /**
   * Assign user and transportation device
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createTransportationDeviceUser: TTransportationDeviceUser;
  /**
   * Create new user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
   *
   */
  readonly createUser: TUser;
  /**
   * Assign user that will deliver order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createUserDeliveringOrder: TUserDeliveringOrder;
  /**
   * Assign user that will deliver order
   *
   * ALLOWED ROLES: [admin, cashier_delivery, driver, super_admin, support]
   *
   */
  readonly createUserDelivery: TUserDelivery;
  /**
   * Create voucher and send it to user by SMS. Maximum length is 160 characters. It is possible to use `code` keyword wrapped by two curly brackets.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createUserVoucher: TPromoCode;
  /**
   * Create order record for virtual cash box
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly createVirtualCashBoxOrder: TOrder;
  /**
   * Create ware record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createWare: TWare;
  /**
   * Create ware category record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createWareCategory: TWareCategory;
  /**
   * Create new ware category color with appropriate code
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly createWareCategoryColor: TWareCategoryColor;
  /**
   * Create ware relation to specific ware category (subcategory is defined by ware category type)
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category_relation, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createWareCategoryRelation: TWareCategoryRelation;
  /**
   * Create wifi order record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly createWifiOrder: TOrder;
  /**
   * Create new zone
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly createZone: TZone;
  /**
   * Create new zone color with appropriate code
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly createZoneColor: TZoneColor;
  /**
   * Destroy address
   *
   * ALLOWED ROLES: [admin, customer, editor_address, super_admin]
   *
   */
  readonly destroyAddress: TAddress;
  /**
   * Board destroy
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyBoard: TBoard;
  /**
   * Board screen destroy
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyBoardScreen: TBoardScreen;
  /**
   * Destroy business hour record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyBusinessHour: TBusinessHour;
  /**
   * Delete current company branch popup messages for given origins
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly destroyCompanyBranchPopup: ReadonlyArray<TPopup>;
  /**
   * Destroy binding printer to company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyCompanyBranchPrinter: TCompanyBranchPrinter;
  /**
   * Destroy trigger for company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyCompanyBranchTrigger: TCompanyBranchTrigger;
  /**
   * Destroy printer to trigger assign
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyCompanyBranchTriggerPrinter: TCompanyBranchTriggerPrinter;
  /**
   * Destroy connection between user and specific company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyCompanyBranchUser: TUser;
  /**
   * Delete current company popup messages for given origins
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly destroyCompanyPopup: ReadonlyArray<TPopup>;
  /**
   * Destroy consent assigned to order
   *
   * ALLOWED ROLES: [admin, guest, super_admin]
   *
   */
  readonly destroyConsentOrder: TOrder;
  /**
   * Destroy ingredient record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_ingredient, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyIngredient: TIngredient;
  /**
   * Destroy multiple order recipe record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin]
   *
   */
  readonly destroyMultipleOrderRecipes: TOrder;
  /**
   * Destroy occasion
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyOccasion: TOccasion;
  /**
   * Destroy payment record for order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyOrderPaymentMethod: TOrder;
  /**
   * Destroy updating default delivery or pickup time of company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, super_admin, supervisor]
   *
   */
  readonly destroyOrderProcessTime: TCompanyBranch;
  /**
   * Destroy order recipe record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin]
   *
   */
  readonly destroyOrderRecipe: TOrder;
  /**
   * Destroy same recipes of one order
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin]
   *
   */
  readonly destroyOrderRecipes: TOrder;
  /**
   * Printer destroy
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyPrinter: TPrinter;
  /**
   * Destroy recipe record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyRecipe: TRecipe;
  /**
   * Destroy recipe relation record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_recipe_relation, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly destroyRecipeRelation: TRecipe;
  /**
   * Destroy a RecipeTag record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor]
   *
   */
  readonly destroyRecipeTag: TRecipeTag;
  /**
   * Destroy sector record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly destroySector: TSector;
  /**
   * Destroy sector recipe
   *
   * ALLOWED ROLES: [admin, cashier, super_admin]
   *
   */
  readonly destroySectorRecipe: TSector;
  /**
   * Destroy shift record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_shift, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyShift: TShift;
  /**
   * Destroy stock inventory record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyStockInventory: TStockInventory;
  /**
   * Destroy stock item record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyStockItem: TStockItem;
  /**
   * Destroy stock item transfer
   *
   * ALLOWED ROLES: [admin, editor_stock_transfer, operator, super_admin]
   *
   */
  readonly destroyStockItemTransfer: TStockTransfer;
  /**
   * Remove assignation of user and transportation device
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly destroyTransportationDeviceUser: TTransportationDeviceUser;
  /**
   * Destroy the current user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
   *
   */
  readonly destroyUser: Scalars['Boolean']['output'];
  /**
   * Remove user that will assign user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyUserDeliveringOrder: TUserDeliveringOrder;
  /**
   * Destroy ware category record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_ware_category, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyWareCategory: TWareCategory;
  /**
   * Remove ware from defined subcategory of appropriate ware category
   *
   * ALLOWED ROLES: [admin, editor_ware_category_relation, operator, super_admin]
   *
   */
  readonly destroyWareCategoryRelation: TWareCategoryRelation;
  /**
   * Destroy zone
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_zone, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly destroyZone: TZone;
  /**
   * Create a background customer export.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, export_customers, super_admin, supervisor]
   *
   */
  readonly exportCustomers: TCustomerExport;
  /**
   * Mark order as finished by external service
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly finishExternalOrder: TOrder;
  /**
   * Mark order as finished
   *
   * ALLOWED ROLES: [admin, cashier, editor_order, operator, super_admin]
   *
   */
  readonly finishKioskOrder: TFinishedOrder;
  /**
   * Mark order as finished
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly finishOrder: TFinishedOrder;
  /**
   * Mark order as finished by staff
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly finishStaffOrder: TOrder;
  /**
   * Finish stock inventory
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly finishStockInventory: TStockInventory;
  /**
   * Mark order as finished
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly finishVirtualCashBoxOrder: TFinishedOrder;
  /**
   * Create staff order record
   *
   * ALLOWED ROLES: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
   *
   */
  readonly importOrders: ReadonlyArray<TImportedOrder>;
  /**
   * Login user to appropriate cash box
   *
   * ALLOWED ROLES: [admin, cashier_kiosk, cashier_pos, editor_cash_box, super_admin]
   *
   */
  readonly logKioskEvent: Scalars['Boolean']['output'];
  /**
   * Logout the current User
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
   *
   */
  readonly logoutUser: Maybe<Scalars['Boolean']['output']>;
  /**
   * Send notification to user that his/her order is prepared
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly orderNotifyCustomer: TOrder;
  /**
   * Reject stock item transfer
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly rejectStockItemTransfer: TStockTransfer;
  /**
   * Accept rejection of stock item transfer
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly rejectionAcceptedStockItemTransfer: TStockTransfer;
  /**
   * Remove allergen for defined recipe
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_item_allergen, sales_representative, super_admin, supervisor]
   *
   */
  readonly removeAllergenStockItem: TStockItem;
  /**
   * Remove driver from all orders of order group
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly removeDriverFromOrderGroup: TOrderGroup;
  /**
   * Create order group record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly removeItemFromOrderGroup: Maybe<TOrderGroup>;
  /**
   * Remove promo code from order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, guest, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly removeOrderPromoCode: TOrder;
  /**
   * Remove order state for defined order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order_state_relation, guest, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly removeOrderState: TOrder;
  /**
   * Send order cancel request to support
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_order, operator, request_cancel, sales_representative, super_admin, supervisor]
   *
   */
  readonly requestCancelOrder: TOrder;
  /**
   * Request sending confirmation code for given phone number
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly requestEmailConfirmationCode: TRequestEmailConfirmationCode;
  /**
   * Request sending confirmation code for given phone number
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly requestPhoneConfirmationCode: TRequestPhoneConfirmationCode;
  /**
   * Resend EET Receipt if previous attempt end with error
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly resendEETReceipt: TOrder;
  /**
   * Change priority of order
   *
   * ALLOWED ROLES: [admin, cashier, editor_order, operator, super_admin]
   *
   */
  readonly setPriorityOrder: TOrder;
  /**
   * Send storno EET Receipt for order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly stornoEETReceipt: TOrder;
  /**
   * Suspends user and sends password reset email
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
   *
   */
  readonly suspendUser: TUser;
  /**
   * Transfer order to different CompanyBranch
   *
   * ALLOWED ROLES: [admin, cashier_transfer_company_branch, editor_order, operator, super_admin]
   *
   */
  readonly transferOrder: TOrder;
  /**
   * Update address record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, customer, editor_address, operator, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly updateAddress: TAddress;
  /**
   * Board update
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateBoard: TBoard;
  /**
   * Board screen update
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateBoardScreen: TBoardScreen;
  /**
   * Update current company branch popup message
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, merchant, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateCompanyBranchPopup: TPopup;
  /**
   * Update company branch specific recipe data
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_basic_recipes, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateCompanyBranchRecipe: TRecipe;
  /**
   * Create printer trigger for company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateCompanyBranchTrigger: TCompanyBranchTrigger;
  /**
   * Update connection between user and specific company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateCompanyBranchUser: TCompanyBranchUser;
  /**
   * Update company branch specific recipe data
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateCompanyBranchWareCategory: TWareCategory;
  /**
   * Update current company popup message
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateCompanyPopup: TPopup;
  /**
   * Update exchange rate of defined currency
   *
   * ALLOWED ROLES: [admin, editor_currency, super_admin, support]
   *
   */
  readonly updateCurrencyExchangeRate: TCurrency;
  /**
   * Update default delivery time of company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_process_time, editor_company_branch, sales_representative, super_admin, supervisor]
   *
   */
  readonly updateDefaultDeliveryTime: TCompanyBranch;
  /**
   * Update default order process time of company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_process_time, editor_company_branch, sales_representative, super_admin, supervisor]
   *
   */
  readonly updateDefaultOrderProcessTime: TCompanyBranch;
  /**
   * Update promo header text of company or company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_setting, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateGraphicHeaders: Maybe<Scalars['Boolean']['output']>;
  /**
   * Update graphic styles of company or company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_setting, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateGraphicStyles: TGraphicStyle;
  /**
   * Update ingredient record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_ingredient, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateIngredient: TIngredient;
  /**
   * Update occasion
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateOccasion: TOccasion;
  /**
   * Update order record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateOrder: TOrder;
  /**
   * Change received order from DELIVERY to PICKUP
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_change_delivery_type, editor_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly updateOrderDeliveryToPickup: TOrder;
  /**
   * Create order group record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateOrderGroup: Maybe<TOrderGroup>;
  /**
   * Change order of orders in order group
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_sorting, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateOrderGroupOrder: Scalars['Boolean']['output'];
  /**
   * Update the OrderOnlineState of a kiosk Order
   *
   * ALLOWED ROLES: [admin, cashier, cashier_kiosk, editor_order, operator, super_admin]
   *
   */
  readonly updateOrderOnlineStateKioskOrder: TOrder;
  /**
   * Change payment method of order.
   *
   * ALLOWED ROLES: [admin, cashier_payment_methods, driver, editor_order, operator, super_admin]
   *
   */
  readonly updateOrderPaymentMethod: TOrder;
  /**
   * Change payment methods of order - allows to pay order by multiple payment methods
   *
   * ALLOWED ROLES: [admin, cashier_payment_methods, driver, editor_order, operator, super_admin]
   *
   */
  readonly updateOrderPaymentMethods: TOrder;
  /**
   * Prepare preview of order record update. Keep in mind that new changes are stored just in-memory,
   * so digging deep inside GraphQL structure may lead to read of inaccurate data.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateOrderPreview: ReadonlyArray<TOrderDiffEntry>;
  /**
   * Update order recipe record (item of order)
   *
   * ALLOWED ROLES: [admin, cashier, customer, driver, editor_order_recipe, guest, operator, super_admin, support]
   *
   */
  readonly updateOrderRecipe: TOrder;
  /**
   * Update order recipe record (item of order)
   *
   * ALLOWED ROLES: [admin, cashier, customer, driver, editor_order_recipe, guest, operator, super_admin, support]
   *
   */
  readonly updateOrderRecipeState: TOrderRecipe;
  /**
   * Update the User of an Order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateOrderUser: TOrder;
  /**
   * Change print queue state
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updatePrintQueue: TPrintQueue;
  /**
   * Update a print template record
   *
   * ALLOWED ROLES: [admin, super_admin, templatable_manager]
   *
   */
  readonly updatePrintTemplate: TPrintTemplate;
  /**
   * Printer update
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updatePrinter: TPrinter;
  /**
   * Update printer state
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updatePrinterState: Maybe<Scalars['Boolean']['output']>;
  /**
   * Update recipe record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateRecipe: TRecipe;
  /**
   * Update recipe price record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateRecipePrice: TRecipe;
  /**
   * Update a RecipeTag record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
   *
   */
  readonly updateRecipeTag: TRecipeTag;
  /**
   * Change order of recipes of ware category
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_sorting, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateRecipesOrder: Scalars['Boolean']['output'];
  /**
   * Update sector record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateSector: TSector;
  /**
   * Update sector recipe
   *
   * ALLOWED ROLES: [admin, cashier, super_admin, support]
   *
   */
  readonly updateSectorRecipe: TSectorRecipe;
  /**
   * Update sector recipes
   *
   * ALLOWED ROLES: [admin, cashier, super_admin, support]
   *
   */
  readonly updateSectorRecipes: ReadonlyArray<TSectorRecipe>;
  /**
   * Update shift record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_shift, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateShift: TShift;
  /**
   * Update user shift record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateShiftUser: TShift;
  /**
   * Change order of ware categories of recipe (side dishes)
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_sorting, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateSideDishesOrder: Scalars['Boolean']['output'];
  /**
   * Update information about stock item
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateStockInventoryItem: TStockInventoryItem;
  /**
   * Update information about stock item
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateStockItem: TStockItem;
  /**
   * Change state of defined transportation device
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateTransportationDeviceState: TTransportationDevice;
  /**
   * Update information about users and its transportation device
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateTransportationDeviceUser: TTransportationDeviceUser;
  /**
   * Update information about user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
   *
   */
  readonly updateUser: TUser;
  /**
   * Remove user that will assign user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateUserDeliveringOrder: TUserDeliveringOrder;
  /**
   * Assign user that will deliver order
   *
   * ALLOWED ROLES: [admin, cashier_delivery, driver, super_admin, support]
   *
   */
  readonly updateUserDelivery: TUserDelivery;
  /**
   * Update information about user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, suspended_user, user]
   *
   */
  readonly updateUserPassword: TUserUpdatedPassword;
  /**
   * Update ware information
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateWare: TWare;
  /**
   * Change order of recipes categories of company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_sorting, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateWareCategoriesOrder: Scalars['Boolean']['output'];
  /**
   * Update ware category record
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateWareCategory: TWareCategory;
  /**
   * Change color of defined ware category color
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly updateWareCategoryColor: TWareCategoryColor;
  /**
   * Update zone
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateZone: TZone;
  /**
   * Change color of defined zone color
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly updateZoneColor: TZoneColor;
  /**
   * Change order of zones of company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_sorting, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly updateZonePriority: ReadonlyArray<TZone>;
  /**
   * Create information about calling customer on server.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly userNotifyCustomerCalling: TUserCustomerCalling;
  /**
   * Create information about customer call hang-up.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly userNotifyCustomerHangup: TUserCustomerHangup;
  /**
   * Confirm current user phone number with given activation code for exports
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, export_customers, super_admin, supervisor]
   *
   */
  readonly validateCurrentUserConfirmationCode: Maybe<TCurrentUserValidation>;
  /**
   * Request sending confirmation code for given phone number
   *
   * ALLOWED ROLES: [admin, guest, super_admin, user]
   *
   */
  readonly validateEmailConfirmationCode: TRequestEmailConfirmationCode;
  /**
   * Confirm phone number with given activation code
   *
   * ALLOWED ROLES: [admin, guest, super_admin, user]
   *
   */
  readonly validatePhoneConfirmationCode: Maybe<TPhoneCodeValidation>;
};


/** The mutation root of this schema */
export type TMutationAcknowledgeExternalDeliveryArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationAddAllergenStockItemArgs = {
  allergen: TAllergenEnum;
  stockItem: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationAddCreditsPaymentArgs = {
  amount: Scalars['Float']['input'];
  orderId: Scalars['ID']['input'];
  walletId: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationAddItemToOrderGroupArgs = {
  order: Scalars['ID']['input'];
  orderGroup: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationAddOrderPromoCodeArgs = {
  order: Scalars['ID']['input'];
  promoCode: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationAddOrderStateArgs = {
  order: Scalars['ID']['input'];
  orderState: TOrderStateEnum;
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/** The mutation root of this schema */
export type TMutationAddSpecialBusinessHourArgs = {
  businessHour: TInputBusinessHourSpecificDateCreate;
};


/** The mutation root of this schema */
export type TMutationAddSpecialClosingBusinessHoursArgs = {
  closingSpecification: TInputBusinessHourSpecificCloseCreate;
};


/** The mutation root of this schema */
export type TMutationBulkUpdateInAppNotificationsArgs = {
  ids: ReadonlyArray<Scalars['ID']['input']>;
  isRead: Scalars['Boolean']['input'];
};


/** The mutation root of this schema */
export type TMutationCancelOrdersArgs = {
  ids: ReadonlyArray<Scalars['ID']['input']>;
};


/** The mutation root of this schema */
export type TMutationCashBoxLogTerminalEventArgs = {
  cashBox: Scalars['ID']['input'];
  events: ReadonlyArray<TInputCashBoxLogTerminalEvent>;
};


/** The mutation root of this schema */
export type TMutationCashBoxLoginArgs = {
  cashBox: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationCashBoxLogoutArgs = {
  cashBox: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationChangeAmountStockItemArgs = {
  amountOffset: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


/** The mutation root of this schema */
export type TMutationConfirmStockItemTransferArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateAddressArgs = {
  address: TInputAddressCreate;
};


/** The mutation root of this schema */
export type TMutationCreateBoardArgs = {
  backgroundImage?: InputMaybe<Scalars['InputFile']['input']>;
  backgroundVideo?: InputMaybe<Scalars['InputFile']['input']>;
  boardScreens?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  boardTemplate: Scalars['ID']['input'];
  colors?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  companyBranch: Scalars['ID']['input'];
  features: TInputBoardFeaturesCreate;
  logo?: InputMaybe<Scalars['InputFile']['input']>;
  name: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateBoardScreenArgs = {
  backgroundImage?: InputMaybe<Scalars['InputFile']['input']>;
  backgroundVideo?: InputMaybe<Scalars['InputFile']['input']>;
  board: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  wareCategories: ReadonlyArray<Scalars['ID']['input']>;
};


/** The mutation root of this schema */
export type TMutationCreateBusinessHoursArgs = {
  businessHours: ReadonlyArray<TInputBusinessHourCreate>;
  companyBranch: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateCompanyArgs = {
  company: TInputCompanyCreate;
};


/** The mutation root of this schema */
export type TMutationCreateCompanyBranchArgs = {
  company: Scalars['ID']['input'];
  companyBranch: TInputCompanyBranchCreate;
};


/** The mutation root of this schema */
export type TMutationCreateCompanyBranchPopupArgs = {
  id: Scalars['ID']['input'];
  orderOriginCategories: ReadonlyArray<TOrderOriginCategoryEnum>;
  text: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateCompanyBranchPrinterArgs = {
  companyBranch: Scalars['ID']['input'];
  printer: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateCompanyBranchTriggerArgs = {
  companyBranch: Scalars['ID']['input'];
  templatable?: InputMaybe<Scalars['ID']['input']>;
  triggerConfiguration?: InputMaybe<Scalars['ID']['input']>;
};


/** The mutation root of this schema */
export type TMutationCreateCompanyBranchTriggerPrinterArgs = {
  companyBranchPrinter: Scalars['ID']['input'];
  companyBranchTrigger: Scalars['ID']['input'];
  targetMac: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateCompanyBranchUserArgs = {
  companyBranch: Scalars['ID']['input'];
  driverSetting?: InputMaybe<TInputCompanyBranchUserDriverSetting>;
  user: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateCompanyPopupArgs = {
  id: Scalars['ID']['input'];
  orderOriginCategories: ReadonlyArray<TOrderOriginCategoryEnum>;
  text: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateConsentOrderArgs = {
  consentOrder: TInputConsentOrderCreate;
};


/** The mutation root of this schema */
export type TMutationCreateCurrencyArgs = {
  code: Scalars['String']['input'];
  decimalRound?: InputMaybe<Scalars['Int']['input']>;
  exchangeRate: Scalars['Float']['input'];
  promoDecimalRound?: InputMaybe<Scalars['Int']['input']>;
};


/** The mutation root of this schema */
export type TMutationCreateDeliveryOrderArgs = {
  order: TInputOrderDeliveryCreate;
};


/** The mutation root of this schema */
export type TMutationCreateExternalDeliveryArgs = {
  closestPickup?: InputMaybe<Scalars['DateTime']['input']>;
  externalDeliveryProvider: TExternalDeliveryProviderEnum;
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateExternalOrderArgs = {
  inputOrder: TInputExternalOrderCreate;
};


/** The mutation root of this schema */
export type TMutationCreateFinancialReportArgs = {
  cashBoxId?: InputMaybe<Scalars['ID']['input']>;
  companyBranchId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


/** The mutation root of this schema */
export type TMutationCreateIngredientArgs = {
  ingredient: TInputIngredientCreate;
};


/** The mutation root of this schema */
export type TMutationCreateKioskOrderArgs = {
  cashBox: Scalars['ID']['input'];
  order: TInputOrderStaffPosCreate;
};


/** The mutation root of this schema */
export type TMutationCreateLabelArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  translations: ReadonlyArray<TInputLabelTranslation>;
};


/** The mutation root of this schema */
export type TMutationCreateOccasionArgs = {
  occasion: TInputOccasionCreate;
};


/** The mutation root of this schema */
export type TMutationCreateOrderArgs = {
  order: TInputOrderCreate;
};


/** The mutation root of this schema */
export type TMutationCreateOrderGroupArgs = {
  orderGroup: TInputOrderGroupCreate;
};


/** The mutation root of this schema */
export type TMutationCreateOrderPaymentMethodArgs = {
  orderPaymentMethod: TInputOrderPaymentMethodCreate;
};


/** The mutation root of this schema */
export type TMutationCreateOrderProcessTimeArgs = {
  companyBranch: Scalars['ID']['input'];
  deliveryType: TDeliveryTypeEnum;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  processTime: Scalars['Int']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateOrderRatingArgs = {
  id: Scalars['ID']['input'];
  ratings: ReadonlyArray<TInputOrderRatingCreate>;
};


/** The mutation root of this schema */
export type TMutationCreateOrderRecipeArgs = {
  orderRecipe: TInputOrderRecipeCreate;
};


/** The mutation root of this schema */
export type TMutationCreatePickupOrderArgs = {
  order: TInputOrderPickupCreate;
};


/** The mutation root of this schema */
export type TMutationCreatePrintQueueArgs = {
  printableObject: Scalars['ID']['input'];
  printer: Scalars['ID']['input'];
  targetMac: Scalars['String']['input'];
  template: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationCreatePrinterArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  mac: Scalars['String']['input'];
  name: Scalars['String']['input'];
  printerType: TPrinterTypeEnum;
};


/** The mutation root of this schema */
export type TMutationCreateRecipeArgs = {
  recipe: TInputRecipeCreate;
};


/** The mutation root of this schema */
export type TMutationCreateRecipePriceArgs = {
  recipe: Scalars['ID']['input'];
  recipePrice: TInputRecipePriceCreate;
};


/** The mutation root of this schema */
export type TMutationCreateRecipeRelationArgs = {
  associatedRecipe: Scalars['ID']['input'];
  recipe: Scalars['ID']['input'];
  warePriceType: TWarePriceTypeEnum;
};


/** The mutation root of this schema */
export type TMutationCreateRecipeTagArgs = {
  recipeTag: TInputRecipeTagCreate;
};


/** The mutation root of this schema */
export type TMutationCreateRegisteredUserArgs = {
  user: TInputUserRegisteredCreate;
};


/** The mutation root of this schema */
export type TMutationCreateReportPrintQueueArgs = {
  cashBox: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  printer: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateSectorArgs = {
  sector: TInputSectorCreate;
};


/** The mutation root of this schema */
export type TMutationCreateSectorRecipeArgs = {
  sectorRecipe: TInputSectorRecipeCreate;
};


/** The mutation root of this schema */
export type TMutationCreateSectorRecipesArgs = {
  sectorRecipes: ReadonlyArray<TInputSectorRecipeCreate>;
};


/** The mutation root of this schema */
export type TMutationCreateShiftArgs = {
  shift: TInputShiftCreate;
};


/** The mutation root of this schema */
export type TMutationCreateShiftUserArgs = {
  shift: Scalars['ID']['input'];
  shiftUserState?: InputMaybe<TShiftUserStateEnum>;
  user: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateStaffOrderArgs = {
  cashBox: Scalars['ID']['input'];
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  deliveryType?: InputMaybe<TDeliveryTypeEnum>;
  orderRecipes?: InputMaybe<ReadonlyArray<TInputOrderRecipeCreates>>;
  sector?: InputMaybe<Scalars['ID']['input']>;
  warePriceType: TWarePriceTypeEnum;
};


/** The mutation root of this schema */
export type TMutationCreateStockInventoryArgs = {
  companyBranch: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateStockItemArgs = {
  stockItem: TInputStockItemCreate;
};


/** The mutation root of this schema */
export type TMutationCreateStockItemTransferArgs = {
  companyBranch: Scalars['ID']['input'];
  quantity: Scalars['Float']['input'];
  stockItem: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateStockItemTransfersArgs = {
  destinationBranchId: Scalars['ID']['input'];
  transfers: ReadonlyArray<TInputStockTransferCreate>;
};


/** The mutation root of this schema */
export type TMutationCreateTransportationDeviceArgs = {
  transportationDevice: TInputTransportationDeviceCreate;
};


/** The mutation root of this schema */
export type TMutationCreateTransportationDeviceUserArgs = {
  user?: InputMaybe<Scalars['ID']['input']>;
};


/** The mutation root of this schema */
export type TMutationCreateUserArgs = {
  user: TInputUserCreate;
};


/** The mutation root of this schema */
export type TMutationCreateUserDeliveringOrderArgs = {
  assignmentType?: InputMaybe<TUserDeliveringOrdersAssignmentTypeEnum>;
  automaticOnWay?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['ID']['input'];
  user: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateUserDeliveryArgs = {
  transportationDeviceUser: Scalars['ID']['input'];
  userDeliveringOrders: ReadonlyArray<Scalars['ID']['input']>;
};


/** The mutation root of this schema */
export type TMutationCreateUserVoucherArgs = {
  companyBranch: Scalars['ID']['input'];
  discount: Scalars['Float']['input'];
  message: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  public?: InputMaybe<Scalars['Boolean']['input']>;
  validTill: Scalars['DateTime']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateVirtualCashBoxOrderArgs = {
  order: TInputOrderStaffPosCreate;
};


/** The mutation root of this schema */
export type TMutationCreateWareArgs = {
  ware: TInputWareCreate;
};


/** The mutation root of this schema */
export type TMutationCreateWareCategoryArgs = {
  wareCategory: TInputWareCategoryCreate;
};


/** The mutation root of this schema */
export type TMutationCreateWareCategoryColorArgs = {
  code: Scalars['String']['input'];
  color: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateWareCategoryRelationArgs = {
  categoryOfWare?: InputMaybe<Scalars['Boolean']['input']>;
  recipe: Scalars['ID']['input'];
  wareCategory: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationCreateWifiOrderArgs = {
  order: TInputOrderWifiCreate;
};


/** The mutation root of this schema */
export type TMutationCreateZoneArgs = {
  zone: TInputZoneCreate;
};


/** The mutation root of this schema */
export type TMutationCreateZoneColorArgs = {
  code: Scalars['String']['input'];
  color: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyAddressArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyBoardArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyBoardScreenArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyBusinessHourArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyCompanyBranchPopupArgs = {
  id: Scalars['ID']['input'];
  orderOriginCategories?: InputMaybe<ReadonlyArray<TOrderOriginCategoryEnum>>;
};


/** The mutation root of this schema */
export type TMutationDestroyCompanyBranchPrinterArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyCompanyBranchTriggerArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyCompanyBranchTriggerPrinterArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyCompanyBranchUserArgs = {
  companyBranchUser: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyCompanyPopupArgs = {
  id: Scalars['ID']['input'];
  orderOriginCategories?: InputMaybe<ReadonlyArray<TOrderOriginCategoryEnum>>;
};


/** The mutation root of this schema */
export type TMutationDestroyConsentOrderArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyIngredientArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyMultipleOrderRecipesArgs = {
  ids: ReadonlyArray<Scalars['ID']['input']>;
};


/** The mutation root of this schema */
export type TMutationDestroyOccasionArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyOrderPaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyOrderProcessTimeArgs = {
  companyBranch: Scalars['ID']['input'];
  deliveryType: TDeliveryTypeEnum;
};


/** The mutation root of this schema */
export type TMutationDestroyOrderRecipeArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyOrderRecipesArgs = {
  order: Scalars['ID']['input'];
  recipe: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyPrinterArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyRecipeArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyRecipeRelationArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyRecipeTagArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroySectorArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroySectorRecipeArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyShiftArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyStockInventoryArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyStockItemArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyStockItemTransferArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyTransportationDeviceUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The mutation root of this schema */
export type TMutationDestroyUserArgs = {
  password: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyUserDeliveringOrderArgs = {
  id: Scalars['ID']['input'];
  keepDriver?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<TDeliveryStateEnum>;
};


/** The mutation root of this schema */
export type TMutationDestroyWareCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyWareCategoryRelationArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationDestroyZoneArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationExportCustomersArgs = {
  companyBranches: ReadonlyArray<Scalars['ID']['input']>;
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  format: TFileReportFormat;
  madeOrder: Scalars['Boolean']['input'];
};


/** The mutation root of this schema */
export type TMutationFinishExternalOrderArgs = {
  id: Scalars['ID']['input'];
  paymentMethods: ReadonlyArray<TInputOrderPaymentMethodsCreate>;
};


/** The mutation root of this schema */
export type TMutationFinishKioskOrderArgs = {
  id: Scalars['ID']['input'];
  order: TInputOrderFinish;
};


/** The mutation root of this schema */
export type TMutationFinishOrderArgs = {
  id: Scalars['ID']['input'];
  order: TInputOrderFinish;
};


/** The mutation root of this schema */
export type TMutationFinishStaffOrderArgs = {
  id: Scalars['ID']['input'];
  invoice?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  paymentMethods?: InputMaybe<ReadonlyArray<TInputOrderPaymentMethodsCreate>>;
};


/** The mutation root of this schema */
export type TMutationFinishStockInventoryArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


/** The mutation root of this schema */
export type TMutationFinishVirtualCashBoxOrderArgs = {
  id: Scalars['ID']['input'];
  order: TInputOrderFinish;
};


/** The mutation root of this schema */
export type TMutationImportOrdersArgs = {
  cashBox: Scalars['String']['input'];
  lastInvoiceNumber: Scalars['Int']['input'];
  orders: ReadonlyArray<TInputOrderStaffImport>;
};


/** The mutation root of this schema */
export type TMutationLogKioskEventArgs = {
  cashBox: Scalars['ID']['input'];
  events: ReadonlyArray<TInputKioskEventLog>;
};


/** The mutation root of this schema */
export type TMutationOrderNotifyCustomerArgs = {
  id: Scalars['ID']['input'];
  minutes: Scalars['Int']['input'];
};


/** The mutation root of this schema */
export type TMutationRejectStockItemTransferArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationRejectionAcceptedStockItemTransferArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationRemoveAllergenStockItemArgs = {
  allergen: TAllergenEnum;
  stockItem: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationRemoveDriverFromOrderGroupArgs = {
  orderGroup: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationRemoveItemFromOrderGroupArgs = {
  order: Scalars['ID']['input'];
  orderGroup: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationRemoveOrderPromoCodeArgs = {
  order: Scalars['ID']['input'];
  promoCode: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationRemoveOrderStateArgs = {
  order: Scalars['ID']['input'];
  orderState: TOrderStateEnum;
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/** The mutation root of this schema */
export type TMutationRequestCancelOrderArgs = {
  cancelReason: TStornoRequestTypeEnum;
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationRequestEmailConfirmationCodeArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  returnUrl: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationRequestPhoneConfirmationCodeArgs = {
  backgroundExport?: InputMaybe<Scalars['ID']['input']>;
  originatorHost?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationResendEetReceiptArgs = {
  id: Scalars['ID']['input'];
  storno?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The mutation root of this schema */
export type TMutationSetPriorityOrderArgs = {
  isPriority: Scalars['Boolean']['input'];
  order: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationStornoEetReceiptArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationSuspendUserArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationTransferOrderArgs = {
  companyBranch: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateAddressArgs = {
  address: TInputAddressUpdate;
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateBoardArgs = {
  backgroundImage?: InputMaybe<TInputFileUpdate>;
  backgroundVideo?: InputMaybe<TInputFileUpdate>;
  boardScreens?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  boardTemplate?: InputMaybe<Scalars['ID']['input']>;
  colors?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  features?: InputMaybe<TInputBoardFeaturesUpdate>;
  id: Scalars['ID']['input'];
  logo?: InputMaybe<TInputFileUpdate>;
  name?: InputMaybe<Scalars['String']['input']>;
};


/** The mutation root of this schema */
export type TMutationUpdateBoardScreenArgs = {
  backgroundImage?: InputMaybe<TInputFileUpdate>;
  backgroundVideo?: InputMaybe<TInputFileUpdate>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  wareCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};


/** The mutation root of this schema */
export type TMutationUpdateCompanyBranchPopupArgs = {
  id: Scalars['ID']['input'];
  orderOriginCategory: TOrderOriginCategoryEnum;
  text: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateCompanyBranchRecipeArgs = {
  companyBranch: Scalars['ID']['input'];
  recipe: TInputCompanyBranchRecipeUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateCompanyBranchTriggerArgs = {
  id: Scalars['ID']['input'];
  templatable?: InputMaybe<Scalars['ID']['input']>;
  triggerConfiguration?: InputMaybe<Scalars['ID']['input']>;
};


/** The mutation root of this schema */
export type TMutationUpdateCompanyBranchUserArgs = {
  companyBranchUser: TInputCompanyBranchUserUpdate;
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateCompanyBranchWareCategoryArgs = {
  companyBranch: Scalars['ID']['input'];
  wareCategory: TInputCompanyBranchWareCategoryUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateCompanyPopupArgs = {
  id: Scalars['ID']['input'];
  orderOriginCategory: TOrderOriginCategoryEnum;
  text: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateCurrencyExchangeRateArgs = {
  exchangeRate: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateDefaultDeliveryTimeArgs = {
  defaultDeliveryTime: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateDefaultOrderProcessTimeArgs = {
  companyBranch: Scalars['ID']['input'];
  defaultTime: Scalars['Int']['input'];
  deliveryType: TDeliveryTypeEnum;
};


/** The mutation root of this schema */
export type TMutationUpdateGraphicHeadersArgs = {
  company?: InputMaybe<Scalars['ID']['input']>;
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  promoTranslations?: InputMaybe<ReadonlyArray<TInputLabelTranslation>>;
};


/** The mutation root of this schema */
export type TMutationUpdateGraphicStylesArgs = {
  applicationStyles?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  originCategory: TOrderOriginCategoryEnum;
};


/** The mutation root of this schema */
export type TMutationUpdateIngredientArgs = {
  id: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  recipe?: InputMaybe<Scalars['ID']['input']>;
  stockItem?: InputMaybe<Scalars['ID']['input']>;
};


/** The mutation root of this schema */
export type TMutationUpdateOccasionArgs = {
  id: Scalars['ID']['input'];
  occasion: TInputOccasionUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderArgs = {
  id: Scalars['ID']['input'];
  order: TInputOrderUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderDeliveryToPickupArgs = {
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateOrderGroupArgs = {
  orderGroup: TInputOrderGroupUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderGroupOrderArgs = {
  offset: Scalars['Int']['input'];
  order: Scalars['ID']['input'];
  orderGroup: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateOrderOnlineStateKioskOrderArgs = {
  order: Scalars['ID']['input'];
  orderOnlineState: TOrderOnlineStateEnum;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderPaymentMethodArgs = {
  orderId: Scalars['ID']['input'];
  paymentMethodId: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateOrderPaymentMethodsArgs = {
  orderId: Scalars['ID']['input'];
  paymentMethods: ReadonlyArray<TInputOrderPaymentMethodUpdate>;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderPreviewArgs = {
  id: Scalars['ID']['input'];
  order: TInputOrderUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderRecipeArgs = {
  id: Scalars['ID']['input'];
  orderRecipe: TInputOrderRecipeUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderRecipeStateArgs = {
  id: Scalars['ID']['input'];
  orderRecipeState: TOrderRecipeStateEnum;
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/** The mutation root of this schema */
export type TMutationUpdateOrderUserArgs = {
  order: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdatePrintQueueArgs = {
  id: Scalars['ID']['input'];
  printQueueState: TPrintQueueStateEnum;
};


/** The mutation root of this schema */
export type TMutationUpdatePrintTemplateArgs = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdatePrinterArgs = {
  companyBranches: ReadonlyArray<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  mac?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  printerType?: InputMaybe<TPrinterTypeEnum>;
};


/** The mutation root of this schema */
export type TMutationUpdatePrinterStateArgs = {
  printerId: Scalars['ID']['input'];
  state: Scalars['Int']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateRecipeArgs = {
  id: Scalars['ID']['input'];
  recipe: TInputRecipeUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateRecipePriceArgs = {
  id: Scalars['ID']['input'];
  price?: InputMaybe<TInputCurrencyCreate>;
  vat?: InputMaybe<Scalars['Float']['input']>;
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};


/** The mutation root of this schema */
export type TMutationUpdateRecipeTagArgs = {
  id: Scalars['ID']['input'];
  recipeTag: TInputRecipeTagUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateRecipesOrderArgs = {
  offset: Scalars['Int']['input'];
  recipe: Scalars['ID']['input'];
  wareCategory: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateSectorArgs = {
  sector: TInputSectorUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateSectorRecipeArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  orderRecipeState?: InputMaybe<TOrderRecipeStateEnum>;
  sector?: InputMaybe<Scalars['ID']['input']>;
};


/** The mutation root of this schema */
export type TMutationUpdateSectorRecipesArgs = {
  orderRecipeState: TOrderRecipeStateEnum;
  sectorId: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateShiftArgs = {
  beginAt?: InputMaybe<Scalars['DateTime']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  placeCode?: InputMaybe<Scalars['String']['input']>;
};


/** The mutation root of this schema */
export type TMutationUpdateShiftUserArgs = {
  id: Scalars['ID']['input'];
  shiftUserState: TShiftUserStateEnum;
};


/** The mutation root of this schema */
export type TMutationUpdateSideDishesOrderArgs = {
  offset: Scalars['Int']['input'];
  recipe: Scalars['ID']['input'];
  wareCategory: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateStockInventoryItemArgs = {
  id: Scalars['ID']['input'];
  stockInventoryItem: TInputStockInventoryItemUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateStockItemArgs = {
  id: Scalars['ID']['input'];
  stockItem: TInputStockItemUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateTransportationDeviceStateArgs = {
  deviceState: TDeviceStateEnum;
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateTransportationDeviceUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locality?: InputMaybe<TInputGeoPointCreate>;
};


/** The mutation root of this schema */
export type TMutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  user: TInputUserUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateUserDeliveringOrderArgs = {
  deliveryState: TDeliveryStateEnum;
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateUserDeliveryArgs = {
  id: Scalars['ID']['input'];
  userDeliveringOrders: ReadonlyArray<Scalars['ID']['input']>;
};


/** The mutation root of this schema */
export type TMutationUpdateUserPasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword?: InputMaybe<Scalars['String']['input']>;
};


/** The mutation root of this schema */
export type TMutationUpdateWareArgs = {
  id: Scalars['ID']['input'];
  ware: TInputWareUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateWareCategoriesOrderArgs = {
  companyBranch: Scalars['ID']['input'];
  offset: Scalars['Int']['input'];
  wareCategory: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateWareCategoryArgs = {
  id: Scalars['ID']['input'];
  wareCategory: TInputWareCategoryUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateWareCategoryColorArgs = {
  color: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateZoneArgs = {
  id: Scalars['ID']['input'];
  zone: TInputZoneUpdate;
};


/** The mutation root of this schema */
export type TMutationUpdateZoneColorArgs = {
  color: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUpdateZonePriorityArgs = {
  offset: Scalars['Int']['input'];
  zone: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationUserNotifyCustomerCallingArgs = {
  phone: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationUserNotifyCustomerHangupArgs = {
  eventId: Scalars['ID']['input'];
};


/** The mutation root of this schema */
export type TMutationValidateCurrentUserConfirmationCodeArgs = {
  code: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationValidateEmailConfirmationCodeArgs = {
  token: Scalars['String']['input'];
};


/** The mutation root of this schema */
export type TMutationValidatePhoneConfirmationCodeArgs = {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

/** Possible types of notification */
export type TNotification = {
  readonly __typename?: 'Notification';
  readonly chrome: Maybe<Scalars['Boolean']['output']>;
  readonly firebase: Maybe<Scalars['Boolean']['output']>;
  readonly sms: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Occasion event information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TOccasion = {
  readonly __typename?: 'Occasion';
  readonly companyBranch: TCompanyBranch;
  /** @deprecated Divided into dateFrom and dateTo fields */
  readonly date: Scalars['DateTime']['output'];
  readonly dateFrom: Scalars['DateTime']['output'];
  readonly dateTo: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly image: Maybe<Scalars['String']['output']>;
  readonly preorderFrom: Scalars['DateTime']['output'];
  readonly preorderTo: Scalars['DateTime']['output'];
  readonly title: Scalars['String']['output'];
  readonly titleShort: Scalars['String']['output'];
};


/**
 * Occasion event information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TOccasionImageArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type TOnlinePaymentGatesInterface = {
  readonly csobUrl: Maybe<Scalars['String']['output']>;
  readonly gopayUrl: Maybe<Scalars['String']['output']>;
  readonly gpWebpayUrl: Maybe<Scalars['String']['output']>;
  readonly payFastUrl: Maybe<Scalars['String']['output']>;
  readonly payuUrl: Maybe<Scalars['String']['output']>;
};

/**
 * Possible OperatingCostFrequency types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOperatingCostFrequency = {
  readonly __typename?: 'OperatingCostFrequency';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TOperatingCostFrequencyEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** OperatingCostFrequency enum */
export type TOperatingCostFrequencyEnum =
  | 'AUTOMATIC'
  | 'MONTH'
  | 'ON_DEMAND';

/**
 * OperatingCostType and OperatingCostFrequency grouping model
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOperatingCostFrequencyType = {
  readonly __typename?: 'OperatingCostFrequencyType';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly operatingCostFrequency: TOperatingCostFrequency;
  readonly operatingCostType: TOperatingCostType;
};

/**
 * OperatingCostRecord graphql model
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [super_admin]
 *
 */
export type TOperatingCostRecord = {
  readonly __typename?: 'OperatingCostRecord';
  readonly absoluteValue: TPriceConverted;
  readonly canceled: Scalars['Boolean']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly operatingCostSetting: TOperatingCostSetting;
  readonly percentageValue: TPriceConverted;
  readonly recordValue: TPriceConverted;
};

/**
 * OperatingCostSetting graphql model
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [super_admin]
 *
 */
export type TOperatingCostSetting = {
  readonly __typename?: 'OperatingCostSetting';
  readonly absoluteValue: Scalars['Float']['output'];
  readonly cancelable: Scalars['Boolean']['output'];
  readonly closed: Scalars['Boolean']['output'];
  readonly companyBranch: TCompanyBranch;
  readonly id: Scalars['ID']['output'];
  readonly month: Scalars['Date']['output'];
  readonly operatingCostFrequencyType: TOperatingCostFrequencyType;
  readonly percentageValue: Scalars['Float']['output'];
};

/**
 * Possible OperatingCostType types
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier_statistics, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier_statistics, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOperatingCostType = {
  readonly __typename?: 'OperatingCostType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TOperatingCostTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** OperatingCostType enum */
export type TOperatingCostTypeEnum =
  | 'AXIMA'
  | 'BASIC'
  | 'CASH'
  | 'COMMISSION'
  | 'CREDIT'
  | 'CSOB'
  | 'FOODORA_GO'
  | 'GOPAY'
  | 'GP_WEBPAY'
  | 'INHOUSE'
  | 'MESSENGER'
  | 'NETHOST'
  | 'PAYU'
  | 'PAY_FAST'
  | 'PICKUP'
  | 'SPEEDLO_SERVICE'
  | 'TMOBILE'
  | 'WALLET_CREDIT'
  | 'WOLT_DRIVE';

/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrder = TFlagAttributesInterface & TInvoiceSequencesInterface & TOrderStateInterface & TPriceInterface & TRestrictedAttributes & TTransportFeeInterface & {
  readonly __typename?: 'Order';
  readonly acceptedAt: Maybe<Scalars['DateTime']['output']>;
  /** can be address from google - no consistent data */
  readonly address: TJsonAddress;
  readonly affiliate: Maybe<TCompany>;
  readonly ageControl: Scalars['Boolean']['output'];
  /** rules applied to order and all order wares */
  readonly allAppliedRules: ReadonlyArray<Scalars['String']['output']>;
  /** rules applied to this order */
  readonly appliedRules: ReadonlyArray<Scalars['String']['output']>;
  readonly billing: ReadonlyArray<TOrderBilling>;
  /** order payment method can be updated to these values */
  readonly canBeUpdatedToPaymentMethods: ReadonlyArray<TPaymentMethod>;
  readonly canRequestCancel: Scalars['Boolean']['output'];
  readonly cancelAlreadyRequested: Scalars['Boolean']['output'];
  readonly cashBox: Maybe<TCashBox>;
  /** how much courier should collect from customer */
  readonly collectFromCustomer: TPriceConverted;
  readonly companyBranch: TCompanyBranch;
  /** number of wares */
  readonly countWares: Scalars['Int']['output'];
  readonly coverPrice: TPriceConverted;
  /** array of orders covered by virtual one */
  readonly coveringOrders: ReadonlyArray<TOrder>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly creditsPendingWalletPayment: Maybe<TCreditsPendingWalletPayment>;
  readonly creditsReward: Maybe<TCreditsReward>;
  readonly currentUserCanFinishOrder: Scalars['Boolean']['output'];
  /** customer data - can be deleted after order is finished */
  readonly customer: TJsonCustomer;
  /** customer data - can be deleted after order is finished */
  readonly customerJson: TJsonCustomer;
  /** count of all customers orders */
  readonly customerOrdersCountCurrent: Scalars['Int']['output'];
  /** sequence of current customers order */
  readonly customerOrdersCountTotal: Scalars['Int']['output'];
  /** delivery time specified by user */
  readonly delayedDeliveryTime: Maybe<Scalars['DateTime']['output']>;
  /** time of when should be order delivered */
  readonly deliverAt: Maybe<Scalars['DateTime']['output']>;
  /** time of when should be order delivered in worst case */
  readonly deliverAtWorst: Maybe<Scalars['DateTime']['output']>;
  /** time of when order was deliver */
  readonly deliveredAt: Maybe<Scalars['DateTime']['output']>;
  readonly deliverySlot: Maybe<TDeliverySlot>;
  readonly deliveryType: Maybe<TDeliveryType>;
  readonly discounts: ReadonlyArray<TPriceWithDescription>;
  readonly doNotCount: Maybe<Scalars['Int']['output']>;
  readonly driverWillPickupAt: Maybe<Scalars['DateTime']['output']>;
  readonly eet: Maybe<TEetType>;
  /** list of available external drivers for order */
  readonly externalDeliveryProviders: ReadonlyArray<TExternalDeliveryProvider>;
  readonly extraCharge: TPriceConverted;
  /** List of extra fees */
  readonly extraFees: ReadonlyArray<TExtraFee>;
  /** Sum of all extra fees */
  readonly extraFeesSum: TPriceConverted;
  /** flat items of orders -- same recipes are grouped together */
  readonly flatItems: ReadonlyArray<TOrderRecipeFlat>;
  readonly gps: Maybe<TGeoPoint>;
  readonly hasRating: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  /** invoice sequence of company branch */
  readonly invoiceSequence: Maybe<Scalars['String']['output']>;
  /** invoice sequence of cash_box */
  readonly invoiceSequenceCashBox: Maybe<Scalars['Int']['output']>;
  /** resettable invoice sequence of company branch, e.g. queue number */
  readonly invoiceSequenceResettable: Maybe<Scalars['Int']['output']>;
  /** was it non registered user who made order */
  readonly isAnonymous: Scalars['Boolean']['output'];
  /** can user cancel current order */
  readonly isCancelable: Scalars['Boolean']['output'];
  readonly isCustomerRegistered: Scalars['Boolean']['output'];
  /** is current order finalized */
  readonly isFinalized: Scalars['Boolean']['output'];
  readonly isPaidWithCard: Scalars['Boolean']['output'];
  /** is current order partially finalized */
  readonly isPartiallyFinalized: Scalars['Boolean']['output'];
  /** is current order marked as high priority */
  readonly isPriority: Scalars['Boolean']['output'];
  /** ordered items (recipes) */
  readonly items: ReadonlyArray<TOrderRecipe>;
  readonly language: TLanguage;
  /** array of all possible transport fees for order */
  readonly levelsOfTransportFees: ReadonlyArray<TTransportFees>;
  /** the number of possible transport fees for order */
  readonly levelsOfTransportFeesCount: Maybe<Scalars['Int']['output']>;
  /** highly depends on location origin - for example, in restaurant can contain number of table */
  readonly location: Maybe<TJsonLocation>;
  /** minimal price of order in case of delivery */
  readonly minimalOrderPrice: Maybe<TPriceConverted>;
  /** Return how much should customer add to order to succeed validation. When succeeds, returns nil. */
  readonly minimalOrderPriceRemainder: Maybe<TPriceConverted>;
  /** Indicates if discounts are included in minimalOrderPrice. When zone is not assignet to order, always return true */
  readonly minimalOrderPriceWithDiscounts: Scalars['Boolean']['output'];
  /** Indicates if transportFee is included in minimalOrderPrice. When zone is not assignet to order, always return true */
  readonly minimalOrderPriceWithTransportFee: Scalars['Boolean']['output'];
  /** the nearest lower value of the transport fee for order */
  readonly nextPossibleTransportFee: Maybe<TTransportFees>;
  /** actual user note */
  readonly note: Maybe<Scalars['String']['output']>;
  /** what method use for user notification */
  readonly notification: TNotification;
  /** operating cost records related to order */
  readonly operatingCostRecords: ReadonlyArray<TOperatingCostRecord>;
  readonly orderConsents: ReadonlyArray<TConsentOrder>;
  readonly orderDeliverySlot: Maybe<TOrderDeliverySlot>;
  /** associated orger group */
  readonly orderGroup: Maybe<TOrderGroup>;
  /** index of order inside associated orger group */
  readonly orderGroupIndex: Maybe<Scalars['Int']['output']>;
  readonly orderOnlineState: Maybe<TOrderOnlineState>;
  readonly orderOrigin: TOrderOrigin;
  /** paid information of order */
  readonly orderPayments: ReadonlyArray<TOrderPaymentMethod>;
  /**
   * OrderStateCategory array where order belongs to
   * @deprecated Use only orderStateCategory query
   */
  readonly orderStateCategories: ReadonlyArray<TOrderStateCategoryEnum>;
  /** last OrderStateCategory where order belongs to */
  readonly orderStateCategory: TOrderStateCategoryEnum;
  /** list of relations to order category state */
  readonly orderStateCategoryRelations: ReadonlyArray<TOrderStateCategoryRelation>;
  readonly orderStateRelations: ReadonlyArray<TOrderStateRelation>;
  readonly orderStates: ReadonlyArray<TOrderState>;
  readonly paidPrice: TPriceConverted;
  /** Note from previous order */
  readonly previousNote: Maybe<Scalars['String']['output']>;
  /** active promo codes of order */
  readonly promoCodes: ReadonlyArray<TPromoCode>;
  /** array of order rating notes */
  readonly rating: Maybe<ReadonlyArray<TOrderRating>>;
  readonly returnPrice: TPriceConverted;
  readonly sector: Maybe<TSector>;
  readonly tip: TPriceConverted;
  readonly totalDiscount: TPriceConverted;
  /** summarized price of order */
  readonly totalSum: TPriceConverted;
  readonly totalVouchers: TPriceConverted;
  /** original order which was transferred to current one */
  readonly transferOrderFrom: Maybe<TOrder>;
  /** last order this order was transferred to */
  readonly transferOrderTo: Maybe<TOrder>;
  readonly transportFee: TPriceConverted;
  readonly updatedAt: Maybe<Scalars['DateTime']['output']>;
  readonly user: Maybe<TUser>;
  /** current user delivering order */
  readonly userDeliveringOrder: Maybe<TUserDeliveringOrder>;
  /** all associations of user delivering order */
  readonly userDeliveringOrders: ReadonlyArray<TUserDeliveringOrder>;
  readonly vouchers: ReadonlyArray<TPriceWithDescription>;
  readonly warePriceType: TWarePriceType;
  readonly zone: Maybe<TZone>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderCollectFromCustomerArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderCoverPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderEetArgs = {
  storno?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderExtraChargeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderExtraFeesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderExtraFeesSumArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderLevelsOfTransportFeesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderMinimalOrderPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderNextPossibleTransportFeeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderOrderStateCategoriesArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderOrderStateCategoryArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderOrderStateCategoryRelationsArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderPaidPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderReturnPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderTipArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderTotalDiscountArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderTotalSumArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderTotalVouchersArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Type holding information about user order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, cashier, editor_order, operator, super_admin]
 *
 */
export type TOrderTransportFeeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/**
 * Complete billing information about order
 *
 *
 * INDEX: [accountant, admin, branch_owner, brand_owner, editor_billings, editor_order_billing, merchant, sales_representative, super_admin, supervisor]
 *
 * READ: [accountant, admin, branch_owner, brand_owner, editor_billings, editor_order_billing, merchant, sales_representative, super_admin, supervisor]
 *
 * CREATE: [admin, editor_order_billing, super_admin]
 *
 * UPDATE: [admin, editor_order_billing, super_admin]
 *
 * DESTROY: [admin, editor_order_billing, super_admin]
 *
 */
export type TOrderBilling = {
  readonly __typename?: 'OrderBilling';
  readonly id: Scalars['ID']['output'];
  readonly order: TOrder;
  /** Type of billing */
  readonly orderBillingType: TOrderBillingType;
  /** price converted to prefered currency */
  readonly price: Maybe<TPriceConverted>;
  readonly processed: Maybe<Scalars['Boolean']['output']>;
};


/**
 * Complete billing information about order
 *
 *
 * INDEX: [accountant, admin, branch_owner, brand_owner, editor_billings, editor_order_billing, merchant, sales_representative, super_admin, supervisor]
 *
 * READ: [accountant, admin, branch_owner, brand_owner, editor_billings, editor_order_billing, merchant, sales_representative, super_admin, supervisor]
 *
 * CREATE: [admin, editor_order_billing, super_admin]
 *
 * UPDATE: [admin, editor_order_billing, super_admin]
 *
 * DESTROY: [admin, editor_order_billing, super_admin]
 *
 */
export type TOrderBillingPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/**
 * Possible OrderBillingType types
 *
 *
 * INDEX: [accountant, admin, editor_billings, super_admin, support, user]
 *
 * READ: [accountant, admin, editor_billings, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderBillingType = {
  readonly __typename?: 'OrderBillingType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TOrderBillingTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** OrderBillingType enum */
export type TOrderBillingTypeEnum =
  | 'AFFILIATE'
  | 'COMMISSION'
  | 'FEE'
  | 'PRICE_SUM'
  | 'REWARD_RESULT';

/** Order which was not canceled with reason */
export type TOrderCancelFailed = {
  readonly __typename?: 'OrderCancelFailed';
  readonly id: Scalars['ID']['output'];
  readonly reason: Scalars['String']['output'];
};

/** Subscription of order category change */
export type TOrderCategoryCountSubscription = {
  readonly __typename?: 'OrderCategoryCountSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly id: Scalars['ID']['output'];
  readonly newOrderStateCategory: TOrderStateCategoryEnum;
  readonly oldOrderStateCategory: TOrderStateCategoryEnum;
  readonly order: TOrder;
};

/** Subscription of order count changes */
export type TOrderCountSubscription = {
  readonly __typename?: 'OrderCountSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly id: Scalars['ID']['output'];
  readonly ordersCount: Scalars['Int']['output'];
};

/**
 * Schema of an OrderDeliverySlot
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderDeliverySlot = {
  readonly __typename?: 'OrderDeliverySlot';
  readonly applied: Scalars['Boolean']['output'];
  readonly deliverySlotSize: Scalars['Int']['output'];
  readonly firstDeliverySlot: TDeliverySlotElement;
  readonly id: Scalars['ID']['output'];
  readonly order: TOrder;
};

/** Objects which may be returned from OrderUpdatePreview */
export type TOrderDiffAttribute = TCompanyBranch | TDateTimeWrapped | TDeliverySlot | TDeliveryType | TOrderRecipe | TPriceConverted;

/** Possible attributes which may change in updateOrderPreview */
export type TOrderDiffAttributeEnum =
  | 'COMPANY_BRANCH'
  | 'DELIVERY_SLOT'
  | 'DELIVERY_TYPE'
  | 'DELIVER_AT'
  | 'ORDER_RECIPE_MAIN'
  | 'ORDER_RECIPE_SIDE_DISH'
  | 'PRICE_EXTRA_CHARGE'
  | 'PRICE_TIP'
  | 'PRICE_TOTAL_SUM'
  | 'PRICE_TRANSPORT_FEE';

/** Possible change types of OrderDiff */
export type TOrderDiffChangeTypeEnum =
  | 'ADD'
  | 'REMOVE'
  | 'UPDATE';

/** Objects which may be commented on */
export type TOrderDiffEntry = {
  readonly __typename?: 'OrderDiffEntry';
  readonly attribute: TOrderDiffAttributeEnum;
  readonly changeType: TOrderDiffChangeTypeEnum;
  readonly newData: Maybe<TOrderDiffAttribute>;
  readonly oldData: Maybe<TOrderDiffAttribute>;
};

/**
 * Entity grouping multiple orders together.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderGroup = {
  readonly __typename?: 'OrderGroup';
  readonly color: Maybe<TOrderGroupColor>;
  readonly id: Scalars['ID']['output'];
  readonly name: Maybe<Scalars['String']['output']>;
  readonly orders: ReadonlyArray<TOrder>;
  readonly user: TUser;
};

/**
 * Order group color with code and color definition
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderGroupColor = TColorInterface & {
  readonly __typename?: 'OrderGroupColor';
  readonly code: Scalars['String']['output'];
  readonly color: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
};

/** OrderMenu */
export type TOrderMenu = TAvailabilityInterface & {
  readonly __typename?: 'OrderMenu';
  /** when record is available */
  readonly availabilities: ReadonlyArray<TAvailability>;
  readonly id: Scalars['ID']['output'];
  /** is available at specific time? */
  readonly isAvailable: Scalars['Boolean']['output'];
  readonly nameLabel: Scalars['String']['output'];
  readonly pictogram: Maybe<Scalars['String']['output']>;
  readonly recipes: ReadonlyArray<TOrderMenuRecipe>;
  readonly wareCategoryColor: Maybe<TWareCategoryColor>;
};


/** OrderMenu */
export type TOrderMenuIsAvailableArgs = {
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};

/** OrderMenuRecipe */
export type TOrderMenuRecipe = {
  readonly __typename?: 'OrderMenuRecipe';
  readonly code: Scalars['String']['output'];
  readonly descriptionLabel: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly internalNote: Maybe<Scalars['String']['output']>;
  readonly nameLabel: Scalars['String']['output'];
  readonly price: TPriceConverted;
  readonly sideDishesWareCategoriesCount: Scalars['Int']['output'];
};


/** OrderMenuRecipe */
export type TOrderMenuRecipePriceArgs = {
  warePriceType: TWarePriceTypeEnum;
};

/** Status of payment in external service */
export type TOrderOnlinePaymentStatus = TOnlinePaymentGatesInterface & {
  readonly __typename?: 'OrderOnlinePaymentStatus';
  readonly csobUrl: Maybe<Scalars['String']['output']>;
  readonly gopayUrl: Maybe<Scalars['String']['output']>;
  readonly gpWebpayUrl: Maybe<Scalars['String']['output']>;
  /** Indicates that online payment transaction is processing. */
  readonly isProcessing: Scalars['Boolean']['output'];
  /** Indicates that online payment transaction finished successfully. */
  readonly isSuccess: Scalars['Boolean']['output'];
  readonly order: TOrder;
  readonly payFastUrl: Maybe<Scalars['String']['output']>;
  readonly payuUrl: Maybe<Scalars['String']['output']>;
  /** errors which we should display to user */
  readonly userErrors: ReadonlyArray<Scalars['String']['output']>;
};

/**
 * Possible OrderOnlineState types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderOnlineState = {
  readonly __typename?: 'OrderOnlineState';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TOrderOnlineStateEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** OrderOnlineState enum */
export type TOrderOnlineStateEnum =
  | 'CANCELED'
  | 'COMPLETED'
  | 'CREATED'
  | 'PAID'
  | 'PENDING'
  | 'REFUNDED';

/**
 * Possible OrderOrigin types
 *
 *
 * INDEX: [admin, editor_orders, guest, super_admin, support, user]
 *
 * READ: [admin, editor_orders, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderOrigin = {
  readonly __typename?: 'OrderOrigin';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TOrderOriginEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/**
 * Possible OrderOriginCategory types
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderOriginCategory = {
  readonly __typename?: 'OrderOriginCategory';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TOrderOriginCategoryEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** OrderOriginCategory enum */
export type TOrderOriginCategoryEnum =
  | 'DOVEZE'
  | 'KIOSK'
  | 'MENUBOARD'
  | 'STAFF'
  | 'STAFF_POS'
  | 'WEBSITE'
  | 'WIFI'
  | 'WOLT';

/** OrderOrigin enum */
export type TOrderOriginEnum =
  | 'AFFILIATE_PIZZA_ROZVOZ'
  | 'AFFILIATE_ROZVOZ_JIDLA'
  | 'AFFILIATE_ROZVOZ_PIZZY_ZDARMA'
  | 'BAKER'
  | 'BISTRO'
  | 'BOLT'
  | 'CALL_CENTER'
  | 'DAME_JIDLO'
  | 'DEFAULT'
  | 'ENIGOO'
  | 'JIDLO_POD_NOS'
  | 'KIOSK'
  | 'MINISITE'
  | 'MOBIL_ANDROID'
  | 'MOBIL_IOS'
  | 'MPIZZA'
  | 'PWA'
  | 'STAFF'
  | 'STAFF_POS'
  | 'WEB'
  | 'WEB_MENU'
  | 'WEB_PARTNER'
  | 'WIFI'
  | 'WIFI_DEFAULT'
  | 'WIFI_PREORDER'
  | 'WOLT';

/**
 * Holds information about one payment of order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_payment_method, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, editor_order_payment_method, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor]
 *
 */
export type TOrderPaymentMethod = {
  readonly __typename?: 'OrderPaymentMethod';
  readonly id: Scalars['ID']['output'];
  readonly order: TOrder;
  readonly paymentMethod: TPaymentMethod;
  readonly price: TPriceConverted;
};


/**
 * Holds information about one payment of order
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_payment_method, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, editor_order_payment_method, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, editor_order_payment_method, sales_representative, super_admin, supervisor]
 *
 */
export type TOrderPaymentMethodPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/**
 * Orders default delivery/pickup time overriding
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, super_admin, supervisor]
 *
 */
export type TOrderProcessTime = {
  readonly __typename?: 'OrderProcessTime';
  readonly companyBranch: TCompanyBranch;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly deliveryType: TDeliveryType;
  readonly expiresAt: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly processTime: Scalars['Int']['output'];
};

/** Order rating */
export type TOrderRating = {
  readonly __typename?: 'OrderRating';
  readonly id: Scalars['ID']['output'];
  readonly orderRatingType: TOrderRatingType;
  readonly text: Maybe<Scalars['String']['output']>;
  readonly value: Maybe<Scalars['Int']['output']>;
};

/** Possible OrderRating types */
export type TOrderRatingType = {
  readonly __typename?: 'OrderRatingType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TOrderRatingTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** Possible order rating types */
export type TOrderRatingTypeEnum =
  | 'RATING'
  | 'RATING_DELIVERY'
  | 'RATING_FOOD'
  | 'RATING_ORDER';

/**
 * One item of Order (ordered recipe)
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, cashier, customer, driver, editor_order_recipe, guest, operator, super_admin, support]
 *
 * DESTROY: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin]
 *
 */
export type TOrderRecipe = {
  readonly __typename?: 'OrderRecipe';
  /** rules applied to this order */
  readonly appliedRules: ReadonlyArray<Scalars['String']['output']>;
  /** was item added to order automatically */
  readonly automatic: Scalars['Boolean']['output'];
  /** covers of item */
  readonly covers: ReadonlyArray<TOrderRecipe>;
  readonly id: Scalars['ID']['output'];
  /** actual user note */
  readonly note: Maybe<Scalars['String']['output']>;
  readonly order: TOrder;
  readonly orderRecipeState: TOrderRecipeState;
  readonly parent: Maybe<TOrderRecipe>;
  readonly price: TPriceConverted;
  readonly priceWithSideDishes: TPriceConverted;
  readonly promoTag: Maybe<TPromoTag>;
  readonly recipe: TRecipe;
  /** side dishes of item */
  readonly sideDishes: ReadonlyArray<TOrderRecipe>;
  readonly wareCategory: Maybe<TWareCategory>;
};


/**
 * One item of Order (ordered recipe)
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, cashier, customer, driver, editor_order_recipe, guest, operator, super_admin, support]
 *
 * DESTROY: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin]
 *
 */
export type TOrderRecipePriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * One item of Order (ordered recipe)
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin, support]
 *
 * UPDATE: [admin, cashier, customer, driver, editor_order_recipe, guest, operator, super_admin, support]
 *
 * DESTROY: [admin, cashier, customer, editor_order_recipe, guest, operator, super_admin]
 *
 */
export type TOrderRecipePriceWithSideDishesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/** Grouped recipes of one order. Recipes are grouped when they property are same. */
export type TOrderRecipeFlat = {
  readonly __typename?: 'OrderRecipeFlat';
  readonly automatic: Scalars['Boolean']['output'];
  readonly order: TOrder;
  readonly price: TPriceConverted;
  readonly quantity: Scalars['Int']['output'];
  readonly recipe: TRecipe;
  /** tree structure of wares of order */
  readonly sideDishes: ReadonlyArray<TOrderRecipeFlat>;
};


/** Grouped recipes of one order. Recipes are grouped when they property are same. */
export type TOrderRecipeFlatPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/**
 * Possible OrderRecipeState types
 *
 *
 * INDEX: [admin, editor_orders, super_admin, support, user]
 *
 * READ: [admin, editor_orders, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderRecipeState = {
  readonly __typename?: 'OrderRecipeState';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TOrderRecipeStateEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** OrderRecipeState enum */
export type TOrderRecipeStateEnum =
  | 'CANCELED'
  | 'COOKED'
  | 'DISPATCHED'
  | 'FINISHED'
  | 'FRESH'
  | 'PREPARING'
  | 'READY';

/**
 * Order state type schema
 *
 *
 * INDEX: [admin, editor_orders, guest, super_admin, support, user]
 *
 * READ: [admin, editor_orders, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderState = {
  readonly __typename?: 'OrderState';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TOrderStateEnum;
  readonly id: Scalars['ID']['output'];
  readonly orderStateCategory: TOrderStateCategory;
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/**
 * Order state category type schema
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderStateCategory = {
  readonly __typename?: 'OrderStateCategory';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TOrderStateCategoryEnum;
  readonly id: Scalars['ID']['output'];
  readonly orderStates: ReadonlyArray<TOrderStateEnum>;
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};


/**
 * Order state category type schema
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderStateCategoryOrderStatesArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};

/** Order state category type schema */
export type TOrderStateCategoryCount = {
  readonly __typename?: 'OrderStateCategoryCount';
  /** enum string used to identify object */
  readonly orderStateCategory: TOrderStateCategory;
  readonly ordersCount: Scalars['Int']['output'];
};

/** OrderStateCategory enum */
export type TOrderStateCategoryEnum =
  | 'BILLS'
  | 'CANCEL'
  | 'DELIVERY'
  | 'FINISHED'
  | 'IN_CART'
  | 'MAIN'
  | 'NEW_ORDERS'
  | 'NOTIFICATION'
  | 'ON_WAY'
  | 'PAYMENT'
  | 'PREPARING'
  | 'PRODUCTION'
  | 'READY_TO_DELIVER'
  | 'RECLAMATION'
  | 'UNCATEGORIZED';

/**
 * Order state category relation type schema
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TOrderStateCategoryRelation = {
  readonly __typename?: 'OrderStateCategoryRelation';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly orderStateCategory: TOrderStateCategoryEnum;
  readonly orderStates: ReadonlyArray<TOrderStateHistorical>;
};

/** OrderStateCategoryTarget enum */
export type TOrderStateCategoryTargetEnum =
  | 'BACKEND'
  | 'DRIVER'
  | 'FE_ADMIN'
  | 'FE_COMPLETION'
  | 'FE_KITCHEN';

/** OrderState enum */
export type TOrderStateEnum =
  | 'ACCEPTED'
  | 'ASSIGNED_TO_DELIVER'
  | 'BILL_PASSED'
  | 'BILL_PRINTED'
  | 'BRANCH_CANCEL'
  | 'BY_CREDIT_CARD'
  | 'CANCELED'
  | 'CANCEL_ON_WAY'
  | 'CAUSE'
  | 'CUSTOMER_CANCEL'
  | 'CUSTOMER_DID_NOT_COME'
  | 'CUSTOMER_NOTIFIED'
  | 'DELIVERED'
  | 'DELIVER_REJECTED'
  | 'EVALUATED'
  | 'FINISHED'
  | 'HANDOVER'
  | 'HIGH_PRIORITY'
  | 'IN_CART'
  | 'IN_PRODUCE'
  | 'IN_PROGRESS'
  | 'KITCHEN_TICKET_PRINTED'
  | 'LATE'
  | 'MADE'
  | 'NEW'
  | 'NOT_EVALUATED'
  | 'ONLINE'
  | 'ON_WAY'
  | 'PAID'
  | 'READY_TO_DELIVER'
  | 'READY_TO_PRODUCE'
  | 'RECEIVED'
  | 'RECLAMATION'
  | 'RECLAMATION_HANDLED'
  | 'REFUND'
  | 'SHOULD_BE_PAID'
  | 'SHOWN'
  | 'STUCK_ON_ROAD'
  | 'TRANSFER_CANCEL'
  | 'UNPAID'
  | 'WAITING_FOR_CUSTOMER'
  | 'WIFI_DELAYED';

/** All order states taken from events */
export type TOrderStateHistorical = {
  readonly __typename?: 'OrderStateHistorical';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly orderState: TOrderStateEnum;
  readonly user: TUser;
};

export type TOrderStateInterface = {
  /**
   * OrderStateCategory array where order belongs to
   * @deprecated Use only orderStateCategory query
   */
  readonly orderStateCategories: ReadonlyArray<TOrderStateCategoryEnum>;
  /** last OrderStateCategory where order belongs to */
  readonly orderStateCategory: TOrderStateCategoryEnum;
  /** list of relations to order category state */
  readonly orderStateCategoryRelations: ReadonlyArray<TOrderStateCategoryRelation>;
  readonly orderStateRelations: ReadonlyArray<TOrderStateRelation>;
  readonly orderStates: ReadonlyArray<TOrderState>;
};


export type TOrderStateInterfaceOrderStateCategoriesArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


export type TOrderStateInterfaceOrderStateCategoryArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


export type TOrderStateInterfaceOrderStateCategoryRelationsArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};

/**
 * Order state relation type schema
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_state_relation, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_state_relation, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, cashier_cancel, customer, driver, editor_order_state_relation, guest, operator, owner_cancel, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, customer, editor_order_state_relation, guest, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, customer, editor_order_state_relation, guest, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TOrderStateRelation = {
  readonly __typename?: 'OrderStateRelation';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly order: TOrder;
  readonly orderState: TOrderState;
};

/** Subscription of order changes */
export type TOrderUpdateSubscription = {
  readonly __typename?: 'OrderUpdateSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly id: Scalars['ID']['output'];
  readonly order: Maybe<TOrder>;
};

/** Provide order information with errors */
export type TOrderWithErrors = {
  readonly __typename?: 'OrderWithErrors';
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly order: TOrder;
};

/** Result of canceling multiple orders */
export type TOrdersBulkCanceledResult = {
  readonly __typename?: 'OrdersBulkCanceledResult';
  readonly canceled: ReadonlyArray<TOrder>;
  readonly notCanceled: ReadonlyArray<TOrderCancelFailed>;
};

export type TOrdersInterface = {
  readonly orders: ReadonlyArray<TOrder>;
};


export type TOrdersInterfaceOrdersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  orderOrigins?: InputMaybe<ReadonlyArray<TOrderOriginEnum>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Information about pagination in a connection. */
export type TPageInfo = {
  readonly __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor: Maybe<Scalars['String']['output']>;
};

/**
 * Possible PaymentGate types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPaymentGate = {
  readonly __typename?: 'PaymentGate';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TPaymentGateEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** PaymentGate enum */
export type TPaymentGateEnum =
  | 'CASH'
  | 'CREDIT'
  | 'CSOB'
  | 'EXTERNAL_GATE'
  | 'GOPAY'
  | 'GP_WEBPAY'
  | 'KIOSK_GATE'
  | 'PAYPAL'
  | 'PAYU'
  | 'PAY_FAST'
  | 'WALLET_CREDIT';

/**
 * Holds information about specifications of payment method
 *
 *
 * INDEX: [admin, editor_payment_method, guest, super_admin, support, user]
 *
 * READ: [admin, editor_payment_method, guest, super_admin, support, user]
 *
 * CREATE: [admin, editor_payment_method, super_admin, support]
 *
 * UPDATE: [admin, editor_payment_method, super_admin, support]
 *
 * DESTROY: [admin, editor_payment_method, super_admin]
 *
 */
export type TPaymentMethod = {
  readonly __typename?: 'PaymentMethod';
  readonly country: TCountry;
  /** default description of payment method */
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly paymentGate: TPaymentGate;
  readonly paymentType: TPaymentType;
  /** default value of payment method */
  readonly price: Maybe<TPriceConverted>;
};


/**
 * Holds information about specifications of payment method
 *
 *
 * INDEX: [admin, editor_payment_method, guest, super_admin, support, user]
 *
 * READ: [admin, editor_payment_method, guest, super_admin, support, user]
 *
 * CREATE: [admin, editor_payment_method, super_admin, support]
 *
 * UPDATE: [admin, editor_payment_method, super_admin, support]
 *
 * DESTROY: [admin, editor_payment_method, super_admin]
 *
 */
export type TPaymentMethodPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/**
 * Payment methods used by branch
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, editor_payment_method_branch, guest, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, editor_payment_method_branch, guest, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_payment_method_branch, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_payment_method_branch, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_payment_method_branch, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TPaymentMethodBranch = {
  readonly __typename?: 'PaymentMethodBranch';
  readonly companyBranch: TCompanyBranch;
  readonly deliveryType: Maybe<TDeliveryType>;
  readonly enabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  /** Maximum amount allowed for the payment method */
  readonly maximumAmount: Maybe<TPriceConverted>;
  readonly orderOrigin: TOrderOrigin;
  readonly paymentMethod: TPaymentMethod;
  readonly warePriceType: TWarePriceType;
};

/**
 * Possible PaymentType types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPaymentType = {
  readonly __typename?: 'PaymentType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TPaymentTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** PaymentType enum */
export type TPaymentTypeEnum =
  | 'CASH'
  | 'CREDIT'
  | 'DISCOUNT'
  | 'POST_PAID'
  | 'VOUCHER'
  | 'WALLET_CREDIT';

/** Holds information about phone number and its description */
export type TPhone = {
  readonly __typename?: 'Phone';
  /** is contact method default one */
  readonly default: Scalars['Boolean']['output'];
  readonly description: Maybe<Scalars['String']['output']>;
  readonly phone: Scalars['String']['output'];
};


/** Holds information about phone number and its description */
export type TPhonePhoneArgs = {
  part?: InputMaybe<TPhonePartSelectorEnum>;
};

/** Hold registration token and information about user presence for given phone number */
export type TPhoneCodeValidation = {
  readonly __typename?: 'PhoneCodeValidation';
  readonly token: Scalars['String']['output'];
  readonly userExists: Scalars['Boolean']['output'];
};

/** Allows to select a specific part of a phone number (country code, local number) or the full international number. Without a selection, the default is the full international number. */
export type TPhonePartSelectorEnum =
  | 'COUNTRY_CODE'
  | 'FULL'
  | 'LOCAL_NUMBER';

export type TPopup = {
  readonly __typename?: 'Popup';
  readonly orderOriginCategories: Maybe<TOrderOriginCategoryEnum>;
  readonly text: Scalars['String']['output'];
};

/** Price converted to preferred currency with ware category id */
export type TPriceComboSideDish = {
  readonly __typename?: 'PriceComboSideDish';
  readonly price: TPriceConverted;
  readonly wareCategoryId: Scalars['ID']['output'];
};

/** Price converted to preferred currency */
export type TPriceConverted = {
  readonly __typename?: 'PriceConverted';
  readonly currency: TCurrency;
  /** value formatted based on provided currency */
  readonly formattedValue: Scalars['String']['output'];
  /** value rounded to defined number of decimal places based on currency */
  readonly roundedValue: Scalars['Float']['output'];
  readonly value: Scalars['Float']['output'];
};

export type TPriceInterface = {
  /** rules applied to order and all order wares */
  readonly allAppliedRules: ReadonlyArray<Scalars['String']['output']>;
  /** rules applied to this order */
  readonly appliedRules: ReadonlyArray<Scalars['String']['output']>;
  readonly billing: ReadonlyArray<TOrderBilling>;
  /** order payment method can be updated to these values */
  readonly canBeUpdatedToPaymentMethods: ReadonlyArray<TPaymentMethod>;
  readonly cashBox: Maybe<TCashBox>;
  /** how much courier should collect from customer */
  readonly collectFromCustomer: TPriceConverted;
  readonly coverPrice: TPriceConverted;
  readonly creditsPendingWalletPayment: Maybe<TCreditsPendingWalletPayment>;
  readonly discounts: ReadonlyArray<TPriceWithDescription>;
  readonly eet: Maybe<TEetType>;
  readonly extraCharge: TPriceConverted;
  /** List of extra fees */
  readonly extraFees: ReadonlyArray<TExtraFee>;
  /** Sum of all extra fees */
  readonly extraFeesSum: TPriceConverted;
  readonly isPaidWithCard: Scalars['Boolean']['output'];
  /** minimal price of order in case of delivery */
  readonly minimalOrderPrice: Maybe<TPriceConverted>;
  /** Return how much should customer add to order to succeed validation. When succeeds, returns nil. */
  readonly minimalOrderPriceRemainder: Maybe<TPriceConverted>;
  /** Indicates if discounts are included in minimalOrderPrice. When zone is not assignet to order, always return true */
  readonly minimalOrderPriceWithDiscounts: Scalars['Boolean']['output'];
  /** Indicates if transportFee is included in minimalOrderPrice. When zone is not assignet to order, always return true */
  readonly minimalOrderPriceWithTransportFee: Scalars['Boolean']['output'];
  /** operating cost records related to order */
  readonly operatingCostRecords: ReadonlyArray<TOperatingCostRecord>;
  /** paid information of order */
  readonly orderPayments: ReadonlyArray<TOrderPaymentMethod>;
  readonly paidPrice: TPriceConverted;
  /** active promo codes of order */
  readonly promoCodes: ReadonlyArray<TPromoCode>;
  readonly returnPrice: TPriceConverted;
  readonly tip: TPriceConverted;
  readonly totalDiscount: TPriceConverted;
  /** summarized price of order */
  readonly totalSum: TPriceConverted;
  readonly totalVouchers: TPriceConverted;
  readonly vouchers: ReadonlyArray<TPriceWithDescription>;
};


export type TPriceInterfaceCollectFromCustomerArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceCoverPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceEetArgs = {
  storno?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TPriceInterfaceExtraChargeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceExtraFeesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceExtraFeesSumArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceMinimalOrderPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfacePaidPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceReturnPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceTipArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceTotalDiscountArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceTotalSumArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TPriceInterfaceTotalVouchersArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

export type TPriceRangeRuleCreate = {
  readonly price: TInputCurrencyCreate;
  readonly toPrice: TInputCurrencyCreate;
};

export type TPriceWithDescription = {
  readonly __typename?: 'PriceWithDescription';
  readonly code: Scalars['ID']['output'];
  readonly description: Scalars['String']['output'];
  readonly price: TPriceConverted;
  readonly promoCodes: ReadonlyArray<Scalars['String']['output']>;
};


export type TPriceWithDescriptionPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/** Print configuration */
export type TPrintConfiguration = {
  readonly __typename?: 'PrintConfiguration';
  readonly configuration: Scalars['Json']['output'];
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly printableType: TPrintableType;
};

/**
 * Print queue item
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPrintQueue = {
  readonly __typename?: 'PrintQueue';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly expiresAt: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly printQueueState: TPrintQueueState;
  readonly printTemplateRender: TPrintTemplateRender;
  readonly printer: TPrinter;
  /** Printer identification through company branch trigger printer */
  readonly targetMac: Scalars['String']['output'];
};

/**
 * Possible PrintQueueState types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPrintQueueState = {
  readonly __typename?: 'PrintQueueState';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TPrintQueueStateEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** PrintQueueState enum */
export type TPrintQueueStateEnum =
  | 'CANCELED'
  | 'EXPIRED'
  | 'FAILURE'
  | 'FRESH'
  | 'PRINTED';

/** Subscription of print queue */
export type TPrintQueueUpdateSubscription = {
  readonly __typename?: 'PrintQueueUpdateSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly id: Scalars['ID']['output'];
  readonly printQueue: TPrintQueue;
};

/**
 * Print template schema
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPrintTemplate = {
  readonly __typename?: 'PrintTemplate';
  /** template */
  readonly content: Scalars['String']['output'];
  readonly default: Scalars['Boolean']['output'];
  readonly description: Scalars['String']['output'];
  /** @deprecated Replaced with `PrintTemplate.default` */
  readonly enabled: Scalars['Boolean']['output'];
  readonly expirationMinutes: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly language: Maybe<TLanguage>;
  readonly printTemplateType: TPrintTemplateType;
  /** @deprecated Replaced with triggerable_type */
  readonly printableType: TPrintableType;
  readonly public: Scalars['Boolean']['output'];
  readonly triggerableType: TTriggerableType;
};

/**
 * Print template render
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPrintTemplateRender = {
  readonly __typename?: 'PrintTemplateRender';
  readonly id: Scalars['ID']['output'];
  readonly printableId: Scalars['ID']['output'];
  readonly printableType: Scalars['String']['output'];
  readonly renderedContent: Scalars['String']['output'];
  readonly renderedContentBase64: Scalars['String']['output'];
};

/**
 * Possible PrintTemplateType types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPrintTemplateType = {
  readonly __typename?: 'PrintTemplateType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TPrintTemplateTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** PrintTemplateType enum */
export type TPrintTemplateTypeEnum =
  | 'FINANCIAL_REPORT_BRANCH'
  | 'FINANCIAL_REPORT_TERMINAL'
  | 'KITCHEN_TICKET'
  | 'ORDER_TICKET';

/** Possible PrintableType types */
export type TPrintableType = {
  readonly __typename?: 'PrintableType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TPrintableTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** PrintableType enum */
export type TPrintableTypeEnum =
  | 'FINANCIAL_REPORT'
  | 'NOTE'
  | 'ORDER'
  | 'PRINTER'
  | 'USERS_CONFIRMATION_CODE';

/**
 * Printer schema
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor]
 *
 */
export type TPrinter = {
  readonly __typename?: 'Printer';
  readonly companyBranchPrinters: ReadonlyArray<TCompanyBranchPrinter>;
  readonly id: Scalars['ID']['output'];
  readonly mac: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly printerType: TPrinterType;
  readonly user: TUser;
};

/**
 * Possible PrinterType types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPrinterType = {
  readonly __typename?: 'PrinterType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TPrinterTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** PrinterType enum */
export type TPrinterTypeEnum =
  | 'KIOSK'
  | 'W58MM'
  | 'W80MM';

export type TProcessTimeInterface = {
  readonly currentDeliveryTime: Scalars['Int']['output'];
  readonly currentPickupTime: Scalars['Int']['output'];
  /** time in minutes that is required to deliver order */
  readonly defaultDeliveryTime: Scalars['Int']['output'];
  readonly defaultDeliveryTimeEnabled: Scalars['Boolean']['output'];
  /** time in minutes that is required to pickup order */
  readonly defaultPickupTime: Scalars['Int']['output'];
  readonly defaultPickupTimeEnabled: Scalars['Boolean']['output'];
  readonly delayedDeliveryEnabled: Scalars['Boolean']['output'];
  readonly delayedDeliveryLimit: Scalars['Int']['output'];
  readonly overriddenDeliveryTime: Maybe<TOrderProcessTime>;
  readonly overriddenPickupTime: Maybe<TOrderProcessTime>;
};

/**
 * Information about promo code
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, editor_orders, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, editor_orders, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TPromoCode = {
  readonly __typename?: 'PromoCode';
  readonly code: Scalars['String']['output'];
  readonly company: Maybe<TCompany>;
  readonly companyBranch: Maybe<TCompanyBranch>;
  readonly enabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly maxUsage: Maybe<Scalars['Int']['output']>;
  readonly maxUsagePerUser: Maybe<Scalars['Int']['output']>;
  readonly public: Scalars['Boolean']['output'];
  readonly type: TPromoCodeType;
  readonly validTill: Maybe<Scalars['DateTime']['output']>;
};

/** Promo code statistics */
export type TPromoCodeStatistic = {
  readonly __typename?: 'PromoCodeStatistic';
  /** order where the promo code was used */
  readonly appliedOrder: Maybe<TOrder>;
  /** Phone of customer who claimed the voucher */
  readonly claimCustomerPhone: Maybe<Scalars['String']['output']>;
  /** origin of the right to use promo code */
  readonly claimDate: Maybe<Scalars['Date']['output']>;
  /** expiration of claim */
  readonly claimExpiration: Maybe<Scalars['Date']['output']>;
  /** order that entitles use promo code */
  readonly claimOrder: Maybe<TOrder>;
  /** Description of promo code. */
  readonly description: Maybe<Scalars['String']['output']>;
  /** Discount given by promo code. */
  readonly discount: Maybe<TPriceConverted>;
  readonly promoCode: TPromoCode;
};

/**
 * Possible PromoCodeType types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPromoCodeType = {
  readonly __typename?: 'PromoCodeType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TPromoCodeTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** PromoCodeType enum */
export type TPromoCodeTypeEnum =
  | 'PROMO_CODE'
  | 'VOUCHER';

/** Promo header translations */
export type TPromoHeaderTranslation = {
  readonly __typename?: 'PromoHeaderTranslation';
  readonly content: Maybe<Scalars['String']['output']>;
  readonly language: TLanguageEnum;
};

/**
 * Possible PromoTag types
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TPromoTag = {
  readonly __typename?: 'PromoTag';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TPromoTagEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** PromoTag enum */
export type TPromoTagEnum =
  | 'HIDDEN_FROM_STANDARD'
  | 'PROMO_CART'
  | 'PROMO_CATEGORY_LIST'
  | 'PROMO_FOOTER'
  | 'PROMO_HEADER'
  | 'PROMO_SIDE_DISH';

/** The query root of this schema */
export type TQuery = {
  readonly __typename?: 'Query';
  /**
   * Index all records of AddressType
   *
   * ALLOWED ROLES: [admin, operator, super_admin, support, user]
   *
   */
  readonly addressTypes: ReadonlyArray<TAddressType>;
  /**
   * Index all records of Allergen
   *
   * ALLOWED ROLES: [admin, editor_menu, editor_orders, guest, super_admin, support, user]
   *
   */
  readonly allergens: ReadonlyArray<TAllergen>;
  /**
   * List setting for application (styles, header text, homepage url)
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
   *
   */
  readonly applicationSettings: TApplicationSettings;
  /**
   * Get details of Board
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly board: TBoard;
  /**
   * Get details of BoardScreen
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly boardScreen: TBoardScreen;
  /**
   * Index boards
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly boardScreens: ReadonlyArray<TBoardScreen>;
  /**
   * Get details of BoardTemplate
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly boardTemplate: TBoardTemplate;
  /**
   * Index board templates
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly boardTemplates: ReadonlyArray<TBoardTemplate>;
  /**
   * Index boards
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, guest, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly boards: ReadonlyArray<TBoard>;
  /**
   * Get details of BusinessHour
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_business_hour, editor_business_hours, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly businessHour: TBusinessHour;
  /**
   * Get all business hours based on specified filtering
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_reports, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam, wolt_menu_sync]
   *
   */
  readonly businessHours: ReadonlyArray<TBusinessHour>;
  /**
   * Get appropriate cash box
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly cashBox: TCashBox;
  /**
   * Index of cash boxes
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_cash_box, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly cashBoxes: ReadonlyArray<TCashBox>;
  /**
   * Get list of cashiers
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
   *
   */
  readonly cashiers: ReadonlyArray<TUser>;
  /**
   * Index of companies of appropriate type
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_reports, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam, wolt_menu_sync]
   *
   */
  readonly companies: ReadonlyArray<TCompany>;
  /**
   * Get details of Company
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_company, guest, sales_representative, super_admin, supervisor, support, user, vam]
   *
   */
  readonly company: TCompany;
  /**
   * Get details of CompanyBranch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
   *
   */
  readonly companyBranch: TCompanyBranch;
  /**
   * Find a suitable company branch.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
   *
   */
  readonly companyBranchLookUp: TCompanyBrandLookUp;
  /**
   * Index company branch trigger printers
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly companyBranchTriggerPrinters: ReadonlyArray<TCompanyBranchTriggerPrinter>;
  /**
   * Index company branch triggers
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_isolated_print, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly companyBranchTriggers: ReadonlyArray<TCompanyBranchTrigger>;
  /**
   * Get details of CompanyBranchUser
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly companyBranchUser: TCompanyBranchUser;
  /**
   * Get links between Company Branch and User
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_company_branch_user, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly companyBranchUsers: ReadonlyArray<TCompanyBranchUser>;
  /**
   * Get all company branches of defined company
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
   *
   */
  readonly companyBranches: ReadonlyArray<TCompanyBranch>;
  /**
   * Obtain all company branches that deliver to appropriate address
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
   *
   */
  readonly companyBranchesLookUp: TCompanyBranchesLookUp;
  /**
   * Index all records of CompanyType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly companyTypes: ReadonlyArray<TCompanyType>;
  /**
   * Get details of Consent
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly consent: TConsent;
  /**
   * Index all records of ConsentRevokeType
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly consentRevokeTypes: ReadonlyArray<TConsentsRevokeType>;
  /**
   * Index all records of ConsentType
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly consentTypes: ReadonlyArray<TConsentsType>;
  /**
   * Index all records of Country
   *
   * ALLOWED ROLES: [admin, editor_country, editor_menu, guest, operator, super_admin, support, user]
   *
   */
  readonly countries: ReadonlyArray<TCountry>;
  /**
   * Get details of Country
   *
   * ALLOWED ROLES: [admin, editor_country, editor_menu, guest, operator, super_admin, support, user]
   *
   */
  readonly country: TCountry;
  /**
   * Details of a Reward
   *
   * ALLOWED ROLES: [admin, customer, super_admin, support]
   *
   */
  readonly creditsReward: TCreditsReward;
  /**
   * Details of a Wallet
   *
   * ALLOWED ROLES: [admin, customer, super_admin, support]
   *
   */
  readonly creditsWallet: TCreditsWallet;
  /**
   * Details of a WalletActivity
   *
   * ALLOWED ROLES: [admin, customer, super_admin, support]
   *
   */
  readonly creditsWalletActivity: TCreditsWalletActivity;
  /**
   * Index all records of Currency
   *
   * ALLOWED ROLES: [admin, editor_currency, guest, super_admin, support, user]
   *
   */
  readonly currencies: ReadonlyArray<TCurrency>;
  /**
   * Get details of Currency
   *
   * ALLOWED ROLES: [admin, editor_currency, guest, super_admin, support, user]
   *
   */
  readonly currency: TCurrency;
  /**
   * Details of a Customer
   *
   * ALLOWED ROLES: [admin, customer, super_admin, support]
   *
   */
  readonly customer: TCustomer;
  /**
   * Export customers for specified period of time
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, export_customers, super_admin, supervisor]
   *
   */
  readonly customersFileReports: Scalars['String']['output'];
  /**
   * Get all delivery slots from now + default_order_process_time until delayed_delivery_limit. If a Zone is passed in as argument, its delivery_deviation_minutes is added to the delayed_delivery_limit.
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly deliverySlots: ReadonlyArray<TDeliverySlot>;
  /**
   * Index all records of DeliveryType
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly deliveryTypes: ReadonlyArray<TDeliveryType>;
  /**
   * Index all records of DeviceState
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly deviceStates: ReadonlyArray<TDeviceState>;
  /**
   * Index all records of DeviceType
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly deviceTypes: ReadonlyArray<TDeviceType>;
  /**
   * Get list of drivers
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
   *
   */
  readonly drivers: ReadonlyArray<TUser>;
  /**
   * Get estimated pickup, delivery times and estimated delivery fee
   *
   * ALLOWED ROLES: [admin, editor_order, operator, request_external_driver, super_admin]
   *
   */
  readonly estimateExternalDelivery: TExternalDeliveryEstimate;
  /**
   * Get all active external deliveries of company branches
   *
   * ALLOWED ROLES: [admin, editor_order, operator, request_external_driver, super_admin]
   *
   */
  readonly externalDeliveries: ReadonlyArray<TExternalDelivery>;
  /**
   * Index all records of FieldState
   *
   * ALLOWED ROLES: [admin, editor, super_admin, support, user]
   *
   */
  readonly fieldStates: ReadonlyArray<TFieldState>;
  /**
   * Index all records of FileReportType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly fileReportTypes: ReadonlyArray<TFileReportType>;
  /**
   * Calculate statistics for specified period of time
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_statistics, editor_company_branch, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly fileReports: Scalars['String']['output'];
  /**
   * Get details of FinancialReport
   *
   * ALLOWED ROLES: [accountant, admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly financialReport: TFinancialReport;
  /**
   * Index all financial reports for specified object.
   *
   * ALLOWED ROLES: [accountant, admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly financialReports: ReadonlyArray<TFinancialReport>;
  /**
   * Index all records of Group
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly groups: ReadonlyArray<TGroup>;
  /**
   * Get details of Ingredient
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_ingredient, editor_menu, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly ingredient: TIngredient;
  /**
   * Get ingredients for appropriate recipe
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_ingredient, editor_menu, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly ingredients: ReadonlyArray<TIngredient>;
  /**
   * Index all records of Language
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly languages: ReadonlyArray<TLanguage>;
  /**
   * Generate current financial report for specified object.
   *
   * ALLOWED ROLES: [accountant, admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly lastFinancialReport: TFinancialReport;
  /**
   * Find last generated financial report for specified object.
   *
   * ALLOWED ROLES: [accountant, admin, branch_owner, brand_owner, cashier_reports, editor_financial_report, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly lastGeneratedFinancialReport: Maybe<TFinancialReport>;
  /**
   * List setting for mobile application
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor, editor_company_branch, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, vam, wolt_menu_sync]
   *
   */
  readonly mobileApplicationSettings: Maybe<TMobileApplicationSetting>;
  /**
   * Get details of Occasion
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly occasion: TOccasion;
  /**
   * Index occasion records
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly occasions: ReadonlyArray<TOccasion>;
  /**
   * Index all records of OperatingCostType
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_statistics, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly operatingCostTypes: ReadonlyArray<TOperatingCostType>;
  /**
   * Index records of OperatingCostType for deliveries
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_statistics, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly operatingCostTypesForDeliveries: ReadonlyArray<TOperatingCostType>;
  /**
   * Index records of OperatingCostType for payment gates
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_statistics, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly operatingCostTypesForPayments: ReadonlyArray<TOperatingCostType>;
  /**
   * Index records of OperatingCostType for SMS
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_statistics, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly operatingCostTypesForSms: ReadonlyArray<TOperatingCostType>;
  /**
   * Get appropriate order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly order: TOrder;
  /**
   * Index all records of OrderBillingType
   *
   * ALLOWED ROLES: [accountant, admin, editor_billings, super_admin, support, user]
   *
   */
  readonly orderBillingTypes: ReadonlyArray<TOrderBillingType>;
  /**
   * Get details of OrderGroup
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly orderGroup: TOrderGroup;
  /**
   * Index all records of OrderGroupColor
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly orderGroupColors: ReadonlyArray<TOrderGroupColor>;
  /**
   * Get categories of recipes
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
   *
   */
  readonly orderMenuAdmin: ReadonlyArray<TOrderMenu>;
  /**
   * Reload information about payment status from external service
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly orderOnlinePaymentStatus: TOrderOnlinePaymentStatus;
  /**
   * Index all records of OrderOnlineState
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly orderOnlineStates: ReadonlyArray<TOrderOnlineState>;
  /**
   * Index all records of OrderOriginCategory
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly orderOriginCategories: ReadonlyArray<TOrderOriginCategory>;
  /**
   * Index all records of OrderOrigin
   *
   * ALLOWED ROLES: [admin, editor_orders, guest, super_admin, support, user]
   *
   */
  readonly orderOrigins: ReadonlyArray<TOrderOrigin>;
  /**
   * Index all records of OrderRatingType
   *
   * ALLOWED ROLES: [admin, cashier_menu, editor_menu, merchant, super_admin, support, user]
   *
   */
  readonly orderRatingTypes: ReadonlyArray<TOrderRatingType>;
  /**
   * Read Order Recipe
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly orderRecipe: TOrderRecipe;
  /**
   * Get items of order
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order_recipe, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly orderRecipes: ReadonlyArray<TOrderRecipe>;
  /**
   *
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly orderStateCategories: ReadonlyArray<TOrderStateCategory>;
  /**
   * Index all records of OrderState
   *
   * ALLOWED ROLES: [admin, editor_orders, guest, super_admin, support, user]
   *
   */
  readonly orderStates: ReadonlyArray<TOrderState>;
  /**
   * Get orders with using of additional filters
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly orders: ReadonlyArray<TOrder>;
  /**
   * Count number of orders for specified user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly ordersCategoryCount: ReadonlyArray<TOrderStateCategoryCount>;
  /**
   * Count number of orders for specified user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   * @deprecated Use ordersCategoryCount instead.
   */
  readonly ordersCount: Scalars['Int']['output'];
  /**
   * Index all records of PaymentGate
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly paymentGates: ReadonlyArray<TPaymentGate>;
  /**
   * Get details of PaymentMethod
   *
   * ALLOWED ROLES: [admin, editor_payment_method, guest, super_admin, support, user]
   *
   */
  readonly paymentMethod: TPaymentMethod;
  /**
   * List of payment methods used by branch
   *
   * ALLOWED ROLES: [admin, editor_payment_method, guest, super_admin, support, user]
   *
   */
  readonly paymentMethods: ReadonlyArray<TPaymentMethod>;
  /**
   * Index all records of PaymentType
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly paymentTypes: ReadonlyArray<TPaymentType>;
  /**
   * Obtain global user permissions for specified set of actions
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_reports, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam, wolt_menu_sync]
   *
   */
  readonly permissions: TUserPermission;
  /**
   * Index print configurations
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   * @deprecated Use triggerConfigurations instead.
   */
  readonly printConfigurations: ReadonlyArray<TTriggerConfiguration>;
  /**
   * Read relevant print queue records
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly printQueues: ReadonlyArray<TPrintQueue>;
  /**
   * Index print templates
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly printTemplates: ReadonlyArray<TPrintTemplate>;
  /**
   * Index all records of PrintableType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   * @deprecated Use triggerableTypes instead.
   */
  readonly printableTypes: ReadonlyArray<TPrintableType>;
  /**
   * Get details of Printer
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly printer: TPrinter;
  /**
   * Index all records of PrinterType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly printerTypes: ReadonlyArray<TPrinterType>;
  /**
   * Index printers
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly printers: ReadonlyArray<TPrinter>;
  /**
   * Get details of PromoCode
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_orders, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly promoCode: TPromoCode;
  /**
   * List of promo code used by branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_orders, editor_promo_code, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly promoCodes: ReadonlyArray<TPromoCode>;
  /**
   * Get details of promo tag
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly promoTag: TPromoTag;
  /**
   * Index all records of PromoTag
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly promoTags: ReadonlyArray<TPromoTag>;
  /**
   * Read recipe
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
   *
   */
  readonly recipe: TRecipe;
  /**
   * Index all records of RecipeColor
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly recipeColors: ReadonlyArray<TRecipeColor>;
  /**
   * Get details of promo tag
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly recipeTag: TRecipeTag;
  /**
   * Index all records of RecipeTagCategoryType
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly recipeTagCategoryTypes: ReadonlyArray<TRecipeTagCategoryType>;
  /**
   * Get details of RecipeTagRelation
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly recipeTagRelation: TRecipeTagRelation;
  /**
   *
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly recipeTagRelations: ReadonlyArray<TRecipeTagRelation>;
  /**
   * Returns all RecipeTags available to the User – system RecipeTags + company RecipeTags for the companies the User is in.
   *
   * ALLOWED ROLES: [admin, guest, super_admin, support, user]
   *
   */
  readonly recipeTags: ReadonlyArray<TRecipeTag>;
  /**
   * Index recipe records
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
   *
   */
  readonly recipes: ReadonlyArray<TRecipe>;
  /**
   * Obtain correct gps coordinates/address from user defined gps/address. Uses even IP address in case that gps/address is missing.
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_reports, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam, wolt_menu_sync]
   *
   */
  readonly resolveLocation: TAddressResolvedLocation;
  /**
   * Get details of Sector
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, guest, operator, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly sector: TSector;
  /**
   * Get details of SectorRecipe
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly sectorRecipe: TSectorRecipe;
  /**
   * Index sector recipes
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly sectorRecipes: ReadonlyArray<TSectorRecipe>;
  /**
   * Index sector records
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, guest, operator, sales_representative, super_admin, supervisor, support, user]
   *
   */
  readonly sectors: ReadonlyArray<TSector>;
  /**
   * Index all records of SettingType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly settingTypes: ReadonlyArray<TSettingType>;
  /**
   * Get details of Shift
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_shift, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly shift: TShift;
  /**
   * Index all records of ShiftUserState
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly shiftUserStates: ReadonlyArray<TShiftUserState>;
  /**
   * Index of shifts for appropriate company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_shift, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly shifts: ReadonlyArray<Maybe<TShift>>;
  /**
   * Calculate statistics for specified period of time
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_statistics, driver, editor_company_branch, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly statistics: TStatistics;
  /**
   * Calculate fees for specified period of time
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly statisticsForFees: ReadonlyArray<TStatisticsForFees>;
  /**
   * Calculate turnover and fees divided by order origin
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly statisticsForOperatingCosts: ReadonlyArray<TStatisticsForOperatingCosts>;
  /**
   * Calculate total amount divided by type of payment (online vs other)
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_company_branch, merchant, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly statisticsForPayments: TStatisticsForPayments;
  /**
   * Index of stock items for appropriate company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly stockInventories: ReadonlyArray<TStockInventory>;
  /**
   * Get details of StockInventory
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly stockInventory: TStockInventory;
  /**
   * Get details of StockInventoryItem
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly stockInventoryItem: TStockInventoryItem;
  /**
   * Index all records of StockInventoryItemChangeType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly stockInventoryItemChangeTypes: ReadonlyArray<TStockInventoryItemChangeType>;
  /**
   * Get details of StockItem
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_menu, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly stockItem: TStockItem;
  /**
   * Index all records of StockItemChangeType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly stockItemChangeTypes: ReadonlyArray<TStockItemChangeType>;
  /**
   * Get details of StockTransfer
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly stockItemTransfer: TStockTransfer;
  /**
   * Index stock item transfers
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly stockItemTransfers: ReadonlyArray<TStockTransfer>;
  /**
   * Index of stock items for appropriate company branch
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_menu, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly stockItems: ReadonlyArray<TStockItem>;
  /**
   * Index all records of StornoRequestType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly stornoRequestTypes: ReadonlyArray<TStornoRequestType>;
  /**
   * Obtain correct gps coordinates from seznam suggestions defined gps/address.
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_reports, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam, wolt_menu_sync]
   *
   */
  readonly suggestAddress: ReadonlyArray<TAddressResolvedLocation>;
  /**
   * Return list of places with similar name from geolocation service
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_reports, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam, wolt_menu_sync]
   *
   */
  readonly suggestGeolocation: ReadonlyArray<TJsonAddress>;
  /**
   * Get details of TransportationDevice
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly transportationDevice: TTransportationDevice;
  /**
   * Get details of TransportationDeviceUser
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly transportationDeviceUser: TTransportationDeviceUser;
  /**
   * Index of transportation devices assigned to user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly transportationDeviceUsers: ReadonlyArray<TTransportationDeviceUser>;
  /**
   * Get all transportation device of defined company branch - can use additional filtering
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly transportationDevices: ReadonlyArray<TTransportationDevice>;
  /**
   * Index trigger configurations
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly triggerConfigurations: ReadonlyArray<TTriggerConfiguration>;
  /**
   * Index all records of TriggerType
   *
   * ALLOWED ROLES: [admin, super_admin, support]
   *
   */
  readonly triggerTypes: ReadonlyArray<TTriggerType>;
  /**
   * Index all records of TriggerableType
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly triggerableTypes: ReadonlyArray<TTriggerableType>;
  /**
   * Get details of User
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
   *
   */
  readonly user: TUser;
  /**
   * Find information about call event.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_order, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly userCustomerCalling: TUserCustomerCalling;
  /**
   * Assign user that will deliver order
   *
   * ALLOWED ROLES: [admin, cashier_delivery, driver, super_admin, support]
   *
   */
  readonly userDeliveries: ReadonlyArray<TUserDelivery>;
  /**
   * Get details of UserDeliveringOrder
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly userDeliveringOrder: TUserDeliveringOrder;
  /**
   * Index of orders delivered by appropriate user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly userDeliveringOrders: ReadonlyArray<TUserDeliveringOrder>;
  /**
   * Get details of UserDelivery
   *
   * ALLOWED ROLES: [admin, cashier_delivery, driver, super_admin, support]
   *
   */
  readonly userDelivery: TUserDelivery;
  /**
   * Index of shifts of appropriate user
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly userShifts: ReadonlyArray<TShiftUser>;
  /**
   * Get list of users
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
   *
   */
  readonly users: ReadonlyArray<TUser>;
  /**
   * Find customer by phone and return known information.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, editor_company_branch, operator, sales_representative, super_admin, supervisor]
   *
   */
  readonly vamInformation: TCustomerInformation;
  /**
   * Query VAM and return its result about user agreements.
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, customer, driver, editor_order, editor_orders, guest, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly vamStatus: ReadonlyArray<TVamAgreement>;
  /**
   * Index of vats
   *
   * ALLOWED ROLES: [admin, editor_country, editor_menu, guest, operator, super_admin, support, user]
   *
   */
  readonly vats: ReadonlyArray<TVat>;
  /**
   * Get details of Ware
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly ware: TWare;
  /**
   * Get categories of recipes
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
   *
   */
  readonly wareCategories: ReadonlyArray<TWareCategory>;
  /**
   * Read ware category
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
   *
   */
  readonly wareCategory: TWareCategory;
  /**
   * Index all records of WareCategoryColor
   *
   * ALLOWED ROLES: [admin, super_admin, support, user]
   *
   */
  readonly wareCategoryColors: ReadonlyArray<TWareCategoryColor>;
  /**
   * Index all records of WareCategoryType
   *
   * ALLOWED ROLES: [admin, editor_menu, guest, super_admin, support, user]
   *
   */
  readonly wareCategoryTypes: ReadonlyArray<TWareCategoryType>;
  /**
   * Index all records of WareUnit
   *
   * ALLOWED ROLES: [admin, editor_menu, operator, super_admin, support, user]
   *
   */
  readonly wareUnits: ReadonlyArray<TWareUnit>;
  /**
   * Index of wares
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly wares: ReadonlyArray<TWare>;
  /**
   * Index all records of WeekDay
   *
   * ALLOWED ROLES: [admin, editor_business_hours, editor_orders, guest, super_admin, support, user]
   *
   */
  readonly weekDays: ReadonlyArray<TWeekDay>;
  /**
   * Get details of Zone
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly zone: TZone;
  /**
   * Index all records of ZoneColor
   *
   * ALLOWED ROLES: [admin, editor_zones, super_admin, support, user]
   *
   */
  readonly zoneColors: ReadonlyArray<TZoneColor>;
  /**
   * Index all records of ZoneType
   *
   * ALLOWED ROLES: [admin, editor_zones, super_admin, support, user]
   *
   */
  readonly zoneTypes: ReadonlyArray<TZoneType>;
  /**
   * Index of zones
   *
   * ALLOWED ROLES: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
   *
   */
  readonly zones: ReadonlyArray<TZone>;
};


/** The query root of this schema */
export type TQueryAddressTypesArgs = {
  internal?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root of this schema */
export type TQueryApplicationSettingsArgs = {
  brand?: InputMaybe<Scalars['ID']['input']>;
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryBoardArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryBoardScreenArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryBoardScreensArgs = {
  board: ReadonlyArray<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryBoardTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryBoardTemplatesArgs = {
  features?: InputMaybe<TInputBoardTemplateFeaturesIndex>;
};


/** The query root of this schema */
export type TQueryBoardsArgs = {
  boardTemplates?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};


/** The query root of this schema */
export type TQueryBusinessHourArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryBusinessHoursArgs = {
  companyBranch: Scalars['ID']['input'];
  specific?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root of this schema */
export type TQueryCashBoxArgs = {
  uuid: Scalars['String']['input'];
};


/** The query root of this schema */
export type TQueryCashBoxesArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root of this schema */
export type TQueryCashiersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};


/** The query root of this schema */
export type TQueryCompaniesArgs = {
  companyType?: InputMaybe<TCompanyTypeEnum>;
};


/** The query root of this schema */
export type TQueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryCompanyBranchArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryCompanyBranchLookUpArgs = {
  findNearestCompanyBranch?: InputMaybe<Scalars['Boolean']['input']>;
  hostUrl?: InputMaybe<Scalars['String']['input']>;
};


/** The query root of this schema */
export type TQueryCompanyBranchTriggerPrintersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  onlyTarget?: InputMaybe<Scalars['Boolean']['input']>;
  targetMac?: InputMaybe<Scalars['String']['input']>;
};


/** The query root of this schema */
export type TQueryCompanyBranchTriggersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  triggerType?: InputMaybe<TTriggerTypeEnum>;
};


/** The query root of this schema */
export type TQueryCompanyBranchUserArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryCompanyBranchUsersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root of this schema */
export type TQueryCompanyBranchesArgs = {
  brand?: InputMaybe<Scalars['ID']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  portal?: InputMaybe<Scalars['Boolean']['input']>;
  woltMenuSync?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root of this schema */
export type TQueryCompanyBranchesLookUpArgs = {
  address: Scalars['String']['input'];
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};


/** The query root of this schema */
export type TQueryConsentArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryCountryArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryCreditsRewardArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryCreditsWalletArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryCreditsWalletActivityArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryCurrencyArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryCustomerArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryCustomersFileReportsArgs = {
  backgroundExport: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryDeliverySlotsArgs = {
  companyBranch: Scalars['ID']['input'];
  deliveryType: TDeliveryTypeEnum;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  full?: InputMaybe<Scalars['Boolean']['input']>;
  taken?: InputMaybe<Scalars['Boolean']['input']>;
  zone?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryDriversArgs = {
  availableForAll?: InputMaybe<Scalars['Boolean']['input']>;
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  onlyAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  showExternalApi?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root of this schema */
export type TQueryEstimateExternalDeliveryArgs = {
  externalDeliveryProvider: TExternalDeliveryProviderEnum;
  order: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryExternalDeliveriesArgs = {
  companyBranches: ReadonlyArray<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryFileReportsArgs = {
  fileReportType: TFileReportTypeEnum;
  format?: InputMaybe<TFileReportFormat>;
  statisticsInput: TInputStatisticCreate;
};


/** The query root of this schema */
export type TQueryFinancialReportArgs = {
  report: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryFinancialReportsArgs = {
  cashBoxId?: InputMaybe<Scalars['ID']['input']>;
  companyBranchId: Scalars['ID']['input'];
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryIngredientArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryIngredientsArgs = {
  quantity?: InputMaybe<Scalars['Int']['input']>;
  recipe: Scalars['ID']['input'];
  stockItem?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryLastFinancialReportArgs = {
  cashBoxId?: InputMaybe<Scalars['ID']['input']>;
  companyBranchId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryLastGeneratedFinancialReportArgs = {
  cashBoxId?: InputMaybe<Scalars['ID']['input']>;
  companyBranchId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryMobileApplicationSettingsArgs = {
  companyBranch: Scalars['ID']['input'];
  platform: TMobilePlatformEnum;
};


/** The query root of this schema */
export type TQueryOccasionArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryOccasionsArgs = {
  activePreorder?: InputMaybe<Scalars['Boolean']['input']>;
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  future?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root of this schema */
export type TQueryOrderArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryOrderGroupArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryOrderMenuAdminArgs = {
  companyBranch: Scalars['ID']['input'];
  language?: InputMaybe<TLanguageEnum>;
  orderOriginCategory: TOrderOriginCategoryEnum;
  wareCategoryType: TWareCategoryTypeEnum;
};


/** The query root of this schema */
export type TQueryOrderOnlinePaymentStatusArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryOrderRecipeArgs = {
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  language?: InputMaybe<TLanguageEnum>;
};


/** The query root of this schema */
export type TQueryOrderRecipesArgs = {
  order: Scalars['ID']['input'];
  orderRecipeState?: InputMaybe<TOrderRecipeStateEnum>;
  recipe?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryOrderStateCategoriesArgs = {
  target?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/** The query root of this schema */
export type TQueryOrdersArgs = {
  order?: InputMaybe<TInputOrderIndex>;
  pagination?: InputMaybe<TInputPaginationParams>;
};


/** The query root of this schema */
export type TQueryOrdersCategoryCountArgs = {
  companyBranches: ReadonlyArray<Scalars['ID']['input']>;
  includeOldFinished?: InputMaybe<Scalars['Boolean']['input']>;
  orderStateCategoriesOR?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  orderStateCategoryTarget?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/** The query root of this schema */
export type TQueryOrdersCountArgs = {
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  includeOldFinished?: InputMaybe<Scalars['Boolean']['input']>;
  orderStateCategories?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  orderStateCategoriesOR?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  orderStateCategoryTarget?: InputMaybe<TOrderStateCategoryTargetEnum>;
  orderStates?: InputMaybe<ReadonlyArray<TOrderStateEnum>>;
  orderStatesOR?: InputMaybe<ReadonlyArray<TOrderStateEnum>>;
};


/** The query root of this schema */
export type TQueryPaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryPaymentMethodsArgs = {
  paymentMethod: TInputPaymentMethodIndex;
};


/** The query root of this schema */
export type TQueryPrintConfigurationsArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  printableType?: InputMaybe<TPrintableTypeEnum>;
};


/** The query root of this schema */
export type TQueryPrintQueuesArgs = {
  printers?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  targetMac?: InputMaybe<Scalars['String']['input']>;
};


/** The query root of this schema */
export type TQueryPrintTemplatesArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  triggerableType?: InputMaybe<TTriggerableTypeEnum>;
};


/** The query root of this schema */
export type TQueryPrinterArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryPrintersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  printerType?: InputMaybe<TPrinterTypeEnum>;
  targetMac?: InputMaybe<Scalars['String']['input']>;
};


/** The query root of this schema */
export type TQueryPromoCodeArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryPromoCodesArgs = {
  promoCode: TInputPromoCodeIndex;
};


/** The query root of this schema */
export type TQueryPromoTagArgs = {
  enum?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryRecipeArgs = {
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  language?: InputMaybe<TLanguageEnum>;
};


/** The query root of this schema */
export type TQueryRecipeTagArgs = {
  id: Scalars['ID']['input'];
  skipSystemTagFallback?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root of this schema */
export type TQueryRecipeTagRelationArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryRecipeTagRelationsArgs = {
  usedByCompanyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  withRecipeTagsByCompanies?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};


/** The query root of this schema */
export type TQueryRecipeTagsArgs = {
  companies?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  recipeTagCategoryTypes?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  systemTags?: InputMaybe<Scalars['Boolean']['input']>;
  usedByCompanyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};


/** The query root of this schema */
export type TQueryRecipesArgs = {
  ageControl?: InputMaybe<Scalars['Boolean']['input']>;
  companyBranch: Scalars['ID']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailableAt?: InputMaybe<Scalars['DateTime']['input']>;
  isCombinationMeal?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<TLanguageEnum>;
  onlyNotInCategory?: InputMaybe<Scalars['Boolean']['input']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
  recipeTags?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  ware?: InputMaybe<Scalars['ID']['input']>;
  wareCategory?: InputMaybe<Scalars['ID']['input']>;
  wareCategoryType?: InputMaybe<TWareCategoryTypeEnum>;
};


/** The query root of this schema */
export type TQueryResolveLocationArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['ID']['input']>;
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};


/** The query root of this schema */
export type TQuerySectorArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQuerySectorRecipeArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQuerySectorRecipesArgs = {
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  groups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  orderRecipeStateOR?: InputMaybe<ReadonlyArray<TOrderRecipeStateEnum>>;
  sectors?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  sectorsWithChildren?: InputMaybe<Scalars['Boolean']['input']>;
  stateChangeSince?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The query root of this schema */
export type TQuerySectorsArgs = {
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
  sectorType?: InputMaybe<TSectorTypeEnum>;
};


/** The query root of this schema */
export type TQueryShiftArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryShiftsArgs = {
  beginAt?: InputMaybe<Scalars['DateTime']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  companyBranch: Scalars['ID']['input'];
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The query root of this schema */
export type TQueryStatisticsArgs = {
  statisticsInput: TInputStatisticCreate;
};


/** The query root of this schema */
export type TQueryStatisticsForFeesArgs = {
  statisticsParams: TInputFeeStatistics;
};


/** The query root of this schema */
export type TQueryStatisticsForOperatingCostsArgs = {
  statisticsParams: TInputFeeStatistics;
};


/** The query root of this schema */
export type TQueryStatisticsForPaymentsArgs = {
  statisticsParams: TInputFeeStatistics;
};


/** The query root of this schema */
export type TQueryStockInventoriesArgs = {
  companyBranch: Scalars['ID']['input'];
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdTo?: InputMaybe<Scalars['DateTime']['input']>;
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryStockInventoryArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryStockInventoryItemArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryStockItemArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryStockItemTransferArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryStockItemTransfersArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  rejectAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  rejectedByTarget?: InputMaybe<Scalars['Boolean']['input']>;
  sourceCompanyBranch?: InputMaybe<Scalars['ID']['input']>;
  targetCompanyBranch?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryStockItemsArgs = {
  company?: InputMaybe<Scalars['ID']['input']>;
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** The query root of this schema */
export type TQuerySuggestAddressArgs = {
  brand?: InputMaybe<Scalars['ID']['input']>;
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  gps: ReadonlyArray<TInputGeoPointCreate>;
};


/** The query root of this schema */
export type TQuerySuggestGeolocationArgs = {
  address: Scalars['String']['input'];
  country?: InputMaybe<TCountryEnum>;
};


/** The query root of this schema */
export type TQueryTransportationDeviceArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryTransportationDeviceUserArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryTransportationDeviceUsersArgs = {
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdTo?: InputMaybe<Scalars['DateTime']['input']>;
  returnedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  returnedTo?: InputMaybe<Scalars['DateTime']['input']>;
  transportationDevice?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryTransportationDevicesArgs = {
  companyBranch: Scalars['ID']['input'];
  deviceState?: InputMaybe<TDeviceStateEnum>;
  deviceType?: InputMaybe<TDeviceTypeEnum>;
};


/** The query root of this schema */
export type TQueryTriggerConfigurationsArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  triggerType?: InputMaybe<TTriggerTypeEnum>;
  triggerableType?: InputMaybe<TTriggerableTypeEnum>;
};


/** The query root of this schema */
export type TQueryUserArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryUserCustomerCallingArgs = {
  eventId: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryUserDeliveriesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  transportationDeviceUser?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryUserDeliveringOrderArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryUserDeliveringOrdersArgs = {
  includeOldFinished?: InputMaybe<Scalars['Boolean']['input']>;
  orderStates: ReadonlyArray<TOrderStateEnum>;
  user: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryUserDeliveryArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryUserShiftsArgs = {
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  shiftUserState?: InputMaybe<TShiftUserStateEnum>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryUsersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};


/** The query root of this schema */
export type TQueryVamInformationArgs = {
  companyBranchId: Scalars['ID']['input'];
  phone: Scalars['String']['input'];
};


/** The query root of this schema */
export type TQueryVamStatusArgs = {
  input: TInputVamStatus;
};


/** The query root of this schema */
export type TQueryVatsArgs = {
  companyBranch: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryWareArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryWareCategoriesArgs = {
  companyBranch: Scalars['ID']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailableAt?: InputMaybe<Scalars['DateTime']['input']>;
  language?: InputMaybe<TLanguageEnum>;
  occasion?: InputMaybe<Scalars['ID']['input']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
  promoTags?: InputMaybe<ReadonlyArray<TPromoTagEnum>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sector?: InputMaybe<Scalars['ID']['input']>;
  wareCategoryType?: InputMaybe<TWareCategoryTypeEnum>;
  withoutPromoTags?: InputMaybe<ReadonlyArray<TPromoTagEnum>>;
};


/** The query root of this schema */
export type TQueryWareCategoryArgs = {
  companyBranch?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  language?: InputMaybe<TLanguageEnum>;
};


/** The query root of this schema */
export type TQueryWaresArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  recipe?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type TQueryZoneArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type TQueryZonesArgs = {
  companyBranches: ReadonlyArray<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  zoneTypes?: InputMaybe<ReadonlyArray<TZoneTypeEnum>>;
};

/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipe = TAvailabilityInterface & {
  readonly __typename?: 'Recipe';
  readonly ageControl: Scalars['Boolean']['output'];
  /** possible allergens */
  readonly allergens: ReadonlyArray<TAllergen>;
  /** recipes that are associated with current recipe */
  readonly associatedRecipes: ReadonlyArray<TRecipeRelation>;
  /** when record is available */
  readonly availabilities: ReadonlyArray<TAvailability>;
  /** number of items that can be produced based on stock */
  readonly availableAmount: Scalars['Int']['output'];
  readonly bistroId: Maybe<Scalars['ID']['output']>;
  /** recipe code */
  readonly code: Scalars['String']['output'];
  /** Description of rules where current recipe is used. */
  readonly dependentRules: ReadonlyArray<Scalars['String']['output']>;
  readonly descriptionLabel: Maybe<Scalars['String']['output']>;
  readonly descriptionLabelTranslated: Maybe<Scalars['String']['output']>;
  readonly dotykackaId: Maybe<Scalars['ID']['output']>;
  readonly enabled: Scalars['Boolean']['output'];
  readonly enabledByOwner: Scalars['Boolean']['output'];
  /** Groups (Workplaces) where the recipe belongs to */
  readonly groups: ReadonlyArray<TGroup>;
  /** Return true if recipe has at least one mandatory side dish category */
  readonly hasMandatoryCategories: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly image: Maybe<Scalars['String']['output']>;
  /** ingredients of recipe */
  readonly ingredients: ReadonlyArray<TIngredient>;
  /** recipe internal code */
  readonly internalCode: Scalars['String']['output'];
  readonly internalNote: Maybe<Scalars['String']['output']>;
  /** is available at specific time? */
  readonly isAvailable: Scalars['Boolean']['output'];
  readonly isCombinationMeal: Scalars['Boolean']['output'];
  readonly isCover: Scalars['Boolean']['output'];
  readonly isMain: Scalars['Boolean']['output'];
  readonly isSideDish: Scalars['Boolean']['output'];
  /** minimum possible sum of the prices of all recipes from side dishes categories */
  readonly mainCombinationMealPrice: TPriceConverted;
  readonly nameLabel: Scalars['String']['output'];
  readonly nameLabelTranslated: Maybe<Scalars['String']['output']>;
  /** number recipes that is part of appropriate order */
  readonly orderRecipeCount: Scalars['Int']['output'];
  /** Return pictogram of recipe. If not specified, inheritance fallback to primaryCategory is enabled. */
  readonly pictogram: Maybe<Scalars['String']['output']>;
  /** delivered price converted to prefered currency */
  readonly price: TPriceConverted;
  /** possible prices of recipes */
  readonly prices: ReadonlyArray<TRecipePrice>;
  /** all categories where recipe is used */
  readonly primaryWareCategory: Maybe<TWareCategory>;
  readonly recipeColor: Maybe<TRecipeColor>;
  readonly recipeTagRelations: Maybe<ReadonlyArray<TRecipeTagRelation>>;
  readonly recipeTags: Maybe<ReadonlyArray<TRecipeTag>>;
  /** which payment methods can be used to pay for recipe */
  readonly rejectedPaymentMethods: ReadonlyArray<TPaymentMethod>;
  readonly shared: Scalars['Boolean']['output'];
  /** returns an array of the difference between the price of recipe and minimum price of all recipes for each recipe categories */
  readonly sideDishCombinationMealPrices: Maybe<ReadonlyArray<TPriceComboSideDish>>;
  /** all categories that contains possible side dishes of recipe */
  readonly sideDishesWareCategories: ReadonlyArray<TWareCategory>;
  /** number of side dishes categories that recipe can use */
  readonly sideDishesWareCategoriesCount: Scalars['Int']['output'];
  readonly soldOut: Scalars['Boolean']['output'];
  /** stock items of recipe */
  readonly stockItems: ReadonlyArray<TStockItem>;
  readonly translations: ReadonlyArray<TRecipeTranslation>;
  readonly video: Maybe<Scalars['String']['output']>;
  readonly ware: Maybe<TWare>;
  /** all categories where recipe is used */
  readonly wareCategories: ReadonlyArray<TWareCategory>;
  /** number of categories where recipe is used */
  readonly wareCategoriesCount: Scalars['Int']['output'];
  readonly wareCategoryType: TWareCategoryType;
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipeImageArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipeIsAvailableArgs = {
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipeMainCombinationMealPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipeOrderRecipeCountArgs = {
  orderId: Scalars['ID']['input'];
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipePictogramArgs = {
  enableFallback?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipePriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipePricesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};


/**
 * Recipe description for every Ware. Holds information about types of Ware - for example can keep information that Pizza is XXL.
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_menu, editor_orders, editor_recipe, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipeSideDishCombinationMealPricesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
  warePriceType?: InputMaybe<TWarePriceTypeEnum>;
};

/**
 * Recipe color with code and color definition
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TRecipeColor = TColorInterface & {
  readonly __typename?: 'RecipeColor';
  readonly code: Scalars['String']['output'];
  readonly color: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
};

/**
 * Price of recipe
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_menu, editor_recipe_price, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_menu, editor_recipe_price, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipePrice = {
  readonly __typename?: 'RecipePrice';
  readonly id: Scalars['ID']['output'];
  /** price converted to prefered currency */
  readonly price: TPriceConverted;
  readonly recipe: TRecipe;
  readonly vat: TVat;
  readonly warePriceType: TWarePriceType;
};


/**
 * Price of recipe
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_menu, editor_recipe_price, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_menu, editor_recipe_price, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe_price, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipePricePriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/**
 * Relation between two recipes
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_recipe_relation, merchant, operator, sales_representative, super_admin, supervisor, support, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_recipe_relation, merchant, operator, sales_representative, super_admin, supervisor, support, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_recipe_relation, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_recipe_relation, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_recipe_relation, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TRecipeRelation = {
  readonly __typename?: 'RecipeRelation';
  readonly associatedRecipe: TRecipe;
  readonly id: Scalars['ID']['output'];
  readonly recipe: TRecipe;
  readonly warePriceType: TWarePriceType;
};

/**
 *
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor]
 *
 */
export type TRecipeTag = {
  readonly __typename?: 'RecipeTag';
  readonly color: Maybe<Scalars['String']['output']>;
  readonly company: Maybe<TCompany>;
  readonly id: Scalars['ID']['output'];
  readonly image: Maybe<Scalars['String']['output']>;
  readonly label: Maybe<Scalars['String']['output']>;
  readonly pictogram: Maybe<Scalars['String']['output']>;
  readonly recipeTagCategoryType: Maybe<TRecipeTagCategoryType>;
  readonly systemRecipeTag: Maybe<TRecipeTag>;
  readonly translations: ReadonlyArray<TRecipeTagTranslation>;
};


/**
 *
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor]
 *
 */
export type TRecipeTagImageArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/**
 *
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_menu, super_admin, supervisor]
 *
 */
export type TRecipeTagLabelArgs = {
  company?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Possible RecipeTagCategoryType types
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TRecipeTagCategoryType = {
  readonly __typename?: 'RecipeTagCategoryType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TRecipeTagCategoryTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** RecipeTagCategoryType enum */
export type TRecipeTagCategoryTypeEnum =
  | 'SPECIAL_FLAG'
  | 'WARE_PROPERTY'
  | 'WARE_TYPE';

/**
 *
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TRecipeTagRelation = {
  readonly __typename?: 'RecipeTagRelation';
  readonly id: Scalars['ID']['output'];
  readonly inherited: Scalars['Boolean']['output'];
  readonly parentRelation: Maybe<TRecipeTagRelation>;
  readonly recipeTag: TRecipeTag;
  readonly taggable: TRecipeTagTaggable;
};

/** Object which can be tagged by a RecipeTag */
export type TRecipeTagTaggable = TRecipe | TWareCategory;

/** Translations */
export type TRecipeTagTranslation = {
  readonly __typename?: 'RecipeTagTranslation';
  readonly label: Maybe<Scalars['String']['output']>;
  readonly language: TLanguage;
};

/** Translations */
export type TRecipeTranslation = {
  readonly __typename?: 'RecipeTranslation';
  readonly descriptionLabel: Maybe<Scalars['String']['output']>;
  readonly label: Maybe<Scalars['String']['output']>;
  readonly language: TLanguage;
};

export type TRequestEmailConfirmationCode = {
  readonly __typename?: 'RequestEmailConfirmationCode';
  readonly email: Scalars['String']['output'];
};

export type TRequestPhoneConfirmationCode = {
  readonly __typename?: 'RequestPhoneConfirmationCode';
  readonly phone: Scalars['String']['output'];
};


export type TRequestPhoneConfirmationCodePhoneArgs = {
  part?: InputMaybe<TPhonePartSelectorEnum>;
};

export type TResolvedCompanyBranch = {
  readonly __typename?: 'ResolvedCompanyBranch';
  readonly companyBranch: TCompanyBranch;
  /** url to doveze app */
  readonly url: Scalars['String']['output'];
  /** zone that applies for customer delivery */
  readonly zone: TZone;
};

export type TRestrictedAttributes = {
  /** can be address from google - no consistent data */
  readonly address: TJsonAddress;
  /** customer data - can be deleted after order is finished */
  readonly customer: TJsonCustomer;
  /** customer data - can be deleted after order is finished */
  readonly customerJson: TJsonCustomer;
  readonly gps: Maybe<TGeoPoint>;
  /** highly depends on location origin - for example, in restaurant can contain number of table */
  readonly location: Maybe<TJsonLocation>;
};

/**
 * Possible user roles
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, editor_role, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, editor_role, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, editor_role, super_admin]
 *
 * UPDATE: [admin, editor_role, super_admin]
 *
 * DESTROY: [admin, editor_role, super_admin]
 *
 */
export type TRole = {
  readonly __typename?: 'Role';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TRoleEnum;
  readonly id: Scalars['ID']['output'];
  /** @deprecated Use rawCode instead. */
  readonly name: Scalars['String']['output'];
  readonly rawCode: Scalars['String']['output'];
};

/** Possible roles for user */
export type TRoleEnum =
  | 'ACCESS_CONFIG'
  | 'ACCOUNTANT'
  | 'ACCOUNT_MANAGER'
  | 'ADMIN'
  | 'BRANCH_OWNER'
  | 'BRAND_OWNER'
  | 'CALL_CENTER'
  | 'CASHIER'
  | 'CASHIER_BASIC_RECIPES'
  | 'CASHIER_CANCEL'
  | 'CASHIER_CHANGE_DELIVERY_TYPE'
  | 'CASHIER_DELIVERY'
  | 'CASHIER_ISOLATED_PRINT'
  | 'CASHIER_KIOSK'
  | 'CASHIER_MENU'
  | 'CASHIER_PAYMENT_METHODS'
  | 'CASHIER_POS'
  | 'CASHIER_PROCESS_TIME'
  | 'CASHIER_REPORTS'
  | 'CASHIER_STATISTICS'
  | 'CASHIER_TRANSFER_COMPANY_BRANCH'
  | 'CASHIER_UNLIMITED'
  | 'CASHIER_UNLIMITED_CUSTOMER'
  | 'CASHIER_WITHOUT_PRINT'
  | 'CUSTOMER'
  | 'DRIVER'
  | 'DRIVER_DEFAULT'
  | 'DRIVER_DODO'
  | 'DRIVER_FOODIS'
  | 'DRIVER_FOODORA_GO'
  | 'DRIVER_LIFTAGO'
  | 'DRIVER_PROROZVOZ'
  | 'DRIVER_WOLT_DRIVE'
  | 'EDITOR'
  | 'EDITOR_ADDRESS'
  | 'EDITOR_ANNOUNCEMENT'
  | 'EDITOR_AVAILABILITY'
  | 'EDITOR_BILLINGS'
  | 'EDITOR_BUSINESS_HOUR'
  | 'EDITOR_BUSINESS_HOURS'
  | 'EDITOR_CASH_BOX'
  | 'EDITOR_COMPANY'
  | 'EDITOR_COMPANY_BRANCH'
  | 'EDITOR_COMPANY_BRANCH_CURRENCY'
  | 'EDITOR_COMPANY_BRANCH_DELIVERY'
  | 'EDITOR_COMPANY_BRANCH_USER'
  | 'EDITOR_COMPANY_ORDER_ORIGIN'
  | 'EDITOR_COUNTRY'
  | 'EDITOR_COUNTRY_VAT'
  | 'EDITOR_COUNTRY_VAT_TYPE_PRICE'
  | 'EDITOR_CURRENCY'
  | 'EDITOR_EVENT'
  | 'EDITOR_FINANCIAL_REPORT'
  | 'EDITOR_IMPORT_LOG'
  | 'EDITOR_INGREDIENT'
  | 'EDITOR_LABEL'
  | 'EDITOR_LABEL_TRANSLATION'
  | 'EDITOR_MENU'
  | 'EDITOR_NOTE'
  | 'EDITOR_ORDER'
  | 'EDITOR_ORDERS'
  | 'EDITOR_ORDER_BILLING'
  | 'EDITOR_ORDER_DISCOUNT'
  | 'EDITOR_ORDER_ORIGIN_PRICE_TYPE'
  | 'EDITOR_ORDER_PAYMENT_METHOD'
  | 'EDITOR_ORDER_PRICE_MODIFICATION'
  | 'EDITOR_ORDER_RECIPE'
  | 'EDITOR_ORDER_STATE_RELATION'
  | 'EDITOR_PAGE_ELEMENT'
  | 'EDITOR_PAYMENT_METHOD'
  | 'EDITOR_PAYMENT_METHOD_BRANCH'
  | 'EDITOR_PROMO_CODE'
  | 'EDITOR_RECIPE'
  | 'EDITOR_RECIPE_PRICE'
  | 'EDITOR_RECIPE_RELATION'
  | 'EDITOR_REJECTED_PAYMENT_METHOD'
  | 'EDITOR_ROLE'
  | 'EDITOR_SETTING'
  | 'EDITOR_SHIFT'
  | 'EDITOR_SHIFT_USER'
  | 'EDITOR_SORTING'
  | 'EDITOR_STOCK_ITEM'
  | 'EDITOR_STOCK_ITEM_ALLERGEN'
  | 'EDITOR_STOCK_TRANSFER'
  | 'EDITOR_TRANSPORTATION_DEVICE'
  | 'EDITOR_TRANSPORTATION_DEVICE_USER'
  | 'EDITOR_USER'
  | 'EDITOR_USER_DELIVERING_ORDER'
  | 'EDITOR_USER_LOGIN_PROVIDER'
  | 'EDITOR_USER_PERSONAL'
  | 'EDITOR_WALLET_CREDITS'
  | 'EDITOR_WARE'
  | 'EDITOR_WARE_CATEGORY'
  | 'EDITOR_WARE_CATEGORY_RELATION'
  | 'EDITOR_ZONE'
  | 'EDITOR_ZONES'
  | 'EXPORT_CUSTOMERS'
  | 'EXTERN'
  | 'EXTERNAL_API'
  | 'GUEST'
  | 'LIFTAGO'
  | 'MERCHANT'
  | 'OPERATOR'
  | 'OWNER_CANCEL'
  | 'REQUEST_CANCEL'
  | 'REQUEST_EXTERNAL_DRIVER'
  | 'SALES_REPRESENTATIVE'
  | 'SUPERVISOR'
  | 'SUPER_ADMIN'
  | 'SUPPORT'
  | 'SUSPENDED_USER'
  | 'TEMPLATABLE_MANAGER'
  | 'USER'
  | 'VAM'
  | 'WOLT_MENU_SYNC';

/**
 * Sector information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, guest, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, guest, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TSector = TAvailabilityInterface & {
  readonly __typename?: 'Sector';
  /** when record is available */
  readonly availabilities: ReadonlyArray<TAvailability>;
  readonly code: Scalars['String']['output'];
  readonly companyBranch: TCompanyBranch;
  /** delivery type for sector */
  readonly deliveryType: Maybe<TDeliveryType>;
  readonly eetEnabled: Maybe<Scalars['Boolean']['output']>;
  readonly enabled: Scalars['Boolean']['output'];
  readonly gps: Maybe<TGeoPoint>;
  readonly id: Scalars['ID']['output'];
  readonly inheritedAvailabilities: ReadonlyArray<TAvailability>;
  /** delivery type for sector when inheritance is used */
  readonly inheritedDeliveryType: Maybe<TDeliveryType>;
  readonly inheritedEetEnabled: Scalars['Boolean']['output'];
  readonly inheritedEnabled: Scalars['Boolean']['output'];
  readonly inheritedOccasionsEnabled: Scalars['Boolean']['output'];
  readonly inheritedOrderDelaySeconds: Scalars['Int']['output'];
  /** ware price type for sector when inheritance is used */
  readonly inheritedWarePriceType: TWarePriceType;
  /** is available at specific time? */
  readonly isAvailable: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  /** all available occasions */
  readonly occasions: ReadonlyArray<TOccasion>;
  readonly occasionsEnabled: Maybe<Scalars['Boolean']['output']>;
  readonly orderDelaySeconds: Maybe<Scalars['Int']['output']>;
  /** sectors parent */
  readonly parent: Maybe<TSector>;
  /** occasions with active preorder */
  readonly preordableOccasions: ReadonlyArray<TOccasion>;
  readonly sectorType: TSectorType;
  readonly wareCategoryAvailabilities: ReadonlyArray<TSectorWareCategory>;
  /** ware price type for sector */
  readonly warePriceType: Maybe<TWarePriceType>;
};


/**
 * Sector information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, guest, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, guest, operator, sales_representative, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TSectorIsAvailableArgs = {
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};

/**
 * SectorRecipe information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, cashier, super_admin, support]
 *
 * UPDATE: [admin, cashier, super_admin, support]
 *
 * DESTROY: [admin, cashier, super_admin]
 *
 */
export type TSectorRecipe = {
  readonly __typename?: 'SectorRecipe';
  readonly canceledAt: Maybe<Scalars['DateTime']['output']>;
  readonly canceledBy: Maybe<TUser>;
  /** covers of item */
  readonly covers: ReadonlyArray<TSectorRecipe>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy: Maybe<TUser>;
  readonly id: Scalars['ID']['output'];
  /** actual user note */
  readonly note: Maybe<Scalars['String']['output']>;
  readonly orderRecipeState: TOrderRecipeState;
  readonly parent: Maybe<TSectorRecipe>;
  readonly recipe: TRecipe;
  readonly sector: TSector;
  /** side dishes of item */
  readonly sideDishes: ReadonlyArray<TSectorRecipe>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

/** Subscription of sector recipe */
export type TSectorRecipeUpdateSubscription = {
  readonly __typename?: 'SectorRecipeUpdateSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly id: Scalars['ID']['output'];
  readonly sectorRecipe: Maybe<TSectorRecipe>;
};

/**
 * Possible SectorType types
 *
 *
 * INDEX: [admin, guest, super_admin, support, user]
 *
 * READ: [admin, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TSectorType = {
  readonly __typename?: 'SectorType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TSectorTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** SectorType enum */
export type TSectorTypeEnum =
  | 'AREA'
  | 'TABLE';

/** Ware Category information about Sector */
export type TSectorWareCategory = {
  readonly __typename?: 'SectorWareCategory';
  readonly access: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly inherited: Scalars['Boolean']['output'];
  readonly wareCategory: TWareCategory;
};

/** Settings of Company */
export type TSettingCompany = {
  readonly __typename?: 'SettingCompany';
  readonly kioskStyles: Maybe<TKioskStylesSetting>;
};

/** Settings of CompanyBranch */
export type TSettingCompanyBranch = {
  readonly __typename?: 'SettingCompanyBranch';
  readonly deliveryVat: TVat;
  readonly dotykacka: Maybe<TDotykackaSetting>;
  readonly kioskStyles: Maybe<TKioskStylesSetting>;
  readonly wolt: Maybe<TWoltSetting>;
};


/** Settings of CompanyBranch */
export type TSettingCompanyBranchKioskStylesArgs = {
  enableFallback?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Possible SettingType types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TSettingType = {
  readonly __typename?: 'SettingType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TSettingTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** SettingType enum */
export type TSettingTypeEnum =
  | 'ADMIN_ORDER_LISTING'
  | 'CONFIRMATION'
  | 'GRAPHIC'
  | 'OPTIONS'
  | 'RULES'
  | 'URL';

/** Settings of User */
export type TSettingUser = {
  readonly __typename?: 'SettingUser';
  readonly userAssignableRoles: ReadonlyArray<TRole>;
};

/**
 * Description of shift
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_shift, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_shift, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_shift, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_shift, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_shift, sales_representative, super_admin, supervisor]
 *
 */
export type TShift = {
  readonly __typename?: 'Shift';
  readonly beginAt: Maybe<Scalars['DateTime']['output']>;
  readonly capacity: Scalars['Int']['output'];
  readonly companyBranch: TCompanyBranch;
  readonly endAt: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly placeCode: Maybe<Scalars['String']['output']>;
  readonly shiftUsers: ReadonlyArray<TShiftUser>;
};

/**
 * Keeps user information for appropriate shift
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, driver, editor_shift_user, sales_representative, super_admin, supervisor]
 *
 */
export type TShiftUser = {
  readonly __typename?: 'ShiftUser';
  readonly id: Scalars['ID']['output'];
  readonly shift: TShift;
  readonly shiftUserState: TShiftUserState;
  readonly user: TUser;
};

/**
 * Possible ShiftUserState types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TShiftUserState = {
  readonly __typename?: 'ShiftUserState';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TShiftUserStateEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** ShiftUserState enum */
export type TShiftUserStateEnum =
  | 'ACCEPTED'
  | 'REJECTED'
  | 'WAITING_FOR_RESPONSE';

/**
 * Sms template schema
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TSmsTemplate = {
  readonly __typename?: 'SmsTemplate';
  /** template */
  readonly body: Scalars['String']['output'];
  readonly default: Scalars['Boolean']['output'];
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly language: TLanguage;
  readonly public: Scalars['Boolean']['output'];
  readonly smsTemplateType: TSmsTemplateType;
  readonly triggerableType: TTriggerableType;
};

/**
 * Possible SmsTemplateType types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TSmsTemplateType = {
  readonly __typename?: 'SmsTemplateType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TSmsTemplateTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** SmsTemplateType enum */
export type TSmsTemplateTypeEnum =
  | 'ONE_TIME_SMS'
  | 'ORDER_ACCEPTED'
  | 'ORDER_CANCELED'
  | 'ORDER_FINISHED'
  | 'ORDER_IN_PRODUCE'
  | 'ORDER_IN_PROGRESS'
  | 'ORDER_ON_WAY'
  | 'ORDER_READY_TO_DELIVER'
  | 'ORDER_RECEIVED'
  | 'PRINTER_CANNOT_PRINT'
  | 'PRINTER_OUT_OF_PAPER'
  | 'PRINTER_READY_FOR_PRINT'
  | 'PROMO_CODE'
  | 'RECEIVED_BY_USER';

/** Statistics for branches */
export type TStatistics = {
  readonly __typename?: 'Statistics';
  readonly categoryStatistics: ReadonlyArray<TStatisticsCategory>;
  readonly categoryStatisticsPlain: Scalars['String']['output'];
  readonly customerStatistics: TStatisticsCustomer;
  readonly dailyStatistics: ReadonlyArray<TStatisticsDaily>;
  readonly dailyStatisticsPlain: Scalars['String']['output'];
  readonly deliveryStatistics: ReadonlyArray<TStatisticsDelivery>;
  readonly deliveryStatisticsPlain: Scalars['String']['output'];
  readonly deliveryZoneStatistics: ReadonlyArray<TStatisticsDeliveryZone>;
  readonly deliveryZoneStatisticsPlain: Scalars['String']['output'];
  readonly discountStatistics: ReadonlyArray<TStatisticsDiscount>;
  readonly discountStatisticsPlain: Scalars['String']['output'];
  readonly driversStatistics: ReadonlyArray<TStatisticsDrivers>;
  readonly driversStatisticsPlain: Scalars['String']['output'];
  readonly finishedOrders: TStatisticsOrders;
  readonly orderStatistics: TStatisticsOrdersCategories;
  readonly orderStatisticsPlain: Scalars['String']['output'];
  readonly ordersDetailsUrl: Scalars['String']['output'];
  readonly vatStatisticsPlain: Scalars['String']['output'];
};

/** Income statistics for specific billing type */
export type TStatisticsBilling = {
  readonly __typename?: 'StatisticsBilling';
  readonly income: TPriceConverted;
  readonly ordersCount: Scalars['Int']['output'];
  readonly paymentType: TPaymentType;
};

/** Sales statistics for whole category */
export type TStatisticsCategory = {
  readonly __typename?: 'StatisticsCategory';
  readonly noWareCategory: ReadonlyArray<TStatisticsRecipeCategory>;
  readonly wareCategories: ReadonlyArray<TStatisticsWareCategory>;
  readonly warePriceType: TWarePriceType;
};

/** Customer statistics */
export type TStatisticsCustomer = {
  readonly __typename?: 'StatisticsCustomer';
  readonly addresses: ReadonlyArray<Scalars['String']['output']>;
  readonly emails: ReadonlyArray<Scalars['String']['output']>;
  readonly fullNames: ReadonlyArray<Scalars['String']['output']>;
  readonly orders: ReadonlyArray<TOrder>;
  readonly phone: Maybe<Scalars['String']['output']>;
  readonly promoCodeStatistics: ReadonlyArray<TPromoCodeStatistic>;
};

/** Daily statistics for branches */
export type TStatisticsDaily = {
  readonly __typename?: 'StatisticsDaily';
  readonly date: Scalars['Date']['output'];
  readonly incomes: ReadonlyArray<TStatisticsBilling>;
  readonly incomesWithBill: ReadonlyArray<TStatisticsBilling>;
  readonly ordersCount: Scalars['Int']['output'];
};

/** Delivery statistics for branches */
export type TStatisticsDelivery = {
  readonly __typename?: 'StatisticsDelivery';
  readonly deliveryType: Maybe<TDeliveryType>;
  readonly incomes: ReadonlyArray<TStatisticsBilling>;
  readonly ordersCount: Scalars['Int']['output'];
  readonly stornoCount: Scalars['Int']['output'];
  readonly stornoValue: TPriceConverted;
  readonly vatSummarization: ReadonlyArray<TStatisticsVatSummarization>;
  readonly warePriceType: TWarePriceType;
};

/** Delivery zone statistics for branches */
export type TStatisticsDeliveryZone = {
  readonly __typename?: 'StatisticsDeliveryZone';
  readonly deliveries: ReadonlyArray<TStatisticsZoneDeliveryPrice>;
  /** Delivering zone */
  readonly zone: TZoneType;
};

/** Discount statistics for branches */
export type TStatisticsDiscount = {
  readonly __typename?: 'StatisticsDiscount';
  readonly count: Scalars['Int']['output'];
  readonly description: Scalars['String']['output'];
  readonly totalValue: TPriceConverted;
};

/** Drivers statistics for branches */
export type TStatisticsDrivers = {
  readonly __typename?: 'StatisticsDrivers';
  readonly drivenDistance: Scalars['Int']['output'];
  readonly incomes: ReadonlyArray<TStatisticsBilling>;
  readonly ordersCount: Scalars['Int']['output'];
  readonly user: TUser;
};

/** Fees for specified branches */
export type TStatisticsForFees = {
  readonly __typename?: 'StatisticsForFees';
  readonly commission: TPriceConverted;
  readonly commissionAfterLimit: TPriceConverted;
  readonly commissionLimit: TPriceConverted;
  readonly companyBranch: TCompanyBranch;
  readonly deliveries: TPriceConverted;
  readonly month: Scalars['Date']['output'];
  readonly notifications: TPriceConverted;
  readonly paymentGates: TPriceConverted;
  readonly speedloServices: TPriceConverted;
  readonly total: TPriceConverted;
  readonly totalWithVat: TPriceConverted;
  readonly vat: Scalars['Float']['output'];
};

/** Operating costs summarization */
export type TStatisticsForOperatingCosts = {
  readonly __typename?: 'StatisticsForOperatingCosts';
  readonly companyBranch: TCompanyBranch;
  readonly date: Scalars['Date']['output'];
  readonly operatingCostFrequencyType: TOperatingCostFrequencyType;
  readonly operatingCostSetting: Maybe<TOperatingCostSetting>;
  readonly orderOrigin: Maybe<TOrderOrigin>;
  readonly timePrecision: TTimePrecisionTypeEnum;
  readonly totalAbsoluteSum: TPriceConverted;
  readonly totalCount: Scalars['Int']['output'];
  readonly totalPercentageSum: TPriceConverted;
  readonly totalRecordValueSum: TPriceConverted;
};

/** Calculate total amount from online and normal payments */
export type TStatisticsForPayments = {
  readonly __typename?: 'StatisticsForPayments';
  readonly postPaidOrderCount: Scalars['Int']['output'];
  readonly postPaidTurnover: TPriceConverted;
  readonly prePaidOrderCount: Scalars['Int']['output'];
  readonly prePaidTurnover: TPriceConverted;
  readonly valueHoldBySpeedlo: TPriceConverted;
};

/** Summarized statistics about orders in specific category */
export type TStatisticsOrderCategoryInfo = {
  readonly __typename?: 'StatisticsOrderCategoryInfo';
  readonly ordersCount: Scalars['Int']['output'];
  readonly ordersFee: TPriceConverted;
  readonly paidOut: TPriceConverted;
  readonly tips: TPriceConverted;
  readonly turnover: TPriceConverted;
};


/** Summarized statistics about orders in specific category */
export type TStatisticsOrderCategoryInfoOrdersFeeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/** Summarized statistics about orders in specific category */
export type TStatisticsOrderCategoryInfoPaidOutArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/** Summarized statistics about orders in specific category */
export type TStatisticsOrderCategoryInfoTipsArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/** Summarized statistics about orders in specific category */
export type TStatisticsOrderCategoryInfoTurnoverArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/** Summarized statistics about finished orders */
export type TStatisticsOrders = {
  readonly __typename?: 'StatisticsOrders';
  readonly fees: TPriceConverted;
  readonly onlinePayments: TPriceConverted;
  readonly orders: ReadonlyArray<TOrder>;
  readonly ordersCanceledCount: Scalars['Int']['output'];
  readonly ordersCount: Scalars['Int']['output'];
  readonly total: TPriceConverted;
};


/** Summarized statistics about finished orders */
export type TStatisticsOrdersFeesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/** Summarized statistics about finished orders */
export type TStatisticsOrdersOnlinePaymentsArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/** Summarized statistics about finished orders */
export type TStatisticsOrdersOrdersArgs = {
  includeCanceled?: InputMaybe<Scalars['Boolean']['input']>;
  orderStatesOr?: InputMaybe<ReadonlyArray<TOrderStateEnum>>;
  pagination?: InputMaybe<TInputPaginationParams>;
};


/** Summarized statistics about finished orders */
export type TStatisticsOrdersTotalArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/** Summarized statistics about finished orders divided into specific categories */
export type TStatisticsOrdersCategories = {
  readonly __typename?: 'StatisticsOrdersCategories';
  readonly ordersBistro: TStatisticsOrderCategoryInfo;
  readonly ordersBolt: TStatisticsOrderCategoryInfo;
  readonly ordersCanceled: TStatisticsOrderCategoryInfo;
  readonly ordersCsob: TStatisticsOrderCategoryInfo;
  readonly ordersDameJidlo: TStatisticsOrderCategoryInfo;
  readonly ordersEshop: TStatisticsOrderCategoryInfo;
  readonly ordersExternalGate: TStatisticsOrderCategoryInfo;
  readonly ordersGpWebpay: TStatisticsOrderCategoryInfo;
  readonly ordersJidloPodNos: TStatisticsOrderCategoryInfo;
  readonly ordersKiosk: TStatisticsOrderCategoryInfo;
  readonly ordersKioskGate: TStatisticsOrderCategoryInfo;
  readonly ordersOnline: TStatisticsOrderCategoryInfo;
  readonly ordersPayU: TStatisticsOrderCategoryInfo;
  readonly ordersStaff: TStatisticsOrderCategoryInfo;
  readonly ordersStaffPos: TStatisticsOrderCategoryInfo;
  readonly ordersWolt: TStatisticsOrderCategoryInfo;
};

/** Counts sales of specific recipe */
export type TStatisticsRecipeCategory = {
  readonly __typename?: 'StatisticsRecipeCategory';
  readonly historicalRecipes: ReadonlyArray<TStatisticsRecipeCategory>;
  readonly name: Scalars['String']['output'];
  /** price of each recipe */
  readonly price: TPriceConverted;
  readonly recipeCount: Scalars['Int']['output'];
};

/** Statistics for SectorRecipes */
export type TStatisticsSectorRecipe = {
  readonly __typename?: 'StatisticsSectorRecipe';
  readonly canceled: ReadonlyArray<TSectorRecipe>;
};

/** Vat summarization for reports/statistics */
export type TStatisticsVatSummarization = {
  readonly __typename?: 'StatisticsVatSummarization';
  readonly value: TPriceConverted;
  readonly vat: Maybe<TVat>;
};

/** Sales statistics for WareCategory */
export type TStatisticsWareCategory = {
  readonly __typename?: 'StatisticsWareCategory';
  readonly recipes: ReadonlyArray<TStatisticsRecipeCategory>;
  readonly wareCategory: TWareCategory;
};

/** Delivery zone statistics for branches */
export type TStatisticsZoneDeliveryPrice = {
  readonly __typename?: 'StatisticsZoneDeliveryPrice';
  /** Number of deliveries into zone. */
  readonly count: Scalars['Int']['output'];
  /** Price of single delivery. */
  readonly price: TPriceConverted;
};

export type TStockInterface = {
  /** stock items that are incoming to branch */
  readonly incomingStockTransfer: ReadonlyArray<TStockTransfer>;
  /** stock items that are leaving branch */
  readonly outcomingStockTransfer: ReadonlyArray<TStockTransfer>;
  readonly stockItemsCanBeNegative: Scalars['Boolean']['output'];
};

/**
 * Keeps information about stock inventories
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TStockInventory = {
  readonly __typename?: 'StockInventory';
  readonly companyBranch: TCompanyBranch;
  /** time when stock inventory was initialized */
  readonly createdAt: Scalars['DateTime']['output'];
  /** time when stock inventory was finished */
  readonly finishedAt: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['ID']['output'];
  /** stock intentory items */
  readonly items: ReadonlyArray<TStockInventoryItem>;
  /** user note */
  readonly note: Maybe<Scalars['String']['output']>;
  readonly user: TUser;
};

/**
 * Keeps information about stock inventory items
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TStockInventoryItem = {
  readonly __typename?: 'StockInventoryItem';
  readonly finalQuantity: Maybe<Scalars['Float']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly originalQuantity: Scalars['Float']['output'];
  readonly stockInventory: TStockInventory;
  readonly stockInventoryItemChangeType: Maybe<TStockInventoryItemChangeType>;
  readonly stockItem: TStockItem;
  readonly stockItemChangeType: Maybe<TStockItemChangeType>;
};

/** Possible StockInventoryItemChangeType types */
export type TStockInventoryItemChangeType = {
  readonly __typename?: 'StockInventoryItemChangeType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TStockInventoryItemChangeTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** Possible StockInventoryItem change types */
export type TStockInventoryItemChangeTypeEnum =
  | 'DAMAGE'
  | 'EXPIRED'
  | 'SOLD_OUTSIDE_SYSTEM'
  | 'STOCK_CANCEL'
  | 'STOCK_DOWN'
  | 'STOCK_RETURN'
  | 'STOCK_TRANSFER'
  | 'STOCK_UP'
  | 'STOLEN'
  | 'TASTING';

/**
 * Keeps information about items at stock
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, editor_menu, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, editor_menu, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TStockItem = {
  readonly __typename?: 'StockItem';
  /** possible allergens */
  readonly allergens: ReadonlyArray<TAllergen>;
  readonly allowNegative: TFieldStateEnum;
  readonly allowNegativeValue: Scalars['Boolean']['output'];
  readonly code: Scalars['String']['output'];
  readonly companyBranch: TCompanyBranch;
  readonly history: ReadonlyArray<TStockItemHistory>;
  readonly id: Scalars['ID']['output'];
  /** ingredients that are using stock item */
  readonly ingredients: ReadonlyArray<TIngredient>;
  readonly label: Scalars['String']['output'];
  readonly note: Scalars['String']['output'];
  /** The StockItem that this StockItem is shared from. When the StockItem is not shared, it references itself. */
  readonly originalStockItem: TStockItem;
  /** The StockItem that will be used to perform stock manipulations when this StockItem is used. */
  readonly physicalStockItem: TStockItem;
  readonly plu: Maybe<Scalars['String']['output']>;
  readonly price: Scalars['Float']['output'];
  readonly quantity: Scalars['Float']['output'];
  readonly quantityChange: Scalars['Float']['output'];
  /** recipes that are using stock item */
  readonly recipes: ReadonlyArray<TRecipe>;
  /** True when the StockItem is shared, false when it is an original StockItem. */
  readonly shared: Scalars['Boolean']['output'];
  readonly wareUnit: TWareUnit;
};


/**
 * Keeps information about items at stock
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, editor_menu, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, editor_menu, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_stock_item, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TStockItemQuantityChangeArgs = {
  fromDate: Scalars['DateTime']['input'];
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * Possible StockItemChangeType types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TStockItemChangeType = {
  readonly __typename?: 'StockItemChangeType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TStockItemChangeTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** StockItemChangeType enum */
export type TStockItemChangeTypeEnum =
  | 'DAMAGE'
  | 'EXPIRED'
  | 'SOLD_OUTSIDE_SYSTEM'
  | 'STOCK_CANCEL'
  | 'STOCK_DOWN'
  | 'STOCK_RETURN'
  | 'STOCK_SALE'
  | 'STOCK_TRANSFER'
  | 'STOCK_UP'
  | 'STOLEN'
  | 'TASTING';

export type TStockItemHistory = {
  readonly __typename?: 'StockItemHistory';
  readonly amount: Scalars['Float']['output'];
  readonly dateTime: Scalars['DateTime']['output'];
  readonly user: TUser;
  readonly wareUnit: TWareUnit;
};

/**
 * Transfer information about stock item
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_stock_transfer, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, editor_stock_transfer, operator, super_admin]
 *
 */
export type TStockTransfer = {
  readonly __typename?: 'StockTransfer';
  readonly id: Scalars['ID']['output'];
  readonly quantity: Scalars['Float']['output'];
  readonly rejectAccepted: Scalars['Boolean']['output'];
  readonly rejectedByTarget: Scalars['Boolean']['output'];
  readonly sourceCompanyBranch: TCompanyBranch;
  /** code of stock item from source company branch */
  readonly stockItemCode: Scalars['String']['output'];
  readonly targetCompanyBranch: TCompanyBranch;
  readonly wareUnit: TWareUnit;
};

/**
 * Possible StornoRequestType types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TStornoRequestType = {
  readonly __typename?: 'StornoRequestType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TStornoRequestTypeEnum;
  readonly id: Scalars['ID']['output'];
  readonly needComment: Scalars['Boolean']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** StornoRequestType enum */
export type TStornoRequestTypeEnum =
  | 'CLOSED'
  | 'CUSTOMER_STORNED'
  | 'CUSTOMER_UNAVAILABLE'
  | 'DUPLICATE'
  | 'MISTAKE_IN_ORDER'
  | 'OTHER'
  | 'TECHNICAL_DIFFICULTIES'
  | 'THIRD_PARTY';

/** The subscription root of this schema */
export type TSubscription = {
  readonly __typename?: 'Subscription';
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_reports, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam, wolt_menu_sync]
   *
   */
  readonly updatedExternalDelivery: TExternalDeliveryUpdateSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_reports, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam, wolt_menu_sync]
   *
   */
  readonly updatedOrder: TOrderUpdateSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_reports, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam, wolt_menu_sync]
   *
   */
  readonly updatedOrderCategoryCount: TOrderCategoryCountSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_reports, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam, wolt_menu_sync]
   *
   */
  readonly updatedOrdersCount: TOrderCountSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_reports, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam, wolt_menu_sync]
   *
   */
  readonly updatedPrintQueue: TPrintQueueUpdateSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_reports, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam, wolt_menu_sync]
   *
   */
  readonly updatedSectorRecipe: TSectorRecipeUpdateSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_reports, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam, wolt_menu_sync]
   *
   */
  readonly updatedTransportationDeviceUser: TTransportationDeviceUserUpdateSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_reports, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam, wolt_menu_sync]
   *
   */
  readonly updatedUserCallingCustomer: TUserCallingCustomerSubscription;
  /**
   *
   *
   * ALLOWED ROLES: [access_config, account_manager, accountant, admin, branch_owner, brand_owner, call_center, cashier, cashier_basic_recipes, cashier_cancel, cashier_change_delivery_type, cashier_delivery, cashier_isolated_print, cashier_kiosk, cashier_menu, cashier_payment_methods, cashier_pos, cashier_process_time, cashier_reports, cashier_statistics, cashier_transfer_company_branch, cashier_unlimited, cashier_unlimited_customer, cashier_without_print, customer, driver, driver_default, driver_dodo, driver_foodis, driver_foodora_go, driver_liftago, driver_prorozvoz, driver_wolt_drive, editor, editor_address, editor_announcement, editor_availability, editor_billings, editor_business_hour, editor_business_hours, editor_cash_box, editor_company, editor_company_branch, editor_company_branch_currency, editor_company_branch_delivery, editor_company_branch_user, editor_company_order_origin, editor_country, editor_country_vat, editor_country_vat_type_price, editor_currency, editor_event, editor_financial_report, editor_import_log, editor_ingredient, editor_label, editor_label_translation, editor_menu, editor_note, editor_order, editor_order_billing, editor_order_discount, editor_order_origin_price_type, editor_order_payment_method, editor_order_price_modification, editor_order_recipe, editor_order_state_relation, editor_orders, editor_page_element, editor_payment_method, editor_payment_method_branch, editor_promo_code, editor_recipe, editor_recipe_price, editor_recipe_relation, editor_rejected_payment_method, editor_role, editor_setting, editor_shift, editor_shift_user, editor_sorting, editor_stock_item, editor_stock_item_allergen, editor_stock_transfer, editor_transportation_device, editor_transportation_device_user, editor_user, editor_user_delivering_order, editor_user_login_provider, editor_user_personal, editor_wallet_credits, editor_ware, editor_ware_category, editor_ware_category_relation, editor_zone, editor_zones, export_customers, extern, external_api, guest, liftago, merchant, operator, owner_cancel, request_cancel, request_external_driver, sales_representative, super_admin, supervisor, support, suspended_user, templatable_manager, user, vam, wolt_menu_sync]
   *
   */
  readonly updatedUserDeliveringOrder: TUserDeliveringOrderUpdateSubscription;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedExternalDeliveryArgs = {
  companyBranches: ReadonlyArray<Scalars['ID']['input']>;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedOrderArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  groups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includeOldFinished?: InputMaybe<Scalars['Boolean']['input']>;
  occasions?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  orderStateCategoriesOR?: InputMaybe<ReadonlyArray<TOrderStateCategoryEnum>>;
  orderStateCategoryTarget?: InputMaybe<TOrderStateCategoryTargetEnum>;
  sectors?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  sectorsWithChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedOrderCategoryCountArgs = {
  companyBranches: ReadonlyArray<Scalars['ID']['input']>;
  orderStateCategories: ReadonlyArray<TOrderStateCategoryEnum>;
  orderStateCategoryTarget?: InputMaybe<TOrderStateCategoryTargetEnum>;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedOrdersCountArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedPrintQueueArgs = {
  printers: ReadonlyArray<Scalars['ID']['input']>;
  targetMac: Scalars['String']['input'];
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedSectorRecipeArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  groups?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  orderRecipeStateOR?: InputMaybe<ReadonlyArray<TOrderRecipeStateEnum>>;
  sectors?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  sectorsWithChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedTransportationDeviceUserArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  transportationDevice?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedUserCallingCustomerArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


/** The subscription root of this schema */
export type TSubscriptionUpdatedUserDeliveringOrderArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

/** Possible action types of subscription */
export type TSubscriptionActionType =
  | 'CREATE'
  | 'DESTROY'
  | 'REMOVE'
  | 'UPDATE';

/** Possible time precision types */
export type TTimePrecisionTypeEnum =
  | 'DAY'
  | 'MONTH'
  | 'YEAR';

export type TTransportFeeInterface = {
  /** array of all possible transport fees for order */
  readonly levelsOfTransportFees: ReadonlyArray<TTransportFees>;
  /** the number of possible transport fees for order */
  readonly levelsOfTransportFeesCount: Maybe<Scalars['Int']['output']>;
  /** the nearest lower value of the transport fee for order */
  readonly nextPossibleTransportFee: Maybe<TTransportFees>;
  readonly transportFee: TPriceConverted;
};


export type TTransportFeeInterfaceLevelsOfTransportFeesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TTransportFeeInterfaceNextPossibleTransportFeeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


export type TTransportFeeInterfaceTransportFeeArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/** Transport fee according to zone rules */
export type TTransportFees = {
  readonly __typename?: 'TransportFees';
  /** minimum price for a new transport fee */
  readonly fromPrice: Maybe<TPriceConverted>;
  readonly newTransportFee: Maybe<TPriceConverted>;
  /**  the difference between order price and minimum price for a new transport fee */
  readonly priceNeedToOrder: Maybe<TPriceConverted>;
};

/**
 * Type for transportation device
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_transportation_device, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_transportation_device, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TTransportationDevice = {
  readonly __typename?: 'TransportationDevice';
  readonly companyBranch: TCompanyBranch;
  readonly deviceState: TDeviceState;
  readonly deviceType: TDeviceType;
  readonly id: Scalars['ID']['output'];
  readonly idNumber: Scalars['String']['output'];
};

/**
 * Information about transportation device assigned to user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, driver, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_transportation_device_user, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TTransportationDeviceUser = {
  readonly __typename?: 'TransportationDeviceUser';
  /** Active UserDelivery of TransportationDeviceUser */
  readonly activeUserDelivery: Maybe<TUserDelivery>;
  /** time of when order was assigned to user */
  readonly createdAt: Scalars['DateTime']['output'];
  /** points that transportation device visited */
  readonly geoRoad: ReadonlyArray<TGeoPositionWithTimestamp>;
  readonly id: Scalars['ID']['output'];
  /** driver returned transportation device and logged out */
  readonly isFinalized: Scalars['Boolean']['output'];
  /** last geo position that device visited */
  readonly lastPosition: Maybe<TGeoPositionWithTimestamp>;
  /** actual return zone in which is user located */
  readonly returnZone: Maybe<TZone>;
  /** time when transportation device was returned */
  readonly returnedAt: Maybe<Scalars['DateTime']['output']>;
  /** crossed return zone */
  readonly returning: Scalars['Boolean']['output'];
  readonly transportationDevice: TTransportationDevice;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: TUser;
};

/** Subscription of transportation device of user */
export type TTransportationDeviceUserUpdateSubscription = {
  readonly __typename?: 'TransportationDeviceUserUpdateSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly id: Scalars['ID']['output'];
  readonly transportationDeviceUser: Maybe<TTransportationDeviceUser>;
};

/**
 * Trigger configuration
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TTriggerConfiguration = {
  readonly __typename?: 'TriggerConfiguration';
  readonly configuration: Scalars['Json']['output'];
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  /** Trigger type */
  readonly triggerType: TTriggerType;
  readonly triggerableType: TTriggerableType;
};

/**
 * Possible TriggerType types
 *
 *
 * INDEX: [admin, super_admin, support]
 *
 * READ: [admin, super_admin, support]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TTriggerType = {
  readonly __typename?: 'TriggerType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TTriggerTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** TriggerType enum */
export type TTriggerTypeEnum =
  | 'MAIL'
  | 'PRINT'
  | 'SMS';

/**
 * Possible TriggerableType types
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TTriggerableType = {
  readonly __typename?: 'TriggerableType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TTriggerableTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** TriggerableType enum */
export type TTriggerableTypeEnum =
  | 'FINANCIAL_REPORT'
  | 'NOTE'
  | 'ORDER'
  | 'PRINTER'
  | 'USERS_CONFIRMATION_CODE';

/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUser = TCreditsOverviewInterface & TDriverInterface & TOrdersInterface & {
  readonly __typename?: 'User';
  readonly accessibleBranches: ReadonlyArray<TCompanyBranch>;
  readonly address: Maybe<TAddress>;
  readonly addresses: Maybe<ReadonlyArray<TAddress>>;
  readonly companyBranchUsers: ReadonlyArray<TCompanyBranchUser>;
  readonly countUndeliveredOrders: Scalars['Int']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly creditsExpiringSoon: Maybe<TCreditsWalletActivityConnection>;
  readonly creditsPendingRewards: TCreditsRewardConnection;
  readonly creditsRewards: TCreditsRewardConnection;
  readonly creditsWalletActivities: TCreditsWalletActivityConnection;
  readonly creditsWallets: ReadonlyArray<TCreditsWallet>;
  readonly customers: ReadonlyArray<TCustomer>;
  readonly email: Scalars['String']['output'];
  readonly emails: ReadonlyArray<Scalars['String']['output']>;
  readonly employedBy: ReadonlyArray<TCompanyBranch>;
  readonly firstName: Maybe<Scalars['String']['output']>;
  readonly gps: Maybe<TGeoPoint>;
  readonly id: Scalars['ID']['output'];
  readonly inAppNotifications: TInAppNotificationConnection;
  readonly initials: Scalars['String']['output'];
  /** is user guest type? -> customer specific data should be taken from different source */
  readonly isGuest: Scalars['Boolean']['output'];
  readonly language: TLanguage;
  readonly lastName: Maybe<Scalars['String']['output']>;
  readonly login: Maybe<Scalars['String']['output']>;
  readonly maskedEmail: Maybe<Scalars['String']['output']>;
  /** what method use for user notification */
  readonly notification: Maybe<TNotification>;
  readonly orders: ReadonlyArray<TOrder>;
  readonly phone: Scalars['String']['output'];
  readonly roles: ReadonlyArray<TRole>;
  readonly settings: TSettingUser;
  readonly shifts: ReadonlyArray<TShiftUser>;
  readonly signInAt: Maybe<Scalars['DateTime']['output']>;
  readonly signInCount: Maybe<Scalars['Int']['output']>;
  readonly signInIp: Maybe<Scalars['String']['output']>;
  readonly transportationDeviceUsers: ReadonlyArray<TTransportationDeviceUser>;
  readonly unreadInAppNotificationsCount: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly usedTransportationDevice: Maybe<TTransportationDeviceUser>;
  readonly userDeliveringOrders: ReadonlyArray<TUserDeliveringOrder>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserAccessibleBranchesArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserAddressArgs = {
  addressType?: InputMaybe<TAddressTypeEnum>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserAddressesArgs = {
  addressTypes?: InputMaybe<ReadonlyArray<TAddressTypeEnum>>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserCreditsExpiringSoonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserCreditsPendingRewardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserCreditsRewardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<ReadonlyArray<TCreditsRewardStateEnum>>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserCreditsWalletActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyBranchIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserCreditsWalletsArgs = {
  companyBranchId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserCustomersArgs = {
  companies?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserEmailsArgs = {
  confirmationStatus?: InputMaybe<TConfirmationStatusSelectorEnum>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserInAppNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserOrdersArgs = {
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  orderOrigins?: InputMaybe<ReadonlyArray<TOrderOriginEnum>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserPhoneArgs = {
  part?: InputMaybe<TPhonePartSelectorEnum>;
};


/**
 * Holds information about every user
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_user, operator, super_admin, supervisor, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_user, super_admin, supervisor, user]
 *
 */
export type TUserUserDeliveringOrdersArgs = {
  onlyUndelivered?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Subscription for calling numbers for logged user */
export type TUserCallingCustomerSubscription = {
  readonly __typename?: 'UserCallingCustomerSubscription';
  /** ID of event which started call */
  readonly eventId: Scalars['ID']['output'];
  /** Indicator of call activity */
  readonly isRinging: Scalars['Boolean']['output'];
  /** phone of caller */
  readonly phone: Scalars['String']['output'];
  /** country code */
  readonly prefix: Scalars['String']['output'];
};

/** Information about user calling customer */
export type TUserCustomerCalling = {
  readonly __typename?: 'UserCustomerCalling';
  /** ID of created event */
  readonly eventId: Scalars['ID']['output'];
  /** Indicator of call activity */
  readonly isRinging: Scalars['Boolean']['output'];
  /** phone of caller */
  readonly phone: Scalars['String']['output'];
  /** country code */
  readonly prefix: Scalars['String']['output'];
};

/** Information about call hangup */
export type TUserCustomerHangup = {
  readonly __typename?: 'UserCustomerHangup';
  /** ID of created event */
  readonly eventId: Scalars['ID']['output'];
  /** Created order */
  readonly order: Maybe<TOrder>;
  /** ID of original event */
  readonly originalEventId: Scalars['ID']['output'];
};

/**
 * Information about user and order that is being delivered
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, cashier_delivery, driver, editor_user_delivering_order, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TUserDeliveringOrder = {
  readonly __typename?: 'UserDeliveringOrder';
  readonly assignmentType: Maybe<TUserDeliveringOrdersAssignmentTypeEnum>;
  /** time of when order was assigned to user */
  readonly createdAt: Scalars['DateTime']['output'];
  readonly current: Scalars['Boolean']['output'];
  /** time of when order was deliver */
  readonly deliveredAt: Maybe<Scalars['DateTime']['output']>;
  /** state of current association */
  readonly deliveryState: TDeliveryStateEnum;
  readonly deliveryStates: ReadonlyArray<TDeliveryStateHistorical>;
  readonly id: Scalars['ID']['output'];
  readonly order: TOrder;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: TUser;
  readonly userDelivery: Maybe<TUserDelivery>;
  readonly willPickupAt: Maybe<Scalars['DateTime']['output']>;
};

/** Subscription of user delivering order changes */
export type TUserDeliveringOrderUpdateSubscription = {
  readonly __typename?: 'UserDeliveringOrderUpdateSubscription';
  readonly actionType: TSubscriptionActionType;
  readonly id: Scalars['ID']['output'];
  readonly userDeliveringOrder: Maybe<TUserDeliveringOrder>;
};

/** Possible UserDeliveringOrdersAssignmentType types */
export type TUserDeliveringOrdersAssignmentType = {
  readonly __typename?: 'UserDeliveringOrdersAssignmentType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TUserDeliveringOrdersAssignmentTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** UserDeliveringOrdersAssignmentType enum */
export type TUserDeliveringOrdersAssignmentTypeEnum =
  | 'CHECKED_BY_DRIVER'
  | 'DRIVER'
  | 'STAFF';

/**
 * Information about users delivery
 *
 *
 * INDEX: [admin, cashier_delivery, driver, super_admin, support]
 *
 * READ: [admin, cashier_delivery, driver, super_admin, support]
 *
 * CREATE: [admin, cashier_delivery, driver, super_admin, support]
 *
 * UPDATE: [admin, cashier_delivery, driver, super_admin, support]
 *
 * DESTROY: [admin, cashier_delivery, driver, super_admin]
 *
 */
export type TUserDelivery = {
  readonly __typename?: 'UserDelivery';
  readonly active: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly remainingUserDeliveringOrders: ReadonlyArray<TUserDeliveringOrder>;
  readonly user: TTransportationDeviceUser;
  readonly userDeliveringOrders: ReadonlyArray<TUserDeliveringOrder>;
};

/** Global user permissions */
export type TUserPermission = {
  readonly __typename?: 'UserPermission';
  /** User can cancel orders */
  readonly canCancelOrders: Scalars['Boolean']['output'];
  /** User can create order */
  readonly canCreateOrder: Scalars['Boolean']['output'];
  /** User can index orders */
  readonly canIndexOrders: Scalars['Boolean']['output'];
};

/** New token after updating password */
export type TUserUpdatedPassword = {
  readonly __typename?: 'UserUpdatedPassword';
  /** user id */
  readonly id: Scalars['ID']['output'];
  /** users token */
  readonly token: Scalars['String']['output'];
};

/** Information about specific agreement. */
export type TVamAgreement = {
  readonly __typename?: 'VAMAgreement';
  /** Consent description */
  readonly description: Scalars['String']['output'];
  /** Consent ID */
  readonly id: Scalars['ID']['output'];
  /** Consent is confirmed by customer */
  readonly isConfirmed: Scalars['Boolean']['output'];
  /** Consent is required to finish order */
  readonly isMandatory: Scalars['Boolean']['output'];
  /** Consent name */
  readonly name: Scalars['String']['output'];
};

/** Vat values */
export type TVat = {
  readonly __typename?: 'Vat';
  readonly default: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly vat: Scalars['Float']['output'];
};

/** Vat value for defined ware price type */
export type TVatPriceType = {
  readonly __typename?: 'VatPriceType';
  readonly id: Scalars['ID']['output'];
  readonly vat: Scalars['Float']['output'];
  readonly warePriceType: TWarePriceType;
};

/**
 * Type for Ware
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_ware, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TWare = {
  readonly __typename?: 'Ware';
  /** when ware is available */
  readonly availabilities: ReadonlyArray<TAvailability>;
  /** ware code */
  readonly code: Scalars['String']['output'];
  readonly companyBranch: TCompanyBranch;
  readonly descriptionLabel: Scalars['String']['output'];
  readonly enabled: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isAvailable: Scalars['Boolean']['output'];
  readonly nameLabel: Scalars['String']['output'];
  /** all recipes of Ware */
  readonly recipes: ReadonlyArray<TRecipe>;
};

/**
 * Information about category of wares
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_ware_category, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TWareCategory = TAvailabilityInterface & {
  readonly __typename?: 'WareCategory';
  readonly automaticFinish: Scalars['Boolean']['output'];
  /** when record is available */
  readonly availabilities: ReadonlyArray<TAvailability>;
  /** owner of category */
  readonly companyBranch: TCompanyBranch;
  /** number of items in category */
  readonly countRecipes: Scalars['Int']['output'];
  /** covers of ware category */
  readonly covers: ReadonlyArray<TRecipe>;
  /** Description of rules where current ware category is used. */
  readonly dependentRules: ReadonlyArray<Scalars['String']['output']>;
  readonly descriptionLabel: Maybe<Scalars['String']['output']>;
  readonly descriptionLabelTranslated: Maybe<Scalars['String']['output']>;
  readonly dotykackaId: Maybe<Scalars['ID']['output']>;
  /** is category active? */
  readonly enabled: Scalars['Boolean']['output'];
  readonly enabledByOwner: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly image: Maybe<Scalars['String']['output']>;
  readonly internalNoteLabel: Maybe<Scalars['String']['output']>;
  readonly internalNoteLabelTranslated: Maybe<Scalars['String']['output']>;
  /** is available at specific time? */
  readonly isAvailable: Scalars['Boolean']['output'];
  /** main recipes of ware category */
  readonly mains: ReadonlyArray<TRecipe>;
  /** maximal number of wares that have to selected at this category */
  readonly maxCount: Scalars['Int']['output'];
  /** max number of recipes of one kind that can be selected */
  readonly maxRecipesCount: Scalars['Int']['output'];
  /** minimal number of wares that have to selected at this category */
  readonly minCount: Scalars['Int']['output'];
  readonly nameLabel: Scalars['String']['output'];
  readonly nameLabelTranslated: Maybe<Scalars['String']['output']>;
  readonly orderOriginCategories: ReadonlyArray<TOrderOriginCategoryEnum>;
  readonly pictogram: Maybe<Scalars['String']['output']>;
  readonly promoTags: ReadonlyArray<TPromoTag>;
  /** should be category shown to public? */
  readonly public: Scalars['Boolean']['output'];
  readonly recipeTagRelations: Maybe<ReadonlyArray<TRecipeTagRelation>>;
  readonly recipeTags: Maybe<ReadonlyArray<TRecipeTag>>;
  /** all recipes of ware category */
  readonly recipes: ReadonlyArray<TRecipe>;
  readonly sharedCompanyBranches: ReadonlyArray<TCompanyBranch>;
  /** side dishes of ware category */
  readonly sideDishes: ReadonlyArray<TRecipe>;
  readonly translations: ReadonlyArray<TWareCategoryTranslation>;
  readonly wareCategoryColor: Maybe<TWareCategoryColor>;
  readonly wareCategoryType: TWareCategoryType;
};


/**
 * Information about category of wares
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_ware_category, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TWareCategoryImageArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Information about category of wares
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_ware_category, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TWareCategoryIsAvailableArgs = {
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};


/**
 * Information about category of wares
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * READ: [admin, branch_owner, brand_owner, cashier_menu, editor_menu, editor_ware_category, guest, merchant, operator, sales_representative, super_admin, supervisor, support, user, wolt_menu_sync]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_ware_category, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TWareCategoryRecipesArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailableAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};

/**
 * Ware category color with code and color definition
 *
 *
 * INDEX: [admin, super_admin, support, user]
 *
 * READ: [admin, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TWareCategoryColor = TColorInterface & {
  readonly __typename?: 'WareCategoryColor';
  readonly code: Scalars['String']['output'];
  readonly color: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
};

/**
 * Subcategory of ware categories. Every recipe can be part of different ware categories and can represent different recipe type (for example can be main dish in one category and dessert at another).
 *
 *
 * INDEX: [admin, editor_ware_category_relation, guest, operator, super_admin, support, user]
 *
 * READ: [admin, editor_ware_category_relation, guest, operator, super_admin, support, user]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_menu, editor_ware_category_relation, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, editor_ware_category_relation, operator, super_admin, support]
 *
 * DESTROY: [admin, editor_ware_category_relation, operator, super_admin]
 *
 */
export type TWareCategoryRelation = {
  readonly __typename?: 'WareCategoryRelation';
  readonly categoryOfWare: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly recipe: TRecipe;
  readonly wareCategory: TWareCategory;
};

/** Translations */
export type TWareCategoryTranslation = {
  readonly __typename?: 'WareCategoryTranslation';
  readonly descriptionLabel: Maybe<Scalars['String']['output']>;
  readonly internalNoteLabel: Maybe<Scalars['String']['output']>;
  readonly label: Maybe<Scalars['String']['output']>;
  readonly language: TLanguage;
};

/**
 * Possible WareCategoryType types
 *
 *
 * INDEX: [admin, editor_menu, guest, super_admin, support, user]
 *
 * READ: [admin, editor_menu, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TWareCategoryType = {
  readonly __typename?: 'WareCategoryType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TWareCategoryTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** WareCategoryType enum */
export type TWareCategoryTypeEnum =
  | 'COVER'
  | 'MAIN'
  | 'MIXIN'
  | 'SIDE_DISH';

/**
 * Possible WarePriceType types
 *
 *
 * INDEX: [admin, editor_menu, guest, super_admin, support, user]
 *
 * READ: [admin, editor_menu, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TWarePriceType = {
  readonly __typename?: 'WarePriceType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TWarePriceTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** WarePriceType enum */
export type TWarePriceTypeEnum =
  | 'DELIVERY'
  | 'INHOUSE';

/** WareRequirement enum */
export type TWareRequirementEnum =
  | 'MANDATORY'
  | 'MAX_ONE'
  | 'NO_LIMIT'
  | 'OPTIONAL';

/**
 * Possible WareUnit types
 *
 *
 * INDEX: [admin, editor_menu, operator, super_admin, support, user]
 *
 * READ: [admin, editor_menu, operator, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TWareUnit = {
  readonly __typename?: 'WareUnit';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TWareUnitEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** WareUnit enum */
export type TWareUnitEnum =
  | 'GRAM'
  | 'KILOGRAM'
  | 'LITRE'
  | 'MILLIGRAM'
  | 'MILLILITRE'
  | 'PIECE';

/**
 * Possible WeekDay types
 *
 *
 * INDEX: [admin, editor_business_hours, editor_orders, guest, super_admin, support, user]
 *
 * READ: [admin, editor_business_hours, editor_orders, guest, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TWeekDay = {
  readonly __typename?: 'WeekDay';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TWeekDayEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** WeekDay enum */
export type TWeekDayEnum =
  | 'FRIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'WEDNESDAY';

/** One page of instructions for wifi app */
export type TWiFiAppInstruction = {
  readonly __typename?: 'WiFiAppInstruction';
  readonly header: Maybe<Scalars['String']['output']>;
  readonly image: Maybe<Scalars['String']['output']>;
  readonly text: Scalars['String']['output'];
};


/** One page of instructions for wifi app */
export type TWiFiAppInstructionImageArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Profile attributes for Wolt */
export type TWoltProfile = {
  readonly __typename?: 'WoltProfile';
  readonly menuSyncPassword: Maybe<Scalars['String']['output']>;
  readonly menuSyncUsername: Maybe<Scalars['String']['output']>;
  readonly restaurantId: Maybe<Scalars['String']['output']>;
};

/** Setting attributes for Wolt */
export type TWoltSetting = {
  readonly __typename?: 'WoltSetting';
  readonly enabled: Scalars['Boolean']['output'];
  readonly profiles: Maybe<ReadonlyArray<TWoltProfile>>;
};

/**
 * Zone information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_zone, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TZone = TAvailabilityInterface & {
  readonly __typename?: 'Zone';
  /** when record is available */
  readonly availabilities: ReadonlyArray<TAvailability>;
  readonly companyBranch: TCompanyBranch;
  readonly createdAt: Scalars['DateTime']['output'];
  /** in minutes */
  readonly defaultDeliveryTime: Scalars['Int']['output'];
  /** in minutes */
  readonly deliveryTimeDeviation: Scalars['Int']['output'];
  readonly enabled: Scalars['Boolean']['output'];
  readonly geoPolygon: ReadonlyArray<TGeoPoint>;
  readonly id: Scalars['ID']['output'];
  /** is available at specific time? */
  readonly isAvailable: Scalars['Boolean']['output'];
  readonly minimalOrderPrice: TPriceConverted;
  /** Indicates if discounts are included in minimalOrderPrice */
  readonly minimalOrderPriceWithDiscounts: Scalars['Boolean']['output'];
  /** Indicates if transportFee is included in minimalOrderPrice */
  readonly minimalOrderPriceWithTransportFee: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  /** price range rules converted to prefered currency */
  readonly priceRangeRules: ReadonlyArray<TZonePriceRangeRule>;
  readonly priority: Scalars['Int']['output'];
  /** description of rule */
  readonly rule: Maybe<Scalars['Json']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly zoneColor: TZoneColor;
  readonly zoneType: TZoneType;
};


/**
 * Zone information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_zone, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TZoneIsAvailableArgs = {
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  orderOriginCategory?: InputMaybe<TOrderOriginCategoryEnum>;
};


/**
 * Zone information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_zone, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TZoneMinimalOrderPriceArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};


/**
 * Zone information
 *
 *
 * INDEX: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * READ: [admin, branch_owner, brand_owner, cashier, driver, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * CREATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * UPDATE: [admin, branch_owner, brand_owner, editor_zone, editor_zones, merchant, operator, sales_representative, super_admin, supervisor, support]
 *
 * DESTROY: [admin, branch_owner, brand_owner, editor_zone, merchant, operator, sales_representative, super_admin, supervisor]
 *
 */
export type TZonePriceRangeRulesArgs = {
  currency?: InputMaybe<TCurrencyEnum>;
};

/**
 * Zone color with code and color definition
 *
 *
 * INDEX: [admin, editor_zones, super_admin, support, user]
 *
 * READ: [admin, editor_zones, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TZoneColor = TColorInterface & {
  readonly __typename?: 'ZoneColor';
  readonly code: Scalars['String']['output'];
  readonly color: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
};

/** Price rules of the zone */
export type TZonePriceRangeRule = {
  readonly __typename?: 'ZonePriceRangeRule';
  /** price converted to prefered currency */
  readonly price: TPriceConverted;
  /** maximal price of rule */
  readonly toPrice: TPriceConverted;
};

/**
 * Possible ZoneType types
 *
 *
 * INDEX: [admin, editor_zones, super_admin, support, user]
 *
 * READ: [admin, editor_zones, super_admin, support, user]
 *
 * CREATE: [admin, super_admin, support]
 *
 * UPDATE: [admin, super_admin, support]
 *
 * DESTROY: [admin, super_admin]
 *
 */
export type TZoneType = {
  readonly __typename?: 'ZoneType';
  readonly code: Scalars['String']['output'];
  /** enum string used to identify object */
  readonly enum: TZoneTypeEnum;
  readonly id: Scalars['ID']['output'];
  /** not localized code */
  readonly rawCode: Scalars['String']['output'];
};

/** ZoneType enum */
export type TZoneTypeEnum =
  | 'AREA'
  | 'RETURN'
  | 'SECTOR'
  | 'TABLE';

export type TQAllergensVariables = Exact<{ [key: string]: never; }>;


export type TQAllergens = { readonly __typename?: 'Query', readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly enum: TAllergenEnum, readonly number: number, readonly name: string }> };

export type TFBranchStyles = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly headerText: string | null, readonly promoHeaderText: string | null, readonly nameLabel: string, readonly brand: { readonly __typename?: 'Company', readonly nameLabel: string }, readonly images: { readonly __typename?: 'GraphicStyle', readonly companyLogoUrl: string, readonly heroImageUrl: string }, readonly colors: { readonly __typename?: 'GraphicStyle', readonly companyPrimary: string, readonly conversion: string }, readonly advancedStyles: { readonly __typename?: 'GraphicStyle', readonly colors: string } };

export type TFBrandStyles = { readonly __typename?: 'Company', readonly id: ID, readonly headerText: string | null, readonly promoHeaderText: string | null, readonly nameLabel: string, readonly images: { readonly __typename?: 'GraphicStyle', readonly companyLogoUrl: string, readonly heroImageUrl: string }, readonly colors: { readonly __typename?: 'GraphicStyle', readonly companyPrimary: string, readonly conversion: string }, readonly advancedStyles: { readonly __typename?: 'GraphicStyle', readonly colors: string } };

type TFCompanyStylesApplicationSettings = { readonly __typename?: 'ApplicationSettings', readonly headerText: string | null, readonly promoHeaderText: string | null, readonly images: { readonly __typename?: 'GraphicStyle', readonly companyLogoUrl: string, readonly heroImageUrl: string }, readonly colors: { readonly __typename?: 'GraphicStyle', readonly companyPrimary: string, readonly conversion: string }, readonly advancedStyles: { readonly __typename?: 'GraphicStyle', readonly colors: string } };

type TFCompanyStylesCompany = { readonly __typename?: 'Company', readonly headerText: string | null, readonly promoHeaderText: string | null, readonly images: { readonly __typename?: 'GraphicStyle', readonly companyLogoUrl: string, readonly heroImageUrl: string }, readonly colors: { readonly __typename?: 'GraphicStyle', readonly companyPrimary: string, readonly conversion: string }, readonly advancedStyles: { readonly __typename?: 'GraphicStyle', readonly colors: string } };

type TFCompanyStylesCompanyBranch = { readonly __typename?: 'CompanyBranch', readonly headerText: string | null, readonly promoHeaderText: string | null, readonly images: { readonly __typename?: 'GraphicStyle', readonly companyLogoUrl: string, readonly heroImageUrl: string }, readonly colors: { readonly __typename?: 'GraphicStyle', readonly companyPrimary: string, readonly conversion: string }, readonly advancedStyles: { readonly __typename?: 'GraphicStyle', readonly colors: string } };

export type TFCompanyStyles = TFCompanyStylesApplicationSettings | TFCompanyStylesCompany | TFCompanyStylesCompanyBranch;

export type TQBranchStylesVariables = Exact<{
  branchId: Scalars['ID']['input'];
}>;


export type TQBranchStyles = { readonly __typename?: 'Query', readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly headerText: string | null, readonly promoHeaderText: string | null, readonly nameLabel: string, readonly brand: { readonly __typename?: 'Company', readonly nameLabel: string }, readonly images: { readonly __typename?: 'GraphicStyle', readonly companyLogoUrl: string, readonly heroImageUrl: string }, readonly colors: { readonly __typename?: 'GraphicStyle', readonly companyPrimary: string, readonly conversion: string }, readonly advancedStyles: { readonly __typename?: 'GraphicStyle', readonly colors: string } } };

export type TQCompanyStylesVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type TQCompanyStyles = { readonly __typename?: 'Query', readonly lookup: { readonly __typename?: 'CompanyBrandLookUp', readonly isBrand: boolean, readonly resolvedBrand: { readonly __typename?: 'Company', readonly id: ID, readonly headerText: string | null, readonly promoHeaderText: string | null, readonly nameLabel: string, readonly images: { readonly __typename?: 'GraphicStyle', readonly companyLogoUrl: string, readonly heroImageUrl: string }, readonly colors: { readonly __typename?: 'GraphicStyle', readonly companyPrimary: string, readonly conversion: string }, readonly advancedStyles: { readonly __typename?: 'GraphicStyle', readonly colors: string } } | null, readonly resolvedBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly headerText: string | null, readonly promoHeaderText: string | null, readonly nameLabel: string, readonly brand: { readonly __typename?: 'Company', readonly nameLabel: string }, readonly images: { readonly __typename?: 'GraphicStyle', readonly companyLogoUrl: string, readonly heroImageUrl: string }, readonly colors: { readonly __typename?: 'GraphicStyle', readonly companyPrimary: string, readonly conversion: string }, readonly advancedStyles: { readonly __typename?: 'GraphicStyle', readonly colors: string } } | null } };

export type TQOrderBranchStylesVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQOrderBranchStyles = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly headerText: string | null, readonly promoHeaderText: string | null, readonly nameLabel: string, readonly brand: { readonly __typename?: 'Company', readonly nameLabel: string }, readonly images: { readonly __typename?: 'GraphicStyle', readonly companyLogoUrl: string, readonly heroImageUrl: string }, readonly colors: { readonly __typename?: 'GraphicStyle', readonly companyPrimary: string, readonly conversion: string }, readonly advancedStyles: { readonly __typename?: 'GraphicStyle', readonly colors: string } } } };

export type TMChangePasswordVariables = Exact<{
  newPassword: Scalars['String']['input'];
  oldPassword?: InputMaybe<Scalars['String']['input']>;
}>;


export type TMChangePassword = { readonly __typename?: 'Mutation', readonly customer: { readonly __typename?: 'UserUpdatedPassword', readonly id: ID, readonly authToken: string } };

export type TMReportLogoutVariables = Exact<{ [key: string]: never; }>;


export type TMReportLogout = { readonly __typename?: 'Mutation', readonly isLoggedOut: boolean | null };

export type TMTransferOrderVariables = Exact<{
  orderId: Scalars['ID']['input'];
  newToken: Scalars['String']['input'];
}>;


export type TMTransferOrder = { readonly __typename?: 'Mutation', readonly updatedOrder: { readonly __typename?: 'Order', readonly id: ID } };

export type TQValidateAuthTokenVariables = Exact<{ [key: string]: never; }>;


export type TQValidateAuthToken = { readonly __typename?: 'Query', readonly result: ReadonlyArray<{ readonly __typename?: 'WeekDay', readonly id: ID }> };

export type TFAvailableBranch = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly pickupEnabled: boolean, readonly pickupAsapEnabled: boolean | null, readonly deliveryAsapEnabled: boolean | null, readonly headerText: string | null, readonly promoHeaderText: string | null, readonly isOpen: boolean, readonly willOpenAt: Date | null, readonly willCloseAt: Date | null, readonly phone: string, readonly deliveryEnabled: boolean, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly customerAccountsEnabled: boolean, readonly nameLabel: string, readonly pickupOnTimeEnabled: boolean, readonly deliveryOnTimeEnabled: boolean, readonly companyWebUrl: string | null, readonly defaultDeliveryTime: number, readonly defaultPickupTime: number, readonly brand: { readonly __typename?: 'Company', readonly id: ID }, readonly creditsGroupMembership: { readonly __typename?: 'CreditsGroupMembership', readonly canCollect: boolean, readonly canSpend: boolean } | null, readonly styles: { readonly __typename?: 'GraphicStyle', readonly branchLogoUrl: string }, readonly gps: { readonly __typename?: 'GeoPoint', readonly longitude: number, readonly latitude: number }, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly location: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null }, readonly openingHours: ReadonlyArray<{ readonly __typename?: 'BusinessHourInterval', readonly startsAt: Date, readonly endsAt: Date, readonly isClosed: boolean, readonly belongsIntoDay: Date }>, readonly contacts: { readonly __typename?: 'Address', readonly emails: ReadonlyArray<{ readonly __typename?: 'Email', readonly default: boolean, readonly email: string }> }, readonly currentClosedNote: { readonly __typename?: 'BusinessHourInterval', readonly message: string | null } | null };

export type TFAvailableDeliveryBranch = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly deliveryAsapEnabled: boolean | null, readonly deliveryOnTimeEnabled: boolean };

export type TFAvailablePickupBranch = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly pickupEnabled: boolean, readonly pickupAsapEnabled: boolean | null, readonly isOpen: boolean, readonly willOpenAt: Date | null, readonly willCloseAt: Date | null, readonly nameLabel: string, readonly pickupOnTimeEnabled: boolean, readonly gps: { readonly __typename?: 'GeoPoint', readonly longitude: number, readonly latitude: number }, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly location: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null }, readonly openingHours: ReadonlyArray<{ readonly __typename?: 'BusinessHourInterval', readonly startsAt: Date, readonly endsAt: Date, readonly isClosed: boolean, readonly belongsIntoDay: Date }>, readonly currentClosedNote: { readonly __typename?: 'BusinessHourInterval', readonly message: string | null } | null };

export type TFBranchDetail = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly headerText: string | null, readonly promoHeaderText: string | null, readonly phone: string, readonly deliveryEnabled: boolean, readonly defaultDeliveryTimeEnabled: boolean, readonly pickupEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly isOpen: boolean, readonly willOpenAt: Date | null, readonly willCloseAt: Date | null, readonly nameLabel: string, readonly companyWebUrl: string | null, readonly defaultDeliveryTime: number, readonly defaultPickupTime: number, readonly styles: { readonly __typename?: 'GraphicStyle', readonly branchLogoUrl: string }, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly location: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null }, readonly contacts: { readonly __typename?: 'Address', readonly emails: ReadonlyArray<{ readonly __typename?: 'Email', readonly default: boolean, readonly email: string }> }, readonly gps: { readonly __typename?: 'GeoPoint', readonly longitude: number, readonly latitude: number }, readonly openingHours: ReadonlyArray<{ readonly __typename?: 'BusinessHourInterval', readonly startsAt: Date, readonly endsAt: Date, readonly isClosed: boolean, readonly belongsIntoDay: Date }>, readonly currentClosedNote: { readonly __typename?: 'BusinessHourInterval', readonly message: string | null } | null };

export type TQAvailableBranchesVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
  openingHoursFrom?: InputMaybe<Scalars['DateTime']['input']>;
  openingHoursTo?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type TQAvailableBranches = { readonly __typename?: 'Query', readonly lookup: { readonly __typename?: 'CompanyBrandLookUp', readonly isBrand: boolean, readonly resolvedBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly pickupEnabled: boolean, readonly pickupAsapEnabled: boolean | null, readonly deliveryAsapEnabled: boolean | null, readonly headerText: string | null, readonly promoHeaderText: string | null, readonly isOpen: boolean, readonly willOpenAt: Date | null, readonly willCloseAt: Date | null, readonly phone: string, readonly deliveryEnabled: boolean, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly customerAccountsEnabled: boolean, readonly nameLabel: string, readonly pickupOnTimeEnabled: boolean, readonly deliveryOnTimeEnabled: boolean, readonly companyWebUrl: string | null, readonly defaultDeliveryTime: number, readonly defaultPickupTime: number, readonly brand: { readonly __typename?: 'Company', readonly id: ID }, readonly creditsGroupMembership: { readonly __typename?: 'CreditsGroupMembership', readonly canCollect: boolean, readonly canSpend: boolean } | null, readonly styles: { readonly __typename?: 'GraphicStyle', readonly branchLogoUrl: string }, readonly gps: { readonly __typename?: 'GeoPoint', readonly longitude: number, readonly latitude: number }, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly location: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null }, readonly openingHours: ReadonlyArray<{ readonly __typename?: 'BusinessHourInterval', readonly startsAt: Date, readonly endsAt: Date, readonly isClosed: boolean, readonly belongsIntoDay: Date }>, readonly contacts: { readonly __typename?: 'Address', readonly emails: ReadonlyArray<{ readonly __typename?: 'Email', readonly default: boolean, readonly email: string }> }, readonly currentClosedNote: { readonly __typename?: 'BusinessHourInterval', readonly message: string | null } | null }>, readonly resolvedBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly pickupEnabled: boolean, readonly pickupAsapEnabled: boolean | null, readonly deliveryAsapEnabled: boolean | null, readonly headerText: string | null, readonly promoHeaderText: string | null, readonly isOpen: boolean, readonly willOpenAt: Date | null, readonly willCloseAt: Date | null, readonly phone: string, readonly deliveryEnabled: boolean, readonly defaultDeliveryTimeEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly customerAccountsEnabled: boolean, readonly nameLabel: string, readonly pickupOnTimeEnabled: boolean, readonly deliveryOnTimeEnabled: boolean, readonly companyWebUrl: string | null, readonly defaultDeliveryTime: number, readonly defaultPickupTime: number, readonly brand: { readonly __typename?: 'Company', readonly id: ID }, readonly creditsGroupMembership: { readonly __typename?: 'CreditsGroupMembership', readonly canCollect: boolean, readonly canSpend: boolean } | null, readonly styles: { readonly __typename?: 'GraphicStyle', readonly branchLogoUrl: string }, readonly gps: { readonly __typename?: 'GeoPoint', readonly longitude: number, readonly latitude: number }, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly location: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null }, readonly openingHours: ReadonlyArray<{ readonly __typename?: 'BusinessHourInterval', readonly startsAt: Date, readonly endsAt: Date, readonly isClosed: boolean, readonly belongsIntoDay: Date }>, readonly contacts: { readonly __typename?: 'Address', readonly emails: ReadonlyArray<{ readonly __typename?: 'Email', readonly default: boolean, readonly email: string }> }, readonly currentClosedNote: { readonly __typename?: 'BusinessHourInterval', readonly message: string | null } | null } | null } };

export type TFCartBaseContent = { readonly __typename?: 'Order', readonly id: ID, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly product: { readonly __typename?: 'Recipe', readonly isCombinationMeal: boolean, readonly id: ID, readonly nameLabel: string, readonly availableAddonCount: number }, readonly promoTag: { readonly __typename?: 'PromoTag', readonly enum: TPromoTagEnum } | null, readonly productCategory: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }> }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly vouchers: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly tip: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } };

export type TFCartContent = { readonly __typename?: 'Order', readonly levelsOfTransportFeesCount: number | null, readonly id: ID, readonly nextPossibleTransportFee: { readonly __typename?: 'TransportFees', readonly amountRemainingToLevel: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly orderPriceMinimum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null } | null, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly product: { readonly __typename?: 'Recipe', readonly isCombinationMeal: boolean, readonly id: ID, readonly nameLabel: string, readonly availableAddonCount: number }, readonly promoTag: { readonly __typename?: 'PromoTag', readonly enum: TPromoTagEnum } | null, readonly productCategory: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }> }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly vouchers: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly tip: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly creditsReward: { readonly __typename?: 'CreditsReward', readonly id: ID | null, readonly createdAt: Date | null, readonly state: { readonly __typename?: 'CreditsRewardState', readonly id: ID, readonly code: string, readonly rawCode: string, readonly enum: TCreditsRewardStateEnum }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } } | null, readonly creditsPendingWalletPayment: { readonly __typename?: 'CreditsPendingWalletPayment', readonly amount: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly unpaid: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly label: string, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly enum: TPaymentGateEnum } }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> };

export type TFCartFullItem = { readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly product: { readonly __typename?: 'Recipe', readonly isCombinationMeal: boolean, readonly id: ID, readonly nameLabel: string, readonly availableAddonCount: number }, readonly promoTag: { readonly __typename?: 'PromoTag', readonly enum: TPromoTagEnum } | null, readonly productCategory: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }> };

export type TFCartOrder = { readonly __typename?: 'Order', readonly id: ID, readonly ageControl: boolean, readonly itemCount: number, readonly isMinPriceAfterDiscounts: boolean, readonly isMinPriceWithTransport: boolean, readonly updateTimestamp: Date | null, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly collectFromCustomer: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly minimalOrderPriceRemainder: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null };

export type TFCartStatic = { readonly __typename?: 'Order', readonly id: ID, readonly isMinPriceAfterDiscounts: boolean, readonly isMinPriceWithTransport: boolean, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly minimalOrderPriceRemainder: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null };

export type TFCartSummary = { readonly __typename?: 'Order', readonly id: ID, readonly ageControl: boolean, readonly itemCount: number, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly collectFromCustomer: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } };

export type TFCartUpdateTime = { readonly __typename?: 'Order', readonly id: ID, readonly updateTimestamp: Date | null };

export type TFDiscount = { readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } };

export type TFOrderInCart = { readonly __typename?: 'Order', readonly id: ID, readonly levelsOfTransportFeesCount: number | null, readonly ageControl: boolean, readonly shopId: ID, readonly itemCount: number, readonly isMinPriceAfterDiscounts: boolean, readonly isMinPriceWithTransport: boolean, readonly updateTimestamp: Date | null, readonly nextPossibleTransportFee: { readonly __typename?: 'TransportFees', readonly amountRemainingToLevel: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly orderPriceMinimum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null } | null, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly collectFromCustomer: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly minimalOrderPriceRemainder: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly product: { readonly __typename?: 'Recipe', readonly isCombinationMeal: boolean, readonly id: ID, readonly nameLabel: string, readonly availableAddonCount: number }, readonly promoTag: { readonly __typename?: 'PromoTag', readonly enum: TPromoTagEnum } | null, readonly productCategory: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }> }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly vouchers: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly tip: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly creditsReward: { readonly __typename?: 'CreditsReward', readonly id: ID | null, readonly createdAt: Date | null, readonly state: { readonly __typename?: 'CreditsRewardState', readonly id: ID, readonly code: string, readonly rawCode: string, readonly enum: TCreditsRewardStateEnum }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } } | null, readonly creditsPendingWalletPayment: { readonly __typename?: 'CreditsPendingWalletPayment', readonly amount: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly unpaid: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly label: string, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly enum: TPaymentGateEnum } }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> };

export type TFOrderPayment = { readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly label: string, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly enum: TPaymentGateEnum } }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } };

export type TQOrderForCartVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQOrderForCart = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly levelsOfTransportFeesCount: number | null, readonly ageControl: boolean, readonly shopId: ID, readonly itemCount: number, readonly isMinPriceAfterDiscounts: boolean, readonly isMinPriceWithTransport: boolean, readonly updateTimestamp: Date | null, readonly nextPossibleTransportFee: { readonly __typename?: 'TransportFees', readonly amountRemainingToLevel: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly orderPriceMinimum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null } | null, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly collectFromCustomer: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly minimalOrderPriceRemainder: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly product: { readonly __typename?: 'Recipe', readonly isCombinationMeal: boolean, readonly id: ID, readonly nameLabel: string, readonly availableAddonCount: number }, readonly promoTag: { readonly __typename?: 'PromoTag', readonly enum: TPromoTagEnum } | null, readonly productCategory: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }> }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly vouchers: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly tip: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly creditsReward: { readonly __typename?: 'CreditsReward', readonly id: ID | null, readonly createdAt: Date | null, readonly state: { readonly __typename?: 'CreditsRewardState', readonly id: ID, readonly code: string, readonly rawCode: string, readonly enum: TCreditsRewardStateEnum }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } } | null, readonly creditsPendingWalletPayment: { readonly __typename?: 'CreditsPendingWalletPayment', readonly amount: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly unpaid: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly label: string, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly enum: TPaymentGateEnum } }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> } };

export type TFAddonDetailBase = { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly sideDishCombinationMealPrices?: ReadonlyArray<{ readonly __typename?: 'PriceComboSideDish', readonly categoryId: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> | null };

export type TFMainAddonDetailBase = { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly ageControl: boolean, readonly image: string | null, readonly pictogram: string | null, readonly descriptionLabel: string | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly sideDishCombinationMealPrices?: ReadonlyArray<{ readonly __typename?: 'PriceComboSideDish', readonly categoryId: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> | null, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly nameLabel: string, readonly number: number }> };

export type TFMainProductDetailBase = { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly isCombinationMeal: boolean, readonly ageControl: boolean, readonly image: string | null, readonly pictogram: string | null, readonly descriptionLabel: string | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly combinationMealPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly nameLabel: string, readonly number: number }> };

export type TFProductDetail = { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly isCombinationMeal: boolean, readonly ageControl: boolean, readonly image: string | null, readonly pictogram: string | null, readonly descriptionLabel: string | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string, readonly decimalPlaces: number } }, readonly addonCategories: ReadonlyArray<{ readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string, readonly minTotalCount: number, readonly maxTotalCount: number, readonly maxIndividualCount: number, readonly addons: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly isMainProduct: boolean, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly sideDishCombinationMealPrices?: ReadonlyArray<{ readonly __typename?: 'PriceComboSideDish', readonly categoryId: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> | null }> }>, readonly combinationMealPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly nameLabel: string, readonly number: number }> };

export type TFProductDetailBase = { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly isCombinationMeal: boolean, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly combinationMealPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } };

export type TFProductDetailExtra = { readonly __typename?: 'Recipe', readonly ageControl: boolean, readonly image: string | null, readonly pictogram: string | null, readonly descriptionLabel: string | null, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly nameLabel: string, readonly number: number }> };

export type TMAddProductToCartVariables = Exact<{
  amount: Scalars['Int']['input'];
  orderId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  promoTag?: InputMaybe<TPromoTagEnum>;
  addons?: InputMaybe<ReadonlyArray<TInputOrderRecipeSideDishCreate>>;
}>;


export type TMAddProductToCart = { readonly __typename?: 'Mutation', readonly updatedOrder: { readonly __typename?: 'Order', readonly id: ID, readonly levelsOfTransportFeesCount: number | null, readonly ageControl: boolean, readonly shopId: ID, readonly itemCount: number, readonly isMinPriceAfterDiscounts: boolean, readonly isMinPriceWithTransport: boolean, readonly updateTimestamp: Date | null, readonly nextPossibleTransportFee: { readonly __typename?: 'TransportFees', readonly amountRemainingToLevel: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly orderPriceMinimum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null } | null, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly collectFromCustomer: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly minimalOrderPriceRemainder: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly product: { readonly __typename?: 'Recipe', readonly isCombinationMeal: boolean, readonly id: ID, readonly nameLabel: string, readonly availableAddonCount: number }, readonly promoTag: { readonly __typename?: 'PromoTag', readonly enum: TPromoTagEnum } | null, readonly productCategory: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }> }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly vouchers: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly tip: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly creditsReward: { readonly __typename?: 'CreditsReward', readonly id: ID | null, readonly createdAt: Date | null, readonly state: { readonly __typename?: 'CreditsRewardState', readonly id: ID, readonly code: string, readonly rawCode: string, readonly enum: TCreditsRewardStateEnum }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } } | null, readonly creditsPendingWalletPayment: { readonly __typename?: 'CreditsPendingWalletPayment', readonly amount: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly unpaid: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly label: string, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly enum: TPaymentGateEnum } }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> } };

export type TMRemoveCartItemsVariables = Exact<{
  itemIds: ReadonlyArray<Scalars['ID']['input']>;
}>;


export type TMRemoveCartItems = { readonly __typename?: 'Mutation', readonly updatedOrder: { readonly __typename?: 'Order', readonly id: ID, readonly levelsOfTransportFeesCount: number | null, readonly ageControl: boolean, readonly shopId: ID, readonly itemCount: number, readonly isMinPriceAfterDiscounts: boolean, readonly isMinPriceWithTransport: boolean, readonly updateTimestamp: Date | null, readonly nextPossibleTransportFee: { readonly __typename?: 'TransportFees', readonly amountRemainingToLevel: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly orderPriceMinimum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null } | null, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly collectFromCustomer: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly minimalOrderPriceRemainder: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly product: { readonly __typename?: 'Recipe', readonly isCombinationMeal: boolean, readonly id: ID, readonly nameLabel: string, readonly availableAddonCount: number }, readonly promoTag: { readonly __typename?: 'PromoTag', readonly enum: TPromoTagEnum } | null, readonly productCategory: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }> }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly vouchers: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly tip: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly creditsReward: { readonly __typename?: 'CreditsReward', readonly id: ID | null, readonly createdAt: Date | null, readonly state: { readonly __typename?: 'CreditsRewardState', readonly id: ID, readonly code: string, readonly rawCode: string, readonly enum: TCreditsRewardStateEnum }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } } | null, readonly creditsPendingWalletPayment: { readonly __typename?: 'CreditsPendingWalletPayment', readonly amount: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly unpaid: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly label: string, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly enum: TPaymentGateEnum } }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> } };

export type TMUpdateCartItemVariables = Exact<{
  itemId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  addons?: InputMaybe<ReadonlyArray<TInputOrderRecipeSideDishUpdate>>;
}>;


export type TMUpdateCartItem = { readonly __typename?: 'Mutation', readonly updatedOrder: { readonly __typename?: 'Order', readonly id: ID, readonly levelsOfTransportFeesCount: number | null, readonly ageControl: boolean, readonly shopId: ID, readonly itemCount: number, readonly isMinPriceAfterDiscounts: boolean, readonly isMinPriceWithTransport: boolean, readonly updateTimestamp: Date | null, readonly nextPossibleTransportFee: { readonly __typename?: 'TransportFees', readonly amountRemainingToLevel: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly orderPriceMinimum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null } | null, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly collectFromCustomer: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly minimalOrderPriceRemainder: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly product: { readonly __typename?: 'Recipe', readonly isCombinationMeal: boolean, readonly id: ID, readonly nameLabel: string, readonly availableAddonCount: number }, readonly promoTag: { readonly __typename?: 'PromoTag', readonly enum: TPromoTagEnum } | null, readonly productCategory: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }> }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly vouchers: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly tip: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly creditsReward: { readonly __typename?: 'CreditsReward', readonly id: ID | null, readonly createdAt: Date | null, readonly state: { readonly __typename?: 'CreditsRewardState', readonly id: ID, readonly code: string, readonly rawCode: string, readonly enum: TCreditsRewardStateEnum }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } } | null, readonly creditsPendingWalletPayment: { readonly __typename?: 'CreditsPendingWalletPayment', readonly amount: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly unpaid: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly label: string, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly enum: TPaymentGateEnum } }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> } };

export type TQAddonDetailVariables = Exact<{
  productId: Scalars['ID']['input'];
  branchId?: InputMaybe<Scalars['ID']['input']>;
  priceType?: InputMaybe<TWarePriceTypeEnum>;
  isCombinationMeal: Scalars['Boolean']['input'];
}>;


export type TQAddonDetail = { readonly __typename?: 'Query', readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly ageControl: boolean, readonly image: string | null, readonly pictogram: string | null, readonly descriptionLabel: string | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly sideDishCombinationMealPrices?: ReadonlyArray<{ readonly __typename?: 'PriceComboSideDish', readonly categoryId: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> | null, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly nameLabel: string, readonly number: number }> } };

export type TQCartItemVariables = Exact<{
  itemId: Scalars['ID']['input'];
  priceType?: InputMaybe<TWarePriceTypeEnum>;
  isCombinationMeal: Scalars['Boolean']['input'];
}>;


export type TQCartItem = { readonly __typename?: 'Query', readonly item: { readonly __typename?: 'OrderRecipe', readonly id: ID, readonly note: string | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly isCombinationMeal: boolean, readonly ageControl: boolean, readonly image: string | null, readonly pictogram: string | null, readonly descriptionLabel: string | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string, readonly decimalPlaces: number } }, readonly addonCategories: ReadonlyArray<{ readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string, readonly minTotalCount: number, readonly maxTotalCount: number, readonly maxIndividualCount: number, readonly addons: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly isMainProduct: boolean, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly sideDishCombinationMealPrices?: ReadonlyArray<{ readonly __typename?: 'PriceComboSideDish', readonly categoryId: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> | null }> }>, readonly combinationMealPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly nameLabel: string, readonly number: number }> }, readonly selectedAddons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly product: { readonly __typename?: 'Recipe', readonly id: ID } }> } };

export type TQProductDetailVariables = Exact<{
  productId: Scalars['ID']['input'];
  branchId?: InputMaybe<Scalars['ID']['input']>;
  priceType?: InputMaybe<TWarePriceTypeEnum>;
  isCombinationMeal: Scalars['Boolean']['input'];
}>;


export type TQProductDetail = { readonly __typename?: 'Query', readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly isCombinationMeal: boolean, readonly ageControl: boolean, readonly image: string | null, readonly pictogram: string | null, readonly descriptionLabel: string | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string, readonly decimalPlaces: number } }, readonly addonCategories: ReadonlyArray<{ readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string, readonly minTotalCount: number, readonly maxTotalCount: number, readonly maxIndividualCount: number, readonly addons: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly isMainProduct: boolean, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly sideDishCombinationMealPrices?: ReadonlyArray<{ readonly __typename?: 'PriceComboSideDish', readonly categoryId: ID, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> | null }> }>, readonly combinationMealPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly nameLabel: string, readonly number: number }> } };

export type TFAddress = { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null };

export type TFBranchAddress = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly location: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null } };

export type TFBranchEmail = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly contacts: { readonly __typename?: 'Address', readonly emails: ReadonlyArray<{ readonly __typename?: 'Email', readonly default: boolean, readonly email: string }> } };

export type TFBranchGps = { readonly __typename?: 'CompanyBranch', readonly gps: { readonly __typename?: 'GeoPoint', readonly longitude: number, readonly latitude: number } };

export type TFBranchHandoverTimes = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly deliveryEnabled: boolean, readonly defaultDeliveryTimeEnabled: boolean, readonly pickupEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly defaultDeliveryTime: number, readonly defaultPickupTime: number };

export type TFBranchInfoTopLine = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly phone: string, readonly deliveryEnabled: boolean, readonly defaultDeliveryTimeEnabled: boolean, readonly pickupEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly isOpen: boolean, readonly willOpenAt: Date | null, readonly willCloseAt: Date | null, readonly defaultDeliveryTime: number, readonly defaultPickupTime: number, readonly openingHours: ReadonlyArray<{ readonly __typename?: 'BusinessHourInterval', readonly startsAt: Date, readonly endsAt: Date, readonly isClosed: boolean, readonly belongsIntoDay: Date }>, readonly currentClosedNote: { readonly __typename?: 'BusinessHourInterval', readonly message: string | null } | null };

export type TFBranchOpeningHours = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly isOpen: boolean, readonly willOpenAt: Date | null, readonly willCloseAt: Date | null, readonly openingHours: ReadonlyArray<{ readonly __typename?: 'BusinessHourInterval', readonly startsAt: Date, readonly endsAt: Date, readonly isClosed: boolean, readonly belongsIntoDay: Date }>, readonly currentClosedNote: { readonly __typename?: 'BusinessHourInterval', readonly message: string | null } | null };

export type TFBranchOpeningStatus = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly isOpen: boolean, readonly willOpenAt: Date | null, readonly willCloseAt: Date | null, readonly currentClosedNote: { readonly __typename?: 'BusinessHourInterval', readonly message: string | null } | null };

export type TFBranchPhone = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly phone: string };

export type TFBranchPhonePrefix = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly country: { readonly __typename?: 'Country', readonly phonePrefix: string } | null } };

export type TFCartItem = { readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }>, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } };

export type TFCartItemBase = { readonly __typename?: 'OrderRecipe', readonly id: ID, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } };

export type TFCreditPrice = { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string };

export type TFDeliveryZone = { readonly __typename?: 'Zone', readonly id: ID, readonly deliveryTimeDeviation: number };

export type TFHandoverType = { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum };

export type TFOpeningHoursInterval = { readonly __typename?: 'BusinessHourInterval', readonly startsAt: Date, readonly endsAt: Date, readonly isClosed: boolean, readonly belongsIntoDay: Date };

export type TFOrderAddress = { readonly __typename?: 'Order', readonly id: ID, readonly handoverAddress: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } };

export type TFPhone = { readonly __typename?: 'Phone', readonly phone: string, readonly isDefault: boolean };

export type TFPrice = { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number };

export type TFTimeSlot = { readonly __typename?: 'DeliverySlot', readonly id: ID, readonly startsAt: Date, readonly endsAt: Date };

export type TFBranchForWallet = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string };

export type TFCreditActivity = { readonly __typename?: 'CreditsWalletActivity', readonly id: ID, readonly createdAt: Date, readonly expiresAt: Date | null, readonly isExpiringSoon: boolean, readonly isExpired: boolean, readonly activityType: { readonly __typename?: 'CreditsWalletActivityType', readonly id: ID, readonly enum: TCreditsWalletActivityTypeEnum, readonly code: string }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly remainingAmount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly order: { readonly __typename?: 'Order', readonly id: ID } | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly wallet: { readonly __typename?: 'CreditsWallet', readonly id: ID, readonly name: string } };

export type TFCreditGroupMembership = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly creditsGroupMembership: { readonly __typename?: 'CreditsGroupMembership', readonly canCollect: boolean, readonly canSpend: boolean } | null };

export type TFCreditWallet = { readonly __typename?: 'CreditsWallet', readonly id: ID, readonly name: string, readonly isClosed: boolean, readonly balance: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly currency: { readonly __typename?: 'Currency', readonly decimalRound: number }, readonly creditsExpiringSoon: { readonly __typename?: 'CreditsWalletActivityConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CreditsWalletActivityEdge', readonly node: { readonly __typename?: 'CreditsWalletActivity', readonly id: ID, readonly remainingAmount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } } | null } | null> | null } | null, readonly companyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }> };

export type TFCreditWalletSummary = { readonly __typename?: 'CreditsWallet', readonly id: ID, readonly name: string, readonly isClosed: boolean, readonly balance: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly currency: { readonly __typename?: 'Currency', readonly decimalRound: number }, readonly creditsExpiringSoon: { readonly __typename?: 'CreditsWalletActivityConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CreditsWalletActivityEdge', readonly node: { readonly __typename?: 'CreditsWalletActivity', readonly id: ID, readonly remainingAmount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } } | null } | null> | null } | null, readonly companyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }> };

export type TFCreditsPayments = { readonly __typename?: 'Order', readonly id: ID, readonly creditsPendingWalletPayment: { readonly __typename?: 'CreditsPendingWalletPayment', readonly amount: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly unpaid: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly label: string, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly enum: TPaymentGateEnum } }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> };

export type TFCreditsPendingPayment = { readonly __typename?: 'CreditsPendingWalletPayment', readonly amount: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly unpaid: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } };

export type TFCreditsPendingReward = { readonly __typename?: 'CreditsReward', readonly id: ID | null, readonly createdAt: Date | null, readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } }, readonly state: { readonly __typename?: 'CreditsRewardState', readonly id: ID, readonly code: string, readonly rawCode: string, readonly enum: TCreditsRewardStateEnum }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } };

export type TFCreditsReward = { readonly __typename?: 'CreditsReward', readonly id: ID | null, readonly createdAt: Date | null, readonly state: { readonly __typename?: 'CreditsRewardState', readonly id: ID, readonly code: string, readonly rawCode: string, readonly enum: TCreditsRewardStateEnum }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } };

export type TFOrderForCredits = { readonly __typename?: 'Order', readonly id: ID, readonly creditsReward: { readonly __typename?: 'CreditsReward', readonly id: ID | null, readonly createdAt: Date | null, readonly state: { readonly __typename?: 'CreditsRewardState', readonly id: ID, readonly code: string, readonly rawCode: string, readonly enum: TCreditsRewardStateEnum }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } } | null, readonly creditsPendingWalletPayment: { readonly __typename?: 'CreditsPendingWalletPayment', readonly amount: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly unpaid: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly label: string, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly enum: TPaymentGateEnum } }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> };

export type TMRedeemCreditsVariables = Exact<{
  orderId: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  walletId: Scalars['ID']['input'];
}>;


export type TMRedeemCredits = { readonly __typename?: 'Mutation', readonly addCreditsPayment: { readonly __typename?: 'CreditsPaymentAdd', readonly order: { readonly __typename?: 'Order', readonly id: ID } } };

export type TQAvailableCreditsVariables = Exact<{
  userId: Scalars['ID']['input'];
  branchId: Scalars['ID']['input'];
}>;


export type TQAvailableCredits = { readonly __typename?: 'Query', readonly customer: { readonly __typename?: 'User', readonly id: ID, readonly creditsWallets: ReadonlyArray<{ readonly __typename?: 'CreditsWallet', readonly id: ID, readonly cashPaymentUnit: number, readonly balance: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly currency: { readonly __typename?: 'Currency', readonly decimalRound: number } }> } };

export type TQCreditWalletVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TQCreditWallet = { readonly __typename?: 'Query', readonly creditsWallet: { readonly __typename?: 'CreditsWallet', readonly id: ID, readonly name: string, readonly isClosed: boolean, readonly balance: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly currency: { readonly __typename?: 'Currency', readonly decimalRound: number }, readonly creditsExpiringSoon: { readonly __typename?: 'CreditsWalletActivityConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CreditsWalletActivityEdge', readonly node: { readonly __typename?: 'CreditsWalletActivity', readonly id: ID, readonly remainingAmount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } } | null } | null> | null } | null, readonly companyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }> } };

export type TQCustomerCreditsVariables = Exact<{
  id: Scalars['ID']['input'];
  companyBranches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TQCustomerCredits = { readonly __typename?: 'Query', readonly customer: { readonly __typename?: 'User', readonly id: ID, readonly creditsWalletActivities: { readonly __typename?: 'CreditsWalletActivityConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly startCursor: string | null, readonly endCursor: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CreditsWalletActivityEdge', readonly node: { readonly __typename?: 'CreditsWalletActivity', readonly id: ID, readonly createdAt: Date, readonly expiresAt: Date | null, readonly isExpiringSoon: boolean, readonly isExpired: boolean, readonly activityType: { readonly __typename?: 'CreditsWalletActivityType', readonly id: ID, readonly enum: TCreditsWalletActivityTypeEnum, readonly code: string }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly remainingAmount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly order: { readonly __typename?: 'Order', readonly id: ID } | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly wallet: { readonly __typename?: 'CreditsWallet', readonly id: ID, readonly name: string } } | null } | null> | null } } };

export type TQCustomerWalletsVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TQCustomerWallets = { readonly __typename?: 'Query', readonly customer: { readonly __typename?: 'User', readonly id: ID, readonly creditsWallets: ReadonlyArray<{ readonly __typename?: 'CreditsWallet', readonly id: ID, readonly name: string, readonly isClosed: boolean, readonly balance: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly currency: { readonly __typename?: 'Currency', readonly decimalRound: number }, readonly creditsExpiringSoon: { readonly __typename?: 'CreditsWalletActivityConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CreditsWalletActivityEdge', readonly node: { readonly __typename?: 'CreditsWalletActivity', readonly id: ID, readonly remainingAmount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } } | null } | null> | null } | null, readonly companyBranches: ReadonlyArray<{ readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }> }> } };

export type TQExpiringSoonInWalletVariables = Exact<{
  walletId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type TQExpiringSoonInWallet = { readonly __typename?: 'Query', readonly creditsWallet: { readonly __typename?: 'CreditsWallet', readonly id: ID, readonly creditsExpiringSoon: { readonly __typename?: 'CreditsWalletActivityConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly startCursor: string | null, readonly endCursor: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CreditsWalletActivityEdge', readonly node: { readonly __typename?: 'CreditsWalletActivity', readonly id: ID, readonly createdAt: Date, readonly expiresAt: Date | null, readonly isExpiringSoon: boolean, readonly isExpired: boolean, readonly activityType: { readonly __typename?: 'CreditsWalletActivityType', readonly id: ID, readonly enum: TCreditsWalletActivityTypeEnum, readonly code: string }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly remainingAmount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly order: { readonly __typename?: 'Order', readonly id: ID } | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly wallet: { readonly __typename?: 'CreditsWallet', readonly id: ID, readonly name: string } } | null } | null> | null } | null } };

export type TQPendingRewardsVariables = Exact<{
  walletId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type TQPendingRewards = { readonly __typename?: 'Query', readonly creditsWallet: { readonly __typename?: 'CreditsWallet', readonly id: ID, readonly creditsPendingRewards: { readonly __typename?: 'CreditsRewardConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly startCursor: string | null, readonly endCursor: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CreditsRewardEdge', readonly node: { readonly __typename?: 'CreditsReward', readonly id: ID | null, readonly createdAt: Date | null, readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string } }, readonly state: { readonly __typename?: 'CreditsRewardState', readonly id: ID, readonly code: string, readonly rawCode: string, readonly enum: TCreditsRewardStateEnum }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } } | null } | null> | null } } };

export type TQWalletActivitiesVariables = Exact<{
  walletId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type TQWalletActivities = { readonly __typename?: 'Query', readonly creditsWallet: { readonly __typename?: 'CreditsWallet', readonly id: ID, readonly creditsWalletActivities: { readonly __typename?: 'CreditsWalletActivityConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly startCursor: string | null, readonly endCursor: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CreditsWalletActivityEdge', readonly node: { readonly __typename?: 'CreditsWalletActivity', readonly id: ID, readonly createdAt: Date, readonly expiresAt: Date | null, readonly isExpiringSoon: boolean, readonly isExpired: boolean, readonly activityType: { readonly __typename?: 'CreditsWalletActivityType', readonly id: ID, readonly enum: TCreditsWalletActivityTypeEnum, readonly code: string }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly remainingAmount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string }, readonly order: { readonly __typename?: 'Order', readonly id: ID } | null, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string }, readonly wallet: { readonly __typename?: 'CreditsWallet', readonly id: ID, readonly name: string } } | null } | null> | null } } };

export type TFAddressType = { readonly __typename?: 'AddressType', readonly id: ID, readonly enum: TAddressTypeEnum, readonly label: string };

export type TFCustomer = { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly email: string, readonly givenName: string | null, readonly familyName: string | null, readonly confirmedEmails: ReadonlyArray<string>, readonly phoneNumber: string, readonly phonePrefix: string, readonly fullPhone: string, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } };

export type TFCustomerAddress = { readonly __typename?: 'Address', readonly id: ID, readonly title: string | null, readonly type: { readonly __typename?: 'AddressType', readonly id: ID, readonly enum: TAddressTypeEnum, readonly label: string }, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null, readonly location: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null };

export type TMAddCustomerAddressVariables = Exact<{
  type: TAddressTypeEnum;
  gps: TInputGeoPointCreate;
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type TMAddCustomerAddress = { readonly __typename?: 'Mutation', readonly newAddress: { readonly __typename?: 'Address', readonly id: ID } };

export type TMConsentsAppLinkVariables = Exact<{ [key: string]: never; }>;


export type TMConsentsAppLink = { readonly __typename?: 'Mutation', readonly consentsAppLink: string };

export type TMDeleteCustomerAccountVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type TMDeleteCustomerAccount = { readonly __typename?: 'Mutation', readonly wasDeleted: boolean };

export type TMDeleteCustomerAddressVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TMDeleteCustomerAddress = { readonly __typename?: 'Mutation', readonly deletedAddress: { readonly __typename?: 'Address', readonly id: ID } };

export type TMRequestVerificationEmailVariables = Exact<{
  email: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
}>;


export type TMRequestVerificationEmail = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'RequestEmailConfirmationCode', readonly usedEmail: string } };

export type TMUpdateCustomerVariables = Exact<{
  id: Scalars['ID']['input'];
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
}>;


export type TMUpdateCustomer = { readonly __typename?: 'Mutation', readonly customer: { readonly __typename?: 'User', readonly id: ID } };

export type TMUpdateCustomerAddressVariables = Exact<{
  id: Scalars['ID']['input'];
  type?: InputMaybe<TAddressTypeEnum>;
  gps?: InputMaybe<TInputGeoPointCreate>;
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type TMUpdateCustomerAddress = { readonly __typename?: 'Mutation', readonly updatedAddress: { readonly __typename?: 'Address', readonly id: ID, readonly title: string | null, readonly type: { readonly __typename?: 'AddressType', readonly id: ID, readonly enum: TAddressTypeEnum, readonly label: string }, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null, readonly location: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null } };

export type TMUpdateCustomerLanguageVariables = Exact<{
  id: Scalars['ID']['input'];
  language?: InputMaybe<TLanguageEnum>;
}>;


export type TMUpdateCustomerLanguage = { readonly __typename?: 'Mutation', readonly customer: { readonly __typename?: 'User', readonly id: ID } };

export type TMValidateEmailConfirmationCodeVariables = Exact<{
  confirmationToken: Scalars['String']['input'];
}>;


export type TMValidateEmailConfirmationCode = { readonly __typename?: 'Mutation', readonly verifiedEmail: { readonly __typename?: 'RequestEmailConfirmationCode', readonly email: string } };

export type TQAddressTypesVariables = Exact<{ [key: string]: never; }>;


export type TQAddressTypes = { readonly __typename?: 'Query', readonly addressTypes: ReadonlyArray<{ readonly __typename?: 'AddressType', readonly id: ID, readonly enum: TAddressTypeEnum, readonly label: string }> };

export type TQCustomerVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TQCustomer = { readonly __typename?: 'Query', readonly customer: { readonly __typename?: 'User', readonly id: ID, readonly initials: string, readonly email: string, readonly givenName: string | null, readonly familyName: string | null, readonly confirmedEmails: ReadonlyArray<string>, readonly phoneNumber: string, readonly phonePrefix: string, readonly fullPhone: string, readonly language: { readonly __typename?: 'Language', readonly enum: TLanguageEnum } } };

export type TQCustomerAddressesVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TQCustomerAddresses = { readonly __typename?: 'Query', readonly customer: { readonly __typename?: 'User', readonly id: ID, readonly addresses: ReadonlyArray<{ readonly __typename?: 'Address', readonly id: ID, readonly title: string | null, readonly type: { readonly __typename?: 'AddressType', readonly id: ID, readonly enum: TAddressTypeEnum, readonly label: string }, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null, readonly location: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null }> | null } };

export type TFOrderInHistory = { readonly __typename?: 'Order', readonly id: ID, readonly acceptedAt: Date | null, readonly orderState: TOrderStateCategoryEnum, readonly branch: { readonly __typename?: 'CompanyBranch', readonly name: string }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly creditsReward: { readonly __typename?: 'CreditsReward', readonly id: ID | null, readonly createdAt: Date | null, readonly state: { readonly __typename?: 'CreditsRewardState', readonly id: ID, readonly code: string, readonly rawCode: string, readonly enum: TCreditsRewardStateEnum }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } } | null, readonly creditsPendingWalletPayment: { readonly __typename?: 'CreditsPendingWalletPayment', readonly amount: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly unpaid: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly label: string, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly enum: TPaymentGateEnum } }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> };

export type TQCustomerHistoryVariables = Exact<{
  id: Scalars['ID']['input'];
  branches?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  orderOrigins?: InputMaybe<ReadonlyArray<TOrderOriginEnum>>;
}>;


export type TQCustomerHistory = { readonly __typename?: 'Query', readonly history: { readonly __typename?: 'User', readonly id: ID, readonly orders: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: ID, readonly acceptedAt: Date | null, readonly orderState: TOrderStateCategoryEnum, readonly branch: { readonly __typename?: 'CompanyBranch', readonly name: string }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string }, readonly creditsReward: { readonly __typename?: 'CreditsReward', readonly id: ID | null, readonly createdAt: Date | null, readonly state: { readonly __typename?: 'CreditsRewardState', readonly id: ID, readonly code: string, readonly rawCode: string, readonly enum: TCreditsRewardStateEnum }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } } | null, readonly creditsPendingWalletPayment: { readonly __typename?: 'CreditsPendingWalletPayment', readonly amount: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly unpaid: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly label: string, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly enum: TPaymentGateEnum } }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> }> } };

export type TQOrderDetailVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQOrderDetail = { readonly __typename?: 'Query', readonly orderDetail: { readonly __typename?: 'Order', readonly id: ID, readonly acceptedAt: Date | null, readonly note: string | null, readonly isPaidWithCard: boolean, readonly levelsOfTransportFeesCount: number | null, readonly handedOverAt: Date | null, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly nameLabel: string }, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly transferredFrom: { readonly __typename?: 'Order', readonly id: ID, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly nameLabel: string } } | null, readonly orderPayments: ReadonlyArray<{ readonly __typename?: 'OrderPaymentMethod', readonly id: ID, readonly paymentMethod: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly label: string, readonly paymentType: { readonly __typename?: 'PaymentType', readonly enum: TPaymentTypeEnum, readonly code: string }, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly enum: TPaymentGateEnum } }, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly handoverAddress: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null }, readonly nextPossibleTransportFee: { readonly __typename?: 'TransportFees', readonly amountRemainingToLevel: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly orderPriceMinimum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null } | null, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly product: { readonly __typename?: 'Recipe', readonly isCombinationMeal: boolean, readonly id: ID, readonly nameLabel: string, readonly availableAddonCount: number }, readonly promoTag: { readonly __typename?: 'PromoTag', readonly enum: TPromoTagEnum } | null, readonly productCategory: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }> }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly vouchers: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly tip: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly creditsReward: { readonly __typename?: 'CreditsReward', readonly id: ID | null, readonly createdAt: Date | null, readonly state: { readonly __typename?: 'CreditsRewardState', readonly id: ID, readonly code: string, readonly rawCode: string, readonly enum: TCreditsRewardStateEnum }, readonly amount: { readonly __typename?: 'CreditsPriceConverted', readonly value: number, readonly formattedValue: string } } | null, readonly creditsPendingWalletPayment: { readonly __typename?: 'CreditsPendingWalletPayment', readonly amount: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly unpaid: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } } | null } };

export type TMSubmitOrderFeedbackVariables = Exact<{
  orderId: Scalars['ID']['input'];
  ratings: ReadonlyArray<TInputOrderRatingCreate>;
}>;


export type TMSubmitOrderFeedback = { readonly __typename?: 'Mutation', readonly createOrderRating: { readonly __typename?: 'Order', readonly id: ID } };

export type TQOrderForFeedbackVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQOrderForFeedback = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly wasRatedBefore: boolean, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly phone: string } } };

export type TFBranchCompanyClient = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly companyClient: { readonly __typename?: 'Company', readonly id: ID, readonly nameLabel: string, readonly isVatPayer: boolean, readonly vatNumber: string | null, readonly identificationNumber: string, readonly contacts: { readonly __typename?: 'Address', readonly id: ID, readonly address: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null } | null } };

export type TFBranchFooter = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly phone: string, readonly isOpen: boolean, readonly willOpenAt: Date | null, readonly willCloseAt: Date | null, readonly openingHours: ReadonlyArray<{ readonly __typename?: 'BusinessHourInterval', readonly startsAt: Date, readonly endsAt: Date, readonly isClosed: boolean, readonly belongsIntoDay: Date }>, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly location: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null }, readonly currentClosedNote: { readonly __typename?: 'BusinessHourInterval', readonly message: string | null } | null, readonly contacts: { readonly __typename?: 'Address', readonly emails: ReadonlyArray<{ readonly __typename?: 'Email', readonly default: boolean, readonly email: string }> } };

export type TFCompanyClient = { readonly __typename?: 'Company', readonly id: ID, readonly nameLabel: string, readonly isVatPayer: boolean, readonly vatNumber: string | null, readonly identificationNumber: string, readonly contacts: { readonly __typename?: 'Address', readonly id: ID, readonly address: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null } | null };

export type TQBranchCompanyClientVariables = Exact<{
  branchId: Scalars['ID']['input'];
}>;


export type TQBranchCompanyClient = { readonly __typename?: 'Query', readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly companyClient: { readonly __typename?: 'Company', readonly id: ID, readonly nameLabel: string, readonly isVatPayer: boolean, readonly vatNumber: string | null, readonly identificationNumber: string, readonly contacts: { readonly __typename?: 'Address', readonly id: ID, readonly address: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null } | null } } };

export type TQOrderBranchDetailVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQOrderBranchDetail = { readonly __typename?: 'Query', readonly orderBranchDetail: { readonly __typename?: 'Order', readonly id: ID, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly phone: string, readonly isOpen: boolean, readonly willOpenAt: Date | null, readonly willCloseAt: Date | null, readonly openingHours: ReadonlyArray<{ readonly __typename?: 'BusinessHourInterval', readonly startsAt: Date, readonly endsAt: Date, readonly isClosed: boolean, readonly belongsIntoDay: Date }>, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly location: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null }, readonly currentClosedNote: { readonly __typename?: 'BusinessHourInterval', readonly message: string | null } | null, readonly contacts: { readonly __typename?: 'Address', readonly emails: ReadonlyArray<{ readonly __typename?: 'Email', readonly default: boolean, readonly email: string }> } } } };

export type TQOrderCompanyClientVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQOrderCompanyClient = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly companyClient: { readonly __typename?: 'Company', readonly id: ID, readonly nameLabel: string, readonly isVatPayer: boolean, readonly vatNumber: string | null, readonly identificationNumber: string, readonly contacts: { readonly __typename?: 'Address', readonly id: ID, readonly address: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null } | null } } } };

export type TFOrderForForm = { readonly __typename?: 'Order', readonly id: ID, readonly orderState: TOrderStateCategoryEnum, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly deliveryEnabled: boolean, readonly defaultDeliveryTimeEnabled: boolean, readonly pickupEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly defaultDeliveryTime: number, readonly defaultPickupTime: number, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly country: { readonly __typename?: 'Country', readonly phonePrefix: string } | null } }, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly priceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum }, readonly timeSlot: { readonly __typename?: 'DeliverySlot', readonly id: ID, readonly startsAt: Date, readonly endsAt: Date } | null, readonly deliveryZone: { readonly __typename?: 'Zone', readonly id: ID, readonly deliveryTimeDeviation: number } | null, readonly handoverAddress: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } };

export type TFOrderForHandoverTime = { readonly __typename?: 'Order', readonly id: ID, readonly timeSlot: { readonly __typename?: 'DeliverySlot', readonly id: ID, readonly startsAt: Date, readonly endsAt: Date } | null, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly deliveryEnabled: boolean, readonly defaultDeliveryTimeEnabled: boolean, readonly pickupEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly defaultDeliveryTime: number, readonly defaultPickupTime: number }, readonly deliveryZone: { readonly __typename?: 'Zone', readonly id: ID, readonly deliveryTimeDeviation: number } | null };

export type TMSubmitOrderVariables = Exact<{
  orderId: Scalars['ID']['input'];
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['ID']['input'];
  confirmedAgreementIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  paymentFinishedScreenUrl?: InputMaybe<Scalars['String']['input']>;
  paymentCanceledScreenUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type TMSubmitOrder = { readonly __typename?: 'Mutation', readonly submitResult: { readonly __typename?: 'FinishedOrder', readonly validationErrors: ReadonlyArray<string>, readonly goPayPaymentGatewayUrl: string | null, readonly payFastPaymentGatewayUrl: string | null, readonly payUPaymentGatewayUrl: string | null, readonly CSOBPaymentGatewayUrl: string | null, readonly globalPaymentsPaymentGatewayUrl: string | null } };

export type TQOrderForFormVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQOrderForForm = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly orderState: TOrderStateCategoryEnum, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly deliveryEnabled: boolean, readonly defaultDeliveryTimeEnabled: boolean, readonly pickupEnabled: boolean, readonly defaultPickupTimeEnabled: boolean, readonly defaultDeliveryTime: number, readonly defaultPickupTime: number, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly country: { readonly __typename?: 'Country', readonly phonePrefix: string } | null } }, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly priceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum }, readonly timeSlot: { readonly __typename?: 'DeliverySlot', readonly id: ID, readonly startsAt: Date, readonly endsAt: Date } | null, readonly deliveryZone: { readonly __typename?: 'Zone', readonly id: ID, readonly deliveryTimeDeviation: number } | null, readonly handoverAddress: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } } };

export type TFUserAgreement = { readonly __typename?: 'VAMAgreement', readonly id: ID, readonly description: string, readonly isMandatory: boolean, readonly title: string, readonly wasConfirmedBefore: boolean };

export type TQUserAgreementsVariables = Exact<{
  orderId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TQUserAgreements = { readonly __typename?: 'Query', readonly agreements: ReadonlyArray<{ readonly __typename?: 'VAMAgreement', readonly id: ID, readonly description: string, readonly isMandatory: boolean, readonly title: string, readonly wasConfirmedBefore: boolean }> };

export type TFPaymentMethod = { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly label: string, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly enum: TPaymentGateEnum } };

export type TMOrderTipUpdateVariables = Exact<{
  orderId: Scalars['ID']['input'];
  tip: Scalars['Float']['input'];
}>;


export type TMOrderTipUpdate = { readonly __typename?: 'Mutation', readonly updateOrder: { readonly __typename?: 'Order', readonly id: ID } };

export type TQAvailablePaymentMethodsVariables = Exact<{
  branchId: Scalars['ID']['input'];
  orderOrigin: TOrderOriginEnum;
  priceType: TWarePriceTypeEnum;
  handoverType?: InputMaybe<TDeliveryTypeEnum>;
}>;


export type TQAvailablePaymentMethods = { readonly __typename?: 'Query', readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly branchPaymentMethods: ReadonlyArray<{ readonly __typename?: 'PaymentMethodBranch', readonly id: ID, readonly maximumAmount: { readonly __typename?: 'PriceConverted', readonly value: number, readonly formattedValue: string } | null, readonly method: { readonly __typename?: 'PaymentMethod', readonly id: ID, readonly label: string, readonly paymentGate: { readonly __typename?: 'PaymentGate', readonly enum: TPaymentGateEnum } } }> } };

export type TFOrderPromoCodes = { readonly __typename?: 'Order', readonly id: ID, readonly promoCodes: ReadonlyArray<{ readonly __typename?: 'PromoCode', readonly id: ID, readonly code: string }> };

export type TMAddPromoCodeVariables = Exact<{
  orderId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
}>;


export type TMAddPromoCode = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'OrderWithErrors', readonly errors: ReadonlyArray<string>, readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly promoCodes: ReadonlyArray<{ readonly __typename?: 'PromoCode', readonly id: ID, readonly code: string }> } } };

export type TMRemovePromoCodeVariables = Exact<{
  orderId: Scalars['ID']['input'];
  codeId: Scalars['ID']['input'];
}>;


export type TMRemovePromoCode = { readonly __typename?: 'Mutation', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly promoCodes: ReadonlyArray<{ readonly __typename?: 'PromoCode', readonly id: ID, readonly code: string }> } };

export type TQOrderPromoCodesVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQOrderPromoCodes = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly promoCodes: ReadonlyArray<{ readonly __typename?: 'PromoCode', readonly id: ID, readonly code: string }> } };

export type TFAllergens = { readonly __typename?: 'Recipe', readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly nameLabel: string, readonly number: number }> };

export type TFProductBase = { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string, readonly descriptionLabel: string | null, readonly isCombinationMeal: boolean, readonly isSoldOut: boolean, readonly availableAddonCount: number, readonly productTags: ReadonlyArray<{ readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null, readonly productTagCategory: { readonly __typename?: 'RecipeTagCategoryType', readonly id: ID, readonly enum: TRecipeTagCategoryTypeEnum } | null }> | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly nameLabel: string, readonly number: number }> };

export type TFProductCategory = { readonly __typename?: 'WareCategory', readonly descriptionLabel: string | null, readonly id: ID, readonly nameLabel: string, readonly products: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly pictogram: string | null, readonly image: string | null, readonly id: ID, readonly nameLabel: string, readonly descriptionLabel: string | null, readonly isCombinationMeal: boolean, readonly isSoldOut: boolean, readonly availableAddonCount: number, readonly productTags: ReadonlyArray<{ readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null, readonly productTagCategory: { readonly __typename?: 'RecipeTagCategoryType', readonly id: ID, readonly enum: TRecipeTagCategoryTypeEnum } | null }> | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly nameLabel: string, readonly number: number }> }> };

export type TFProductCategoryBase = { readonly __typename?: 'WareCategory', readonly id: ID, readonly nameLabel: string };

export type TFProductInList = { readonly __typename?: 'Recipe', readonly pictogram: string | null, readonly image: string | null, readonly id: ID, readonly nameLabel: string, readonly descriptionLabel: string | null, readonly isCombinationMeal: boolean, readonly isSoldOut: boolean, readonly availableAddonCount: number, readonly productTags: ReadonlyArray<{ readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null, readonly productTagCategory: { readonly __typename?: 'RecipeTagCategoryType', readonly id: ID, readonly enum: TRecipeTagCategoryTypeEnum } | null }> | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly nameLabel: string, readonly number: number }> };

export type TFProductTag = { readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null, readonly productTagCategory: { readonly __typename?: 'RecipeTagCategoryType', readonly id: ID, readonly enum: TRecipeTagCategoryTypeEnum } | null };

export type TQCombinationMealsVariables = Exact<{
  branchId: Scalars['ID']['input'];
  isAvailableAt?: InputMaybe<Scalars['DateTime']['input']>;
  priceType?: InputMaybe<TWarePriceTypeEnum>;
}>;


export type TQCombinationMeals = { readonly __typename?: 'Query', readonly recipes: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly id: ID, readonly combinationMealPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }> };

export type TQProductListVariables = Exact<{
  isAvailableAt?: InputMaybe<Scalars['DateTime']['input']>;
  branchId: Scalars['ID']['input'];
  priceType?: InputMaybe<TWarePriceTypeEnum>;
}>;


export type TQProductList = { readonly __typename?: 'Query', readonly productCategories: ReadonlyArray<{ readonly __typename?: 'WareCategory', readonly descriptionLabel: string | null, readonly id: ID, readonly nameLabel: string, readonly products: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly pictogram: string | null, readonly image: string | null, readonly id: ID, readonly nameLabel: string, readonly descriptionLabel: string | null, readonly isCombinationMeal: boolean, readonly isSoldOut: boolean, readonly availableAddonCount: number, readonly productTags: ReadonlyArray<{ readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null, readonly productTagCategory: { readonly __typename?: 'RecipeTagCategoryType', readonly id: ID, readonly enum: TRecipeTagCategoryTypeEnum } | null }> | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly nameLabel: string, readonly number: number }> }> }> };

export type TQPromoCategoryVariables = Exact<{
  isAvailableAt?: InputMaybe<Scalars['DateTime']['input']>;
  branchId: Scalars['ID']['input'];
  promoTag: TPromoTagEnum;
  imageWidth?: InputMaybe<Scalars['Int']['input']>;
  priceType?: InputMaybe<TWarePriceTypeEnum>;
}>;


export type TQPromoCategory = { readonly __typename?: 'Query', readonly productCategories: ReadonlyArray<{ readonly __typename?: 'WareCategory', readonly descriptionLabel: string | null, readonly id: ID, readonly nameLabel: string, readonly products: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly pictogram: string | null, readonly image: string | null, readonly id: ID, readonly nameLabel: string, readonly descriptionLabel: string | null, readonly isCombinationMeal: boolean, readonly isSoldOut: boolean, readonly availableAddonCount: number, readonly productTags: ReadonlyArray<{ readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null, readonly productTagCategory: { readonly __typename?: 'RecipeTagCategoryType', readonly id: ID, readonly enum: TRecipeTagCategoryTypeEnum } | null }> | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly nameLabel: string, readonly number: number }> }> }> };

export type TQWaiterProductListVariables = Exact<{
  branchId: Scalars['ID']['input'];
  sectorId?: InputMaybe<Scalars['ID']['input']>;
  priceType?: InputMaybe<TWarePriceTypeEnum>;
}>;


export type TQWaiterProductList = { readonly __typename?: 'Query', readonly productCategories: ReadonlyArray<{ readonly __typename?: 'WareCategory', readonly descriptionLabel: string | null, readonly id: ID, readonly nameLabel: string, readonly products: ReadonlyArray<{ readonly __typename?: 'Recipe', readonly pictogram: string | null, readonly image: string | null, readonly id: ID, readonly nameLabel: string, readonly descriptionLabel: string | null, readonly isCombinationMeal: boolean, readonly isSoldOut: boolean, readonly availableAddonCount: number, readonly productTags: ReadonlyArray<{ readonly __typename?: 'RecipeTag', readonly id: ID, readonly label: string | null, readonly productTagCategory: { readonly __typename?: 'RecipeTagCategoryType', readonly id: ID, readonly enum: TRecipeTagCategoryTypeEnum } | null }> | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly allergens: ReadonlyArray<{ readonly __typename?: 'Allergen', readonly id: ID, readonly nameLabel: string, readonly number: number }> }> }> };

export type TQDeliveryAddressSuggestionsVariables = Exact<{
  gpsList: ReadonlyArray<TInputGeoPointCreate>;
}>;


export type TQDeliveryAddressSuggestions = { readonly __typename?: 'Query', readonly suggestions: ReadonlyArray<{ readonly __typename?: 'AddressResolvedLocation', readonly address: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null }> };

export type TQResolveDeliveryAddressVariables = Exact<{
  brandId?: InputMaybe<Scalars['ID']['input']>;
  branchId?: InputMaybe<Scalars['ID']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  addressInput?: InputMaybe<Scalars['String']['input']>;
}>;


export type TQResolveDeliveryAddress = { readonly __typename?: 'Query', readonly result: { readonly __typename?: 'AddressResolvedLocation', readonly isResolved: boolean, readonly isValidAddress: boolean, readonly isInDeliveryLocation: boolean, readonly deliveryAddress: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null } | null, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null, readonly deliveryBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly isOpen: boolean, readonly deliveryAsapEnabled: boolean | null, readonly deliveryOnTimeEnabled: boolean } | null, readonly deliveryZone: { readonly __typename?: 'Zone', readonly id: ID, readonly deliveryTimeDeviation: number } | null } };

export type TQTimeSlotsVariables = Exact<{
  branchId: Scalars['ID']['input'];
  handoverType: TDeliveryTypeEnum;
  deliveryZoneId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TQTimeSlots = { readonly __typename?: 'Query', readonly timeSlots: ReadonlyArray<{ readonly __typename?: 'DeliverySlot', readonly isFull: boolean, readonly id: ID, readonly startsAt: Date, readonly endsAt: Date }> };

export type TQMobileAppSettingsVariables = Exact<{
  branchId: Scalars['ID']['input'];
  platform: TMobilePlatformEnum;
}>;


export type TQMobileAppSettings = { readonly __typename?: 'Query', readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly mobileApp: { readonly __typename?: 'MobileApplicationSetting', readonly appStoreUrl: string } | null, readonly brand: { readonly __typename?: 'Company', readonly id: ID, readonly mobileApp: { readonly __typename?: 'MobileApplicationSetting', readonly appStoreUrl: string } | null } } };

export type TFNewOrder = { readonly __typename?: 'Order', readonly id: ID };

export type TFNewWaiterOrder = { readonly __typename?: 'Order', readonly id: ID, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID } };

export type TMCreateDeliveryOrderVariables = Exact<{
  branchId?: InputMaybe<Scalars['ID']['input']>;
  gps: TInputGeoPointCreate;
  orderOrigin: TOrderOriginEnum;
  addressUserInput?: InputMaybe<Scalars['String']['input']>;
  timeSlotId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TMCreateDeliveryOrder = { readonly __typename?: 'Mutation', readonly order: { readonly __typename?: 'Order', readonly id: ID } };

export type TMCreatePickupOrderVariables = Exact<{
  branchId: Scalars['ID']['input'];
  orderOrigin: TOrderOriginEnum;
  timeSlotId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TMCreatePickupOrder = { readonly __typename?: 'Mutation', readonly order: { readonly __typename?: 'Order', readonly id: ID } };

export type TMCreateWaiterOrderVariables = Exact<{
  branchId: Scalars['ID']['input'];
  priceType: TWarePriceTypeEnum;
  deliveryType: TDeliveryTypeEnum;
  sectorId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TMCreateWaiterOrder = { readonly __typename?: 'Mutation', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly companyBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID } } };

export type TMUpdateOrderVariables = Exact<{
  orderId: Scalars['ID']['input'];
  branchId?: InputMaybe<Scalars['ID']['input']>;
  handoverType?: InputMaybe<TDeliveryTypeEnum>;
  timeSlotId?: InputMaybe<Scalars['ID']['input']>;
  gps?: InputMaybe<TInputGeoPointCreate>;
  addressUserInput?: InputMaybe<Scalars['String']['input']>;
}>;


export type TMUpdateOrder = { readonly __typename?: 'Mutation', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID }, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly selectedTimeSlot: { readonly __typename?: 'DeliverySlot', readonly isFull: boolean, readonly id: ID, readonly startsAt: Date, readonly endsAt: Date } | null, readonly deliveryAddress: { readonly __typename?: 'JsonAddress', readonly original: string | null, readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null }, readonly gps: { readonly __typename?: 'GeoPoint', readonly latitude: number, readonly longitude: number } | null, readonly deliveryZone: { readonly __typename?: 'Zone', readonly id: ID, readonly deliveryTimeDeviation: number } | null } };

type TFOrderParamsDiffCompanyBranch = { readonly __typename: 'CompanyBranch', readonly id: ID };

type TFOrderParamsDiffDateTimeWrapped = { readonly __typename: 'DateTimeWrapped', readonly dateTime: Date };

type TFOrderParamsDiffDeliverySlot = { readonly __typename: 'DeliverySlot', readonly id: ID, readonly startsAt: Date, readonly endsAt: Date };

type TFOrderParamsDiffDeliveryType = { readonly __typename: 'DeliveryType', readonly enum: TDeliveryTypeEnum };

type TFOrderParamsDiffOrderRecipe = { readonly __typename: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly parent: { readonly __typename?: 'OrderRecipe', readonly id: ID } | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }>, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } };

type TFOrderParamsDiffPriceConverted = { readonly __typename: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } };

export type TFOrderParamsDiff = TFOrderParamsDiffCompanyBranch | TFOrderParamsDiffDateTimeWrapped | TFOrderParamsDiffDeliverySlot | TFOrderParamsDiffDeliveryType | TFOrderParamsDiffOrderRecipe | TFOrderParamsDiffPriceConverted;

export type TMUpdateOrderPreviewVariables = Exact<{
  orderId: Scalars['ID']['input'];
  branchId?: InputMaybe<Scalars['ID']['input']>;
  handoverType?: InputMaybe<TDeliveryTypeEnum>;
  timeSlotId?: InputMaybe<Scalars['ID']['input']>;
  gps?: InputMaybe<TInputGeoPointCreate>;
  addressUserInput?: InputMaybe<Scalars['String']['input']>;
}>;


export type TMUpdateOrderPreview = { readonly __typename?: 'Mutation', readonly changes: ReadonlyArray<{ readonly __typename?: 'OrderDiffEntry', readonly changeType: TOrderDiffChangeTypeEnum, readonly attribute: TOrderDiffAttributeEnum, readonly oldData: { readonly __typename: 'CompanyBranch', readonly id: ID } | { readonly __typename: 'DateTimeWrapped', readonly dateTime: Date } | { readonly __typename: 'DeliverySlot', readonly id: ID, readonly startsAt: Date, readonly endsAt: Date } | { readonly __typename: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | { readonly __typename: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly parent: { readonly __typename?: 'OrderRecipe', readonly id: ID } | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }>, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } } | { readonly __typename: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } | null, readonly newData: { readonly __typename: 'CompanyBranch', readonly id: ID } | { readonly __typename: 'DateTimeWrapped', readonly dateTime: Date } | { readonly __typename: 'DeliverySlot', readonly id: ID, readonly startsAt: Date, readonly endsAt: Date } | { readonly __typename: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | { readonly __typename: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly parent: { readonly __typename?: 'OrderRecipe', readonly id: ID } | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }>, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } } | { readonly __typename: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } } | null }> };

export type TFDiffBranch = { readonly __typename?: 'CompanyBranch', readonly id: ID };

export type TFDiffHandoverType = { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum };

export type TFDiffOrderItem = { readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly parent: { readonly __typename?: 'OrderRecipe', readonly id: ID } | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }>, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } };

export type TFDiffPrice = { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } };

export type TFDiffTime = { readonly __typename?: 'DateTimeWrapped', readonly dateTime: Date };

export type TFDiffTimeSlot = { readonly __typename?: 'DeliverySlot', readonly id: ID, readonly startsAt: Date, readonly endsAt: Date };

export type TFOrderForPaymentMethods = { readonly __typename?: 'Order', readonly id: ID, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID }, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly priceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum } };

export type TFOrderSubmitResult = { readonly __typename?: 'FinishedOrder', readonly validationErrors: ReadonlyArray<string>, readonly goPayPaymentGatewayUrl: string | null, readonly payFastPaymentGatewayUrl: string | null, readonly payUPaymentGatewayUrl: string | null, readonly CSOBPaymentGatewayUrl: string | null, readonly globalPaymentsPaymentGatewayUrl: string | null };

type TFPaymentGatewayUrlsFinishedOrder = { readonly __typename?: 'FinishedOrder', readonly goPayPaymentGatewayUrl: string | null, readonly payFastPaymentGatewayUrl: string | null, readonly payUPaymentGatewayUrl: string | null, readonly CSOBPaymentGatewayUrl: string | null, readonly globalPaymentsPaymentGatewayUrl: string | null };

type TFPaymentGatewayUrlsOrderOnlinePaymentStatus = { readonly __typename?: 'OrderOnlinePaymentStatus', readonly goPayPaymentGatewayUrl: string | null, readonly payFastPaymentGatewayUrl: string | null, readonly payUPaymentGatewayUrl: string | null, readonly CSOBPaymentGatewayUrl: string | null, readonly globalPaymentsPaymentGatewayUrl: string | null };

export type TFPaymentGatewayUrls = TFPaymentGatewayUrlsFinishedOrder | TFPaymentGatewayUrlsOrderOnlinePaymentStatus;

export type TMReSubmitOrderVariables = Exact<{
  orderId: Scalars['ID']['input'];
  tip?: InputMaybe<Scalars['Float']['input']>;
  paymentMethodId: Scalars['ID']['input'];
  returnUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type TMReSubmitOrder = { readonly __typename?: 'Mutation', readonly submitResult: { readonly __typename?: 'FinishedOrder', readonly validationErrors: ReadonlyArray<string>, readonly goPayPaymentGatewayUrl: string | null, readonly payFastPaymentGatewayUrl: string | null, readonly payUPaymentGatewayUrl: string | null, readonly CSOBPaymentGatewayUrl: string | null, readonly globalPaymentsPaymentGatewayUrl: string | null } };

export type TQLockedOrderVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQLockedOrder = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly value: number }, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly phone: string }, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly priceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly orderOrigin: { readonly __typename?: 'OrderOrigin', readonly enum: TOrderOriginEnum } } };

export type TQPaymentLockedOrderVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQPaymentLockedOrder = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly phone: string } } };

export type TQPaymentStatusVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQPaymentStatus = { readonly __typename?: 'Query', readonly status: { readonly __typename?: 'OrderOnlinePaymentStatus', readonly isPrePaid: boolean, readonly isInPaymentGate: boolean, readonly goPayPaymentGatewayUrl: string | null, readonly payFastPaymentGatewayUrl: string | null, readonly payUPaymentGatewayUrl: string | null, readonly CSOBPaymentGatewayUrl: string | null, readonly globalPaymentsPaymentGatewayUrl: string | null, readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly acceptedAt: Date | null, readonly isLocked: boolean, readonly orderStates: ReadonlyArray<{ readonly __typename?: 'OrderState', readonly id: ID, readonly enum: TOrderStateEnum }> } } };

export type TMCreateRegisteredUserVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
  locale: TLanguageEnum;
  confirmationToken: Scalars['String']['input'];
}>;


export type TMCreateRegisteredUser = { readonly __typename?: 'Mutation', readonly userId: ID };

export type TMRequestConfirmationCodeVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
  envUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type TMRequestConfirmationCode = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'RequestPhoneConfirmationCode', readonly phonePrefix: string, readonly phoneNumber: string } };

export type TMValidateConfirmationCodeVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type TMValidateConfirmationCode = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'PhoneCodeValidation', readonly userExists: boolean, readonly confirmationToken: string } | null };

export type TFResolvedBranch = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly pickupEnabled: boolean, readonly deliveryEnabled: boolean, readonly userBranchLanguages: ReadonlyArray<TLanguageEnum>, readonly creditsGroupMembership: { readonly __typename?: 'CreditsGroupMembership', readonly id: ID } | null, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly country: { readonly __typename?: 'Country', readonly phonePrefix: string } | null } };

export type TFResolvedBrand = { readonly __typename?: 'Company', readonly id: ID, readonly pickupEnabled: boolean | null, readonly deliveryEnabled: boolean | null, readonly hasCreditsGroups: boolean, readonly userBranchLanguages: ReadonlyArray<TLanguageEnum>, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly country: { readonly __typename?: 'Country', readonly phonePrefix: string } | null } | null };

export type TQResolvedCompanyVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type TQResolvedCompany = { readonly __typename?: 'Query', readonly lookup: { readonly __typename?: 'CompanyBrandLookUp', readonly redirectUrl: string | null, readonly orderOrigin: TOrderOriginEnum, readonly isMobileApp: boolean, readonly defaultLanguage: TLanguageEnum, readonly isBrand: boolean, readonly resolvedBrand: { readonly __typename?: 'Company', readonly id: ID, readonly pickupEnabled: boolean | null, readonly deliveryEnabled: boolean | null, readonly hasCreditsGroups: boolean, readonly userBranchLanguages: ReadonlyArray<TLanguageEnum>, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly country: { readonly __typename?: 'Country', readonly phonePrefix: string } | null } | null } | null, readonly resolvedBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly pickupEnabled: boolean, readonly deliveryEnabled: boolean, readonly userBranchLanguages: ReadonlyArray<TLanguageEnum>, readonly creditsGroupMembership: { readonly __typename?: 'CreditsGroupMembership', readonly id: ID } | null, readonly address: { readonly __typename?: 'Address', readonly id: ID, readonly country: { readonly __typename?: 'Country', readonly phonePrefix: string } | null } } | null } };

export type TFMobileAppLinks = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly androidApp: { readonly __typename?: 'MobileApplicationSetting', readonly url: string } | null, readonly iosApp: { readonly __typename?: 'MobileApplicationSetting', readonly url: string } | null };

export type TFOrderBranchAllowedStates = { readonly __typename?: 'Order', readonly id: ID, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly allowedOrderStates: ReadonlyArray<TOrderStateCategoryEnum> } };

export type TFOrderForTracking = { readonly __typename?: 'Order', readonly id: ID, readonly orderState: TOrderStateCategoryEnum, readonly expectedHandoverTime: Date | null, readonly handedOverAt: Date | null, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly transferredIntoOrder: { readonly __typename?: 'Order', readonly id: ID } | null, readonly handoverAddress: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null }, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly allowedOrderStates: ReadonlyArray<TOrderStateCategoryEnum> }, readonly timeSlot: { readonly __typename?: 'DeliverySlot', readonly id: ID, readonly startsAt: Date, readonly endsAt: Date } | null };

export type TFOrderOnlinePayment = { readonly __typename?: 'Order', readonly id: ID, readonly onlinePaymentState: { readonly __typename?: 'OrderOnlineState', readonly enum: TOrderOnlineStateEnum } | null };

export type TFOrderState = { readonly __typename?: 'Order', readonly id: ID, readonly orderState: TOrderStateCategoryEnum };

export type TFPlacedOrderForHandoverTime = { readonly __typename?: 'Order', readonly id: ID, readonly expectedHandoverTime: Date | null, readonly handedOverAt: Date | null, readonly orderState: TOrderStateCategoryEnum, readonly timeSlot: { readonly __typename?: 'DeliverySlot', readonly id: ID, readonly startsAt: Date, readonly endsAt: Date } | null };

export type TFTrackedOrderState = { readonly __typename?: 'Order', readonly id: ID, readonly orderState: TOrderStateCategoryEnum, readonly expectedHandoverTime: Date | null, readonly handedOverAt: Date | null, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly transferredIntoOrder: { readonly __typename?: 'Order', readonly id: ID } | null, readonly timeSlot: { readonly __typename?: 'DeliverySlot', readonly id: ID, readonly startsAt: Date, readonly endsAt: Date } | null };

export type TQOrderForTrackingVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQOrderForTracking = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly orderState: TOrderStateCategoryEnum, readonly expectedHandoverTime: Date | null, readonly handedOverAt: Date | null, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly transferredIntoOrder: { readonly __typename?: 'Order', readonly id: ID } | null, readonly handoverAddress: { readonly __typename?: 'JsonAddress', readonly street: string | null, readonly houseNumber: string | null, readonly city: string | null, readonly venue: string | null, readonly state: string | null }, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly allowedOrderStates: ReadonlyArray<TOrderStateCategoryEnum> }, readonly timeSlot: { readonly __typename?: 'DeliverySlot', readonly id: ID, readonly startsAt: Date, readonly endsAt: Date } | null } };

export type TQSubmittedOrderVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQSubmittedOrder = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly phone: string } } };

export type TSOrderTrackingVariables = Exact<{
  orderId: Scalars['ID']['input'];
  branchId: Scalars['ID']['input'];
}>;


export type TSOrderTracking = { readonly __typename?: 'Subscription', readonly updatedOrder: { readonly __typename?: 'OrderUpdateSubscription', readonly updatedOrder: { readonly __typename?: 'Order', readonly id: ID, readonly orderState: TOrderStateCategoryEnum, readonly expectedHandoverTime: Date | null, readonly handedOverAt: Date | null, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly transferredIntoOrder: { readonly __typename?: 'Order', readonly id: ID } | null, readonly timeSlot: { readonly __typename?: 'DeliverySlot', readonly id: ID, readonly startsAt: Date, readonly endsAt: Date } | null } | null } };

export type TFTransportFeeLevel = { readonly __typename?: 'TransportFees', readonly amountRemainingToLevel: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly orderPriceMinimum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null };

export type TQTransportFeesSummaryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQTransportFeesSummary = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly levelsOfTransportFees: ReadonlyArray<{ readonly __typename?: 'TransportFees', readonly amountRemainingToLevel: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly orderPriceMinimum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null }> } };

export type TFAppInstructions = { readonly __typename?: 'WiFiAppInstruction', readonly header: string | null, readonly image: string | null, readonly text: string };

export type TFBranchForWaiterLookup = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly promoHeaderText: string | null, readonly phone: string, readonly userBranchLanguages: ReadonlyArray<TLanguageEnum>, readonly brand: { readonly __typename?: 'Company', readonly id: ID, readonly name: string }, readonly company: { readonly __typename?: 'Company', readonly id: ID }, readonly address: { readonly __typename?: 'Address', readonly country: { readonly __typename?: 'Country', readonly phonePrefix: string } | null }, readonly instructions: ReadonlyArray<{ readonly __typename?: 'WiFiAppInstruction', readonly header: string | null, readonly image: string | null, readonly text: string }> };

export type TFBranchStylesForWaiter = { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly headerText: string | null, readonly promoHeaderText: string | null, readonly nameLabel: string, readonly brand: { readonly __typename?: 'Company', readonly nameLabel: string }, readonly images: { readonly __typename?: 'GraphicStyle', readonly companyLogoUrl: string, readonly heroImageUrl: string }, readonly colors: { readonly __typename?: 'GraphicStyle', readonly companyPrimary: string, readonly conversion: string }, readonly advancedStyles: { readonly __typename?: 'GraphicStyle', readonly colors: string } };

export type TFSector = { readonly __typename?: 'Sector', readonly id: ID, readonly isAvailable: boolean, readonly enabled: boolean, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null };

export type TFWaiterCart = { readonly __typename?: 'Order', readonly id: ID, readonly ageControl: boolean, readonly itemCount: number, readonly isMinPriceAfterDiscounts: boolean, readonly isMinPriceWithTransport: boolean, readonly updateTimestamp: Date | null, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly product: { readonly __typename?: 'Recipe', readonly isCombinationMeal: boolean, readonly id: ID, readonly nameLabel: string, readonly availableAddonCount: number }, readonly promoTag: { readonly __typename?: 'PromoTag', readonly enum: TPromoTagEnum } | null, readonly productCategory: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }> }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly vouchers: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly tip: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly collectFromCustomer: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly minimalOrderPriceRemainder: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null };

type TFWaiterStylesApplicationSettings = { readonly __typename?: 'ApplicationSettings', readonly headerText: string | null, readonly promoHeaderText: string | null, readonly images: { readonly __typename?: 'GraphicStyle', readonly companyLogoUrl: string, readonly heroImageUrl: string }, readonly colors: { readonly __typename?: 'GraphicStyle', readonly companyPrimary: string, readonly conversion: string }, readonly advancedStyles: { readonly __typename?: 'GraphicStyle', readonly colors: string } };

type TFWaiterStylesCompany = { readonly __typename?: 'Company', readonly headerText: string | null, readonly promoHeaderText: string | null, readonly images: { readonly __typename?: 'GraphicStyle', readonly companyLogoUrl: string, readonly heroImageUrl: string }, readonly colors: { readonly __typename?: 'GraphicStyle', readonly companyPrimary: string, readonly conversion: string }, readonly advancedStyles: { readonly __typename?: 'GraphicStyle', readonly colors: string } };

type TFWaiterStylesCompanyBranch = { readonly __typename?: 'CompanyBranch', readonly headerText: string | null, readonly promoHeaderText: string | null, readonly images: { readonly __typename?: 'GraphicStyle', readonly companyLogoUrl: string, readonly heroImageUrl: string }, readonly colors: { readonly __typename?: 'GraphicStyle', readonly companyPrimary: string, readonly conversion: string }, readonly advancedStyles: { readonly __typename?: 'GraphicStyle', readonly colors: string } };

export type TFWaiterStyles = TFWaiterStylesApplicationSettings | TFWaiterStylesCompany | TFWaiterStylesCompanyBranch;

export type TQBranchStylesForWaiterVariables = Exact<{
  branchId: Scalars['ID']['input'];
}>;


export type TQBranchStylesForWaiter = { readonly __typename?: 'Query', readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly headerText: string | null, readonly promoHeaderText: string | null, readonly nameLabel: string, readonly brand: { readonly __typename?: 'Company', readonly nameLabel: string }, readonly images: { readonly __typename?: 'GraphicStyle', readonly companyLogoUrl: string, readonly heroImageUrl: string }, readonly colors: { readonly __typename?: 'GraphicStyle', readonly companyPrimary: string, readonly conversion: string }, readonly advancedStyles: { readonly __typename?: 'GraphicStyle', readonly colors: string } } };

export type TQBusinessLookupVariables = Exact<{
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type TQBusinessLookup = { readonly __typename?: 'Query', readonly lookup: { readonly __typename?: 'CompanyBrandLookUp', readonly isMobileApp: boolean, readonly knownBasePath: string, readonly redirectUrl: string | null, readonly isBrand: boolean, readonly defaultLanguage: TLanguageEnum, readonly resolvedBranch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly name: string, readonly promoHeaderText: string | null, readonly phone: string, readonly userBranchLanguages: ReadonlyArray<TLanguageEnum>, readonly brand: { readonly __typename?: 'Company', readonly id: ID, readonly name: string }, readonly company: { readonly __typename?: 'Company', readonly id: ID }, readonly address: { readonly __typename?: 'Address', readonly country: { readonly __typename?: 'Country', readonly phonePrefix: string } | null }, readonly instructions: ReadonlyArray<{ readonly __typename?: 'WiFiAppInstruction', readonly header: string | null, readonly image: string | null, readonly text: string }> } | null, readonly sector: { readonly __typename?: 'Sector', readonly id: ID, readonly isAvailable: boolean, readonly enabled: boolean, readonly warePriceType: { readonly __typename?: 'WarePriceType', readonly enum: TWarePriceTypeEnum }, readonly deliveryType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null } | null } };

export type TQCustomerOrderNumberVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQCustomerOrderNumber = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly number: number | null } };

export type TQOrderBranchStylesForWaiterVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQOrderBranchStylesForWaiter = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly branch: { readonly __typename?: 'CompanyBranch', readonly id: ID, readonly headerText: string | null, readonly promoHeaderText: string | null, readonly nameLabel: string, readonly brand: { readonly __typename?: 'Company', readonly nameLabel: string }, readonly images: { readonly __typename?: 'GraphicStyle', readonly companyLogoUrl: string, readonly heroImageUrl: string }, readonly colors: { readonly __typename?: 'GraphicStyle', readonly companyPrimary: string, readonly conversion: string }, readonly advancedStyles: { readonly __typename?: 'GraphicStyle', readonly colors: string } } } };

export type TQWaiterCartVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type TQWaiterCart = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: ID, readonly ageControl: boolean, readonly itemCount: number, readonly isMinPriceAfterDiscounts: boolean, readonly isMinPriceWithTransport: boolean, readonly updateTimestamp: Date | null, readonly handoverType: { readonly __typename?: 'DeliveryType', readonly enum: TDeliveryTypeEnum } | null, readonly items: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly note: string | null, readonly id: ID, readonly addedAutomatically: boolean, readonly product: { readonly __typename?: 'Recipe', readonly isCombinationMeal: boolean, readonly id: ID, readonly nameLabel: string, readonly availableAddonCount: number }, readonly promoTag: { readonly __typename?: 'PromoTag', readonly enum: TPromoTagEnum } | null, readonly productCategory: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly addons: ReadonlyArray<{ readonly __typename?: 'OrderRecipe', readonly id: ID, readonly category: { readonly __typename?: 'WareCategory', readonly id: ID } | null, readonly product: { readonly __typename?: 'Recipe', readonly id: ID, readonly nameLabel: string } }> }>, readonly coverPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly transportFee: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly discounts: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly vouchers: ReadonlyArray<{ readonly __typename?: 'PriceWithDescription', readonly code: ID, readonly description: string, readonly price: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } }>, readonly tip: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly totalSum: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number, readonly currency: { readonly __typename?: 'Currency', readonly code: string } }, readonly collectFromCustomer: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number }, readonly minimalOrderPrice: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null, readonly minimalOrderPriceRemainder: { readonly __typename?: 'PriceConverted', readonly formattedValue: string, readonly value: number } | null } };

export const FCompanyStyles = gql`
    fragment FCompanyStyles on ApplicationSettingsInterface {
  headerText
  promoHeaderText
  images: styles(originCategory: WEBSITE) {
    companyLogoUrl: storeLogo(width: 200, height: 200)
    heroImageUrl: headerImage
  }
  colors: styles(originCategory: WEBSITE) {
    companyPrimary: main
    conversion: active
  }
  advancedStyles: styles(originCategory: WEBSITE) {
    colors: applicationStyles
  }
}
    `;
export const FBranchStyles = gql`
    fragment FBranchStyles on CompanyBranch {
  id
  nameLabel: name
  brand {
    nameLabel: name
  }
  ...FCompanyStyles
}
    ${FCompanyStyles}`;
export const FBrandStyles = gql`
    fragment FBrandStyles on Company {
  id
  nameLabel: name
  ...FCompanyStyles
}
    ${FCompanyStyles}`;
export const FCreditGroupMembership = gql`
    fragment FCreditGroupMembership on CompanyBranch {
  id
  creditsGroupMembership {
    canCollect
    canSpend
  }
}
    `;
export const FBranchGps = gql`
    fragment FBranchGps on CompanyBranch {
  gps {
    longitude
    latitude
  }
}
    `;
export const FAddress = gql`
    fragment FAddress on JsonAddress {
  street
  houseNumber
  city
  venue
  state
}
    `;
export const FBranchAddress = gql`
    fragment FBranchAddress on CompanyBranch {
  id
  address {
    id
    location {
      ...FAddress
    }
  }
}
    ${FAddress}`;
export const FBranchOpeningStatus = gql`
    fragment FBranchOpeningStatus on CompanyBranch {
  id
  isOpen
  willOpenAt
  willCloseAt
  currentClosedNote: currentInterval {
    message: closedNote
  }
}
    `;
export const FOpeningHoursInterval = gql`
    fragment FOpeningHoursInterval on BusinessHourInterval {
  startsAt: openAt
  endsAt: closeAt
  isClosed: closed
  belongsIntoDay: relevantDay
}
    `;
export const FBranchOpeningHours = gql`
    fragment FBranchOpeningHours on CompanyBranch {
  id
  ...FBranchOpeningStatus
  openingHours: businessHoursIntervals(
    from: $openingHoursFrom
    to: $openingHoursTo
    ignoreFastClose: true
  ) {
    ...FOpeningHoursInterval
  }
}
    ${FBranchOpeningStatus}
${FOpeningHoursInterval}`;
export const FAvailablePickupBranch = gql`
    fragment FAvailablePickupBranch on CompanyBranch {
  id
  nameLabel: name
  pickupEnabled
  pickupOnTimeEnabled: delayedDeliveryEnabled
  pickupAsapEnabled
  ...FBranchGps
  ...FBranchAddress
  ...FBranchOpeningHours
}
    ${FBranchGps}
${FBranchAddress}
${FBranchOpeningHours}`;
export const FAvailableDeliveryBranch = gql`
    fragment FAvailableDeliveryBranch on CompanyBranch {
  id
  deliveryOnTimeEnabled: delayedDeliveryEnabled
  deliveryAsapEnabled
}
    `;
export const FBranchPhone = gql`
    fragment FBranchPhone on CompanyBranch {
  id
  phone
}
    `;
export const FBranchHandoverTimes = gql`
    fragment FBranchHandoverTimes on CompanyBranch {
  id
  deliveryEnabled
  defaultDeliveryTime: currentDeliveryTime
  defaultDeliveryTimeEnabled
  pickupEnabled
  defaultPickupTime: currentPickupTime
  defaultPickupTimeEnabled
}
    `;
export const FBranchInfoTopLine = gql`
    fragment FBranchInfoTopLine on CompanyBranch {
  ...FBranchPhone
  ...FBranchHandoverTimes
  ...FBranchOpeningHours
}
    ${FBranchPhone}
${FBranchHandoverTimes}
${FBranchOpeningHours}`;
export const FBranchEmail = gql`
    fragment FBranchEmail on CompanyBranch {
  id
  contacts: address {
    emails {
      default
      email
    }
  }
}
    `;
export const FBranchDetail = gql`
    fragment FBranchDetail on CompanyBranch {
  id
  nameLabel: name
  headerText
  promoHeaderText
  companyWebUrl: homepageUrl
  styles(originCategory: WEBSITE) {
    branchLogoUrl: storeLogo(width: 80, height: 80)
  }
  ...FBranchInfoTopLine
  ...FBranchAddress
  ...FBranchEmail
  ...FBranchGps
  ...FBranchOpeningHours
}
    ${FBranchInfoTopLine}
${FBranchAddress}
${FBranchEmail}
${FBranchGps}
${FBranchOpeningHours}`;
export const FAvailableBranch = gql`
    fragment FAvailableBranch on CompanyBranch {
  brand {
    id
  }
  customerAccountsEnabled: userAccountsEnabledForCustomer
  ...FCreditGroupMembership
  ...FAvailablePickupBranch
  ...FAvailableDeliveryBranch
  ...FBranchDetail
}
    ${FCreditGroupMembership}
${FAvailablePickupBranch}
${FAvailableDeliveryBranch}
${FBranchDetail}`;
export const FPrice = gql`
    fragment FPrice on PriceConverted {
  value: roundedValue
  formattedValue
}
    `;
export const FCartSummary = gql`
    fragment FCartSummary on Order {
  id
  itemCount: countWares
  ageControl
  totalSum {
    currency {
      code
    }
    ...FPrice
  }
  collectFromCustomer {
    ...FPrice
  }
}
    ${FPrice}`;
export const FCartStatic = gql`
    fragment FCartStatic on Order {
  id
  isMinPriceAfterDiscounts: minimalOrderPriceWithDiscounts
  isMinPriceWithTransport: minimalOrderPriceWithTransportFee
  minimalOrderPrice {
    ...FPrice
  }
  minimalOrderPriceRemainder {
    ...FPrice
  }
}
    ${FPrice}`;
export const FCartUpdateTime = gql`
    fragment FCartUpdateTime on Order {
  id
  updateTimestamp: updatedAt
}
    `;
export const FCartOrder = gql`
    fragment FCartOrder on Order {
  ...FCartSummary
  ...FCartStatic
  ...FCartUpdateTime
}
    ${FCartSummary}
${FCartStatic}
${FCartUpdateTime}`;
export const FHandoverType = gql`
    fragment FHandoverType on DeliveryType {
  enum
}
    `;
export const FCartItemBase = gql`
    fragment FCartItemBase on OrderRecipe {
  id
  product: recipe {
    id
    nameLabel
  }
}
    `;
export const FCartItem = gql`
    fragment FCartItem on OrderRecipe {
  ...FCartItemBase
  price: priceWithSideDishes {
    ...FPrice
  }
  addons: sideDishes {
    category: wareCategory {
      id
    }
    ...FCartItemBase
  }
  note
  addedAutomatically: automatic
}
    ${FCartItemBase}
${FPrice}`;
export const FCartFullItem = gql`
    fragment FCartFullItem on OrderRecipe {
  ...FCartItem
  product: recipe {
    availableAddonCount: sideDishesWareCategoriesCount
    isCombinationMeal
  }
  promoTag {
    enum
  }
  productCategory: wareCategory {
    id
  }
}
    ${FCartItem}`;
export const FDiscount = gql`
    fragment FDiscount on PriceWithDescription {
  code
  description
  price {
    ...FPrice
  }
}
    ${FPrice}`;
export const FCartBaseContent = gql`
    fragment FCartBaseContent on Order {
  id
  handoverType: deliveryType {
    ...FHandoverType
  }
  items {
    ...FCartFullItem
  }
  coverPrice {
    ...FPrice
  }
  transportFee {
    ...FPrice
  }
  discounts {
    ...FDiscount
  }
  vouchers {
    ...FDiscount
  }
  tip {
    ...FPrice
  }
}
    ${FHandoverType}
${FCartFullItem}
${FPrice}
${FDiscount}`;
export const FCreditPrice = gql`
    fragment FCreditPrice on CreditsPriceConverted {
  value
  formattedValue
}
    `;
export const FCreditsReward = gql`
    fragment FCreditsReward on CreditsReward {
  id
  state {
    id
    code
    rawCode
    enum
  }
  createdAt
  amount {
    ...FCreditPrice
  }
}
    ${FCreditPrice}`;
export const FCreditsPendingPayment = gql`
    fragment FCreditsPendingPayment on CreditsPendingWalletPayment {
  amount {
    ...FPrice
  }
  unpaid {
    ...FPrice
    currency {
      code
    }
  }
}
    ${FPrice}`;
export const FPaymentMethod = gql`
    fragment FPaymentMethod on PaymentMethod {
  id
  label: description
  paymentGate {
    enum
  }
}
    `;
export const FOrderPayment = gql`
    fragment FOrderPayment on OrderPaymentMethod {
  id
  paymentMethod {
    ...FPaymentMethod
  }
  price {
    ...FPrice
  }
}
    ${FPaymentMethod}
${FPrice}`;
export const FCreditsPayments = gql`
    fragment FCreditsPayments on Order {
  id
  creditsPendingWalletPayment {
    ...FCreditsPendingPayment
  }
  orderPayments {
    ...FOrderPayment
  }
}
    ${FCreditsPendingPayment}
${FOrderPayment}`;
export const FOrderForCredits = gql`
    fragment FOrderForCredits on Order {
  id
  creditsReward {
    ...FCreditsReward
  }
  ...FCreditsPayments
}
    ${FCreditsReward}
${FCreditsPayments}`;
export const FTransportFeeLevel = gql`
    fragment FTransportFeeLevel on TransportFees {
  amountRemainingToLevel: priceNeedToOrder {
    ...FPrice
  }
  transportFee: newTransportFee {
    ...FPrice
  }
  orderPriceMinimum: fromPrice {
    ...FPrice
  }
}
    ${FPrice}`;
export const FCartContent = gql`
    fragment FCartContent on Order {
  ...FCartBaseContent
  ...FOrderForCredits
  levelsOfTransportFeesCount
  nextPossibleTransportFee {
    ...FTransportFeeLevel
  }
}
    ${FCartBaseContent}
${FOrderForCredits}
${FTransportFeeLevel}`;
export const FOrderInCart = gql`
    fragment FOrderInCart on Order {
  id
  shopId: id
  ...FCartOrder
  ...FCartContent
}
    ${FCartOrder}
${FCartContent}`;
export const FAddonDetailBase = gql`
    fragment FAddonDetailBase on Recipe {
  id
  nameLabel
  price(warePriceType: $priceType) {
    ...FPrice
  }
  sideDishCombinationMealPrices(warePriceType: $priceType) @include(if: $isCombinationMeal) {
    categoryId: wareCategoryId
    price {
      ...FPrice
    }
  }
}
    ${FPrice}`;
export const FAllergens = gql`
    fragment FAllergens on Recipe {
  allergens {
    id
    nameLabel: code
    number: category
  }
}
    `;
export const FProductDetailExtra = gql`
    fragment FProductDetailExtra on Recipe {
  ageControl
  image(width: 600, height: 600)
  pictogram
  descriptionLabel
  ...FAllergens
}
    ${FAllergens}`;
export const FMainAddonDetailBase = gql`
    fragment FMainAddonDetailBase on Recipe {
  ...FAddonDetailBase
  ...FProductDetailExtra
}
    ${FAddonDetailBase}
${FProductDetailExtra}`;
export const FProductDetailBase = gql`
    fragment FProductDetailBase on Recipe {
  id
  nameLabel
  price(warePriceType: $priceType) {
    ...FPrice
  }
  combinationMealPrice: mainCombinationMealPrice(warePriceType: $priceType) {
    ...FPrice
  }
  isCombinationMeal
}
    ${FPrice}`;
export const FMainProductDetailBase = gql`
    fragment FMainProductDetailBase on Recipe {
  ...FProductDetailBase
  ...FProductDetailExtra
}
    ${FProductDetailBase}
${FProductDetailExtra}`;
export const FProductCategoryBase = gql`
    fragment FProductCategoryBase on WareCategory {
  id
  nameLabel
}
    `;
export const FProductDetail = gql`
    fragment FProductDetail on Recipe {
  ...FMainProductDetailBase
  price(warePriceType: $priceType) {
    currency {
      code
      decimalPlaces: decimalRound
    }
  }
  addonCategories: sideDishesWareCategories {
    ...FProductCategoryBase
    minTotalCount: minCount
    maxTotalCount: maxCount
    maxIndividualCount: maxRecipesCount
    addons: recipes {
      ...FAddonDetailBase
      isMainProduct: isMain
    }
  }
}
    ${FMainProductDetailBase}
${FProductCategoryBase}
${FAddonDetailBase}`;
export const FPhone = gql`
    fragment FPhone on Phone {
  phone
  isDefault: default
}
    `;
export const FCreditActivity = gql`
    fragment FCreditActivity on CreditsWalletActivity {
  id
  activityType {
    id
    enum
    code
  }
  amount {
    ...FCreditPrice
  }
  remainingAmount {
    ...FCreditPrice
  }
  createdAt
  expiresAt
  isExpiringSoon
  isExpired
  order {
    id
  }
  companyBranch {
    id
    name
  }
  wallet {
    id
    name
  }
}
    ${FCreditPrice}`;
export const FBranchForWallet = gql`
    fragment FBranchForWallet on CompanyBranch {
  id
  name
}
    `;
export const FCreditWalletSummary = gql`
    fragment FCreditWalletSummary on CreditsWallet {
  id
  name
  balance {
    ...FCreditPrice
  }
  isClosed
  currency {
    decimalRound
  }
  creditsExpiringSoon {
    edges {
      node {
        id
        remainingAmount {
          ...FCreditPrice
        }
      }
    }
  }
  companyBranches {
    ...FBranchForWallet
  }
}
    ${FCreditPrice}
${FBranchForWallet}`;
export const FCreditWallet = gql`
    fragment FCreditWallet on CreditsWallet {
  id
  ...FCreditWalletSummary
}
    ${FCreditWalletSummary}`;
export const FCreditsPendingReward = gql`
    fragment FCreditsPendingReward on CreditsReward {
  id
  ...FCreditsReward
  order {
    id
    companyBranch {
      id
      name
    }
  }
}
    ${FCreditsReward}`;
export const FCustomer = gql`
    fragment FCustomer on User {
  id
  language {
    enum
  }
  initials
  givenName: firstName
  familyName: lastName
  email
  confirmedEmails: emails(confirmationStatus: CONFIRMED)
  phoneNumber: phone(part: LOCAL_NUMBER)
  phonePrefix: phone(part: COUNTRY_CODE)
  fullPhone: phone
}
    `;
export const FAddressType = gql`
    fragment FAddressType on AddressType {
  id
  enum
  label: code
}
    `;
export const FCustomerAddress = gql`
    fragment FCustomerAddress on Address {
  id
  title
  type: addressType {
    ...FAddressType
  }
  gps {
    latitude
    longitude
  }
  location {
    ...FAddress
  }
}
    ${FAddressType}
${FAddress}`;
export const FOrderState = gql`
    fragment FOrderState on Order {
  id
  orderState: orderStateCategory(target: FE_ADMIN)
}
    `;
export const FOrderInHistory = gql`
    fragment FOrderInHistory on Order {
  id
  branch: companyBranch {
    name
  }
  totalSum {
    formattedValue
  }
  acceptedAt
  ...FOrderState
  ...FOrderForCredits
}
    ${FOrderState}
${FOrderForCredits}`;
export const FCompanyClient = gql`
    fragment FCompanyClient on Company {
  id
  nameLabel: name
  contacts: address {
    id
    address: location {
      ...FAddress
    }
  }
  isVatPayer: vatPayer
  vatNumber: vatIdent
  identificationNumber: number
}
    ${FAddress}`;
export const FBranchCompanyClient = gql`
    fragment FBranchCompanyClient on CompanyBranch {
  id
  companyClient: company {
    ...FCompanyClient
  }
}
    ${FCompanyClient}`;
export const FBranchFooter = gql`
    fragment FBranchFooter on CompanyBranch {
  id
  ...FBranchAddress
  ...FBranchPhone
  ...FBranchOpeningStatus
  ...FBranchEmail
  openingHours: businessHoursIntervals(ignoreFastClose: true) {
    ...FOpeningHoursInterval
  }
}
    ${FBranchAddress}
${FBranchPhone}
${FBranchOpeningStatus}
${FBranchEmail}
${FOpeningHoursInterval}`;
export const FOrderForPaymentMethods = gql`
    fragment FOrderForPaymentMethods on Order {
  id
  branch: companyBranch {
    id
  }
  handoverType: deliveryType {
    ...FHandoverType
  }
  priceType: warePriceType {
    enum
  }
  orderOrigin {
    enum
  }
}
    ${FHandoverType}`;
export const FTimeSlot = gql`
    fragment FTimeSlot on DeliverySlot {
  id
  startsAt: startAt
  endsAt: endAt
}
    `;
export const FDeliveryZone = gql`
    fragment FDeliveryZone on Zone {
  id
  deliveryTimeDeviation
}
    `;
export const FOrderForHandoverTime = gql`
    fragment FOrderForHandoverTime on Order {
  id
  timeSlot: deliverySlot {
    ...FTimeSlot
  }
  handoverType: deliveryType {
    ...FHandoverType
  }
  branch: companyBranch {
    ...FBranchHandoverTimes
  }
  deliveryZone: zone {
    ...FDeliveryZone
  }
}
    ${FTimeSlot}
${FHandoverType}
${FBranchHandoverTimes}
${FDeliveryZone}`;
export const FOrderAddress = gql`
    fragment FOrderAddress on Order {
  id
  handoverAddress: address {
    ...FAddress
  }
}
    ${FAddress}`;
export const FBranchPhonePrefix = gql`
    fragment FBranchPhonePrefix on CompanyBranch {
  id
  address {
    id
    country {
      phonePrefix
    }
  }
}
    `;
export const FOrderForForm = gql`
    fragment FOrderForForm on Order {
  id
  orderState: orderStateCategory(target: FE_ADMIN)
  ...FOrderForPaymentMethods
  ...FOrderForHandoverTime
  ...FOrderAddress
  branch: companyBranch {
    id
    ...FBranchPhonePrefix
  }
}
    ${FOrderForPaymentMethods}
${FOrderForHandoverTime}
${FOrderAddress}
${FBranchPhonePrefix}`;
export const FUserAgreement = gql`
    fragment FUserAgreement on VAMAgreement {
  id
  title: name
  description
  isMandatory
  wasConfirmedBefore: isConfirmed
}
    `;
export const FOrderPromoCodes = gql`
    fragment FOrderPromoCodes on Order {
  id
  promoCodes {
    id
    code
  }
}
    `;
export const FProductTag = gql`
    fragment FProductTag on RecipeTag {
  id
  label
  productTagCategory: recipeTagCategoryType {
    id
    enum
  }
}
    `;
export const FProductBase = gql`
    fragment FProductBase on Recipe {
  id
  nameLabel
  descriptionLabel
  ...FAllergens
  isSoldOut: soldOut
  isCombinationMeal
  availableAddonCount: sideDishesWareCategoriesCount
  productTags: recipeTags {
    ...FProductTag
  }
  price(warePriceType: $priceType) {
    ...FPrice
  }
}
    ${FAllergens}
${FProductTag}
${FPrice}`;
export const FProductInList = gql`
    fragment FProductInList on Recipe {
  ...FProductBase
  pictogram
  image(width: 192, height: 192)
}
    ${FProductBase}`;
export const FProductCategory = gql`
    fragment FProductCategory on WareCategory {
  ...FProductCategoryBase
  descriptionLabel
  products: recipes(enabled: true, isAvailable: true) {
    ...FProductInList
  }
}
    ${FProductCategoryBase}
${FProductInList}`;
export const FNewOrder = gql`
    fragment FNewOrder on Order {
  id
}
    `;
export const FNewWaiterOrder = gql`
    fragment FNewWaiterOrder on Order {
  ...FNewOrder
  companyBranch {
    id
  }
}
    ${FNewOrder}`;
export const FDiffPrice = gql`
    fragment FDiffPrice on PriceConverted {
  ...FPrice
  currency {
    code
  }
}
    ${FPrice}`;
export const FDiffBranch = gql`
    fragment FDiffBranch on CompanyBranch {
  id
}
    `;
export const FDiffOrderItem = gql`
    fragment FDiffOrderItem on OrderRecipe {
  ...FCartItem
  parent {
    id
  }
}
    ${FCartItem}`;
export const FDiffTime = gql`
    fragment FDiffTime on DateTimeWrapped {
  dateTime: value
}
    `;
export const FDiffHandoverType = gql`
    fragment FDiffHandoverType on DeliveryType {
  ...FHandoverType
}
    ${FHandoverType}`;
export const FDiffTimeSlot = gql`
    fragment FDiffTimeSlot on DeliverySlot {
  ...FTimeSlot
}
    ${FTimeSlot}`;
export const FOrderParamsDiff = gql`
    fragment FOrderParamsDiff on OrderDiffAttribute {
  __typename
  ...FDiffPrice
  ...FDiffBranch
  ...FDiffOrderItem
  ...FDiffTime
  ...FDiffHandoverType
  ...FDiffTimeSlot
}
    ${FDiffPrice}
${FDiffBranch}
${FDiffOrderItem}
${FDiffTime}
${FDiffHandoverType}
${FDiffTimeSlot}`;
export const FPaymentGatewayUrls = gql`
    fragment FPaymentGatewayUrls on OnlinePaymentGatesInterface {
  goPayPaymentGatewayUrl: gopayUrl
  payFastPaymentGatewayUrl: payFastUrl
  payUPaymentGatewayUrl: payuUrl
  CSOBPaymentGatewayUrl: csobUrl
  globalPaymentsPaymentGatewayUrl: gpWebpayUrl
}
    `;
export const FOrderSubmitResult = gql`
    fragment FOrderSubmitResult on FinishedOrder {
  validationErrors: userErrors
  ...FPaymentGatewayUrls
}
    ${FPaymentGatewayUrls}`;
export const FResolvedBranch = gql`
    fragment FResolvedBranch on CompanyBranch {
  id
  userBranchLanguages: supportedLanguages(userSpecific: true)
  ...FBranchPhonePrefix
  pickupEnabled
  deliveryEnabled
  creditsGroupMembership {
    id
  }
}
    ${FBranchPhonePrefix}`;
export const FResolvedBrand = gql`
    fragment FResolvedBrand on Company {
  id
  userBranchLanguages: supportedLanguages(userSpecific: true)
  address {
    id
    country {
      phonePrefix
    }
  }
  pickupEnabled
  deliveryEnabled
  hasCreditsGroups
}
    `;
export const FMobileAppLinks = gql`
    fragment FMobileAppLinks on CompanyBranch {
  id
  androidApp: mobileApplicationSetting(platform: ANDROID) {
    url
  }
  iosApp: mobileApplicationSetting(platform: IOS) {
    url
  }
}
    `;
export const FPlacedOrderForHandoverTime = gql`
    fragment FPlacedOrderForHandoverTime on Order {
  id
  timeSlot: deliverySlot {
    ...FTimeSlot
  }
  expectedHandoverTime: deliverAt
  handedOverAt: deliveredAt
  ...FOrderState
}
    ${FTimeSlot}
${FOrderState}`;
export const FTrackedOrderState = gql`
    fragment FTrackedOrderState on Order {
  id
  ...FOrderState
  handoverType: deliveryType {
    ...FHandoverType
  }
  transferredIntoOrder: transferOrderTo {
    id
  }
  ...FPlacedOrderForHandoverTime
}
    ${FOrderState}
${FHandoverType}
${FPlacedOrderForHandoverTime}`;
export const FOrderBranchAllowedStates = gql`
    fragment FOrderBranchAllowedStates on Order {
  id
  branch: companyBranch {
    id
    allowedOrderStates: allowedCategories(target: FE_ADMIN)
  }
}
    `;
export const FOrderForTracking = gql`
    fragment FOrderForTracking on Order {
  id
  ...FTrackedOrderState
  ...FOrderAddress
  ...FOrderBranchAllowedStates
}
    ${FTrackedOrderState}
${FOrderAddress}
${FOrderBranchAllowedStates}`;
export const FOrderOnlinePayment = gql`
    fragment FOrderOnlinePayment on Order {
  id
  onlinePaymentState: orderOnlineState {
    enum
  }
}
    `;
export const FAppInstructions = gql`
    fragment FAppInstructions on WiFiAppInstruction {
  header
  image
  text
}
    `;
export const FBranchForWaiterLookup = gql`
    fragment FBranchForWaiterLookup on CompanyBranch {
  id
  name
  promoHeaderText
  brand {
    id
    name
  }
  company {
    id
  }
  address {
    country {
      phonePrefix
    }
  }
  phone
  instructions: wifiAppInstructions {
    ...FAppInstructions
  }
  userBranchLanguages: supportedLanguages(userSpecific: true)
}
    ${FAppInstructions}`;
export const FWaiterStyles = gql`
    fragment FWaiterStyles on ApplicationSettingsInterface {
  headerText
  promoHeaderText
  images: styles(originCategory: WIFI) {
    companyLogoUrl: storeLogo(width: 200, height: 200)
    heroImageUrl: headerImage
  }
  colors: styles(originCategory: WIFI) {
    companyPrimary: main
    conversion: active
  }
  advancedStyles: styles(originCategory: WIFI) {
    colors: applicationStyles
  }
}
    `;
export const FBranchStylesForWaiter = gql`
    fragment FBranchStylesForWaiter on CompanyBranch {
  id
  nameLabel: name
  brand {
    nameLabel: name
  }
  ...FWaiterStyles
}
    ${FWaiterStyles}`;
export const FSector = gql`
    fragment FSector on Sector {
  id
  isAvailable
  enabled
  warePriceType: inheritedWarePriceType {
    enum
  }
  deliveryType {
    enum
  }
}
    `;
export const FWaiterCart = gql`
    fragment FWaiterCart on Order {
  id
  ...FCartOrder
  ...FCartBaseContent
}
    ${FCartOrder}
${FCartBaseContent}`;
export const QAllergensDocument = gql`
    query QAllergens {
  allergens {
    id
    enum
    number: category
    name: code
  }
}
    `;
export function useQAllergens(baseOptions?: ApolloReactHooks.QueryHookOptions<TQAllergens, TQAllergensVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQAllergens, TQAllergensVariables>(QAllergensDocument, options);
      }
export function useQAllergensLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQAllergens, TQAllergensVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQAllergens, TQAllergensVariables>(QAllergensDocument, options);
        }
export type QAllergensHookResult = ReturnType<typeof useQAllergens>;
export type QAllergensLazyQueryHookResult = ReturnType<typeof useQAllergensLazyQuery>;
export type QAllergensQueryResult = ApolloReactCommon.QueryResult<TQAllergens, TQAllergensVariables>;
export const QBranchStylesDocument = gql`
    query QBranchStyles($branchId: ID!) {
  branch: companyBranch(id: $branchId) {
    ...FBranchStyles
  }
}
    ${FBranchStyles}`;
export function useQBranchStyles(baseOptions: ApolloReactHooks.QueryHookOptions<TQBranchStyles, TQBranchStylesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBranchStyles, TQBranchStylesVariables>(QBranchStylesDocument, options);
      }
export function useQBranchStylesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBranchStyles, TQBranchStylesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBranchStyles, TQBranchStylesVariables>(QBranchStylesDocument, options);
        }
export type QBranchStylesHookResult = ReturnType<typeof useQBranchStyles>;
export type QBranchStylesLazyQueryHookResult = ReturnType<typeof useQBranchStylesLazyQuery>;
export type QBranchStylesQueryResult = ApolloReactCommon.QueryResult<TQBranchStyles, TQBranchStylesVariables>;
export const QCompanyStylesDocument = gql`
    query QCompanyStyles($url: String) {
  lookup: companyBranchLookUp(hostUrl: $url, findNearestCompanyBranch: false) {
    isBrand: isBrandUrl
    resolvedBrand: brand {
      ...FBrandStyles
    }
    resolvedBranch: companyBranch {
      ...FBranchStyles
    }
  }
}
    ${FBrandStyles}
${FBranchStyles}`;
export function useQCompanyStyles(baseOptions?: ApolloReactHooks.QueryHookOptions<TQCompanyStyles, TQCompanyStylesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCompanyStyles, TQCompanyStylesVariables>(QCompanyStylesDocument, options);
      }
export function useQCompanyStylesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCompanyStyles, TQCompanyStylesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCompanyStyles, TQCompanyStylesVariables>(QCompanyStylesDocument, options);
        }
export type QCompanyStylesHookResult = ReturnType<typeof useQCompanyStyles>;
export type QCompanyStylesLazyQueryHookResult = ReturnType<typeof useQCompanyStylesLazyQuery>;
export type QCompanyStylesQueryResult = ApolloReactCommon.QueryResult<TQCompanyStyles, TQCompanyStylesVariables>;
export const QOrderBranchStylesDocument = gql`
    query QOrderBranchStyles($orderId: ID!) {
  order(id: $orderId) {
    id
    branch: companyBranch {
      ...FBranchStyles
    }
  }
}
    ${FBranchStyles}`;
export function useQOrderBranchStyles(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderBranchStyles, TQOrderBranchStylesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderBranchStyles, TQOrderBranchStylesVariables>(QOrderBranchStylesDocument, options);
      }
export function useQOrderBranchStylesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderBranchStyles, TQOrderBranchStylesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderBranchStyles, TQOrderBranchStylesVariables>(QOrderBranchStylesDocument, options);
        }
export type QOrderBranchStylesHookResult = ReturnType<typeof useQOrderBranchStyles>;
export type QOrderBranchStylesLazyQueryHookResult = ReturnType<typeof useQOrderBranchStylesLazyQuery>;
export type QOrderBranchStylesQueryResult = ApolloReactCommon.QueryResult<TQOrderBranchStyles, TQOrderBranchStylesVariables>;
export const MChangePasswordDocument = gql`
    mutation MChangePassword($newPassword: String!, $oldPassword: String) {
  customer: updateUserPassword(
    newPassword: $newPassword
    oldPassword: $oldPassword
  ) {
    id
    authToken: token
  }
}
    `;
export type TMChangePasswordMutationFn = ApolloReactCommon.MutationFunction<TMChangePassword, TMChangePasswordVariables>;
export function useMChangePassword(baseOptions?: ApolloReactHooks.MutationHookOptions<TMChangePassword, TMChangePasswordVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMChangePassword, TMChangePasswordVariables>(MChangePasswordDocument, options);
      }
export type MChangePasswordHookResult = ReturnType<typeof useMChangePassword>;
export type MChangePasswordMutationResult = ApolloReactCommon.MutationResult<TMChangePassword>;
export type MChangePasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<TMChangePassword, TMChangePasswordVariables>;
export const MReportLogoutDocument = gql`
    mutation MReportLogout {
  isLoggedOut: logoutUser
}
    `;
export type TMReportLogoutMutationFn = ApolloReactCommon.MutationFunction<TMReportLogout, TMReportLogoutVariables>;
export function useMReportLogout(baseOptions?: ApolloReactHooks.MutationHookOptions<TMReportLogout, TMReportLogoutVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMReportLogout, TMReportLogoutVariables>(MReportLogoutDocument, options);
      }
export type MReportLogoutHookResult = ReturnType<typeof useMReportLogout>;
export type MReportLogoutMutationResult = ApolloReactCommon.MutationResult<TMReportLogout>;
export type MReportLogoutMutationOptions = ApolloReactCommon.BaseMutationOptions<TMReportLogout, TMReportLogoutVariables>;
export const MTransferOrderDocument = gql`
    mutation MTransferOrder($orderId: ID!, $newToken: String!) {
  updatedOrder: updateOrderUser(order: $orderId, token: $newToken) {
    id
  }
}
    `;
export type TMTransferOrderMutationFn = ApolloReactCommon.MutationFunction<TMTransferOrder, TMTransferOrderVariables>;
export function useMTransferOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMTransferOrder, TMTransferOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMTransferOrder, TMTransferOrderVariables>(MTransferOrderDocument, options);
      }
export type MTransferOrderHookResult = ReturnType<typeof useMTransferOrder>;
export type MTransferOrderMutationResult = ApolloReactCommon.MutationResult<TMTransferOrder>;
export type MTransferOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMTransferOrder, TMTransferOrderVariables>;
export const QValidateAuthTokenDocument = gql`
    query QValidateAuthToken {
  result: weekDays {
    id
  }
}
    `;
export function useQValidateAuthToken(baseOptions?: ApolloReactHooks.QueryHookOptions<TQValidateAuthToken, TQValidateAuthTokenVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQValidateAuthToken, TQValidateAuthTokenVariables>(QValidateAuthTokenDocument, options);
      }
export function useQValidateAuthTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQValidateAuthToken, TQValidateAuthTokenVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQValidateAuthToken, TQValidateAuthTokenVariables>(QValidateAuthTokenDocument, options);
        }
export type QValidateAuthTokenHookResult = ReturnType<typeof useQValidateAuthToken>;
export type QValidateAuthTokenLazyQueryHookResult = ReturnType<typeof useQValidateAuthTokenLazyQuery>;
export type QValidateAuthTokenQueryResult = ApolloReactCommon.QueryResult<TQValidateAuthToken, TQValidateAuthTokenVariables>;
export const QAvailableBranchesDocument = gql`
    query QAvailableBranches($url: String, $openingHoursFrom: DateTime, $openingHoursTo: DateTime) {
  lookup: companyBranchLookUp(hostUrl: $url, findNearestCompanyBranch: false) {
    isBrand: isBrandUrl
    resolvedBranches: companyBranches {
      ...FAvailableBranch
    }
    resolvedBranch: companyBranch {
      ...FAvailableBranch
    }
  }
}
    ${FAvailableBranch}`;
export function useQAvailableBranches(baseOptions?: ApolloReactHooks.QueryHookOptions<TQAvailableBranches, TQAvailableBranchesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQAvailableBranches, TQAvailableBranchesVariables>(QAvailableBranchesDocument, options);
      }
export function useQAvailableBranchesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQAvailableBranches, TQAvailableBranchesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQAvailableBranches, TQAvailableBranchesVariables>(QAvailableBranchesDocument, options);
        }
export type QAvailableBranchesHookResult = ReturnType<typeof useQAvailableBranches>;
export type QAvailableBranchesLazyQueryHookResult = ReturnType<typeof useQAvailableBranchesLazyQuery>;
export type QAvailableBranchesQueryResult = ApolloReactCommon.QueryResult<TQAvailableBranches, TQAvailableBranchesVariables>;
export const QOrderForCartDocument = gql`
    query QOrderForCart($orderId: ID!) {
  order(id: $orderId) {
    ...FOrderInCart
  }
}
    ${FOrderInCart}`;
export function useQOrderForCart(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderForCart, TQOrderForCartVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderForCart, TQOrderForCartVariables>(QOrderForCartDocument, options);
      }
export function useQOrderForCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderForCart, TQOrderForCartVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderForCart, TQOrderForCartVariables>(QOrderForCartDocument, options);
        }
export type QOrderForCartHookResult = ReturnType<typeof useQOrderForCart>;
export type QOrderForCartLazyQueryHookResult = ReturnType<typeof useQOrderForCartLazyQuery>;
export type QOrderForCartQueryResult = ApolloReactCommon.QueryResult<TQOrderForCart, TQOrderForCartVariables>;
export const MAddProductToCartDocument = gql`
    mutation MAddProductToCart($amount: Int!, $orderId: ID!, $note: String, $productId: ID!, $categoryId: ID, $promoTag: PromoTagEnum, $addons: [InputOrderRecipeSideDishCreate!]) {
  updatedOrder: createOrderRecipe(
    orderRecipe: {note: $note, order: $orderId, amount: $amount, recipe: $productId, sideDishRecipes: $addons, wareCategory: $categoryId, promoTag: $promoTag}
  ) {
    ...FOrderInCart
  }
}
    ${FOrderInCart}`;
export type TMAddProductToCartMutationFn = ApolloReactCommon.MutationFunction<TMAddProductToCart, TMAddProductToCartVariables>;
export function useMAddProductToCart(baseOptions?: ApolloReactHooks.MutationHookOptions<TMAddProductToCart, TMAddProductToCartVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMAddProductToCart, TMAddProductToCartVariables>(MAddProductToCartDocument, options);
      }
export type MAddProductToCartHookResult = ReturnType<typeof useMAddProductToCart>;
export type MAddProductToCartMutationResult = ApolloReactCommon.MutationResult<TMAddProductToCart>;
export type MAddProductToCartMutationOptions = ApolloReactCommon.BaseMutationOptions<TMAddProductToCart, TMAddProductToCartVariables>;
export const MRemoveCartItemsDocument = gql`
    mutation MRemoveCartItems($itemIds: [ID!]!) {
  updatedOrder: destroyMultipleOrderRecipes(ids: $itemIds) {
    ...FOrderInCart
  }
}
    ${FOrderInCart}`;
export type TMRemoveCartItemsMutationFn = ApolloReactCommon.MutationFunction<TMRemoveCartItems, TMRemoveCartItemsVariables>;
export function useMRemoveCartItems(baseOptions?: ApolloReactHooks.MutationHookOptions<TMRemoveCartItems, TMRemoveCartItemsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMRemoveCartItems, TMRemoveCartItemsVariables>(MRemoveCartItemsDocument, options);
      }
export type MRemoveCartItemsHookResult = ReturnType<typeof useMRemoveCartItems>;
export type MRemoveCartItemsMutationResult = ApolloReactCommon.MutationResult<TMRemoveCartItems>;
export type MRemoveCartItemsMutationOptions = ApolloReactCommon.BaseMutationOptions<TMRemoveCartItems, TMRemoveCartItemsVariables>;
export const MUpdateCartItemDocument = gql`
    mutation MUpdateCartItem($itemId: ID!, $note: String, $addons: [InputOrderRecipeSideDishUpdate!]) {
  updatedOrder: updateOrderRecipe(
    id: $itemId
    orderRecipe: {note: $note, sideDishRecipes: $addons}
  ) {
    ...FOrderInCart
  }
}
    ${FOrderInCart}`;
export type TMUpdateCartItemMutationFn = ApolloReactCommon.MutationFunction<TMUpdateCartItem, TMUpdateCartItemVariables>;
export function useMUpdateCartItem(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateCartItem, TMUpdateCartItemVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateCartItem, TMUpdateCartItemVariables>(MUpdateCartItemDocument, options);
      }
export type MUpdateCartItemHookResult = ReturnType<typeof useMUpdateCartItem>;
export type MUpdateCartItemMutationResult = ApolloReactCommon.MutationResult<TMUpdateCartItem>;
export type MUpdateCartItemMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateCartItem, TMUpdateCartItemVariables>;
export const QAddonDetailDocument = gql`
    query QAddonDetail($productId: ID!, $branchId: ID, $priceType: WarePriceTypeEnum, $isCombinationMeal: Boolean!) {
  product: recipe(id: $productId, companyBranch: $branchId) {
    ...FMainAddonDetailBase
  }
}
    ${FMainAddonDetailBase}`;
export function useQAddonDetail(baseOptions: ApolloReactHooks.QueryHookOptions<TQAddonDetail, TQAddonDetailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQAddonDetail, TQAddonDetailVariables>(QAddonDetailDocument, options);
      }
export function useQAddonDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQAddonDetail, TQAddonDetailVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQAddonDetail, TQAddonDetailVariables>(QAddonDetailDocument, options);
        }
export type QAddonDetailHookResult = ReturnType<typeof useQAddonDetail>;
export type QAddonDetailLazyQueryHookResult = ReturnType<typeof useQAddonDetailLazyQuery>;
export type QAddonDetailQueryResult = ApolloReactCommon.QueryResult<TQAddonDetail, TQAddonDetailVariables>;
export const QCartItemDocument = gql`
    query QCartItem($itemId: ID!, $priceType: WarePriceTypeEnum, $isCombinationMeal: Boolean!) {
  item: orderRecipe(id: $itemId) {
    id
    note
    product: recipe {
      ...FProductDetail
    }
    selectedAddons: sideDishes {
      id
      product: recipe {
        id
      }
    }
  }
}
    ${FProductDetail}`;
export function useQCartItem(baseOptions: ApolloReactHooks.QueryHookOptions<TQCartItem, TQCartItemVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCartItem, TQCartItemVariables>(QCartItemDocument, options);
      }
export function useQCartItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCartItem, TQCartItemVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCartItem, TQCartItemVariables>(QCartItemDocument, options);
        }
export type QCartItemHookResult = ReturnType<typeof useQCartItem>;
export type QCartItemLazyQueryHookResult = ReturnType<typeof useQCartItemLazyQuery>;
export type QCartItemQueryResult = ApolloReactCommon.QueryResult<TQCartItem, TQCartItemVariables>;
export const QProductDetailDocument = gql`
    query QProductDetail($productId: ID!, $branchId: ID, $priceType: WarePriceTypeEnum, $isCombinationMeal: Boolean!) {
  product: recipe(id: $productId, companyBranch: $branchId) {
    ...FProductDetail
  }
}
    ${FProductDetail}`;
export function useQProductDetail(baseOptions: ApolloReactHooks.QueryHookOptions<TQProductDetail, TQProductDetailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQProductDetail, TQProductDetailVariables>(QProductDetailDocument, options);
      }
export function useQProductDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQProductDetail, TQProductDetailVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQProductDetail, TQProductDetailVariables>(QProductDetailDocument, options);
        }
export type QProductDetailHookResult = ReturnType<typeof useQProductDetail>;
export type QProductDetailLazyQueryHookResult = ReturnType<typeof useQProductDetailLazyQuery>;
export type QProductDetailQueryResult = ApolloReactCommon.QueryResult<TQProductDetail, TQProductDetailVariables>;
export const MRedeemCreditsDocument = gql`
    mutation MRedeemCredits($orderId: ID!, $amount: Float!, $walletId: ID!) {
  addCreditsPayment(orderId: $orderId, amount: $amount, walletId: $walletId) {
    order {
      id
    }
  }
}
    `;
export type TMRedeemCreditsMutationFn = ApolloReactCommon.MutationFunction<TMRedeemCredits, TMRedeemCreditsVariables>;
export function useMRedeemCredits(baseOptions?: ApolloReactHooks.MutationHookOptions<TMRedeemCredits, TMRedeemCreditsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMRedeemCredits, TMRedeemCreditsVariables>(MRedeemCreditsDocument, options);
      }
export type MRedeemCreditsHookResult = ReturnType<typeof useMRedeemCredits>;
export type MRedeemCreditsMutationResult = ApolloReactCommon.MutationResult<TMRedeemCredits>;
export type MRedeemCreditsMutationOptions = ApolloReactCommon.BaseMutationOptions<TMRedeemCredits, TMRedeemCreditsVariables>;
export const QAvailableCreditsDocument = gql`
    query QAvailableCredits($userId: ID!, $branchId: ID!) {
  customer: user(id: $userId) {
    id
    creditsWallets(companyBranchId: $branchId) {
      id
      balance {
        ...FCreditPrice
      }
      cashPaymentUnit
      currency {
        decimalRound
      }
    }
  }
}
    ${FCreditPrice}`;
export function useQAvailableCredits(baseOptions: ApolloReactHooks.QueryHookOptions<TQAvailableCredits, TQAvailableCreditsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQAvailableCredits, TQAvailableCreditsVariables>(QAvailableCreditsDocument, options);
      }
export function useQAvailableCreditsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQAvailableCredits, TQAvailableCreditsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQAvailableCredits, TQAvailableCreditsVariables>(QAvailableCreditsDocument, options);
        }
export type QAvailableCreditsHookResult = ReturnType<typeof useQAvailableCredits>;
export type QAvailableCreditsLazyQueryHookResult = ReturnType<typeof useQAvailableCreditsLazyQuery>;
export type QAvailableCreditsQueryResult = ApolloReactCommon.QueryResult<TQAvailableCredits, TQAvailableCreditsVariables>;
export const QCreditWalletDocument = gql`
    query QCreditWallet($id: ID!) {
  creditsWallet(id: $id) {
    ...FCreditWallet
  }
}
    ${FCreditWallet}`;
export function useQCreditWallet(baseOptions: ApolloReactHooks.QueryHookOptions<TQCreditWallet, TQCreditWalletVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCreditWallet, TQCreditWalletVariables>(QCreditWalletDocument, options);
      }
export function useQCreditWalletLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCreditWallet, TQCreditWalletVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCreditWallet, TQCreditWalletVariables>(QCreditWalletDocument, options);
        }
export type QCreditWalletHookResult = ReturnType<typeof useQCreditWallet>;
export type QCreditWalletLazyQueryHookResult = ReturnType<typeof useQCreditWalletLazyQuery>;
export type QCreditWalletQueryResult = ApolloReactCommon.QueryResult<TQCreditWallet, TQCreditWalletVariables>;
export const QCustomerCreditsDocument = gql`
    query QCustomerCredits($id: ID!, $companyBranches: [ID!], $after: String, $before: String, $first: Int, $last: Int) {
  customer: user(id: $id) {
    id
    creditsWalletActivities(
      companyBranchIds: $companyBranches
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      pageInfo {
        startCursor
        endCursor
      }
      totalCount
      edges {
        node {
          ...FCreditActivity
        }
      }
    }
  }
}
    ${FCreditActivity}`;
export function useQCustomerCredits(baseOptions: ApolloReactHooks.QueryHookOptions<TQCustomerCredits, TQCustomerCreditsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCustomerCredits, TQCustomerCreditsVariables>(QCustomerCreditsDocument, options);
      }
export function useQCustomerCreditsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCustomerCredits, TQCustomerCreditsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCustomerCredits, TQCustomerCreditsVariables>(QCustomerCreditsDocument, options);
        }
export type QCustomerCreditsHookResult = ReturnType<typeof useQCustomerCredits>;
export type QCustomerCreditsLazyQueryHookResult = ReturnType<typeof useQCustomerCreditsLazyQuery>;
export type QCustomerCreditsQueryResult = ApolloReactCommon.QueryResult<TQCustomerCredits, TQCustomerCreditsVariables>;
export const QCustomerWalletsDocument = gql`
    query QCustomerWallets($id: ID!) {
  customer: user(id: $id) {
    id
    creditsWallets {
      ...FCreditWallet
    }
  }
}
    ${FCreditWallet}`;
export function useQCustomerWallets(baseOptions: ApolloReactHooks.QueryHookOptions<TQCustomerWallets, TQCustomerWalletsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCustomerWallets, TQCustomerWalletsVariables>(QCustomerWalletsDocument, options);
      }
export function useQCustomerWalletsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCustomerWallets, TQCustomerWalletsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCustomerWallets, TQCustomerWalletsVariables>(QCustomerWalletsDocument, options);
        }
export type QCustomerWalletsHookResult = ReturnType<typeof useQCustomerWallets>;
export type QCustomerWalletsLazyQueryHookResult = ReturnType<typeof useQCustomerWalletsLazyQuery>;
export type QCustomerWalletsQueryResult = ApolloReactCommon.QueryResult<TQCustomerWallets, TQCustomerWalletsVariables>;
export const QExpiringSoonInWalletDocument = gql`
    query QExpiringSoonInWallet($walletId: ID!, $first: Int, $last: Int, $after: String, $before: String) {
  creditsWallet(id: $walletId) {
    id
    creditsExpiringSoon(first: $first, last: $last, after: $after, before: $before) {
      totalCount
      pageInfo {
        startCursor
        endCursor
      }
      edges {
        node {
          ...FCreditActivity
        }
      }
    }
  }
}
    ${FCreditActivity}`;
export function useQExpiringSoonInWallet(baseOptions: ApolloReactHooks.QueryHookOptions<TQExpiringSoonInWallet, TQExpiringSoonInWalletVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQExpiringSoonInWallet, TQExpiringSoonInWalletVariables>(QExpiringSoonInWalletDocument, options);
      }
export function useQExpiringSoonInWalletLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQExpiringSoonInWallet, TQExpiringSoonInWalletVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQExpiringSoonInWallet, TQExpiringSoonInWalletVariables>(QExpiringSoonInWalletDocument, options);
        }
export type QExpiringSoonInWalletHookResult = ReturnType<typeof useQExpiringSoonInWallet>;
export type QExpiringSoonInWalletLazyQueryHookResult = ReturnType<typeof useQExpiringSoonInWalletLazyQuery>;
export type QExpiringSoonInWalletQueryResult = ApolloReactCommon.QueryResult<TQExpiringSoonInWallet, TQExpiringSoonInWalletVariables>;
export const QPendingRewardsDocument = gql`
    query QPendingRewards($walletId: ID!, $first: Int, $last: Int, $after: String, $before: String) {
  creditsWallet(id: $walletId) {
    id
    creditsPendingRewards(
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
      }
      edges {
        node {
          ...FCreditsPendingReward
        }
      }
    }
  }
}
    ${FCreditsPendingReward}`;
export function useQPendingRewards(baseOptions: ApolloReactHooks.QueryHookOptions<TQPendingRewards, TQPendingRewardsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQPendingRewards, TQPendingRewardsVariables>(QPendingRewardsDocument, options);
      }
export function useQPendingRewardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQPendingRewards, TQPendingRewardsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQPendingRewards, TQPendingRewardsVariables>(QPendingRewardsDocument, options);
        }
export type QPendingRewardsHookResult = ReturnType<typeof useQPendingRewards>;
export type QPendingRewardsLazyQueryHookResult = ReturnType<typeof useQPendingRewardsLazyQuery>;
export type QPendingRewardsQueryResult = ApolloReactCommon.QueryResult<TQPendingRewards, TQPendingRewardsVariables>;
export const QWalletActivitiesDocument = gql`
    query QWalletActivities($walletId: ID!, $first: Int, $last: Int, $after: String, $before: String) {
  creditsWallet(id: $walletId) {
    id
    creditsWalletActivities(
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
      }
      edges {
        node {
          ...FCreditActivity
        }
      }
    }
  }
}
    ${FCreditActivity}`;
export function useQWalletActivities(baseOptions: ApolloReactHooks.QueryHookOptions<TQWalletActivities, TQWalletActivitiesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQWalletActivities, TQWalletActivitiesVariables>(QWalletActivitiesDocument, options);
      }
export function useQWalletActivitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQWalletActivities, TQWalletActivitiesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQWalletActivities, TQWalletActivitiesVariables>(QWalletActivitiesDocument, options);
        }
export type QWalletActivitiesHookResult = ReturnType<typeof useQWalletActivities>;
export type QWalletActivitiesLazyQueryHookResult = ReturnType<typeof useQWalletActivitiesLazyQuery>;
export type QWalletActivitiesQueryResult = ApolloReactCommon.QueryResult<TQWalletActivities, TQWalletActivitiesVariables>;
export const MAddCustomerAddressDocument = gql`
    mutation MAddCustomerAddress($type: AddressTypeEnum!, $gps: InputGeoPointCreate!, $title: String) {
  newAddress: createAddress(
    address: {addressType: $type, gps: $gps, title: $title}
  ) {
    id
  }
}
    `;
export type TMAddCustomerAddressMutationFn = ApolloReactCommon.MutationFunction<TMAddCustomerAddress, TMAddCustomerAddressVariables>;
export function useMAddCustomerAddress(baseOptions?: ApolloReactHooks.MutationHookOptions<TMAddCustomerAddress, TMAddCustomerAddressVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMAddCustomerAddress, TMAddCustomerAddressVariables>(MAddCustomerAddressDocument, options);
      }
export type MAddCustomerAddressHookResult = ReturnType<typeof useMAddCustomerAddress>;
export type MAddCustomerAddressMutationResult = ApolloReactCommon.MutationResult<TMAddCustomerAddress>;
export type MAddCustomerAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<TMAddCustomerAddress, TMAddCustomerAddressVariables>;
export const MConsentsAppLinkDocument = gql`
    mutation MConsentsAppLink {
  consentsAppLink
}
    `;
export type TMConsentsAppLinkMutationFn = ApolloReactCommon.MutationFunction<TMConsentsAppLink, TMConsentsAppLinkVariables>;
export function useMConsentsAppLink(baseOptions?: ApolloReactHooks.MutationHookOptions<TMConsentsAppLink, TMConsentsAppLinkVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMConsentsAppLink, TMConsentsAppLinkVariables>(MConsentsAppLinkDocument, options);
      }
export type MConsentsAppLinkHookResult = ReturnType<typeof useMConsentsAppLink>;
export type MConsentsAppLinkMutationResult = ApolloReactCommon.MutationResult<TMConsentsAppLink>;
export type MConsentsAppLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<TMConsentsAppLink, TMConsentsAppLinkVariables>;
export const MDeleteCustomerAccountDocument = gql`
    mutation MDeleteCustomerAccount($password: String!) {
  wasDeleted: destroyUser(password: $password)
}
    `;
export type TMDeleteCustomerAccountMutationFn = ApolloReactCommon.MutationFunction<TMDeleteCustomerAccount, TMDeleteCustomerAccountVariables>;
export function useMDeleteCustomerAccount(baseOptions?: ApolloReactHooks.MutationHookOptions<TMDeleteCustomerAccount, TMDeleteCustomerAccountVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMDeleteCustomerAccount, TMDeleteCustomerAccountVariables>(MDeleteCustomerAccountDocument, options);
      }
export type MDeleteCustomerAccountHookResult = ReturnType<typeof useMDeleteCustomerAccount>;
export type MDeleteCustomerAccountMutationResult = ApolloReactCommon.MutationResult<TMDeleteCustomerAccount>;
export type MDeleteCustomerAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<TMDeleteCustomerAccount, TMDeleteCustomerAccountVariables>;
export const MDeleteCustomerAddressDocument = gql`
    mutation MDeleteCustomerAddress($id: ID!) {
  deletedAddress: destroyAddress(id: $id) {
    id
  }
}
    `;
export type TMDeleteCustomerAddressMutationFn = ApolloReactCommon.MutationFunction<TMDeleteCustomerAddress, TMDeleteCustomerAddressVariables>;
export function useMDeleteCustomerAddress(baseOptions?: ApolloReactHooks.MutationHookOptions<TMDeleteCustomerAddress, TMDeleteCustomerAddressVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMDeleteCustomerAddress, TMDeleteCustomerAddressVariables>(MDeleteCustomerAddressDocument, options);
      }
export type MDeleteCustomerAddressHookResult = ReturnType<typeof useMDeleteCustomerAddress>;
export type MDeleteCustomerAddressMutationResult = ApolloReactCommon.MutationResult<TMDeleteCustomerAddress>;
export type MDeleteCustomerAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<TMDeleteCustomerAddress, TMDeleteCustomerAddressVariables>;
export const MRequestVerificationEmailDocument = gql`
    mutation MRequestVerificationEmail($email: String!, $returnUrl: String!) {
  result: requestEmailConfirmationCode(email: $email, returnUrl: $returnUrl) {
    usedEmail: email
  }
}
    `;
export type TMRequestVerificationEmailMutationFn = ApolloReactCommon.MutationFunction<TMRequestVerificationEmail, TMRequestVerificationEmailVariables>;
export function useMRequestVerificationEmail(baseOptions?: ApolloReactHooks.MutationHookOptions<TMRequestVerificationEmail, TMRequestVerificationEmailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMRequestVerificationEmail, TMRequestVerificationEmailVariables>(MRequestVerificationEmailDocument, options);
      }
export type MRequestVerificationEmailHookResult = ReturnType<typeof useMRequestVerificationEmail>;
export type MRequestVerificationEmailMutationResult = ApolloReactCommon.MutationResult<TMRequestVerificationEmail>;
export type MRequestVerificationEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<TMRequestVerificationEmail, TMRequestVerificationEmailVariables>;
export const MUpdateCustomerDocument = gql`
    mutation MUpdateCustomer($id: ID!, $givenName: String, $familyName: String) {
  customer: updateUser(
    id: $id
    user: {firstName: $givenName, lastName: $familyName}
  ) {
    id
  }
}
    `;
export type TMUpdateCustomerMutationFn = ApolloReactCommon.MutationFunction<TMUpdateCustomer, TMUpdateCustomerVariables>;
export function useMUpdateCustomer(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateCustomer, TMUpdateCustomerVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateCustomer, TMUpdateCustomerVariables>(MUpdateCustomerDocument, options);
      }
export type MUpdateCustomerHookResult = ReturnType<typeof useMUpdateCustomer>;
export type MUpdateCustomerMutationResult = ApolloReactCommon.MutationResult<TMUpdateCustomer>;
export type MUpdateCustomerMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateCustomer, TMUpdateCustomerVariables>;
export const MUpdateCustomerAddressDocument = gql`
    mutation MUpdateCustomerAddress($id: ID!, $type: AddressTypeEnum, $gps: InputGeoPointCreate, $title: String) {
  updatedAddress: updateAddress(
    id: $id
    address: {addressType: $type, gps: $gps, title: $title}
  ) {
    ...FCustomerAddress
  }
}
    ${FCustomerAddress}`;
export type TMUpdateCustomerAddressMutationFn = ApolloReactCommon.MutationFunction<TMUpdateCustomerAddress, TMUpdateCustomerAddressVariables>;
export function useMUpdateCustomerAddress(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateCustomerAddress, TMUpdateCustomerAddressVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateCustomerAddress, TMUpdateCustomerAddressVariables>(MUpdateCustomerAddressDocument, options);
      }
export type MUpdateCustomerAddressHookResult = ReturnType<typeof useMUpdateCustomerAddress>;
export type MUpdateCustomerAddressMutationResult = ApolloReactCommon.MutationResult<TMUpdateCustomerAddress>;
export type MUpdateCustomerAddressMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateCustomerAddress, TMUpdateCustomerAddressVariables>;
export const MUpdateCustomerLanguageDocument = gql`
    mutation MUpdateCustomerLanguage($id: ID!, $language: LanguageEnum) {
  customer: updateUser(id: $id, user: {language: $language}) {
    id
  }
}
    `;
export type TMUpdateCustomerLanguageMutationFn = ApolloReactCommon.MutationFunction<TMUpdateCustomerLanguage, TMUpdateCustomerLanguageVariables>;
export function useMUpdateCustomerLanguage(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateCustomerLanguage, TMUpdateCustomerLanguageVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateCustomerLanguage, TMUpdateCustomerLanguageVariables>(MUpdateCustomerLanguageDocument, options);
      }
export type MUpdateCustomerLanguageHookResult = ReturnType<typeof useMUpdateCustomerLanguage>;
export type MUpdateCustomerLanguageMutationResult = ApolloReactCommon.MutationResult<TMUpdateCustomerLanguage>;
export type MUpdateCustomerLanguageMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateCustomerLanguage, TMUpdateCustomerLanguageVariables>;
export const MValidateEmailConfirmationCodeDocument = gql`
    mutation MValidateEmailConfirmationCode($confirmationToken: String!) {
  verifiedEmail: validateEmailConfirmationCode(token: $confirmationToken) {
    email
  }
}
    `;
export type TMValidateEmailConfirmationCodeMutationFn = ApolloReactCommon.MutationFunction<TMValidateEmailConfirmationCode, TMValidateEmailConfirmationCodeVariables>;
export function useMValidateEmailConfirmationCode(baseOptions?: ApolloReactHooks.MutationHookOptions<TMValidateEmailConfirmationCode, TMValidateEmailConfirmationCodeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMValidateEmailConfirmationCode, TMValidateEmailConfirmationCodeVariables>(MValidateEmailConfirmationCodeDocument, options);
      }
export type MValidateEmailConfirmationCodeHookResult = ReturnType<typeof useMValidateEmailConfirmationCode>;
export type MValidateEmailConfirmationCodeMutationResult = ApolloReactCommon.MutationResult<TMValidateEmailConfirmationCode>;
export type MValidateEmailConfirmationCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<TMValidateEmailConfirmationCode, TMValidateEmailConfirmationCodeVariables>;
export const QAddressTypesDocument = gql`
    query QAddressTypes {
  addressTypes(internal: false) {
    ...FAddressType
  }
}
    ${FAddressType}`;
export function useQAddressTypes(baseOptions?: ApolloReactHooks.QueryHookOptions<TQAddressTypes, TQAddressTypesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQAddressTypes, TQAddressTypesVariables>(QAddressTypesDocument, options);
      }
export function useQAddressTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQAddressTypes, TQAddressTypesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQAddressTypes, TQAddressTypesVariables>(QAddressTypesDocument, options);
        }
export type QAddressTypesHookResult = ReturnType<typeof useQAddressTypes>;
export type QAddressTypesLazyQueryHookResult = ReturnType<typeof useQAddressTypesLazyQuery>;
export type QAddressTypesQueryResult = ApolloReactCommon.QueryResult<TQAddressTypes, TQAddressTypesVariables>;
export const QCustomerDocument = gql`
    query QCustomer($id: ID!) {
  customer: user(id: $id) {
    ...FCustomer
  }
}
    ${FCustomer}`;
export function useQCustomer(baseOptions: ApolloReactHooks.QueryHookOptions<TQCustomer, TQCustomerVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCustomer, TQCustomerVariables>(QCustomerDocument, options);
      }
export function useQCustomerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCustomer, TQCustomerVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCustomer, TQCustomerVariables>(QCustomerDocument, options);
        }
export type QCustomerHookResult = ReturnType<typeof useQCustomer>;
export type QCustomerLazyQueryHookResult = ReturnType<typeof useQCustomerLazyQuery>;
export type QCustomerQueryResult = ApolloReactCommon.QueryResult<TQCustomer, TQCustomerVariables>;
export const QCustomerAddressesDocument = gql`
    query QCustomerAddresses($id: ID!) {
  customer: user(id: $id) {
    id
    addresses {
      id
      ...FCustomerAddress
    }
  }
}
    ${FCustomerAddress}`;
export function useQCustomerAddresses(baseOptions: ApolloReactHooks.QueryHookOptions<TQCustomerAddresses, TQCustomerAddressesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCustomerAddresses, TQCustomerAddressesVariables>(QCustomerAddressesDocument, options);
      }
export function useQCustomerAddressesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCustomerAddresses, TQCustomerAddressesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCustomerAddresses, TQCustomerAddressesVariables>(QCustomerAddressesDocument, options);
        }
export type QCustomerAddressesHookResult = ReturnType<typeof useQCustomerAddresses>;
export type QCustomerAddressesLazyQueryHookResult = ReturnType<typeof useQCustomerAddressesLazyQuery>;
export type QCustomerAddressesQueryResult = ApolloReactCommon.QueryResult<TQCustomerAddresses, TQCustomerAddressesVariables>;
export const QCustomerHistoryDocument = gql`
    query QCustomerHistory($id: ID!, $branches: [ID!], $dateFrom: DateTime!, $dateTo: DateTime!, $orderOrigins: [OrderOriginEnum!]) {
  history: user(id: $id) {
    id
    orders(
      companyBranches: $branches
      from: $dateFrom
      to: $dateTo
      orderOrigins: $orderOrigins
    ) {
      ...FOrderInHistory
    }
  }
}
    ${FOrderInHistory}`;
export function useQCustomerHistory(baseOptions: ApolloReactHooks.QueryHookOptions<TQCustomerHistory, TQCustomerHistoryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCustomerHistory, TQCustomerHistoryVariables>(QCustomerHistoryDocument, options);
      }
export function useQCustomerHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCustomerHistory, TQCustomerHistoryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCustomerHistory, TQCustomerHistoryVariables>(QCustomerHistoryDocument, options);
        }
export type QCustomerHistoryHookResult = ReturnType<typeof useQCustomerHistory>;
export type QCustomerHistoryLazyQueryHookResult = ReturnType<typeof useQCustomerHistoryLazyQuery>;
export type QCustomerHistoryQueryResult = ApolloReactCommon.QueryResult<TQCustomerHistory, TQCustomerHistoryVariables>;
export const QOrderDetailDocument = gql`
    query QOrderDetail($orderId: ID!) {
  orderDetail: order(id: $orderId) {
    id
    branch: companyBranch {
      id
      nameLabel: name
    }
    handoverType: deliveryType {
      ...FHandoverType
    }
    acceptedAt
    handedOverAt: deliveredAt
    ...FOrderAddress
    note
    isPaidWithCard
    transferredFrom: transferOrderFrom {
      id
      branch: companyBranch {
        id
        nameLabel: name
      }
    }
    orderPayments {
      paymentMethod {
        paymentType {
          enum
          code
        }
      }
    }
    ...FCartContent
  }
}
    ${FHandoverType}
${FOrderAddress}
${FCartContent}`;
export function useQOrderDetail(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderDetail, TQOrderDetailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderDetail, TQOrderDetailVariables>(QOrderDetailDocument, options);
      }
export function useQOrderDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderDetail, TQOrderDetailVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderDetail, TQOrderDetailVariables>(QOrderDetailDocument, options);
        }
export type QOrderDetailHookResult = ReturnType<typeof useQOrderDetail>;
export type QOrderDetailLazyQueryHookResult = ReturnType<typeof useQOrderDetailLazyQuery>;
export type QOrderDetailQueryResult = ApolloReactCommon.QueryResult<TQOrderDetail, TQOrderDetailVariables>;
export const MSubmitOrderFeedbackDocument = gql`
    mutation MSubmitOrderFeedback($orderId: ID!, $ratings: [InputOrderRatingCreate!]!) {
  createOrderRating(id: $orderId, ratings: $ratings) {
    id
  }
}
    `;
export type TMSubmitOrderFeedbackMutationFn = ApolloReactCommon.MutationFunction<TMSubmitOrderFeedback, TMSubmitOrderFeedbackVariables>;
export function useMSubmitOrderFeedback(baseOptions?: ApolloReactHooks.MutationHookOptions<TMSubmitOrderFeedback, TMSubmitOrderFeedbackVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMSubmitOrderFeedback, TMSubmitOrderFeedbackVariables>(MSubmitOrderFeedbackDocument, options);
      }
export type MSubmitOrderFeedbackHookResult = ReturnType<typeof useMSubmitOrderFeedback>;
export type MSubmitOrderFeedbackMutationResult = ApolloReactCommon.MutationResult<TMSubmitOrderFeedback>;
export type MSubmitOrderFeedbackMutationOptions = ApolloReactCommon.BaseMutationOptions<TMSubmitOrderFeedback, TMSubmitOrderFeedbackVariables>;
export const QOrderForFeedbackDocument = gql`
    query QOrderForFeedback($orderId: ID!) {
  order(id: $orderId) {
    id
    wasRatedBefore: hasRating
    branch: companyBranch {
      ...FBranchPhone
    }
  }
}
    ${FBranchPhone}`;
export function useQOrderForFeedback(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderForFeedback, TQOrderForFeedbackVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderForFeedback, TQOrderForFeedbackVariables>(QOrderForFeedbackDocument, options);
      }
export function useQOrderForFeedbackLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderForFeedback, TQOrderForFeedbackVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderForFeedback, TQOrderForFeedbackVariables>(QOrderForFeedbackDocument, options);
        }
export type QOrderForFeedbackHookResult = ReturnType<typeof useQOrderForFeedback>;
export type QOrderForFeedbackLazyQueryHookResult = ReturnType<typeof useQOrderForFeedbackLazyQuery>;
export type QOrderForFeedbackQueryResult = ApolloReactCommon.QueryResult<TQOrderForFeedback, TQOrderForFeedbackVariables>;
export const QBranchCompanyClientDocument = gql`
    query QBranchCompanyClient($branchId: ID!) {
  branch: companyBranch(id: $branchId) {
    id
    ...FBranchCompanyClient
  }
}
    ${FBranchCompanyClient}`;
export function useQBranchCompanyClient(baseOptions: ApolloReactHooks.QueryHookOptions<TQBranchCompanyClient, TQBranchCompanyClientVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBranchCompanyClient, TQBranchCompanyClientVariables>(QBranchCompanyClientDocument, options);
      }
export function useQBranchCompanyClientLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBranchCompanyClient, TQBranchCompanyClientVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBranchCompanyClient, TQBranchCompanyClientVariables>(QBranchCompanyClientDocument, options);
        }
export type QBranchCompanyClientHookResult = ReturnType<typeof useQBranchCompanyClient>;
export type QBranchCompanyClientLazyQueryHookResult = ReturnType<typeof useQBranchCompanyClientLazyQuery>;
export type QBranchCompanyClientQueryResult = ApolloReactCommon.QueryResult<TQBranchCompanyClient, TQBranchCompanyClientVariables>;
export const QOrderBranchDetailDocument = gql`
    query QOrderBranchDetail($orderId: ID!) {
  orderBranchDetail: order(id: $orderId) {
    id
    branch: companyBranch {
      id
      ...FBranchFooter
    }
  }
}
    ${FBranchFooter}`;
export function useQOrderBranchDetail(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderBranchDetail, TQOrderBranchDetailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderBranchDetail, TQOrderBranchDetailVariables>(QOrderBranchDetailDocument, options);
      }
export function useQOrderBranchDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderBranchDetail, TQOrderBranchDetailVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderBranchDetail, TQOrderBranchDetailVariables>(QOrderBranchDetailDocument, options);
        }
export type QOrderBranchDetailHookResult = ReturnType<typeof useQOrderBranchDetail>;
export type QOrderBranchDetailLazyQueryHookResult = ReturnType<typeof useQOrderBranchDetailLazyQuery>;
export type QOrderBranchDetailQueryResult = ApolloReactCommon.QueryResult<TQOrderBranchDetail, TQOrderBranchDetailVariables>;
export const QOrderCompanyClientDocument = gql`
    query QOrderCompanyClient($orderId: ID!) {
  order(id: $orderId) {
    id
    branch: companyBranch {
      ...FBranchCompanyClient
    }
  }
}
    ${FBranchCompanyClient}`;
export function useQOrderCompanyClient(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderCompanyClient, TQOrderCompanyClientVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderCompanyClient, TQOrderCompanyClientVariables>(QOrderCompanyClientDocument, options);
      }
export function useQOrderCompanyClientLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderCompanyClient, TQOrderCompanyClientVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderCompanyClient, TQOrderCompanyClientVariables>(QOrderCompanyClientDocument, options);
        }
export type QOrderCompanyClientHookResult = ReturnType<typeof useQOrderCompanyClient>;
export type QOrderCompanyClientLazyQueryHookResult = ReturnType<typeof useQOrderCompanyClientLazyQuery>;
export type QOrderCompanyClientQueryResult = ApolloReactCommon.QueryResult<TQOrderCompanyClient, TQOrderCompanyClientVariables>;
export const MSubmitOrderDocument = gql`
    mutation MSubmitOrder($orderId: ID!, $givenName: String, $familyName: String, $email: String!, $phone: String!, $note: String, $paymentMethodId: ID!, $confirmedAgreementIds: [ID!], $paymentFinishedScreenUrl: String, $paymentCanceledScreenUrl: String) {
  submitResult: finishOrder(
    id: $orderId
    order: {note: $note, returnUrl: $paymentFinishedScreenUrl, cancelUrl: $paymentCanceledScreenUrl, paymentMethodId: $paymentMethodId, confirmedAgreements: $confirmedAgreementIds, customer: {firstName: $givenName, lastName: $familyName, emails: [{email: $email}], phones: [{phone: $phone}]}}
  ) {
    ...FOrderSubmitResult
  }
}
    ${FOrderSubmitResult}`;
export type TMSubmitOrderMutationFn = ApolloReactCommon.MutationFunction<TMSubmitOrder, TMSubmitOrderVariables>;
export function useMSubmitOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMSubmitOrder, TMSubmitOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMSubmitOrder, TMSubmitOrderVariables>(MSubmitOrderDocument, options);
      }
export type MSubmitOrderHookResult = ReturnType<typeof useMSubmitOrder>;
export type MSubmitOrderMutationResult = ApolloReactCommon.MutationResult<TMSubmitOrder>;
export type MSubmitOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMSubmitOrder, TMSubmitOrderVariables>;
export const QOrderForFormDocument = gql`
    query QOrderForForm($orderId: ID!) {
  order(id: $orderId) {
    ...FOrderForForm
  }
}
    ${FOrderForForm}`;
export function useQOrderForForm(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderForForm, TQOrderForFormVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderForForm, TQOrderForFormVariables>(QOrderForFormDocument, options);
      }
export function useQOrderForFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderForForm, TQOrderForFormVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderForForm, TQOrderForFormVariables>(QOrderForFormDocument, options);
        }
export type QOrderForFormHookResult = ReturnType<typeof useQOrderForForm>;
export type QOrderForFormLazyQueryHookResult = ReturnType<typeof useQOrderForFormLazyQuery>;
export type QOrderForFormQueryResult = ApolloReactCommon.QueryResult<TQOrderForForm, TQOrderForFormVariables>;
export const QUserAgreementsDocument = gql`
    query QUserAgreements($orderId: ID!, $email: String!, $phone: String!, $givenName: String!, $familyName: String!, $customerId: ID) {
  agreements: vamStatus(
    input: {email: $email, phone: $phone, orderId: $orderId, firstname: $givenName, lastname: $familyName, user: $customerId}
  ) {
    ...FUserAgreement
  }
}
    ${FUserAgreement}`;
export function useQUserAgreements(baseOptions: ApolloReactHooks.QueryHookOptions<TQUserAgreements, TQUserAgreementsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQUserAgreements, TQUserAgreementsVariables>(QUserAgreementsDocument, options);
      }
export function useQUserAgreementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQUserAgreements, TQUserAgreementsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQUserAgreements, TQUserAgreementsVariables>(QUserAgreementsDocument, options);
        }
export type QUserAgreementsHookResult = ReturnType<typeof useQUserAgreements>;
export type QUserAgreementsLazyQueryHookResult = ReturnType<typeof useQUserAgreementsLazyQuery>;
export type QUserAgreementsQueryResult = ApolloReactCommon.QueryResult<TQUserAgreements, TQUserAgreementsVariables>;
export const MOrderTipUpdateDocument = gql`
    mutation MOrderTipUpdate($orderId: ID!, $tip: Float!) {
  updateOrder(id: $orderId, order: {tips: $tip}) {
    id
  }
}
    `;
export type TMOrderTipUpdateMutationFn = ApolloReactCommon.MutationFunction<TMOrderTipUpdate, TMOrderTipUpdateVariables>;
export function useMOrderTipUpdate(baseOptions?: ApolloReactHooks.MutationHookOptions<TMOrderTipUpdate, TMOrderTipUpdateVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMOrderTipUpdate, TMOrderTipUpdateVariables>(MOrderTipUpdateDocument, options);
      }
export type MOrderTipUpdateHookResult = ReturnType<typeof useMOrderTipUpdate>;
export type MOrderTipUpdateMutationResult = ApolloReactCommon.MutationResult<TMOrderTipUpdate>;
export type MOrderTipUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<TMOrderTipUpdate, TMOrderTipUpdateVariables>;
export const QAvailablePaymentMethodsDocument = gql`
    query QAvailablePaymentMethods($branchId: ID!, $orderOrigin: OrderOriginEnum!, $priceType: WarePriceTypeEnum!, $handoverType: DeliveryTypeEnum) {
  branch: companyBranch(id: $branchId) {
    id
    branchPaymentMethods: paymentMethods(
      orderOrigin: $orderOrigin
      warePriceType: $priceType
      deliveryType: $handoverType
    ) {
      id
      maximumAmount {
        value
        formattedValue
      }
      method: paymentMethod {
        ...FPaymentMethod
      }
    }
  }
}
    ${FPaymentMethod}`;
export function useQAvailablePaymentMethods(baseOptions: ApolloReactHooks.QueryHookOptions<TQAvailablePaymentMethods, TQAvailablePaymentMethodsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQAvailablePaymentMethods, TQAvailablePaymentMethodsVariables>(QAvailablePaymentMethodsDocument, options);
      }
export function useQAvailablePaymentMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQAvailablePaymentMethods, TQAvailablePaymentMethodsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQAvailablePaymentMethods, TQAvailablePaymentMethodsVariables>(QAvailablePaymentMethodsDocument, options);
        }
export type QAvailablePaymentMethodsHookResult = ReturnType<typeof useQAvailablePaymentMethods>;
export type QAvailablePaymentMethodsLazyQueryHookResult = ReturnType<typeof useQAvailablePaymentMethodsLazyQuery>;
export type QAvailablePaymentMethodsQueryResult = ApolloReactCommon.QueryResult<TQAvailablePaymentMethods, TQAvailablePaymentMethodsVariables>;
export const MAddPromoCodeDocument = gql`
    mutation MAddPromoCode($orderId: ID!, $code: String!) {
  result: addOrderPromoCode(order: $orderId, promoCode: $code) {
    errors
    order {
      ...FOrderPromoCodes
    }
  }
}
    ${FOrderPromoCodes}`;
export type TMAddPromoCodeMutationFn = ApolloReactCommon.MutationFunction<TMAddPromoCode, TMAddPromoCodeVariables>;
export function useMAddPromoCode(baseOptions?: ApolloReactHooks.MutationHookOptions<TMAddPromoCode, TMAddPromoCodeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMAddPromoCode, TMAddPromoCodeVariables>(MAddPromoCodeDocument, options);
      }
export type MAddPromoCodeHookResult = ReturnType<typeof useMAddPromoCode>;
export type MAddPromoCodeMutationResult = ApolloReactCommon.MutationResult<TMAddPromoCode>;
export type MAddPromoCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<TMAddPromoCode, TMAddPromoCodeVariables>;
export const MRemovePromoCodeDocument = gql`
    mutation MRemovePromoCode($orderId: ID!, $codeId: ID!) {
  order: removeOrderPromoCode(order: $orderId, promoCode: $codeId) {
    ...FOrderPromoCodes
  }
}
    ${FOrderPromoCodes}`;
export type TMRemovePromoCodeMutationFn = ApolloReactCommon.MutationFunction<TMRemovePromoCode, TMRemovePromoCodeVariables>;
export function useMRemovePromoCode(baseOptions?: ApolloReactHooks.MutationHookOptions<TMRemovePromoCode, TMRemovePromoCodeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMRemovePromoCode, TMRemovePromoCodeVariables>(MRemovePromoCodeDocument, options);
      }
export type MRemovePromoCodeHookResult = ReturnType<typeof useMRemovePromoCode>;
export type MRemovePromoCodeMutationResult = ApolloReactCommon.MutationResult<TMRemovePromoCode>;
export type MRemovePromoCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<TMRemovePromoCode, TMRemovePromoCodeVariables>;
export const QOrderPromoCodesDocument = gql`
    query QOrderPromoCodes($orderId: ID!) {
  order(id: $orderId) {
    ...FOrderPromoCodes
  }
}
    ${FOrderPromoCodes}`;
export function useQOrderPromoCodes(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderPromoCodes, TQOrderPromoCodesVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderPromoCodes, TQOrderPromoCodesVariables>(QOrderPromoCodesDocument, options);
      }
export function useQOrderPromoCodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderPromoCodes, TQOrderPromoCodesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderPromoCodes, TQOrderPromoCodesVariables>(QOrderPromoCodesDocument, options);
        }
export type QOrderPromoCodesHookResult = ReturnType<typeof useQOrderPromoCodes>;
export type QOrderPromoCodesLazyQueryHookResult = ReturnType<typeof useQOrderPromoCodesLazyQuery>;
export type QOrderPromoCodesQueryResult = ApolloReactCommon.QueryResult<TQOrderPromoCodes, TQOrderPromoCodesVariables>;
export const QCombinationMealsDocument = gql`
    query QCombinationMeals($branchId: ID!, $isAvailableAt: DateTime, $priceType: WarePriceTypeEnum) {
  recipes(
    companyBranch: $branchId
    wareCategoryType: MAIN
    orderOriginCategory: DOVEZE
    enabled: true
    isAvailable: true
    isAvailableAt: $isAvailableAt
    isCombinationMeal: true
  ) {
    id
    combinationMealPrice: mainCombinationMealPrice(warePriceType: $priceType) {
      ...FPrice
    }
  }
}
    ${FPrice}`;
export function useQCombinationMeals(baseOptions: ApolloReactHooks.QueryHookOptions<TQCombinationMeals, TQCombinationMealsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCombinationMeals, TQCombinationMealsVariables>(QCombinationMealsDocument, options);
      }
export function useQCombinationMealsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCombinationMeals, TQCombinationMealsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCombinationMeals, TQCombinationMealsVariables>(QCombinationMealsDocument, options);
        }
export type QCombinationMealsHookResult = ReturnType<typeof useQCombinationMeals>;
export type QCombinationMealsLazyQueryHookResult = ReturnType<typeof useQCombinationMealsLazyQuery>;
export type QCombinationMealsQueryResult = ApolloReactCommon.QueryResult<TQCombinationMeals, TQCombinationMealsVariables>;
export const QProductListDocument = gql`
    query QProductList($isAvailableAt: DateTime, $branchId: ID!, $priceType: WarePriceTypeEnum) {
  productCategories: wareCategories(
    companyBranch: $branchId
    wareCategoryType: MAIN
    orderOriginCategory: DOVEZE
    enabled: true
    isAvailable: true
    isAvailableAt: $isAvailableAt
    withoutPromoTags: [HIDDEN_FROM_STANDARD]
  ) {
    ...FProductCategory
  }
}
    ${FProductCategory}`;
export function useQProductList(baseOptions: ApolloReactHooks.QueryHookOptions<TQProductList, TQProductListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQProductList, TQProductListVariables>(QProductListDocument, options);
      }
export function useQProductListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQProductList, TQProductListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQProductList, TQProductListVariables>(QProductListDocument, options);
        }
export type QProductListHookResult = ReturnType<typeof useQProductList>;
export type QProductListLazyQueryHookResult = ReturnType<typeof useQProductListLazyQuery>;
export type QProductListQueryResult = ApolloReactCommon.QueryResult<TQProductList, TQProductListVariables>;
export const QPromoCategoryDocument = gql`
    query QPromoCategory($isAvailableAt: DateTime, $branchId: ID!, $promoTag: PromoTagEnum!, $imageWidth: Int = 150, $priceType: WarePriceTypeEnum) {
  productCategories: wareCategories(
    companyBranch: $branchId
    wareCategoryType: MAIN
    orderOriginCategory: DOVEZE
    enabled: true
    isAvailable: true
    isAvailableAt: $isAvailableAt
    promoTags: [$promoTag]
  ) {
    ...FProductCategoryBase
    descriptionLabel
    products: recipes(enabled: true, isAvailable: true) {
      ...FProductBase
      pictogram
      image(width: $imageWidth, height: $imageWidth)
    }
  }
}
    ${FProductCategoryBase}
${FProductBase}`;
export function useQPromoCategory(baseOptions: ApolloReactHooks.QueryHookOptions<TQPromoCategory, TQPromoCategoryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQPromoCategory, TQPromoCategoryVariables>(QPromoCategoryDocument, options);
      }
export function useQPromoCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQPromoCategory, TQPromoCategoryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQPromoCategory, TQPromoCategoryVariables>(QPromoCategoryDocument, options);
        }
export type QPromoCategoryHookResult = ReturnType<typeof useQPromoCategory>;
export type QPromoCategoryLazyQueryHookResult = ReturnType<typeof useQPromoCategoryLazyQuery>;
export type QPromoCategoryQueryResult = ApolloReactCommon.QueryResult<TQPromoCategory, TQPromoCategoryVariables>;
export const QWaiterProductListDocument = gql`
    query QWaiterProductList($branchId: ID!, $sectorId: ID, $priceType: WarePriceTypeEnum) {
  productCategories: wareCategories(
    companyBranch: $branchId
    sector: $sectorId
    wareCategoryType: MAIN
    orderOriginCategory: WIFI
    isAvailable: true
    enabled: true
    withoutPromoTags: [HIDDEN_FROM_STANDARD]
  ) {
    ...FProductCategory
  }
}
    ${FProductCategory}`;
export function useQWaiterProductList(baseOptions: ApolloReactHooks.QueryHookOptions<TQWaiterProductList, TQWaiterProductListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQWaiterProductList, TQWaiterProductListVariables>(QWaiterProductListDocument, options);
      }
export function useQWaiterProductListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQWaiterProductList, TQWaiterProductListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQWaiterProductList, TQWaiterProductListVariables>(QWaiterProductListDocument, options);
        }
export type QWaiterProductListHookResult = ReturnType<typeof useQWaiterProductList>;
export type QWaiterProductListLazyQueryHookResult = ReturnType<typeof useQWaiterProductListLazyQuery>;
export type QWaiterProductListQueryResult = ApolloReactCommon.QueryResult<TQWaiterProductList, TQWaiterProductListVariables>;
export const QDeliveryAddressSuggestionsDocument = gql`
    query QDeliveryAddressSuggestions($gpsList: [InputGeoPointCreate!]!) {
  suggestions: suggestAddress(gps: $gpsList) {
    address: finalAddress {
      ...FAddress
    }
    gps: gpsCoordinates {
      latitude
      longitude
    }
  }
}
    ${FAddress}`;
export function useQDeliveryAddressSuggestions(baseOptions: ApolloReactHooks.QueryHookOptions<TQDeliveryAddressSuggestions, TQDeliveryAddressSuggestionsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQDeliveryAddressSuggestions, TQDeliveryAddressSuggestionsVariables>(QDeliveryAddressSuggestionsDocument, options);
      }
export function useQDeliveryAddressSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQDeliveryAddressSuggestions, TQDeliveryAddressSuggestionsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQDeliveryAddressSuggestions, TQDeliveryAddressSuggestionsVariables>(QDeliveryAddressSuggestionsDocument, options);
        }
export type QDeliveryAddressSuggestionsHookResult = ReturnType<typeof useQDeliveryAddressSuggestions>;
export type QDeliveryAddressSuggestionsLazyQueryHookResult = ReturnType<typeof useQDeliveryAddressSuggestionsLazyQuery>;
export type QDeliveryAddressSuggestionsQueryResult = ApolloReactCommon.QueryResult<TQDeliveryAddressSuggestions, TQDeliveryAddressSuggestionsVariables>;
export const QResolveDeliveryAddressDocument = gql`
    query QResolveDeliveryAddress($brandId: ID, $branchId: ID, $latitude: Float, $longitude: Float, $addressInput: String) {
  result: resolveLocation(
    brand: $brandId
    latitude: $latitude
    longitude: $longitude
    address: $addressInput
    companyBranch: $branchId
  ) {
    isResolved
    isValidAddress
    isInDeliveryLocation: inDeliveryLocation
    deliveryAddress: finalAddress {
      ...FAddress
    }
    gps: gpsCoordinates {
      latitude
      longitude
    }
    deliveryBranch: companyBranch {
      id
      isOpen
      ...FAvailableDeliveryBranch
    }
    deliveryZone: zone {
      ...FDeliveryZone
    }
  }
}
    ${FAddress}
${FAvailableDeliveryBranch}
${FDeliveryZone}`;
export function useQResolveDeliveryAddress(baseOptions?: ApolloReactHooks.QueryHookOptions<TQResolveDeliveryAddress, TQResolveDeliveryAddressVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQResolveDeliveryAddress, TQResolveDeliveryAddressVariables>(QResolveDeliveryAddressDocument, options);
      }
export function useQResolveDeliveryAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQResolveDeliveryAddress, TQResolveDeliveryAddressVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQResolveDeliveryAddress, TQResolveDeliveryAddressVariables>(QResolveDeliveryAddressDocument, options);
        }
export type QResolveDeliveryAddressHookResult = ReturnType<typeof useQResolveDeliveryAddress>;
export type QResolveDeliveryAddressLazyQueryHookResult = ReturnType<typeof useQResolveDeliveryAddressLazyQuery>;
export type QResolveDeliveryAddressQueryResult = ApolloReactCommon.QueryResult<TQResolveDeliveryAddress, TQResolveDeliveryAddressVariables>;
export const QTimeSlotsDocument = gql`
    query QTimeSlots($branchId: ID!, $handoverType: DeliveryTypeEnum!, $deliveryZoneId: ID) {
  timeSlots: deliverySlots(
    companyBranch: $branchId
    deliveryType: $handoverType
    zone: $deliveryZoneId
  ) {
    isFull
    ...FTimeSlot
  }
}
    ${FTimeSlot}`;
export function useQTimeSlots(baseOptions: ApolloReactHooks.QueryHookOptions<TQTimeSlots, TQTimeSlotsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQTimeSlots, TQTimeSlotsVariables>(QTimeSlotsDocument, options);
      }
export function useQTimeSlotsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQTimeSlots, TQTimeSlotsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQTimeSlots, TQTimeSlotsVariables>(QTimeSlotsDocument, options);
        }
export type QTimeSlotsHookResult = ReturnType<typeof useQTimeSlots>;
export type QTimeSlotsLazyQueryHookResult = ReturnType<typeof useQTimeSlotsLazyQuery>;
export type QTimeSlotsQueryResult = ApolloReactCommon.QueryResult<TQTimeSlots, TQTimeSlotsVariables>;
export const QMobileAppSettingsDocument = gql`
    query QMobileAppSettings($branchId: ID!, $platform: MobilePlatformEnum!) {
  branch: companyBranch(id: $branchId) {
    id
    mobileApp: mobileApplicationSetting(platform: $platform) {
      appStoreUrl: url
    }
    brand {
      id
      mobileApp: mobileApplicationSetting(platform: $platform) {
        appStoreUrl: url
      }
    }
  }
}
    `;
export function useQMobileAppSettings(baseOptions: ApolloReactHooks.QueryHookOptions<TQMobileAppSettings, TQMobileAppSettingsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQMobileAppSettings, TQMobileAppSettingsVariables>(QMobileAppSettingsDocument, options);
      }
export function useQMobileAppSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQMobileAppSettings, TQMobileAppSettingsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQMobileAppSettings, TQMobileAppSettingsVariables>(QMobileAppSettingsDocument, options);
        }
export type QMobileAppSettingsHookResult = ReturnType<typeof useQMobileAppSettings>;
export type QMobileAppSettingsLazyQueryHookResult = ReturnType<typeof useQMobileAppSettingsLazyQuery>;
export type QMobileAppSettingsQueryResult = ApolloReactCommon.QueryResult<TQMobileAppSettings, TQMobileAppSettingsVariables>;
export const MCreateDeliveryOrderDocument = gql`
    mutation MCreateDeliveryOrder($branchId: ID, $gps: InputGeoPointCreate!, $orderOrigin: OrderOriginEnum!, $addressUserInput: String, $timeSlotId: ID) {
  order: createDeliveryOrder(
    order: {companyBranch: $branchId, gps: $gps, orderOrigin: $orderOrigin, address: $addressUserInput, deliverySlot: $timeSlotId}
  ) {
    ...FNewOrder
  }
}
    ${FNewOrder}`;
export type TMCreateDeliveryOrderMutationFn = ApolloReactCommon.MutationFunction<TMCreateDeliveryOrder, TMCreateDeliveryOrderVariables>;
export function useMCreateDeliveryOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateDeliveryOrder, TMCreateDeliveryOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateDeliveryOrder, TMCreateDeliveryOrderVariables>(MCreateDeliveryOrderDocument, options);
      }
export type MCreateDeliveryOrderHookResult = ReturnType<typeof useMCreateDeliveryOrder>;
export type MCreateDeliveryOrderMutationResult = ApolloReactCommon.MutationResult<TMCreateDeliveryOrder>;
export type MCreateDeliveryOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateDeliveryOrder, TMCreateDeliveryOrderVariables>;
export const MCreatePickupOrderDocument = gql`
    mutation MCreatePickupOrder($branchId: ID!, $orderOrigin: OrderOriginEnum!, $timeSlotId: ID) {
  order: createPickupOrder(
    order: {companyBranch: $branchId, orderOrigin: $orderOrigin, deliverySlot: $timeSlotId}
  ) {
    ...FNewOrder
  }
}
    ${FNewOrder}`;
export type TMCreatePickupOrderMutationFn = ApolloReactCommon.MutationFunction<TMCreatePickupOrder, TMCreatePickupOrderVariables>;
export function useMCreatePickupOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreatePickupOrder, TMCreatePickupOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreatePickupOrder, TMCreatePickupOrderVariables>(MCreatePickupOrderDocument, options);
      }
export type MCreatePickupOrderHookResult = ReturnType<typeof useMCreatePickupOrder>;
export type MCreatePickupOrderMutationResult = ApolloReactCommon.MutationResult<TMCreatePickupOrder>;
export type MCreatePickupOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreatePickupOrder, TMCreatePickupOrderVariables>;
export const MCreateWaiterOrderDocument = gql`
    mutation MCreateWaiterOrder($branchId: ID!, $priceType: WarePriceTypeEnum!, $deliveryType: DeliveryTypeEnum!, $sectorId: ID) {
  order: createWifiOrder(
    order: {companyBranch: $branchId, orderOrigin: WIFI, deliveryType: $deliveryType, warePriceType: $priceType, sector: $sectorId}
  ) {
    ...FNewWaiterOrder
  }
}
    ${FNewWaiterOrder}`;
export type TMCreateWaiterOrderMutationFn = ApolloReactCommon.MutationFunction<TMCreateWaiterOrder, TMCreateWaiterOrderVariables>;
export function useMCreateWaiterOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateWaiterOrder, TMCreateWaiterOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateWaiterOrder, TMCreateWaiterOrderVariables>(MCreateWaiterOrderDocument, options);
      }
export type MCreateWaiterOrderHookResult = ReturnType<typeof useMCreateWaiterOrder>;
export type MCreateWaiterOrderMutationResult = ApolloReactCommon.MutationResult<TMCreateWaiterOrder>;
export type MCreateWaiterOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateWaiterOrder, TMCreateWaiterOrderVariables>;
export const MUpdateOrderDocument = gql`
    mutation MUpdateOrder($orderId: ID!, $branchId: ID, $handoverType: DeliveryTypeEnum, $timeSlotId: ID, $gps: InputGeoPointCreate, $addressUserInput: String) {
  order: updateOrder(
    id: $orderId
    order: {companyBranch: $branchId, deliveryType: $handoverType, deliverySlot: $timeSlotId, address: $addressUserInput, gps: $gps}
  ) {
    id
    ...FNewOrder
    branch: companyBranch {
      id
    }
    handoverType: deliveryType {
      ...FHandoverType
    }
    selectedTimeSlot: deliverySlot {
      isFull
      ...FTimeSlot
    }
    deliveryAddress: address {
      original
      ...FAddress
    }
    gps {
      latitude
      longitude
    }
    deliveryZone: zone {
      ...FDeliveryZone
    }
  }
}
    ${FNewOrder}
${FHandoverType}
${FTimeSlot}
${FAddress}
${FDeliveryZone}`;
export type TMUpdateOrderMutationFn = ApolloReactCommon.MutationFunction<TMUpdateOrder, TMUpdateOrderVariables>;
export function useMUpdateOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateOrder, TMUpdateOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateOrder, TMUpdateOrderVariables>(MUpdateOrderDocument, options);
      }
export type MUpdateOrderHookResult = ReturnType<typeof useMUpdateOrder>;
export type MUpdateOrderMutationResult = ApolloReactCommon.MutationResult<TMUpdateOrder>;
export type MUpdateOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateOrder, TMUpdateOrderVariables>;
export const MUpdateOrderPreviewDocument = gql`
    mutation MUpdateOrderPreview($orderId: ID!, $branchId: ID, $handoverType: DeliveryTypeEnum, $timeSlotId: ID, $gps: InputGeoPointCreate, $addressUserInput: String) {
  changes: updateOrderPreview(
    id: $orderId
    order: {companyBranch: $branchId, deliveryType: $handoverType, deliverySlot: $timeSlotId, address: $addressUserInput, gps: $gps}
  ) {
    changeType
    attribute
    oldData {
      ...FOrderParamsDiff
    }
    newData {
      ...FOrderParamsDiff
    }
  }
}
    ${FOrderParamsDiff}`;
export type TMUpdateOrderPreviewMutationFn = ApolloReactCommon.MutationFunction<TMUpdateOrderPreview, TMUpdateOrderPreviewVariables>;
export function useMUpdateOrderPreview(baseOptions?: ApolloReactHooks.MutationHookOptions<TMUpdateOrderPreview, TMUpdateOrderPreviewVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMUpdateOrderPreview, TMUpdateOrderPreviewVariables>(MUpdateOrderPreviewDocument, options);
      }
export type MUpdateOrderPreviewHookResult = ReturnType<typeof useMUpdateOrderPreview>;
export type MUpdateOrderPreviewMutationResult = ApolloReactCommon.MutationResult<TMUpdateOrderPreview>;
export type MUpdateOrderPreviewMutationOptions = ApolloReactCommon.BaseMutationOptions<TMUpdateOrderPreview, TMUpdateOrderPreviewVariables>;
export const MReSubmitOrderDocument = gql`
    mutation MReSubmitOrder($orderId: ID!, $tip: Float, $paymentMethodId: ID!, $returnUrl: String) {
  submitResult: finishOrder(
    id: $orderId
    order: {tips: $tip, paymentMethodId: $paymentMethodId, returnUrl: $returnUrl, cancelUrl: $returnUrl}
  ) {
    ...FOrderSubmitResult
  }
}
    ${FOrderSubmitResult}`;
export type TMReSubmitOrderMutationFn = ApolloReactCommon.MutationFunction<TMReSubmitOrder, TMReSubmitOrderVariables>;
export function useMReSubmitOrder(baseOptions?: ApolloReactHooks.MutationHookOptions<TMReSubmitOrder, TMReSubmitOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMReSubmitOrder, TMReSubmitOrderVariables>(MReSubmitOrderDocument, options);
      }
export type MReSubmitOrderHookResult = ReturnType<typeof useMReSubmitOrder>;
export type MReSubmitOrderMutationResult = ApolloReactCommon.MutationResult<TMReSubmitOrder>;
export type MReSubmitOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<TMReSubmitOrder, TMReSubmitOrderVariables>;
export const QLockedOrderDocument = gql`
    query QLockedOrder($orderId: ID!) {
  order(id: $orderId) {
    id
    totalSum {
      value
    }
    ...FOrderForPaymentMethods
    branch: companyBranch {
      id
      ...FBranchPhone
    }
  }
}
    ${FOrderForPaymentMethods}
${FBranchPhone}`;
export function useQLockedOrder(baseOptions: ApolloReactHooks.QueryHookOptions<TQLockedOrder, TQLockedOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQLockedOrder, TQLockedOrderVariables>(QLockedOrderDocument, options);
      }
export function useQLockedOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQLockedOrder, TQLockedOrderVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQLockedOrder, TQLockedOrderVariables>(QLockedOrderDocument, options);
        }
export type QLockedOrderHookResult = ReturnType<typeof useQLockedOrder>;
export type QLockedOrderLazyQueryHookResult = ReturnType<typeof useQLockedOrderLazyQuery>;
export type QLockedOrderQueryResult = ApolloReactCommon.QueryResult<TQLockedOrder, TQLockedOrderVariables>;
export const QPaymentLockedOrderDocument = gql`
    query QPaymentLockedOrder($orderId: ID!) {
  order(id: $orderId) {
    id
    branch: companyBranch {
      ...FBranchPhone
    }
  }
}
    ${FBranchPhone}`;
export function useQPaymentLockedOrder(baseOptions: ApolloReactHooks.QueryHookOptions<TQPaymentLockedOrder, TQPaymentLockedOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQPaymentLockedOrder, TQPaymentLockedOrderVariables>(QPaymentLockedOrderDocument, options);
      }
export function useQPaymentLockedOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQPaymentLockedOrder, TQPaymentLockedOrderVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQPaymentLockedOrder, TQPaymentLockedOrderVariables>(QPaymentLockedOrderDocument, options);
        }
export type QPaymentLockedOrderHookResult = ReturnType<typeof useQPaymentLockedOrder>;
export type QPaymentLockedOrderLazyQueryHookResult = ReturnType<typeof useQPaymentLockedOrderLazyQuery>;
export type QPaymentLockedOrderQueryResult = ApolloReactCommon.QueryResult<TQPaymentLockedOrder, TQPaymentLockedOrderVariables>;
export const QPaymentStatusDocument = gql`
    query QPaymentStatus($orderId: ID!) {
  status: orderOnlinePaymentStatus(id: $orderId) {
    isPrePaid: isSuccess
    isInPaymentGate: isProcessing
    ...FPaymentGatewayUrls
    order {
      id
      acceptedAt
      isLocked: isPartiallyFinalized
      orderStates {
        id
        enum
      }
    }
  }
}
    ${FPaymentGatewayUrls}`;
export function useQPaymentStatus(baseOptions: ApolloReactHooks.QueryHookOptions<TQPaymentStatus, TQPaymentStatusVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQPaymentStatus, TQPaymentStatusVariables>(QPaymentStatusDocument, options);
      }
export function useQPaymentStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQPaymentStatus, TQPaymentStatusVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQPaymentStatus, TQPaymentStatusVariables>(QPaymentStatusDocument, options);
        }
export type QPaymentStatusHookResult = ReturnType<typeof useQPaymentStatus>;
export type QPaymentStatusLazyQueryHookResult = ReturnType<typeof useQPaymentStatusLazyQuery>;
export type QPaymentStatusQueryResult = ApolloReactCommon.QueryResult<TQPaymentStatus, TQPaymentStatusVariables>;
export const MCreateRegisteredUserDocument = gql`
    mutation MCreateRegisteredUser($email: String!, $password: String!, $returnUrl: String!, $locale: LanguageEnum!, $confirmationToken: String!) {
  userId: createRegisteredUser(
    user: {email: $email, password: $password, returnUrl: $returnUrl, language: $locale, token: $confirmationToken}
  )
}
    `;
export type TMCreateRegisteredUserMutationFn = ApolloReactCommon.MutationFunction<TMCreateRegisteredUser, TMCreateRegisteredUserVariables>;
export function useMCreateRegisteredUser(baseOptions?: ApolloReactHooks.MutationHookOptions<TMCreateRegisteredUser, TMCreateRegisteredUserVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMCreateRegisteredUser, TMCreateRegisteredUserVariables>(MCreateRegisteredUserDocument, options);
      }
export type MCreateRegisteredUserHookResult = ReturnType<typeof useMCreateRegisteredUser>;
export type MCreateRegisteredUserMutationResult = ApolloReactCommon.MutationResult<TMCreateRegisteredUser>;
export type MCreateRegisteredUserMutationOptions = ApolloReactCommon.BaseMutationOptions<TMCreateRegisteredUser, TMCreateRegisteredUserVariables>;
export const MRequestConfirmationCodeDocument = gql`
    mutation MRequestConfirmationCode($phoneNumber: String!, $envUrl: String) {
  result: requestPhoneConfirmationCode(
    phoneNumber: $phoneNumber
    originatorHost: $envUrl
  ) {
    phonePrefix: phone(part: COUNTRY_CODE)
    phoneNumber: phone(part: LOCAL_NUMBER)
  }
}
    `;
export type TMRequestConfirmationCodeMutationFn = ApolloReactCommon.MutationFunction<TMRequestConfirmationCode, TMRequestConfirmationCodeVariables>;
export function useMRequestConfirmationCode(baseOptions?: ApolloReactHooks.MutationHookOptions<TMRequestConfirmationCode, TMRequestConfirmationCodeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMRequestConfirmationCode, TMRequestConfirmationCodeVariables>(MRequestConfirmationCodeDocument, options);
      }
export type MRequestConfirmationCodeHookResult = ReturnType<typeof useMRequestConfirmationCode>;
export type MRequestConfirmationCodeMutationResult = ApolloReactCommon.MutationResult<TMRequestConfirmationCode>;
export type MRequestConfirmationCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<TMRequestConfirmationCode, TMRequestConfirmationCodeVariables>;
export const MValidateConfirmationCodeDocument = gql`
    mutation MValidateConfirmationCode($phoneNumber: String!, $code: String!) {
  result: validatePhoneConfirmationCode(phoneNumber: $phoneNumber, code: $code) {
    confirmationToken: token
    userExists
  }
}
    `;
export type TMValidateConfirmationCodeMutationFn = ApolloReactCommon.MutationFunction<TMValidateConfirmationCode, TMValidateConfirmationCodeVariables>;
export function useMValidateConfirmationCode(baseOptions?: ApolloReactHooks.MutationHookOptions<TMValidateConfirmationCode, TMValidateConfirmationCodeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TMValidateConfirmationCode, TMValidateConfirmationCodeVariables>(MValidateConfirmationCodeDocument, options);
      }
export type MValidateConfirmationCodeHookResult = ReturnType<typeof useMValidateConfirmationCode>;
export type MValidateConfirmationCodeMutationResult = ApolloReactCommon.MutationResult<TMValidateConfirmationCode>;
export type MValidateConfirmationCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<TMValidateConfirmationCode, TMValidateConfirmationCodeVariables>;
export const QResolvedCompanyDocument = gql`
    query QResolvedCompany($url: String) {
  lookup: companyBranchLookUp(hostUrl: $url, findNearestCompanyBranch: false) {
    redirectUrl
    orderOrigin
    defaultLanguage: userDefaultLanguage
    isMobileApp
    isBrand: isBrandUrl
    resolvedBrand: brand {
      ...FResolvedBrand
    }
    resolvedBranch: companyBranch {
      ...FResolvedBranch
    }
  }
}
    ${FResolvedBrand}
${FResolvedBranch}`;
export function useQResolvedCompany(baseOptions?: ApolloReactHooks.QueryHookOptions<TQResolvedCompany, TQResolvedCompanyVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQResolvedCompany, TQResolvedCompanyVariables>(QResolvedCompanyDocument, options);
      }
export function useQResolvedCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQResolvedCompany, TQResolvedCompanyVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQResolvedCompany, TQResolvedCompanyVariables>(QResolvedCompanyDocument, options);
        }
export type QResolvedCompanyHookResult = ReturnType<typeof useQResolvedCompany>;
export type QResolvedCompanyLazyQueryHookResult = ReturnType<typeof useQResolvedCompanyLazyQuery>;
export type QResolvedCompanyQueryResult = ApolloReactCommon.QueryResult<TQResolvedCompany, TQResolvedCompanyVariables>;
export const QOrderForTrackingDocument = gql`
    query QOrderForTracking($orderId: ID!) {
  order(id: $orderId) {
    ...FOrderForTracking
  }
}
    ${FOrderForTracking}`;
export function useQOrderForTracking(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderForTracking, TQOrderForTrackingVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderForTracking, TQOrderForTrackingVariables>(QOrderForTrackingDocument, options);
      }
export function useQOrderForTrackingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderForTracking, TQOrderForTrackingVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderForTracking, TQOrderForTrackingVariables>(QOrderForTrackingDocument, options);
        }
export type QOrderForTrackingHookResult = ReturnType<typeof useQOrderForTracking>;
export type QOrderForTrackingLazyQueryHookResult = ReturnType<typeof useQOrderForTrackingLazyQuery>;
export type QOrderForTrackingQueryResult = ApolloReactCommon.QueryResult<TQOrderForTracking, TQOrderForTrackingVariables>;
export const QSubmittedOrderDocument = gql`
    query QSubmittedOrder($orderId: ID!) {
  order(id: $orderId) {
    id
    branch: companyBranch {
      ...FBranchPhone
    }
  }
}
    ${FBranchPhone}`;
export function useQSubmittedOrder(baseOptions: ApolloReactHooks.QueryHookOptions<TQSubmittedOrder, TQSubmittedOrderVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQSubmittedOrder, TQSubmittedOrderVariables>(QSubmittedOrderDocument, options);
      }
export function useQSubmittedOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQSubmittedOrder, TQSubmittedOrderVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQSubmittedOrder, TQSubmittedOrderVariables>(QSubmittedOrderDocument, options);
        }
export type QSubmittedOrderHookResult = ReturnType<typeof useQSubmittedOrder>;
export type QSubmittedOrderLazyQueryHookResult = ReturnType<typeof useQSubmittedOrderLazyQuery>;
export type QSubmittedOrderQueryResult = ApolloReactCommon.QueryResult<TQSubmittedOrder, TQSubmittedOrderVariables>;
export const SOrderTrackingDocument = gql`
    subscription SOrderTracking($orderId: ID!, $branchId: ID!) {
  updatedOrder(
    id: $orderId
    companyBranches: [$branchId]
    orderStateCategoryTarget: FE_ADMIN
  ) {
    updatedOrder: order {
      ...FTrackedOrderState
    }
  }
}
    ${FTrackedOrderState}`;
export function useSOrderTracking(baseOptions: ApolloReactHooks.SubscriptionHookOptions<TSOrderTracking, TSOrderTrackingVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<TSOrderTracking, TSOrderTrackingVariables>(SOrderTrackingDocument, options);
      }
export type SOrderTrackingHookResult = ReturnType<typeof useSOrderTracking>;
export type SOrderTrackingSubscriptionResult = ApolloReactCommon.SubscriptionResult<TSOrderTracking>;
export const QTransportFeesSummaryDocument = gql`
    query QTransportFeesSummary($orderId: ID!) {
  order(id: $orderId) {
    id
    transportFee {
      ...FPrice
    }
    levelsOfTransportFees {
      ...FTransportFeeLevel
    }
  }
}
    ${FPrice}
${FTransportFeeLevel}`;
export function useQTransportFeesSummary(baseOptions: ApolloReactHooks.QueryHookOptions<TQTransportFeesSummary, TQTransportFeesSummaryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQTransportFeesSummary, TQTransportFeesSummaryVariables>(QTransportFeesSummaryDocument, options);
      }
export function useQTransportFeesSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQTransportFeesSummary, TQTransportFeesSummaryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQTransportFeesSummary, TQTransportFeesSummaryVariables>(QTransportFeesSummaryDocument, options);
        }
export type QTransportFeesSummaryHookResult = ReturnType<typeof useQTransportFeesSummary>;
export type QTransportFeesSummaryLazyQueryHookResult = ReturnType<typeof useQTransportFeesSummaryLazyQuery>;
export type QTransportFeesSummaryQueryResult = ApolloReactCommon.QueryResult<TQTransportFeesSummary, TQTransportFeesSummaryVariables>;
export const QBranchStylesForWaiterDocument = gql`
    query QBranchStylesForWaiter($branchId: ID!) {
  branch: companyBranch(id: $branchId) {
    ...FBranchStylesForWaiter
  }
}
    ${FBranchStylesForWaiter}`;
export function useQBranchStylesForWaiter(baseOptions: ApolloReactHooks.QueryHookOptions<TQBranchStylesForWaiter, TQBranchStylesForWaiterVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBranchStylesForWaiter, TQBranchStylesForWaiterVariables>(QBranchStylesForWaiterDocument, options);
      }
export function useQBranchStylesForWaiterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBranchStylesForWaiter, TQBranchStylesForWaiterVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBranchStylesForWaiter, TQBranchStylesForWaiterVariables>(QBranchStylesForWaiterDocument, options);
        }
export type QBranchStylesForWaiterHookResult = ReturnType<typeof useQBranchStylesForWaiter>;
export type QBranchStylesForWaiterLazyQueryHookResult = ReturnType<typeof useQBranchStylesForWaiterLazyQuery>;
export type QBranchStylesForWaiterQueryResult = ApolloReactCommon.QueryResult<TQBranchStylesForWaiter, TQBranchStylesForWaiterVariables>;
export const QBusinessLookupDocument = gql`
    query QBusinessLookup($url: String) {
  lookup: companyBranchLookUp(hostUrl: $url) {
    resolvedBranch: companyBranch {
      ...FBranchForWaiterLookup
    }
    isBrand: isBrandUrl
    isMobileApp
    knownBasePath
    defaultLanguage: userDefaultLanguage
    sector {
      ...FSector
    }
    redirectUrl
  }
}
    ${FBranchForWaiterLookup}
${FSector}`;
export function useQBusinessLookup(baseOptions?: ApolloReactHooks.QueryHookOptions<TQBusinessLookup, TQBusinessLookupVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQBusinessLookup, TQBusinessLookupVariables>(QBusinessLookupDocument, options);
      }
export function useQBusinessLookupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQBusinessLookup, TQBusinessLookupVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQBusinessLookup, TQBusinessLookupVariables>(QBusinessLookupDocument, options);
        }
export type QBusinessLookupHookResult = ReturnType<typeof useQBusinessLookup>;
export type QBusinessLookupLazyQueryHookResult = ReturnType<typeof useQBusinessLookupLazyQuery>;
export type QBusinessLookupQueryResult = ApolloReactCommon.QueryResult<TQBusinessLookup, TQBusinessLookupVariables>;
export const QCustomerOrderNumberDocument = gql`
    query QCustomerOrderNumber($orderId: ID!) {
  order(id: $orderId) {
    id
    number: invoiceSequenceResettable
  }
}
    `;
export function useQCustomerOrderNumber(baseOptions: ApolloReactHooks.QueryHookOptions<TQCustomerOrderNumber, TQCustomerOrderNumberVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQCustomerOrderNumber, TQCustomerOrderNumberVariables>(QCustomerOrderNumberDocument, options);
      }
export function useQCustomerOrderNumberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQCustomerOrderNumber, TQCustomerOrderNumberVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQCustomerOrderNumber, TQCustomerOrderNumberVariables>(QCustomerOrderNumberDocument, options);
        }
export type QCustomerOrderNumberHookResult = ReturnType<typeof useQCustomerOrderNumber>;
export type QCustomerOrderNumberLazyQueryHookResult = ReturnType<typeof useQCustomerOrderNumberLazyQuery>;
export type QCustomerOrderNumberQueryResult = ApolloReactCommon.QueryResult<TQCustomerOrderNumber, TQCustomerOrderNumberVariables>;
export const QOrderBranchStylesForWaiterDocument = gql`
    query QOrderBranchStylesForWaiter($orderId: ID!) {
  order(id: $orderId) {
    id
    branch: companyBranch {
      ...FBranchStylesForWaiter
    }
  }
}
    ${FBranchStylesForWaiter}`;
export function useQOrderBranchStylesForWaiter(baseOptions: ApolloReactHooks.QueryHookOptions<TQOrderBranchStylesForWaiter, TQOrderBranchStylesForWaiterVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQOrderBranchStylesForWaiter, TQOrderBranchStylesForWaiterVariables>(QOrderBranchStylesForWaiterDocument, options);
      }
export function useQOrderBranchStylesForWaiterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQOrderBranchStylesForWaiter, TQOrderBranchStylesForWaiterVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQOrderBranchStylesForWaiter, TQOrderBranchStylesForWaiterVariables>(QOrderBranchStylesForWaiterDocument, options);
        }
export type QOrderBranchStylesForWaiterHookResult = ReturnType<typeof useQOrderBranchStylesForWaiter>;
export type QOrderBranchStylesForWaiterLazyQueryHookResult = ReturnType<typeof useQOrderBranchStylesForWaiterLazyQuery>;
export type QOrderBranchStylesForWaiterQueryResult = ApolloReactCommon.QueryResult<TQOrderBranchStylesForWaiter, TQOrderBranchStylesForWaiterVariables>;
export const QWaiterCartDocument = gql`
    query QWaiterCart($orderId: ID!) {
  order(id: $orderId) {
    ...FWaiterCart
  }
}
    ${FWaiterCart}`;
export function useQWaiterCart(baseOptions: ApolloReactHooks.QueryHookOptions<TQWaiterCart, TQWaiterCartVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TQWaiterCart, TQWaiterCartVariables>(QWaiterCartDocument, options);
      }
export function useQWaiterCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TQWaiterCart, TQWaiterCartVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TQWaiterCart, TQWaiterCartVariables>(QWaiterCartDocument, options);
        }
export type QWaiterCartHookResult = ReturnType<typeof useQWaiterCart>;
export type QWaiterCartLazyQueryHookResult = ReturnType<typeof useQWaiterCartLazyQuery>;
export type QWaiterCartQueryResult = ApolloReactCommon.QueryResult<TQWaiterCart, TQWaiterCartVariables>;